/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Cursor for paging through collections */
  ConnectionCursor: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type Adjustment_Status =
  | 'ALL'
  | 'MATCHED'
  | 'UNMATCHED';

/** Admin user role types */
export type Admin_User_Role =
  | 'ACCOUNTING'
  | 'ACCOUNTS_RECEIVABLE'
  | 'BOOKKEEPER'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'CREDIT_MANAGER'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  | 'OTHER'
  | 'OWNER_FOUNDER'
  | 'PRESIDENT'
  | 'TREASURER';

export type AbandonedCartOfferDto = {
  __typename?: 'AbandonedCartOfferDto';
  accountId: Scalars['String']['output'];
  accountName: Scalars['String']['output'];
  authServiceUuid: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  discountAmount: Scalars['String']['output'];
  discountedAmount: Scalars['String']['output'];
  draftOfferId: Scalars['String']['output'];
  dsPricingUuid: Scalars['String']['output'];
  eligibleInvoiceAmount: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  goodFundsDate: Scalars['String']['output'];
  isExpressAcceptRate: Scalars['Boolean']['output'];
  leadingMakerOrganizationUuid: Scalars['String']['output'];
  leadingMarketingMakerName: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuids: Array<Scalars['String']['output']>;
  marketingMakerNames: Array<Scalars['String']['output']>;
  numberInvoices: Scalars['Float']['output'];
  numberOfCustomers: Scalars['Float']['output'];
  offerDetailsQueryParam: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  srmEmail: Scalars['String']['output'];
  srmName: Scalars['String']['output'];
  suggestedOffer: Scalars['String']['output'];
  suggestedOfferType: Scalars['String']['output'];
  suggestedRateUuid: Scalars['String']['output'];
  weightedAvgDpe: Scalars['String']['output'];
};

export type AbandonedCartOfferInput = {
  authServiceUuid: Scalars['String']['input'];
  offerType: Scalars['String']['input'];
  selectedCustomers?: InputMaybe<Array<SelectedCustomer>>;
  selectedOpportunities?: InputMaybe<Array<Scalars['String']['input']>>;
  selectedPricingServiceUuid?: InputMaybe<Scalars['String']['input']>;
  selectedRate?: InputMaybe<Scalars['Float']['input']>;
  selectedRateType?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptedStats = {
  __typename?: 'AcceptedStats';
  adjustedAmount: Scalars['Float']['output'];
  aprWeightedAvg: Scalars['Float']['output'];
  aprWeightedSum: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountWeightedAvg: Scalars['Float']['output'];
  discountWeightedSum: Scalars['Float']['output'];
  dpeWeightedAvg: Scalars['Float']['output'];
  dpeWeightedSum: Scalars['Float']['output'];
  earn: Scalars['Float']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  yield: Scalars['Float']['output'];
};

/** These mostly mimic the auth service JWT types. */
export type Access =
  /** C2FO User but can only access their own data */
  | 'ACCESSING_USER'
  /** C2FO employee who used LDAP/AD to login */
  | 'ACTIVE_DIRECTORY'
  /** Any application configured in the user auth service */
  | 'APPLICATION_AUTH'
  /** C2FO User */
  | 'PASSWORD';

/** A representation of a SalesForce Account which is a collection of Supplier Divisions. */
export type Account = {
  __typename?: 'Account';
  divisions?: Maybe<Array<Maybe<Division>>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  newExperienceEnabled?: Maybe<Scalars['Boolean']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  srm?: Maybe<Srm>;
};

/** Account Config - configuration fields for a given account */
export type AccountConfig = {
  __typename?: 'AccountConfig';
  accountId: Scalars['String']['output'];
  configUuid: Scalars['ID']['output'];
  newExperienceEligible: Scalars['Boolean']['output'];
  newExperienceEnabled: Scalars['Boolean']['output'];
  newExperienceSubgroup?: Maybe<Scalars['String']['output']>;
};

export type AccountInput = {
  accountId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type AccountsCampaignInput = {
  accounts: Array<AccountInput>;
  isDebugMode?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  offerType?: OfferType;
  srmHomeUserUuid?: InputMaybe<Scalars['String']['input']>;
};

export type ActionableOfferSchedule = {
  __typename?: 'ActionableOfferSchedule';
  campaignCode: Scalars['Int']['output'];
  campaignType: CampaignType;
  created: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  executionDays?: Maybe<Array<DayOfWeek>>;
  executionTime: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDebugMode: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nextExecutionMilliseconds?: Maybe<Scalars['Float']['output']>;
  occurrence: Occurrence;
  offerType: OfferType;
  owner: Scalars['String']['output'];
  repetitionInterval?: Maybe<RepetitionInterval>;
  repetitionStrategy?: Maybe<RepetitionStrategy>;
  source: Source;
  srmHomeSegmentId?: Maybe<Scalars['String']['output']>;
  srmHomeSegmentName: Scalars['String']['output'];
  srmHomeUserUuid: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  tags?: Maybe<Array<ScheduleTagsMappingEntity>>;
  timeZone: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
  weekOfMonth?: Maybe<Array<WeekOfMonth>>;
};


export type ActionableOfferScheduleTagsArgs = {
  filter?: ScheduleTagsMappingEntityFilter;
  sorting?: Array<ScheduleTagsMappingEntitySort>;
};

export type ActionableOfferScheduleConnection = {
  __typename?: 'ActionableOfferScheduleConnection';
  /** Array of edges. */
  edges: Array<ActionableOfferScheduleEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ActionableOfferScheduleDeleteResponse = {
  __typename?: 'ActionableOfferScheduleDeleteResponse';
  campaignCode?: Maybe<Scalars['Int']['output']>;
  campaignType?: Maybe<CampaignType>;
  created?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  executionDays?: Maybe<Array<DayOfWeek>>;
  executionTime?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDebugMode?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextExecutionMilliseconds?: Maybe<Scalars['Float']['output']>;
  occurrence?: Maybe<Occurrence>;
  offerType?: Maybe<OfferType>;
  owner?: Maybe<Scalars['String']['output']>;
  repetitionInterval?: Maybe<RepetitionInterval>;
  repetitionStrategy?: Maybe<RepetitionStrategy>;
  source?: Maybe<Source>;
  srmHomeSegmentId?: Maybe<Scalars['String']['output']>;
  srmHomeSegmentName?: Maybe<Scalars['String']['output']>;
  srmHomeUserUuid?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  weekOfMonth?: Maybe<Array<WeekOfMonth>>;
};

export type ActionableOfferScheduleEdge = {
  __typename?: 'ActionableOfferScheduleEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ActionableOfferSchedule */
  node: ActionableOfferSchedule;
};

export type ActionableOfferScheduleFileInput = {
  uuid: Scalars['String']['input'];
};

export type ActionableOfferScheduleFilter = {
  and?: InputMaybe<Array<ActionableOfferScheduleFilter>>;
  campaignCode?: InputMaybe<IntFieldComparison>;
  campaignType?: InputMaybe<CampaignTypeFilterComparison>;
  created?: InputMaybe<DateFieldComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  nextExecutionMilliseconds?: InputMaybe<NumberFieldComparison>;
  occurrence?: InputMaybe<OccurrenceFilterComparison>;
  or?: InputMaybe<Array<ActionableOfferScheduleFilter>>;
  srmHomeSegmentId?: InputMaybe<StringFieldComparison>;
  srmHomeUserUuid?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ActionableOfferScheduleHistory = {
  __typename?: 'ActionableOfferScheduleHistory';
  executedOn: Scalars['String']['output'];
  offer: ActionableOfferSchedule;
  offerUuid: Scalars['String']['output'];
  status: Status;
  updatedDate?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type ActionableOfferScheduleHistoryConnection = {
  __typename?: 'ActionableOfferScheduleHistoryConnection';
  /** Array of edges. */
  edges: Array<ActionableOfferScheduleHistoryEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ActionableOfferScheduleHistoryEdge = {
  __typename?: 'ActionableOfferScheduleHistoryEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ActionableOfferScheduleHistory */
  node: ActionableOfferScheduleHistory;
};

export type ActionableOfferScheduleHistoryFilter = {
  and?: InputMaybe<Array<ActionableOfferScheduleHistoryFilter>>;
  executedOn?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ActionableOfferScheduleHistoryFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ActionableOfferScheduleHistorySort = {
  direction: SortDirection;
  field: ActionableOfferScheduleHistorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ActionableOfferScheduleHistorySortFields =
  | 'executedOn'
  | 'uuid';

export type ActionableOfferScheduleInput = {
  campaignCode: Scalars['Float']['input'];
  campaignType: CampaignType;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  executionDays?: InputMaybe<Array<DayOfWeek>>;
  executionTime: Scalars['String']['input'];
  file?: InputMaybe<ActionableOfferScheduleFileInput>;
  isDebugMode?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  occurrence: Occurrence;
  offerType?: OfferType;
  repetitionInterval?: InputMaybe<RepetitionInterval>;
  repetitionStrategy?: InputMaybe<RepetitionStrategy>;
  source?: Source;
  srmHomeSegmentId?: InputMaybe<Scalars['String']['input']>;
  srmHomeUserUuid: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  tags?: InputMaybe<Array<ActionableOfferScheduleTagsCreateNew>>;
  timeZone: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  weekOfMonth?: InputMaybe<Array<WeekOfMonth>>;
};

export type ActionableOfferScheduleSort = {
  direction: SortDirection;
  field: ActionableOfferScheduleSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ActionableOfferScheduleSortFields =
  | 'campaignCode'
  | 'campaignType'
  | 'created'
  | 'isActive'
  | 'name'
  | 'nextExecutionMilliseconds'
  | 'occurrence'
  | 'srmHomeSegmentId'
  | 'srmHomeUserUuid'
  | 'updated'
  | 'uuid';

export type ActionableOfferScheduleTags = {
  __typename?: 'ActionableOfferScheduleTags';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActionableOfferScheduleTagsConnection = {
  __typename?: 'ActionableOfferScheduleTagsConnection';
  /** Array of edges. */
  edges: Array<ActionableOfferScheduleTagsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ActionableOfferScheduleTagsCreateNew = {
  id?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
};

export type ActionableOfferScheduleTagsEdge = {
  __typename?: 'ActionableOfferScheduleTagsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ActionableOfferScheduleTags */
  node: ActionableOfferScheduleTags;
};

export type ActionableOfferScheduleTagsFilter = {
  and?: InputMaybe<Array<ActionableOfferScheduleTagsFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<ActionableOfferScheduleTagsFilter>>;
};

export type ActionableOfferScheduleTagsSort = {
  direction: SortDirection;
  field: ActionableOfferScheduleTagsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ActionableOfferScheduleTagsSortFields =
  | 'id';

export type ActionableOfferScheduleUpdate = {
  campaignCode?: InputMaybe<Scalars['Float']['input']>;
  campaignType?: InputMaybe<CampaignType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  executionDays?: InputMaybe<Array<DayOfWeek>>;
  executionTime: Scalars['String']['input'];
  file?: InputMaybe<ActionableOfferScheduleFileInput>;
  isDebugMode?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextExecutionMilliseconds?: InputMaybe<Scalars['Float']['input']>;
  occurrence?: InputMaybe<Occurrence>;
  offerType?: OfferType;
  repetitionInterval?: InputMaybe<RepetitionInterval>;
  repetitionStrategy?: InputMaybe<RepetitionStrategy>;
  source?: Source;
  srmHomeSegmentId?: InputMaybe<Scalars['String']['input']>;
  srmHomeUserUuid?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tags?: InputMaybe<Array<ActionableOfferScheduleTagsCreateNew>>;
  timeZone: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  weekOfMonth?: InputMaybe<Array<WeekOfMonth>>;
};

export type ActivationMarketRateType =
  | 'OneTimePriceDiscoveryRate';

export type ActivationOfferOpportunity = {
  __typename?: 'ActivationOfferOpportunity';
  currency: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  invoiceSummary: ActivationOpportunityInvoiceSummary;
  makerDisplayName: Scalars['String']['output'];
  makerOrganizationUuid: Scalars['String']['output'];
  requestOptions: Array<ActivationRequestOptions>;
  takersMarkets: Array<ActivationOpportunityTakersMarket>;
  uuid: Scalars['String']['output'];
};

export type ActivationOfferSummaryResponse = {
  __typename?: 'ActivationOfferSummaryResponse';
  activationOfferOpportunities?: Maybe<Array<ActivationOfferOpportunity>>;
  additionInvoiceAmountAR: Scalars['Float']['output'];
  avgDaysPaidEarly: Scalars['Float']['output'];
  highestAPCustomerCurrency: Scalars['String']['output'];
  highestAPCustomerUuid: Scalars['String']['output'];
  isDSFMarketPresent: Scalars['Boolean']['output'];
  makerDisplayNames: Array<Scalars['String']['output']>;
  nearestRequestDeadline: Scalars['String']['output'];
  recentMaxGoodFundsDate: Scalars['String']['output'];
  totalAmountAR: Scalars['Float']['output'];
  totalInvoiceCount: Scalars['Float']['output'];
};

/** Aggregate statistics for the eligible invoices in this opportunity */
export type ActivationOpportunityInvoiceSummary = {
  __typename?: 'ActivationOpportunityInvoiceSummary';
  eligibleDpeWeightedSumUsd?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount: Scalars['Float']['output'];
  maxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  requestDeadline?: Maybe<Scalars['String']['output']>;
};

/** TakersMarkets data associated with an opportunity */
export type ActivationOpportunityTakersMarket = {
  __typename?: 'ActivationOpportunityTakersMarket';
  dpe: Scalars['Float']['output'];
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceAmountUsd: Scalars['Float']['output'];
  marketIsEnabled: Scalars['Boolean']['output'];
  marketUuid: Scalars['String']['output'];
  productType?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type ActivationRequestOptions =
  | 'ExpressAcceptPriceDiscovery'
  | 'OneTimeBenchmarkRate'
  | 'OneTimeCashFlowPlus'
  | 'OneTimePriceDiscovery'
  | 'OneTimeStaticRate'
  | 'PreferredTerm'
  | 'RecurringBenchmarkRate'
  | 'RecurringPriceDiscovery'
  | 'RecurringStaticRate';

export type AddItemsToCustomGroupInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type AddSuppliersInput = {
  /** All selected configuration */
  allSelected?: InputMaybe<PlanAllSelectedOptions>;
  /** List of vendor variant IDs to add to the wave */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

/** Address - normalized according to our spec here: https://honeycomb.jira.com/wiki/spaces/ENG/pages/856457228/2018-11-01%2BCLOSED%2B--%2BAddress%2BStorage%2Band%2BViewing */
export type Address = {
  __typename?: 'Address';
  /** Street Address Line(s) */
  addressLines?: Maybe<Scalars['String']['output']>;
  /** Administrative area. State, Province, Island, etc. - California, SP, Seoul */
  adminArea?: Maybe<Scalars['String']['output']>;
  /** City or Locality - Mountain View, São Paulo, Gangnam-Gu */
  city?: Maybe<Scalars['String']['output']>;
  /** This is thname of the locality. USA, Canda, etc. */
  country?: Maybe<Scalars['String']['output']>;
  /** This is the data key as seen in the listing. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** inner-city, district, suburb */
  dependentLocality?: Maybe<Scalars['String']['output']>;
  /** Persons name at the company. */
  name?: Maybe<Scalars['String']['output']>;
  /** The organization name inside the company. Google has Google Korea, Google France, etc. */
  organization?: Maybe<Scalars['String']['output']>;
  /** Zip or postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** Were not sure, but its not used often. */
  sortingCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type AdjustmentToleranceUnionBuyerAppDualAuthorization = BuyerAppAdjustmentSettings | BuyerAppDualAuthorization;

export type AggregatedMarketsStatsInput = {
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type AggregatedMarketsStatsOutput = {
  __typename?: 'AggregatedMarketsStatsOutput';
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  invoicesCustom?: Maybe<Scalars['Float']['output']>;
  weightedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  weightedYield?: Maybe<Scalars['Float']['output']>;
};

export type AggregationLevel =
  | 'ALL'
  | 'DIVISION'
  | 'MARKET'
  | 'ORG';

export type AggregationLevelWithMarketType =
  | 'ALL'
  | 'DIVISION'
  | 'MARKET'
  | 'MARKET_TYPE'
  | 'ORG';

/** An object that links a market with an agreement. */
export type Agreement = {
  __typename?: 'Agreement';
  cmsId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  marketId: Scalars['ID']['output'];
};

/** A record showing what agreeement has been agreed to by what user. */
export type AgreementAudit = {
  __typename?: 'AgreementAudit';
  agreement: Agreement;
  agreementId: Scalars['String']['output'];
  authServiceUuid: Scalars['String']['output'];
  dateAccepted: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  revision: Scalars['String']['output'];
};

export type AgreementAuditConnection = {
  __typename?: 'AgreementAuditConnection';
  /** Array of edges. */
  edges: Array<AgreementAuditEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AgreementAuditEdge = {
  __typename?: 'AgreementAuditEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the AgreementAudit */
  node: AgreementAudit;
};

export type AgreementAuditFilter = {
  agreement?: InputMaybe<AgreementAuditFilterAgreementFilter>;
  agreementId?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<AgreementAuditFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<AgreementAuditFilter>>;
};

export type AgreementAuditFilterAgreementFilter = {
  and?: InputMaybe<Array<AgreementAuditFilterAgreementFilter>>;
  cmsId?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AgreementAuditFilterAgreementFilter>>;
};

/** The input DTO to record that an agreement has been agreed to. */
export type AgreementAuditInput = {
  agreementId: Scalars['String']['input'];
  authServiceUuid: Scalars['String']['input'];
  revision: Scalars['String']['input'];
};

export type AgreementAuditSort = {
  direction: SortDirection;
  field: AgreementAuditSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type AgreementAuditSortFields =
  | 'agreementId'
  | 'authServiceUuid';

export type AgreementConnection = {
  __typename?: 'AgreementConnection';
  /** Array of edges. */
  edges: Array<AgreementEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AgreementEdge = {
  __typename?: 'AgreementEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Agreement */
  node: Agreement;
};

export type AgreementFilter = {
  and?: InputMaybe<Array<AgreementFilter>>;
  cmsId?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<AgreementFilter>>;
};

export type AgreementSort = {
  direction: SortDirection;
  field: AgreementSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type AgreementSortFields =
  | 'cmsId'
  | 'marketId';

export type AgreementStatusEnum =
  | 'DRAFT'
  | 'LIVE'
  | 'STAGE';

export type AllSelectedFiltersInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type AllSelectedOptionsInput = {
  /** Additional filters to apply when all suppliers are selected */
  additionalFilters: AllSelectedFiltersInput;
  /** Must be true to indicate all suppliers are selected */
  value?: Scalars['Boolean']['input'];
};

export type Application = {
  __typename?: 'Application';
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type AssignDefaultBuyerAppDivisionsUsersRolesToUserInput = {
  /** Division UUID of the division the user is added to */
  divisionUuid: Scalars['String']['input'];
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['input'];
};

/** CashFlowPlus Stats from the calculator */
export type Attributes = {
  __typename?: 'Attributes';
  /** Amount of discount for the CashFlowPlus offer */
  depositAmount: Scalars['Float']['output'];
  /** Amount of discount for the CashFlowPlus offer (converted currency) */
  depositAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** Total amount for the CashFlowPlus offer */
  fullAmount: Scalars['Float']['output'];
  /** Total amount for the CashFlowPlus offer (converted currency) */
  fullAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** Maker Organizations UUID for this taker market */
  makerOrgUuid: Scalars['String']['output'];
  /** The market_id associated with the opportunity takers_markets data. */
  marketId: Scalars['Float']['output'];
  /** Amount of rebate C2FO will pay for the CashFlowPlus offer */
  rebateAmount: Scalars['Float']['output'];
  /** Amount of rebate C2FO will pay for the CashFlowPlus offer (converted currency) */
  rebateAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** Amount of reward for the CashFlowPlus offer (only for dynamic discount) */
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  /** The taker_id associated with the opportunity takers_markets data. */
  takerId: Scalars['Float']['output'];
};

export type AwardedStats = {
  __typename?: 'AwardedStats';
  adjustedAmount: Scalars['Float']['output'];
  aprWeightedAvg: Scalars['Float']['output'];
  aprWeightedSum: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountWeightedAvg: Scalars['Float']['output'];
  discountWeightedSum: Scalars['Float']['output'];
  dpeWeightedAvg: Scalars['Float']['output'];
  dpeWeightedSum: Scalars['Float']['output'];
  earn: Scalars['Float']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  yield: Scalars['Float']['output'];
};

export type Benchmarking_Strategies =
  | 'custom'
  | 'industryCountry75'
  | 'industryCountry85'
  | 'industryCountry90'
  | 'industryCountry95'
  | 'industryCountry99'
  | 'industryCountryMedian'
  | 'industryGlobal75'
  | 'industryGlobal85'
  | 'industryGlobal90'
  | 'industryGlobal95'
  | 'industryGlobal99'
  | 'industryGlobalMax'
  | 'industryGlobalMedian'
  | 'waHarmonization';

export type Benchmarking_Strategies_With_Harmonization =
  | 'harmonization'
  | 'industryCountry75'
  | 'industryCountry85'
  | 'industryCountry90'
  | 'industryCountry95'
  | 'industryCountry99'
  | 'industryCountryMax'
  | 'industryCountryMedian'
  | 'industryGlobal75'
  | 'industryGlobal85'
  | 'industryGlobal90'
  | 'industryGlobal95'
  | 'industryGlobal99'
  | 'industryGlobalMax'
  | 'industryGlobalMedian';

export type Buyer_Config =
  | 'SHOW_NEW_SUPPLIER_PROFILE';

export type Buyer_Region =
  | 'AMER'
  | 'EMEA';

export type BenchmarkOffer = {
  __typename?: 'BenchmarkOffer';
  rateInfo?: Maybe<BenchmarkRateInfo>;
  type: Pricing;
};

export type BenchmarkOfferInput = {
  draftId?: InputMaybe<Scalars['String']['input']>;
  excludeNewInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  expireOn?: InputMaybe<Scalars['String']['input']>;
  frequency: Frequency;
  marketUuid: Scalars['String']['input'];
  supplierDivisionUuid: Scalars['String']['input'];
};

/** Provides market level info for benchmark rates. This does not include the reference rate as that is calculated based on the eligible DPE and invoice amount for a taker market. */
export type BenchmarkPricing = {
  __typename?: 'BenchmarkPricing';
  c2foSpread?: Maybe<Scalars['Float']['output']>;
  isStatic: Scalars['Boolean']['output'];
  nodeId: Scalars['ID']['output'];
  rateName: Scalars['String']['output'];
  spread: Scalars['Float']['output'];
  type: Pricing;
};

export type BenchmarkRate = {
  __typename?: 'BenchmarkRate';
  c2foSpread: Scalars['Float']['output'];
  isStatic: Scalars['Boolean']['output'];
  rateName: Scalars['String']['output'];
  spread: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type BenchmarkRateDetails = {
  __typename?: 'BenchmarkRateDetails';
  apr?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Value for the total rate (reference + spread).
   * Null when an estimated rate cannot be computed.
   */
  estimatedRate?: Maybe<Scalars['Float']['output']>;
  /** Name of the referenced rate source. */
  rateName?: Maybe<Scalars['String']['output']>;
  /**
   * Value for the reference rate source.
   * Null when a reference rate cannot be computed.
   */
  referenceRate?: Maybe<Scalars['Float']['output']>;
  /** The total spread (includes c2fo spread). */
  spread?: Maybe<Scalars['Float']['output']>;
};

export type BenchmarkRateDetailsInput = {
  apr?: InputMaybe<Scalars['Float']['input']>;
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Value for the total rate (reference + spread).
   * Null when an estimated rate cannot be computed.
   */
  estimatedRate?: InputMaybe<Scalars['Float']['input']>;
  /** Name of the referenced rate source. */
  rateName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Value for the reference rate source.
   * Null when a reference rate cannot be computed.
   */
  referenceRate?: InputMaybe<Scalars['Float']['input']>;
  /** The total spread (includes c2fo spread). */
  spread?: InputMaybe<Scalars['Float']['input']>;
};

export type BenchmarkRateInfo = {
  __typename?: 'BenchmarkRateInfo';
  /** Total rate of the offer (sum of totalSpread and referenceRate */
  estimatedRate?: Maybe<Scalars['Float']['output']>;
  /** Name of the benchmark rate */
  rateName: Scalars['String']['output'];
  /** Reference rate for the benchmark offer, before spread is applied */
  referenceRate: Scalars['Float']['output'];
  /** Total spread for a benchmark rate offer */
  totalSpread?: Maybe<Scalars['Float']['output']>;
};

/** Statistics for opportunities with a Benchmark Rate */
export type BenchmarkRateStats = {
  __typename?: 'BenchmarkRateStats';
  /** Amount discounted from the opportunity. */
  discount: Scalars['Float']['output'];
  /** The result of total amount - discount. */
  discountedAmount: Scalars['Float']['output'];
  /** Sum of spread and reference rate. */
  estimatedRate: Scalars['Float']['output'];
  /** Reference rate for a bench mark rate opportunity. */
  referenceRate: Scalars['Float']['output'];
  /** The name of the benchmark rate. */
  referenceRateName: Scalars['String']['output'];
  /** Total spread for a bench mark rate opportunity */
  totalSpread: Scalars['Float']['output'];
};

export type BenchmarkStrategyInput = {
  /** Core segment benchmark strategy */
  coreBenchmarkStrategy: Scalars['String']['input'];
  /** No Naics Terms Increment */
  noNaicsTermsIncrement: Scalars['Float']['input'];
  /** Strategic segment benchmark strategy */
  strategicBenchmarkStrategy: Scalars['String']['input'];
  /** Tail segment benchmark strategy */
  tailBenchmarkStrategy: Scalars['String']['input'];
};

export type BenchmarkStrategyOutput = {
  __typename?: 'BenchmarkStrategyOutput';
  /** Core segment benchmark strategy */
  coreBenchmarkStrategy: Scalars['String']['output'];
  /** No Naics Terms Increment */
  noNaicsTermsIncrement: Scalars['Float']['output'];
  /** Strategic segment benchmark strategy */
  strategicBenchmarkStrategy: Scalars['String']['output'];
  /** Tail segment benchmark strategy */
  tailBenchmarkStrategy: Scalars['String']['output'];
};

export type BillingFrequency =
  | 'MONTHLY'
  | 'QUARTERLY'
  | 'YEARLY';

export type BooleanFieldComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessDetailsInput = {
  /** Valid Customer Name */
  customer: Scalars['String']['input'];
  /** Doing business as */
  dba: Scalars['String']['input'];
  /** unique vendor id */
  vendorId: Scalars['String']['input'];
};

export type Buyer = {
  __typename?: 'Buyer';
  active: Scalars['Boolean']['output'];
  buyerEmailDomain?: Maybe<Scalars['String']['output']>;
  buyerPortalUrl?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  makerRouteKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** This is just a helper to let me know where the data came from. We probably dont want it in production */
  source: Scalars['String']['output'];
};

export type BuyerAppAdjustmentSettings = {
  __typename?: 'BuyerAppAdjustmentSettings';
  adjustmentTolerance: Scalars['Float']['output'];
};

export type BuyerAppAdjustmentToleranceInputDto = {
  /** adjustment tolerance value */
  adjTolerance?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppAggregatedScfDisclosureInput = {
  /** Division Uuid */
  divisionUuid: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Funding Partner Uuids */
  fundingPartnerUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppAggregatedScfDisclosureOutput = {
  __typename?: 'BuyerAppAggregatedScfDisclosureOutput';
  /** associated currency wise disclosure */
  currencyWiseScfDisclosure: Array<BuyerAppCurrencyWiseScfDisclosure>;
  /** funding partner uuid */
  fundingPartnerUuid: Scalars['String']['output'];
};

export type BuyerAppApPerformanceReportInput = {
  /** display currency */
  displayCurrency: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** display currency */
  periods: Array<BuyerAppYoyReportPeriod>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppApPerformanceReportOutput = {
  __typename?: 'BuyerAppApPerformanceReportOutput';
  /** Awarded AP */
  awardedAp: Scalars['Float']['output'];
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  /** Eligible AP */
  eligibleAp: Scalars['Float']['output'];
  income?: Maybe<Scalars['Float']['output']>;
  /** Loaded AP */
  loadedAp: Scalars['Float']['output'];
  /** Participated AP */
  participatedAp: Scalars['Float']['output'];
  participationRate?: Maybe<Scalars['Float']['output']>;
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered AP */
  registeredAp: Scalars['Float']['output'];
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppApSummaryOutput = {
  __typename?: 'BuyerAppApSummaryOutput';
  /** Awarded AP */
  awardedAp: Scalars['Float']['output'];
  /** Eligible AP */
  eligibleAp: Scalars['Float']['output'];
  /** Loaded AP */
  loadedAp: Scalars['Float']['output'];
  /** Participated AP */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered AP */
  registeredAp: Scalars['Float']['output'];
};

export type BuyerAppAprSettingsInput = {
  /** Market APR */
  apr: Scalars['Float']['input'];
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Minimum APR from the market */
  minApr: Scalars['Float']['input'];
};

export type BuyerAppAwardedSupplierHistory = {
  __typename?: 'BuyerAppAwardedSupplierHistory';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceCounts?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  displayCurrency: Scalars['String']['output'];
  firstAwardDate?: Maybe<Scalars['String']['output']>;
  funder: Scalars['String']['output'];
  isParticipating: Scalars['Boolean']['output'];
  lastAwardDate?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Float']['output'];
  marketUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  payDate: Scalars['DateTime']['output'];
  rank?: Maybe<Scalars['Float']['output']>;
  takerId: Scalars['Float']['output'];
  takerUuid: Scalars['String']['output'];
  vendorCode: Scalars['String']['output'];
};

export type BuyerAppAwardedSuppliersHistoryFilters = {
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  fundedMarkets: Array<Scalars['String']['input']>;
  orgUuid: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  selfMarkets: Array<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type BuyerAppAwardedSuppliersHistoryInput = {
  filters: BuyerAppAwardedSuppliersHistoryFilters;
  paging: BuyerAppAwardedSuppliersHistoryPaging;
};

export type BuyerAppAwardedSuppliersHistoryOutput = {
  __typename?: 'BuyerAppAwardedSuppliersHistoryOutput';
  history: Array<BuyerAppAwardedSupplierHistory>;
  orgUuid: Scalars['String']['output'];
  totalRows: Scalars['Float']['output'];
};

export type BuyerAppAwardedSuppliersHistoryPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type BuyerAppBuyerConfigResponse = {
  __typename?: 'BuyerAppBuyerConfigResponse';
  /** Configuration object */
  configuration: Scalars['JSON']['output'];
};

export type BuyerAppBuyerReportEmailOutput = {
  __typename?: 'BuyerAppBuyerReportEmailOutput';
  message: Scalars['String']['output'];
};

export type BuyerAppBuyerReportsDbtUnloadInput = {
  /** array of buyer report types */
  dbtModels: Array<Dbt_Model>;
  period: Scalars['String']['input'];
};

export type BuyerAppBuyerReportsDbtUnloadOutput = {
  __typename?: 'BuyerAppBuyerReportsDBTUnloadOutput';
  /** status of dbt unload */
  status: Scalars['Boolean']['output'];
};

export type BuyerAppBuyerReportsEmailsInput = {
  /** Email IDs of users to send buyer report email. NOTE: If none is supplied, then email would be sent to all buyer app users */
  userEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BuyerAppBuyerReportsMarketsInput = {
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Markets Uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppBuyerReportsMarketsInputWithCurrency = {
  /** display currency */
  displayCurrency: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Markets Uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppBuyerSupplierCounts = {
  __typename?: 'BuyerAppBuyerSupplierCounts';
  created: Scalars['DateTime']['output'];
  /** Maker UUID */
  makerUuid: Scalars['String']['output'];
  /** Total number of registered suppliers */
  registeredSuppliers: Scalars['Float']['output'];
  /** Total number of suppliers */
  totalSuppliers: Scalars['Float']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppBuyerSupplierCountsFilter = {
  and?: InputMaybe<Array<BuyerAppBuyerSupplierCountsFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppBuyerSupplierCountsFilter>>;
};

export type BuyerAppBuyerSupplierCountsSort = {
  direction: SortDirection;
  field: BuyerAppBuyerSupplierCountsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppBuyerSupplierCountsSortFields =
  | 'makerUuid';

export type BuyerAppCashPoolSettingsInput = {
  /** Cash Available for the market. NOTE: Supply this only if cashPoolLimit is not supplied */
  cashPool?: InputMaybe<Scalars['Float']['input']>;
  /** Cash pool limit. NOTE: Supply this only if cashPool is not supplied */
  cashPoolLimit?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppClearHistory = {
  __typename?: 'BuyerAppClearHistory';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  marketUuids?: Maybe<Array<Scalars['String']['output']>>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppClearHistoryGraphInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
  timePeriod?: Time_Periods;
};

export type BuyerAppClearHistoryGraphOutput = {
  __typename?: 'BuyerAppClearHistoryGraphOutput';
  history: Array<BuyerAppClearHistory>;
};

export type BuyerAppClearHistoryStats = {
  __typename?: 'BuyerAppClearHistoryStats';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedYield?: Maybe<Scalars['Float']['output']>;
  clearedAprAvg?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmountAvgByPayDate?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  interestAmount?: Maybe<Scalars['Float']['output']>;
  participatingSuppliersCount?: Maybe<Scalars['Float']['output']>;
  region: Scalars['String']['output'];
  revShareAmount?: Maybe<Scalars['Float']['output']>;
  totalSuppliersCount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppClearHistoryStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppClearHistoryStatsOutput = {
  __typename?: 'BuyerAppClearHistoryStatsOutput';
  clearHistoryStats: BuyerAppClearHistoryStats;
};

export type BuyerAppClearingTopOffers = {
  __typename?: 'BuyerAppClearingTopOffers';
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyAcceptedEarn: Scalars['Float']['output'];
  baseCurrencyAcceptedInvoiceAmount: Scalars['Float']['output'];
  displayCurrency: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppClearingTopOffersInput = {
  filters: BuyerAppTopOffersFilters;
  paging: BuyerAppCursorPaging;
  sorting: BuyerAppClearingTopOffersSorting;
};

export type BuyerAppClearingTopOffersOutput = {
  __typename?: 'BuyerAppClearingTopOffersOutput';
  offers: Array<BuyerAppClearingTopOffers>;
  pageInfo: BuyerAppCursorPagingInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppClearingTopOffersSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Clearing_Top_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppCoreMarketMetricsDetailsOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsDetailsOutput';
  /** awarded Ap */
  awardedAp: Scalars['Float']['output'];
  /** count of awarded vendors */
  countOfAwardedVendors: Scalars['Float']['output'];
  /** DPE */
  dpe: Scalars['Float']['output'];
  /** eligible Ap */
  eligibleAp: Scalars['Float']['output'];
  /** income */
  income?: Maybe<Scalars['Float']['output']>;
  /** participated Ap */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered Ap */
  registeredAp: Scalars['Float']['output'];
  /** total Ap */
  totalAp: Scalars['Float']['output'];
  /** yield */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppCoreMarketMetricsDownloadOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsDownloadOutput';
  /** period */
  period: Scalars['DateTime']['output'];
  /** self market metrics */
  self?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
  /** third party market metrics */
  thirdParty?: Maybe<Array<BuyerAppCoreMarketMetricsWithFunderOutput>>;
};

export type BuyerAppCoreMarketMetricsOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsOutput';
  /** all market metrics */
  all: BuyerAppCoreMarketMetricsDetailsOutput;
  /** period */
  period: Scalars['DateTime']['output'];
  /** self market metrics */
  self?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
  /** third party market metrics */
  thirdParty?: Maybe<BuyerAppCoreMarketMetricsDetailsOutput>;
};

export type BuyerAppCoreMarketMetricsWithFunderOutput = {
  __typename?: 'BuyerAppCoreMarketMetricsWithFunderOutput';
  /** awarded Ap */
  awardedAp: Scalars['Float']['output'];
  /** count of awarded vendors */
  countOfAwardedVendors: Scalars['Float']['output'];
  /** DPE */
  dpe: Scalars['Float']['output'];
  /** eligible Ap */
  eligibleAp: Scalars['Float']['output'];
  /** funder name */
  funder: Scalars['String']['output'];
  /** income */
  income?: Maybe<Scalars['Float']['output']>;
  /** participated Ap */
  participatedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered Ap */
  registeredAp: Scalars['Float']['output'];
  /** total Ap */
  totalAp: Scalars['Float']['output'];
  /** yield */
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppCreateReserveInputDto = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** Invoice priority field */
  invoicePriority: Scalars['String']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Reserve percentage value */
  reservePercentage: Scalars['Float']['input'];
  /** Field to indicate run before adjustments */
  runBeforeAdjustments: Scalars['Boolean']['input'];
};

export type BuyerAppCreditLimit = {
  __typename?: 'BuyerAppCreditLimit';
  /** Division uuid */
  buyerDivisionUuid: Scalars['String']['output'];
  /** Credit limit currency */
  currency: Scalars['String']['output'];
  /** Funder uuid */
  funderUuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  /** Credit limit value */
  limit: Scalars['Float']['output'];
};

export type BuyerAppCreditLimitInput = {
  /** Display currency for credit limit amount */
  currency?: Scalars['String']['input'];
  /** Division Uuids */
  divisionUuids: Array<Scalars['String']['input']>;
  investmentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BuyerAppCreditLimitOutput = {
  __typename?: 'BuyerAppCreditLimitOutput';
  /** Credit Limit */
  creditLimit: Array<BuyerAppCreditLimit>;
  /** Credit utilised */
  utilisation: Array<BuyerAppCreditUtilisation>;
};

export type BuyerAppCreditUtilisation = {
  __typename?: 'BuyerAppCreditUtilisation';
  /** Date of cash investment */
  investmentDate: Scalars['String']['output'];
  /** Organization uuid */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Division uuid */
  makerUuid: Scalars['String']['output'];
  /** Market uuid */
  marketUuid: Scalars['String']['output'];
  /** cash invested value */
  normalizedCashInvested: Scalars['Float']['output'];
};

export type BuyerAppCumulativeVendorsDetailsOutput = {
  __typename?: 'BuyerAppCumulativeVendorsDetailsOutput';
  /** newly loaded supplier count */
  newlyLoadedVendors: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** loaded supplier count */
  totalLoadedVendors: Scalars['Float']['output'];
};

export type BuyerAppCurrencyWiseScfDisclosure = {
  __typename?: 'BuyerAppCurrencyWiseScfDisclosure';
  beginningBalance: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  earliestMaturityDate?: Maybe<Scalars['DateTime']['output']>;
  /** The end date of the available data */
  endDate: Scalars['DateTime']['output'];
  endingBalance: Scalars['Float']['output'];
  grossAmountExpedited: Scalars['Float']['output'];
  grossAmountReimbursed: Scalars['Float']['output'];
  latestMaturityDate?: Maybe<Scalars['DateTime']['output']>;
  /** The start date of the available data */
  startDate: Scalars['DateTime']['output'];
};

export type BuyerAppCursorPaging = {
  /** end Cursor for paging through collections */
  end?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Float']['input'];
  /** start Cursor for paging through collections */
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppCursorPagingInfo = {
  __typename?: 'BuyerAppCursorPagingInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppDivisionRegion = {
  __typename?: 'BuyerAppDivisionRegion';
  id: Scalars['Float']['output'];
  makerUuid: Scalars['String']['output'];
  region: Buyer_Region;
};

export type BuyerAppDivisionRegionDeleteResponse = {
  __typename?: 'BuyerAppDivisionRegionDeleteResponse';
  id?: Maybe<Scalars['Float']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Buyer_Region>;
};

export type BuyerAppDivisionRegionFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionRegionFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionRegionFilter>>;
};

export type BuyerAppDivisionRegionInput = {
  makerUuid: Scalars['String']['input'];
  region: Buyer_Region;
};

export type BuyerAppDivisionRegionSort = {
  direction: SortDirection;
  field: BuyerAppDivisionRegionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppDivisionRegionSortFields =
  | 'makerUuid';

export type BuyerAppDivisionRegionUpdateFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionRegionUpdateFilter>>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionRegionUpdateFilter>>;
};

export type BuyerAppDivisionRegionUpdateInput = {
  region: Buyer_Region;
};

export type BuyerAppDivisionReportingCurrencies = {
  __typename?: 'BuyerAppDivisionReportingCurrencies';
  /** currency */
  currency: Scalars['String']['output'];
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
  /** ID */
  id: Scalars['Float']['output'];
  /** Report Type */
  reportType: Report_Type;
};

export type BuyerAppDivisionReportingCurrenciesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionReportingCurrenciesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionReportingCurrenciesDeleteFilter>>;
  reportType?: InputMaybe<Report_TypeFilterComparison>;
};

export type BuyerAppDivisionReportingCurrenciesEdge = {
  __typename?: 'BuyerAppDivisionReportingCurrenciesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDivisionReportingCurrencies */
  node: BuyerAppDivisionReportingCurrencies;
};

export type BuyerAppDivisionReportingCurrenciesInput = {
  /** Division UUIDs */
  divisionUuids: Array<Scalars['String']['input']>;
  /** Report Type */
  reportType: Report_Type;
};

export type BuyerAppDivisionReportingCurrenciesOutput = {
  __typename?: 'BuyerAppDivisionReportingCurrenciesOutput';
  /** Custom currencies configured for the division */
  currencies: Array<Scalars['String']['output']>;
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionRolesOutput = {
  __typename?: 'BuyerAppDivisionRolesOutput';
  /** Division uuid */
  divisionUuid: Scalars['String']['output'];
  /** Is the income to be displayed? */
  showIncome: Scalars['Boolean']['output'];
  /** Is the yield to be displayed? */
  showYield: Scalars['Boolean']['output'];
};

/** Role Assigned to a Division User */
export type BuyerAppDivisionUserRole = {
  __typename?: 'BuyerAppDivisionUserRole';
  id: Scalars['ID']['output'];
  /** Role Name */
  name: Scalars['String']['output'];
  /** Readable Role Name To Display */
  readableName: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRoles = {
  __typename?: 'BuyerAppDivisionsUsersRoles';
  created: Scalars['DateTime']['output'];
  /** Division UUID of the division the user has access to */
  divisionUuid: Scalars['String']['output'];
  role: BuyerAppRole;
  /** Role assigned to the user on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRolesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDivisionsUsersRolesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDivisionsUsersRolesDeleteFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppDivisionsUsersRolesEdge = {
  __typename?: 'BuyerAppDivisionsUsersRolesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDivisionsUsersRoles */
  node: BuyerAppDivisionsUsersRoles;
};

export type BuyerAppDivisionsUsersRolesFilter = {
  /** Division UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** Auth Service UUID of the division user */
  userUuid?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppDivisionsUsersRolesInput = {
  /** Division UUID of the division the user must have access to */
  divisionUuid: Scalars['String']['input'];
  /** Role that must be assigned to the user on the division */
  roleId: Scalars['ID']['input'];
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['input'];
};

export type BuyerAppDivisionsUsersRolesNode = {
  __typename?: 'BuyerAppDivisionsUsersRolesNode';
  /** Division UUID of the division the user has access to */
  divisionUuid: Scalars['String']['output'];
  /** Roles assigned to the user on the division */
  roles: Array<BuyerAppDivisionUserRole>;
  /** Auth Service UUID of the user */
  userUuid: Scalars['String']['output'];
};

export type BuyerAppDivisionsUsersRolesOutput = {
  __typename?: 'BuyerAppDivisionsUsersRolesOutput';
  /** Divisions Users Information */
  nodes: Array<BuyerAppDivisionsUsersRolesNode>;
  /** Total count of divisions users */
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppDpeAnalysisDetailsOutput = {
  __typename?: 'BuyerAppDpeAnalysisDetailsOutput';
  /** awarded DPE */
  awardedDpe: Scalars['Float']['output'];
  /** discount */
  discount: Scalars['Float']['output'];
  /** network DPE */
  networkDpe: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
};

export type BuyerAppDualAuthorization = {
  __typename?: 'BuyerAppDualAuthorization';
  /** action */
  action: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** data */
  data: Scalars['JSON']['output'];
  /** uuid of division */
  divisionUuid: Scalars['String']['output'];
  /** Id of dual auth */
  id: Scalars['ID']['output'];
  /** user auth uuid if initiating user */
  initiatingUserUuid: Scalars['String']['output'];
  /** represent dual auth is approved or not */
  isApproved: Scalars['Boolean']['output'];
  /** represent dual auth is canceled or not */
  isCancelled: Scalars['Boolean']['output'];
  /** user auth uuid if responding user */
  respondingUserUuid?: Maybe<Scalars['String']['output']>;
  /** Role assigned to the user on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppDualAuthorizationRoles = {
  __typename?: 'BuyerAppDualAuthorizationRoles';
  created: Scalars['DateTime']['output'];
  /** Division UUID of the division for which dual auth is enabled */
  divisionUuid: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  role: BuyerAppRole;
  /** Role ID for which dual auth is enabled on the division */
  roleId: Scalars['ID']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppDualAuthorizationRolesDeleteFilter = {
  and?: InputMaybe<Array<BuyerAppDualAuthorizationRolesDeleteFilter>>;
  divisionUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppDualAuthorizationRolesDeleteFilter>>;
  roleId?: InputMaybe<IdFilterComparison>;
};

export type BuyerAppDualAuthorizationRolesEdge = {
  __typename?: 'BuyerAppDualAuthorizationRolesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppDualAuthorizationRoles */
  node: BuyerAppDualAuthorizationRoles;
};

export type BuyerAppDualAuthorizationRolesEnabledInput = {
  /** Division for which dual auth is to be checked */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppDualAuthorizationRolesEnabledOutput = {
  __typename?: 'BuyerAppDualAuthorizationRolesEnabledOutput';
  /** Boolean field denoting dual auth is enabled for the given division or no */
  isDualAuthEnabled: Scalars['Boolean']['output'];
};

export type BuyerAppDualAuthorizationRolesInput = {
  /** Division UUID of the division for which dual auth is to be enabled */
  divisionUuid: Scalars['String']['input'];
  /** Specific Role ID for which dual auth is to be enabled on the division */
  roleId: Scalars['ID']['input'];
};

export type BuyerAppEverafterBuyerConfig = {
  __typename?: 'BuyerAppEverafterBuyerConfig';
  accountId: Scalars['String']['output'];
  apiKey: Scalars['String']['output'];
  divisionUuid: Scalars['String']['output'];
  embedLocationId: Scalars['String']['output'];
  personaName: Scalars['String']['output'];
  workspaceId: Scalars['String']['output'];
};

export type BuyerAppEverafterBuyerConfigEdge = {
  __typename?: 'BuyerAppEverafterBuyerConfigEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppEverafterBuyerConfig */
  node: BuyerAppEverafterBuyerConfig;
};

export type BuyerAppFetchAllSuppliersPaging = {
  pageNum?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type BuyerAppFileHistory = {
  __typename?: 'BuyerAppFileHistory';
  created: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['String']['output'];
};

export type BuyerAppFileHistoryConnection = {
  __typename?: 'BuyerAppFileHistoryConnection';
  /** Array of edges. */
  edges: Array<BuyerAppFileHistoryEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type BuyerAppFileHistoryEdge = {
  __typename?: 'BuyerAppFileHistoryEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppFileHistory */
  node: BuyerAppFileHistory;
};

export type BuyerAppFileHistoryFilter = {
  and?: InputMaybe<Array<BuyerAppFileHistoryFilter>>;
  fileId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppFileHistoryFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppFileHistorySort = {
  direction: SortDirection;
  field: BuyerAppFileHistorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppFileHistorySortFields =
  | 'fileId'
  | 'userUuid';

export type BuyerAppFileHistoryUpsertFields = {
  filePath: Scalars['String']['input'];
  region: Scalars['String']['input'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
};

export type BuyerAppFileHistoryUpsertFilter = {
  fileId: Scalars['String']['input'];
  userUuid: Scalars['String']['input'];
};

export type BuyerAppFileHistoryUpsertInput = {
  filter: BuyerAppFileHistoryUpsertFilter;
  upsert: BuyerAppFileHistoryUpsertFields;
};

export type BuyerAppFileHistoryUpsertOutput = {
  __typename?: 'BuyerAppFileHistoryUpsertOutput';
  created: Scalars['DateTime']['output'];
  fileId: Scalars['String']['output'];
  filePath?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  serviceProvider: Service_Provider;
  status: File_History_Status;
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['String']['output'];
};

export type BuyerAppFundedMarketInfo = {
  /** Name of Funder */
  funderName: Scalars['String']['input'];
  /** Market UUID of Third Party Funded Market */
  marketUuid: Scalars['String']['input'];
};

export type BuyerAppFunderPaymentBaseCurrencyStats = {
  __typename?: 'BuyerAppFunderPaymentBaseCurrencyStats';
  invoiceAmountCurrentOutstanding: Scalars['Float']['output'];
};

export type BuyerAppFunderPaymentClientCurrencyDetails = {
  __typename?: 'BuyerAppFunderPaymentClientCurrencyDetails';
  baseCurrencyInvoiceAmountCurrentOutstanding: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  invoiceAmountCurrentOutstanding: Scalars['Float']['output'];
};

export type BuyerAppFunderPaymentFundersStats = {
  __typename?: 'BuyerAppFunderPaymentFundersStats';
  funderName: Scalars['String']['output'];
  stats: Array<BuyerAppFunderPaymentStatsDetails>;
};

export type BuyerAppFunderPaymentStatsDetails = {
  __typename?: 'BuyerAppFunderPaymentStatsDetails';
  baseCurrencyStats: BuyerAppFunderPaymentBaseCurrencyStats;
  clientCurrencyStats: Array<BuyerAppFunderPaymentClientCurrencyDetails>;
  dueDate: Scalars['String']['output'];
};

export type BuyerAppFunderPaymentStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppFunderPaymentStatsOutput = {
  __typename?: 'BuyerAppFunderPaymentStatsOutput';
  baseCurrency: Scalars['String']['output'];
  funderStats?: Maybe<Array<BuyerAppFunderPaymentFundersStats>>;
};

export type BuyerAppFunderWiseScfTimeframeBoundaries = {
  __typename?: 'BuyerAppFunderWiseScfTimeframeBoundaries';
  fundingPartnerUuid: Scalars['String']['output'];
  /** The end date of the available data */
  maxDate: Scalars['DateTime']['output'];
  /** The start date of the available data */
  minDate: Scalars['DateTime']['output'];
};

export type BuyerAppGetDivisionRolesInput = {
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
};

export type BuyerAppLiveHistoryStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppLiveStatsOutput = {
  __typename?: 'BuyerAppLiveStatsOutput';
  blendedClearingDPE?: Maybe<Scalars['Float']['output']>;
  blendedClearingEarn?: Maybe<Scalars['Float']['output']>;
  blendedClearingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  blendedClearingSupplierCount?: Maybe<Scalars['Float']['output']>;
  blendedClearingYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedDPE?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedSupplierCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppMakerMarketClearHistoryDetails = {
  __typename?: 'BuyerAppMakerMarketClearHistoryDetails';
  baseCurrency: Scalars['String']['output'];
  baseCurrencyClearedEarn: Scalars['Float']['output'];
  baseCurrencyClearedInvoiceAmount: Scalars['Float']['output'];
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId: Scalars['Float']['output'];
  funder: Scalars['String']['output'];
  isAwardFileCreated?: Maybe<Scalars['Boolean']['output']>;
  isCreditNoteEnabled: Scalars['Boolean']['output'];
  marketId: Scalars['Float']['output'];
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  payDate: Scalars['String']['output'];
};

export type BuyerAppMakerMarketClearHistoryInputDto = {
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  isPendingClear: Scalars['Boolean']['input'];
  marketUuids: Array<Scalars['String']['input']>;
  paging: BuyerAppOffsetPaging;
  startDate: Scalars['String']['input'];
};

export type BuyerAppMakerMarketClearHistoryOutputDto = {
  __typename?: 'BuyerAppMakerMarketClearHistoryOutputDto';
  history: Array<BuyerAppMakerMarketClearHistoryDetails>;
  /** total count */
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppManualUploadProcessorHistoryDetails = {
  __typename?: 'BuyerAppManualUploadProcessorHistoryDetails';
  /** created on */
  created: Scalars['String']['output'];
  /** error message */
  errorMessage: Scalars['String']['output'];
  /** file name */
  fileName: Scalars['String']['output'];
  /** id */
  id: Scalars['Float']['output'];
  /** file status */
  status: Scalars['String']['output'];
  /** uploaded on */
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppManualUploadProcessorHistoryInput = {
  divisionUuid: Scalars['String']['input'];
  order: Order_Type;
  paging: BuyerAppOffsetPaging;
};

export type BuyerAppManualUploadProcessorHistoryOutput = {
  __typename?: 'BuyerAppManualUploadProcessorHistoryOutput';
  manualUploadHistory: Array<BuyerAppManualUploadProcessorHistoryDetails>;
  /** total count */
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppMarket = {
  __typename?: 'BuyerAppMarket';
  /** Blended Clearing Earn */
  blendedClearingEarn: Scalars['Float']['output'];
  /** Cash Pool Used */
  cashPoolUsed: Scalars['Float']['output'];
  /** Currency */
  currency: Scalars['String']['output'];
  /** Market ID */
  id: Scalars['Float']['output'];
  /** Market Type */
  marketType?: Maybe<Scalars['String']['output']>;
  /** Market Yield */
  marketYield: Scalars['Float']['output'];
  /** Not Accepted Earn */
  notAcceptedEarn: Scalars['Float']['output'];
  /** Product Type */
  productType?: Maybe<Scalars['String']['output']>;
  /** Market UUID */
  uuid: Scalars['String']['output'];
};

export type BuyerAppMarketSettingsDualAuthorizationOutput = {
  __typename?: 'BuyerAppMarketSettingsDualAuthorizationOutput';
  /** Pending Dual Auth Request for adjustment tolerance update */
  adjustmentTolerance?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for apr update */
  aprSettings?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for cash pool update */
  cashPool?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for cash pool schedule update */
  cashPoolSchedule?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for min income update */
  minimumIncome?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for reserve update */
  reserve?: Maybe<BuyerAppDualAuthorization>;
  /** Pending Dual Auth Request for restriction update */
  restriction?: Maybe<BuyerAppDualAuthorization>;
};

export type BuyerAppMarketTakerConfiguration = {
  __typename?: 'BuyerAppMarketTakerConfiguration';
  minReturnAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppMarketTakerReserveSetting = {
  __typename?: 'BuyerAppMarketTakerReserveSetting';
  allowEslapUpdates?: Maybe<Scalars['Boolean']['output']>;
  invoicePriority?: Maybe<Scalars['String']['output']>;
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  reserveReason?: Maybe<Scalars['String']['output']>;
  runBeforeAdjustments?: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerAppMinEarnSettingsInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Minimum Income from the market */
  minEarn: Scalars['Float']['input'];
};

export type BuyerAppMonthlyCurrencyWiseScfDisclosure = {
  __typename?: 'BuyerAppMonthlyCurrencyWiseScfDisclosure';
  currency: Scalars['String']['output'];
  monthlyDisclosures: Array<BuyerAppMonthlyDisclosures>;
};

export type BuyerAppMonthlyDisclosures = {
  __typename?: 'BuyerAppMonthlyDisclosures';
  endingBalance: Scalars['Float']['output'];
  grossAmountExpedited: Scalars['Float']['output'];
  grossAmountReimbursed: Scalars['Float']['output'];
  period: Scalars['DateTime']['output'];
};

export type BuyerAppMonthlyScfDisclosureFundingPartnerInput = {
  /** Funded in currency */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Funding Partner Uuid */
  fundingPartnerUuid: Scalars['String']['input'];
};

export type BuyerAppMonthlyScfDisclosureInput = {
  /** Division Uuid */
  divisionUuid: Scalars['String']['input'];
  /** end Date */
  endDate: Scalars['String']['input'];
  /** Funding Partner Info */
  fundingPartners: Array<BuyerAppMonthlyScfDisclosureFundingPartnerInput>;
  /** start Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppMonthlyScfDisclosureOutput = {
  __typename?: 'BuyerAppMonthlyScfDisclosureOutput';
  currencyWiseMonthlyDisclosure: Array<BuyerAppMonthlyCurrencyWiseScfDisclosure>;
  fundingPartnerUuid: Scalars['String']['output'];
};

export type BuyerAppNetworkGrowthDetailsOutput = {
  __typename?: 'BuyerAppNetworkGrowthDetailsOutput';
  /** awarded vendors count */
  awardedVendorsCount: Scalars['Float']['output'];
  /** loaded vendors count */
  loadedVendorsCount: Scalars['Float']['output'];
  /** participated vendors count */
  participatedVendorsCount: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** registered vendors count */
  registeredVendorsCount: Scalars['Float']['output'];
};

export type BuyerAppNonClearingTopOffers = {
  __typename?: 'BuyerAppNonClearingTopOffers';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyNotAcceptedEarn: Scalars['Float']['output'];
  baseCurrencyNotAcceptedInvoiceAmount: Scalars['Float']['output'];
  displayCurrency: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppNonClearingTopOffersInput = {
  filters: BuyerAppTopOffersFilters;
  paging: BuyerAppCursorPaging;
  sorting: BuyerAppNonClearingTopOffersSorting;
};

export type BuyerAppNonClearingTopOffersOutput = {
  __typename?: 'BuyerAppNonClearingTopOffersOutput';
  offers: Array<BuyerAppNonClearingTopOffers>;
  pageInfo: BuyerAppCursorPagingInfo;
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppNonClearingTopOffersSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Non_Clearing_Top_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppOffsetPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type BuyerAppParticipationBreakdownDetailsOutput = {
  __typename?: 'BuyerAppParticipationBreakdownDetailsOutput';
  /** new participants count */
  newParticipantsCount: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** repeat participants count */
  repeatParticipantsCount: Scalars['Float']['output'];
};

export type BuyerAppPerformanceByCurrencyData = {
  __typename?: 'BuyerAppPerformanceByCurrencyData';
  awardedAp?: Maybe<Scalars['Float']['output']>;
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  loadedAp?: Maybe<Scalars['Float']['output']>;
  participatedAp?: Maybe<Scalars['Float']['output']>;
  participationRate?: Maybe<Scalars['Float']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppPerformanceByCurrencyDataInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppPerformanceByCurrencyDataOutput = {
  __typename?: 'BuyerAppPerformanceByCurrencyDataOutput';
  all?: Maybe<BuyerAppPerformanceByCurrencyData>;
  currency: Scalars['String']['output'];
  self?: Maybe<BuyerAppPerformanceByCurrencyData>;
  thirdParty?: Maybe<BuyerAppPerformanceByCurrencyData>;
};

export type BuyerAppPerformanceByCurrencyStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Self Markets Uuids */
  selfMarkets: Array<Scalars['String']['input']>;
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAppPerformanceByCurrencyStatsOutput = {
  __typename?: 'BuyerAppPerformanceByCurrencyStatsOutput';
  awardedAp?: Maybe<Scalars['Float']['output']>;
  awardedRate?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  income?: Maybe<Scalars['Float']['output']>;
  loadedAp?: Maybe<Scalars['Float']['output']>;
  participatedAp?: Maybe<Scalars['Float']['output']>;
  participationRate?: Maybe<Scalars['Float']['output']>;
  yield?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppRepeatVsNewLoadedApOutput = {
  __typename?: 'BuyerAppRepeatVSNewLoadedApOutput';
  /** Newly Loaded AP */
  newlyLoadedAp: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Repeat Loaded AP */
  repeatLoadedAp: Scalars['Float']['output'];
};

export type BuyerAppRepeatVsNewIncomeOutput = {
  __typename?: 'BuyerAppRepeatVsNewIncomeOutput';
  /** New Participants Income */
  newParticipantsIncome: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Repeat Participants Income */
  repeatParticipantsIncome: Scalars['Float']['output'];
};

export type BuyerAppRestrictionInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Restriction object */
  restriction: BuyerAppRestrictions;
};

export type BuyerAppRestrictions = {
  /** Max DPE value */
  maxDPE?: InputMaybe<Scalars['Float']['input']>;
  /** Max due Date */
  maxDueDate?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppRevShareGraphInput = {
  displayCurrency?: Scalars['String']['input'];
  /** End Pay Date */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Funded Markets Uuids */
  fundedMarkets: Array<Scalars['String']['input']>;
  /** Starting Pay Date */
  startDate: Scalars['String']['input'];
  timePeriod?: Time_Periods;
};

export type BuyerAppRevShareOutput = {
  __typename?: 'BuyerAppRevShareOutput';
  currency: Scalars['String']['output'];
  /** Name of the funder */
  funderName: Scalars['String']['output'];
  /** Funder's UUID */
  funderUuid: Scalars['String']['output'];
  payDate: Scalars['String']['output'];
  /** The buyer's region */
  region: Scalars['String']['output'];
  /** The revenue share amount */
  revShareAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppRole = {
  __typename?: 'BuyerAppRole';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Role Name */
  name: Scalars['String']['output'];
  /** Readable Role Name To Display */
  readableName: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerAppRoleConnection = {
  __typename?: 'BuyerAppRoleConnection';
  /** Array of edges. */
  edges: Array<BuyerAppRoleEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type BuyerAppRoleEdge = {
  __typename?: 'BuyerAppRoleEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerAppRole */
  node: BuyerAppRole;
};

export type BuyerAppRoleFilter = {
  and?: InputMaybe<Array<BuyerAppRoleFilter>>;
  id?: InputMaybe<IdFilterComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<BuyerAppRoleFilter>>;
  readableName?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppRoleSort = {
  direction: SortDirection;
  field: BuyerAppRoleSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppRoleSortFields =
  | 'id'
  | 'name'
  | 'readableName';

export type BuyerAppScfDisclosureTimeframeBoundariesInput = {
  /** Division Uuids */
  divisionUuids: Array<Scalars['String']['input']>;
};

export type BuyerAppScfDisclosureTimeframeBoundariesOutput = {
  __typename?: 'BuyerAppScfDisclosureTimeframeBoundariesOutput';
  divisionUuid: Scalars['String']['output'];
  funderWiseTimeframeBoundaries: Array<BuyerAppFunderWiseScfTimeframeBoundaries>;
};

export type BuyerAppSubprocessorsSubscription = {
  __typename?: 'BuyerAppSubprocessorsSubscription';
  /** created */
  created: Scalars['DateTime']['output'];
  /** Email Address */
  emailAddress: Scalars['String']['output'];
  /** Entity Name */
  entityName: Scalars['String']['output'];
  /** id */
  id: Scalars['Float']['output'];
  /** Subscription status */
  isActive: Scalars['Boolean']['output'];
  /** Organization Uuid */
  organizationUuid: Scalars['String']['output'];
  /** Role at Entity */
  role: Scalars['String']['output'];
  /** Subscribed By */
  subscribedBy: Scalars['String']['output'];
  /** updated */
  updated: Scalars['DateTime']['output'];
};

export type BuyerAppSubprocessorsSubscriptionFilter = {
  and?: InputMaybe<Array<BuyerAppSubprocessorsSubscriptionFilter>>;
  id?: InputMaybe<NumberFieldComparison>;
  isActive?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<BuyerAppSubprocessorsSubscriptionFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
  subscribedBy?: InputMaybe<StringFieldComparison>;
};

export type BuyerAppSubprocessorsSubscriptionSort = {
  direction: SortDirection;
  field: BuyerAppSubprocessorsSubscriptionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type BuyerAppSubprocessorsSubscriptionSortFields =
  | 'id'
  | 'isActive'
  | 'organizationUuid'
  | 'subscribedBy';

export type BuyerAppSupplierAdjustedInvoices = {
  __typename?: 'BuyerAppSupplierAdjustedInvoices';
  adjInvoiceId?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  /** The status of the adjusted invoice */
  status: Adjustment_Status;
  voucherId: Scalars['String']['output'];
};

export type BuyerAppSupplierAdjustmentsFilters = {
  /** Buyer's Market UUID */
  marketUuid: Scalars['String']['input'];
  /** The status of the adjusted invoice */
  status?: Adjustment_Status;
  /** Supplier UUID */
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierAdjustmentsInput = {
  filters: BuyerAppSupplierAdjustmentsFilters;
  paging: BuyerAppOffsetPaging;
  sorting?: InputMaybe<BuyerAppSupplierAdjustmentsSorting>;
};

export type BuyerAppSupplierAdjustmentsOutput = {
  __typename?: 'BuyerAppSupplierAdjustmentsOutput';
  adjustedInvoices: Array<BuyerAppSupplierAdjustedInvoices>;
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSupplierAdjustmentsSorting = {
  orderLevel: Supplier_Adjustments_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppSupplierClearHistoryInput = {
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  marketUuid: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
  timePeriod?: Scalars['String']['input'];
};

export type BuyerAppSupplierClearHistoryOutput = {
  __typename?: 'BuyerAppSupplierClearHistoryOutput';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSupplierDetailsInput = {
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierDetailsOutput = {
  __typename?: 'BuyerAppSupplierDetailsOutput';
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  isParticipating?: Maybe<Scalars['Boolean']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSupplierInvoices = {
  __typename?: 'BuyerAppSupplierInvoices';
  adjustmentAmount?: Maybe<Scalars['Float']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  /** Yield on the invoice */
  blendedReturnAmount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['DateTime']['output'];
  earn?: Maybe<Scalars['Float']['output']>;
  /** Invoice Id */
  id: Scalars['Float']['output'];
  isPastDue: Scalars['Boolean']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  makerExcluded: Scalars['Boolean']['output'];
  minDiscount?: Maybe<Scalars['Float']['output']>;
  originalAmount?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  /** The status of the invoice */
  status: Scalars['String']['output'];
  voucherId: Scalars['String']['output'];
};

export type BuyerAppSupplierInvoicesFilters = {
  /** The status of the invoice */
  invoiceType: Invoice_Type;
  /** Is the market third party funded? */
  isFundedMarket?: Scalars['Boolean']['input'];
  /** Buyer's Market UUID */
  marketUuid: Scalars['String']['input'];
  /** Invoice ID search string */
  search?: InputMaybe<Scalars['String']['input']>;
  /** The status of the invoice */
  status: Scalars['String']['input'];
  /** Supplier UUID */
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierInvoicesInput = {
  filters: BuyerAppSupplierInvoicesFilters;
  paging: BuyerAppOffsetPaging;
  sorting?: InputMaybe<BuyerAppSupplierInvoicesSorting>;
};

export type BuyerAppSupplierInvoicesOutput = {
  __typename?: 'BuyerAppSupplierInvoicesOutput';
  invoices: Array<BuyerAppSupplierInvoices>;
  makerUuid: Scalars['String']['output'];
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSupplierInvoicesSorting = {
  orderLevel: Supplier_Invoices_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppSupplierOffer = {
  __typename?: 'BuyerAppSupplierOffer';
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  audit: BuyerAppSupplierOfferAudit;
  config: BuyerAppSupplierOfferConfig;
  currency: Scalars['String']['output'];
  divisionUuid: Scalars['String']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  isParticipating: Scalars['Boolean']['output'];
  lastClearDate?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  notAcceptedAboveMinDiscountedAmount: Scalars['Float']['output'];
  notAcceptedAboveMinEarn: Scalars['Float']['output'];
  notAcceptedAboveMinInvoiceAmount: Scalars['Float']['output'];
  notAcceptedAprWeightedAvg: Scalars['Float']['output'];
  notAcceptedDpeWeightedAvg: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
  orgUuid: Scalars['String']['output'];
  reserve: BuyerAppSupplierOfferReserve;
  takerDivisionName: Scalars['String']['output'];
  takerMakerId: Scalars['String']['output'];
  takerOrganizationName: Scalars['String']['output'];
  takerUuid: Scalars['String']['output'];
};

export type BuyerAppSupplierOfferAudit = {
  __typename?: 'BuyerAppSupplierOfferAudit';
  adjustmentInvoiceAmount: Scalars['Float']['output'];
  coveringAdjustmentAmount: Scalars['Float']['output'];
  reservedAmount: Scalars['Float']['output'];
  totalAp?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierOfferConfig = {
  __typename?: 'BuyerAppSupplierOfferConfig';
  minReturnAmount?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierOfferReserve = {
  __typename?: 'BuyerAppSupplierOfferReserve';
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
};

export type BuyerAppSupplierPerformanceReportInput = {
  /** market uuids */
  marketUuids: Array<Scalars['String']['input']>;
  /** display currency */
  periods: Array<BuyerAppYoyReportPeriod>;
};

export type BuyerAppSupplierPerformanceReportOutput = {
  __typename?: 'BuyerAppSupplierPerformanceReportOutput';
  /** Awarded Vendors */
  awardedSuppliers?: Maybe<Scalars['Float']['output']>;
  /** Loaded Vendors */
  eligibleSuppliers: Scalars['Float']['output'];
  /** Newly Loaded Vendors */
  newlyLoadedSuppliers: Scalars['Float']['output'];
  /** Newly Participated Vendors */
  newlyParticipatedSuppliers: Scalars['Float']['output'];
  /** Participated Vendors */
  participatedSuppliers: Scalars['Float']['output'];
  /** period */
  period: Scalars['DateTime']['output'];
  /** Registered Suppliers */
  registeredSuppliers: Scalars['Float']['output'];
  /** Total Loaded Vendors */
  totalLoadedSuppliers: Scalars['Float']['output'];
};

export type BuyerAppSupplierSettingsInput = {
  /** Market Uuid of the Buyer */
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppSupplierSettingsOutput = {
  __typename?: 'BuyerAppSupplierSettingsOutput';
  config: BuyerAppMarketTakerConfiguration;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  reserve: BuyerAppMarketTakerReserveSetting;
};

export type BuyerAppSupplierStatsInput = {
  displayCurrency?: Scalars['String']['input'];
  marketUuids?: Array<Scalars['String']['input']>;
};

export type BuyerAppSupplierStatsOutput = {
  __typename?: 'BuyerAppSupplierStatsOutput';
  clearingAp?: Maybe<Scalars['Float']['output']>;
  clearingSuppliersCount: Scalars['Int']['output'];
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  eligibleSuppliersCount: Scalars['Int']['output'];
  nonClearingAp?: Maybe<Scalars['Float']['output']>;
  nonClearingSuppliersCount: Scalars['Int']['output'];
  overallTotal: Scalars['Int']['output'];
  overallWithAp: Scalars['Int']['output'];
  overallWithoutAp: Scalars['Int']['output'];
  participatingAp?: Maybe<Scalars['Float']['output']>;
  participatingSuppliersCount: Scalars['Int']['output'];
  participatingTotal: Scalars['Int']['output'];
  participatingWithAp: Scalars['Int']['output'];
  participatingWithoutAp: Scalars['Int']['output'];
  registeredTotal: Scalars['Int']['output'];
  registeredWithAp: Scalars['Int']['output'];
  registeredWithoutAp: Scalars['Int']['output'];
};

export type BuyerAppSuppliersOffersFilters = {
  advancedFilters: Array<Suppliers_Offers_Advanced_Filter>;
  displayCurrency?: Scalars['String']['input'];
  fundedMarkets: Array<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppSuppliersOffersInput = {
  filters: BuyerAppSuppliersOffersFilters;
  paging: BuyerAppSuppliersOffersPaging;
  sorting: BuyerAppSuppliersOffersSorting;
};

export type BuyerAppSuppliersOffersOutput = {
  __typename?: 'BuyerAppSuppliersOffersOutput';
  offers: Array<BuyerAppSupplierOffer>;
  pageInfo: BuyerAppSuppliersOffersPageInfo;
  totalCount: Scalars['Float']['output'];
};

export type BuyerAppSuppliersOffersPageInfo = {
  __typename?: 'BuyerAppSuppliersOffersPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppSuppliersOffersPaging = {
  end?: InputMaybe<Scalars['String']['input']>;
  pageSize?: Scalars['Float']['input'];
  start?: InputMaybe<Scalars['String']['input']>;
};

export type BuyerAppSuppliersOffersSorting = {
  orderLevel?: Suppliers_Offers_Order_Level;
  orderType?: Order_Type;
};

export type BuyerAppTopOffersFilters = {
  displayCurrency?: Scalars['String']['input'];
  /** Funded Markets Information */
  fundedMarkets: Array<BuyerAppFundedMarketInfo>;
  /** The market UUIDs of self funded markets */
  selfMarkets: Array<Scalars['String']['input']>;
};

export type BuyerAppTriggerManualAwardInput = {
  awardWithCashPool: Scalars['Boolean']['input'];
  divisionUuid: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppTriggerManualAwardOutput = {
  __typename?: 'BuyerAppTriggerManualAwardOutput';
  isAwarded: Scalars['Boolean']['output'];
};

export type BuyerAppUpdateMarketTakerReserveInput = {
  allowEslapUpdates: Scalars['Boolean']['input'];
  divisionUuid: Scalars['String']['input'];
  invoicePriority: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  reserveAmount?: InputMaybe<Scalars['Float']['input']>;
  reservePercentage?: InputMaybe<Scalars['Float']['input']>;
  reserveReason?: InputMaybe<Scalars['String']['input']>;
  runBeforeAdjustments: Scalars['Boolean']['input'];
  takerUuid: Scalars['String']['input'];
};

export type BuyerAppUpdateMarketTakerReserveOutput = {
  __typename?: 'BuyerAppUpdateMarketTakerReserveOutput';
  allowEslapUpdates: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoicePriority: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  publishMessages: Scalars['Boolean']['output'];
  reserveAmount?: Maybe<Scalars['Float']['output']>;
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  reserveReason?: Maybe<Scalars['String']['output']>;
  runBeforeAdjustments: Scalars['Boolean']['output'];
  takerId: Scalars['Int']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BuyerAppUpsertDivisionRolesInput = {
  /** Division uuid */
  divisionUuid: Scalars['String']['input'];
  /** Is the income to be displayed? */
  showIncome?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is the yield to be displayed? */
  showYield?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BuyerAppUserFiltersOutput = {
  __typename?: 'BuyerAppUserFiltersOutput';
  /** Division ID */
  divisionId: Scalars['Float']['output'];
  /** Division Name */
  divisionName: Scalars['String']['output'];
  /** Division UUID */
  divisionUuid: Scalars['String']['output'];
  /** Whether the division has COGS market */
  isDivisionHasCogsMarket: Scalars['Boolean']['output'];
  /** Maker Organization Name */
  makerOrganizationName: Scalars['String']['output'];
  /** Maker Organization UUID */
  makerOrganizationUuid: Scalars['String']['output'];
  /** List of markets */
  markets: Array<BuyerAppMarket>;
  /** Whether the income is to be shown */
  showIncome?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the revenue share is to be shown */
  showRevShare: Scalars['Boolean']['output'];
  /** Whether the yield is to be shown */
  showYield?: Maybe<Scalars['Boolean']['output']>;
};

export type BuyerAppUserPreference = {
  __typename?: 'BuyerAppUserPreference';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** User preference settings */
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type BuyerAppYoyReportPeriod = {
  /** End Date */
  endDate: Scalars['String']['input'];
  /** Starting Date */
  startDate: Scalars['String']['input'];
};

export type BuyerAuditConfigDefaultResponse = {
  __typename?: 'BuyerAuditConfigDefaultResponse';
  message: Scalars['String']['output'];
};

export type BuyerAuditConfigDto = {
  auditFileCount: Scalars['Float']['input'];
  effectiveTillDate: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};

export type BuyerAuditConfigType =
  | 'dynamic'
  | 'static';

export type BuyerDivisionDetails = {
  __typename?: 'BuyerDivisionDetails';
  divisionUuid?: Maybe<Scalars['String']['output']>;
  executiveContactName?: Maybe<Scalars['String']['output']>;
  executiveContactTitle?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type BuyerFileConfigs = {
  /** Benchmark strategy configuration */
  benchmarkStrategyConfig: BenchmarkStrategyInput;
  /** Economic value */
  economicValueConfig: Scalars['Float']['input'];
  /** Supplier segmentation rules */
  supplierSegmentationConfig: SegmentationRules;
};

export type BuyerInfoDetailsResponse = {
  __typename?: 'BuyerInfoDetailsResponse';
  active?: Maybe<Scalars['Boolean']['output']>;
  buyerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  buyerMarketingAssetsAllowed?: Maybe<Scalars['Boolean']['output']>;
  divisions?: Maybe<Array<BuyerDivisionDetails>>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  marketingAllowed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type BuyerInfoResponse = {
  __typename?: 'BuyerInfoResponse';
  next?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<BuyerInfoDetailsResponse>>;
};

export type BuyerReportingCurrencies = {
  __typename?: 'BuyerReportingCurrencies';
  created: Scalars['DateTime']['output'];
  /** Custom currency configured for the buyer */
  currency: Scalars['String']['output'];
  /** Organization Name */
  organizationName: Scalars['String']['output'];
  /** Organization UUID */
  organizationUuid: Scalars['String']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type BuyerReportingCurrenciesDeleteFilter = {
  and?: InputMaybe<Array<BuyerReportingCurrenciesDeleteFilter>>;
  currency: StringFieldComparison;
  or?: InputMaybe<Array<BuyerReportingCurrenciesDeleteFilter>>;
  organizationUuid: StringFieldComparison;
};

export type BuyerReportingCurrenciesEdge = {
  __typename?: 'BuyerReportingCurrenciesEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the BuyerReportingCurrencies */
  node: BuyerReportingCurrencies;
};

export type BuyerReportingCurrenciesInput = {
  /** Organization UUID */
  organizationUuid: Scalars['String']['input'];
};

export type BuyerReportingCurrenciesOutput = {
  __typename?: 'BuyerReportingCurrenciesOutput';
  /** Custom currencies configured for the buyer */
  currencies: Array<Scalars['String']['output']>;
};

export type BuyerTotals = {
  __typename?: 'BuyerTotals';
  /** Total invoice amount */
  available_ar?: Maybe<Scalars['Float']['output']>;
  /** Average days outstanding */
  dso?: Maybe<Scalars['Float']['output']>;
  /** Estimated early payment amount */
  early_payment_amount?: Maybe<Scalars['Float']['output']>;
  /** Last week's average rate */
  last_week_weighted_avg_apr?: Maybe<Scalars['Float']['output']>;
};

export type ByMakerOrgCustomGroupUuid = {
  __typename?: 'ByMakerOrgCustomGroupUuid';
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  /** The customGroupUuid used to group this collection of opportunities */
  customGroupUuid?: Maybe<Scalars['String']['output']>;
  /** The method in which the opportunities were grouped by. Will always be MAKER_ORG_CUSTOM_GROUP_UUID */
  groupByType: OpportunityGroupByType;
  /** The makerOrganizationUuid used to group this collection of opportunities */
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
};

export type C2FoUser = {
  __typename?: 'C2FOUser';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  nodeId: Scalars['ID']['output'];
};

export type C2foColumnMaster = {
  __typename?: 'C2foColumnMaster';
  columnName: Scalars['String']['output'];
  dataType: Scalars['String']['output'];
  source: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type C2foColumnMasterConnection = {
  __typename?: 'C2foColumnMasterConnection';
  /** Array of nodes. */
  nodes: Array<C2foColumnMaster>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type C2foColumnMasterFilter = {
  and?: InputMaybe<Array<C2foColumnMasterFilter>>;
  or?: InputMaybe<Array<C2foColumnMasterFilter>>;
  source?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type C2foColumnMasterSort = {
  direction: SortDirection;
  field: C2foColumnMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type C2foColumnMasterSortFields =
  | 'source'
  | 'uuid';

export type Clearing_Top_Offers_Order_Level =
  | 'ACCEPTED_DPE_WEIGHTED_AVG'
  | 'ACCEPTED_EARN'
  | 'ACCEPTED_INVOICE_AMOUNT'
  | 'ACCEPTED_YIELD'
  | 'ELIGIBLE_INVOICE_AMOUNT';

export type CampaignInput = {
  isDebugMode?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  srmHomeSegmentId: Scalars['String']['input'];
  srmHomeUserUuid: Scalars['String']['input'];
};

export type CampaignType =
  | 'NEW_PARTICIPATION'
  | 'NON_REGISTERED_USER'
  | 'REPEAT_PARTICIPATION'
  | 'UNKNOWN_PARTICIPATION';

export type CampaignTypeFilterComparison = {
  eq?: InputMaybe<CampaignType>;
  gt?: InputMaybe<CampaignType>;
  gte?: InputMaybe<CampaignType>;
  iLike?: InputMaybe<CampaignType>;
  in?: InputMaybe<Array<CampaignType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<CampaignType>;
  lt?: InputMaybe<CampaignType>;
  lte?: InputMaybe<CampaignType>;
  neq?: InputMaybe<CampaignType>;
  notILike?: InputMaybe<CampaignType>;
  notIn?: InputMaybe<Array<CampaignType>>;
  notLike?: InputMaybe<CampaignType>;
};

/** Amounts and IDs for the associated takers markets data. */
export type CashFlowPlusStats = {
  __typename?: 'CashFlowPlusStats';
  /** Amounts and IDs for the associated takers markets data. */
  attributes: Attributes;
};

export type CashInvested = {
  __typename?: 'CashInvested';
  investmentDate?: Maybe<Scalars['DateTime']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  normalizedCashInvested?: Maybe<Scalars['Float']['output']>;
};

export type CashInvestedGroupByInput = {
  aggregationLevel?: InputMaybe<AggregationLevel>;
  timePeriod?: GroupByTimePeriod;
};

export type CashInvestedInput = {
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy: CashInvestedGroupByInput;
  makerOrganizationUuids?: Array<Scalars['String']['input']>;
  makerUuids?: Array<Scalars['String']['input']>;
  marketUuids?: Array<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<TimeRange>;
};

export type CashPoolScheduleOutput = {
  __typename?: 'CashPoolScheduleOutput';
  /** Cash Pool amount to be replenished  */
  cashPool?: Maybe<Scalars['Float']['output']>;
  /** Recurring replenishment rule */
  rrule?: Maybe<Scalars['String']['output']>;
  /** Cash Pool Replenishment Schedule Uuid */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CashPoolSettingsOutput = {
  __typename?: 'CashPoolSettingsOutput';
  /** Market APR */
  apr?: Maybe<Scalars['Float']['output']>;
  /** Cash Available for the market */
  cashPool?: Maybe<Scalars['Float']['output']>;
  /** Cash pool limit */
  cashPoolLimit?: Maybe<Scalars['Float']['output']>;
  /** Outstanding cash pool amount */
  cashPoolOutstanding?: Maybe<Scalars['Float']['output']>;
  /** Cash pool management strategy */
  managementStrategy?: Maybe<Scalars['String']['output']>;
  /** Minimum APR from the market */
  minApr?: Maybe<Scalars['Float']['output']>;
  /** Minimum Income from the market */
  minEarn?: Maybe<Scalars['Float']['output']>;
};

export type CashPoolSettingsUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | CashPoolSettingsOutput;

export type CashUsed = {
  __typename?: 'CashUsed';
  normalizedCashUsed?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CashUsedInput = {
  aggregationLevel: AggregationLevel;
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  groupBy?: GroupByTimePeriod;
  startDate?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<TimeRange>;
  uuids?: Array<Scalars['String']['input']>;
};

export type CashflowCardsData = {
  __typename?: 'CashflowCardsData';
  makerDisplayName: Scalars['String']['output'];
  rateType: ActivationMarketRateType;
  totalAR: Scalars['Float']['output'];
};

export type CashflowData = {
  __typename?: 'CashflowData';
  avgDaysPayEarly?: Maybe<Scalars['Float']['output']>;
  makerDisplayName: Scalars['String']['output'];
  maxLastWeekAcceptanceRate?: Maybe<Scalars['Float']['output']>;
  minLastWeekAcceptanceRate?: Maybe<Scalars['Float']['output']>;
  newPayDate?: Maybe<Scalars['String']['output']>;
  requestDeadline?: Maybe<Scalars['String']['output']>;
  totalAR: Scalars['Float']['output'];
};

export type CashflowInfoInput = {
  lastWeekAcceptanceRateType?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  sortedField?: InputMaybe<Scalars['String']['input']>;
};

export type CashflowInfoResponse = {
  __typename?: 'CashflowInfoResponse';
  cashflowCardsData?: Maybe<Array<CashflowCardsData>>;
  cashflowData?: Maybe<Array<CashflowData>>;
  count?: Maybe<Scalars['Int']['output']>;
  highestAPCustomerCurrency?: Maybe<Scalars['String']['output']>;
  highestAPCustomerUuid?: Maybe<Scalars['String']['output']>;
  recentMaxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  totalAmountAR?: Maybe<Scalars['Float']['output']>;
};

export type CashflowPlusStatsDiscountsAndRebatesDto = {
  __typename?: 'CashflowPlusStatsDiscountsAndRebatesDto';
  depositAmount: Scalars['Float']['output'];
  fullAmount: Scalars['Float']['output'];
  makerOrgUuid: Scalars['String']['output'];
  marketId: Scalars['Float']['output'];
  opportunityUuid: Scalars['String']['output'];
  rebateAmount: Scalars['Float']['output'];
  rewardAmount?: Maybe<Scalars['Float']['output']>;
  takerId: Scalars['Float']['output'];
};

/** Opportunities for cashflow plus stats */
export type CashflowPlusStatsDto = {
  __typename?: 'CashflowPlusStatsDto';
  authServiceUuid: Scalars['String']['output'];
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerOrgUuid: Scalars['String']['output'];
  opportunityUuid: Scalars['String']['output'];
  takersMarkets: Array<CashflowPlusStatsOpportunitiesTakersMarketsDto>;
};

export type CashflowPlusStatsInputBodyDto = {
  authServiceUuid: Scalars['String']['input'];
  opportunities: Array<CashflowPlusStatsInputDto>;
};

export type CashflowPlusStatsInputDto = {
  authServiceUuid: Scalars['String']['input'];
  eligibleDpeWeightedSum?: InputMaybe<Scalars['Float']['input']>;
  eligibleInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  makerOrgUuid: Scalars['String']['input'];
  opportunityUuid: Scalars['String']['input'];
  takersMarkets: Array<CashflowPlusStatsOpportunitiesTakersMarketsInputDto>;
};

/** Opportunities for cashflow plus stats */
export type CashflowPlusStatsOpportunitiesTakersMarketsDto = {
  __typename?: 'CashflowPlusStatsOpportunitiesTakersMarketsDto';
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  marketId: Scalars['Float']['output'];
  takerId: Scalars['Float']['output'];
};

export type CashflowPlusStatsOpportunitiesTakersMarketsInputDto = {
  eligibleDpeWeightedSum?: InputMaybe<Scalars['Float']['input']>;
  eligibleInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  marketId: Scalars['Float']['input'];
  takerId: Scalars['Float']['input'];
};

export type CashflowPlusStatsOpportunityInputDto = {
  __typename?: 'CashflowPlusStatsOpportunityInputDto';
  authServiceUuid: Scalars['String']['output'];
  opportunities: Array<CashflowPlusStatsDto>;
};

export type CashflowPlusStatsOpportunityInputDtoAggregateFilter = {
  and?: InputMaybe<Array<CashflowPlusStatsOpportunityInputDtoAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CashflowPlusStatsOpportunityInputDtoAggregateFilter>>;
};

export type CashflowPlusStatsOpportunityInputDtoAggregateGroupBy = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type CashflowPlusStatsOpportunityInputDtoAggregateResponse = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoAggregateResponse';
  count?: Maybe<CashflowPlusStatsOpportunityInputDtoCountAggregate>;
  groupBy?: Maybe<CashflowPlusStatsOpportunityInputDtoAggregateGroupBy>;
  max?: Maybe<CashflowPlusStatsOpportunityInputDtoMaxAggregate>;
  min?: Maybe<CashflowPlusStatsOpportunityInputDtoMinAggregate>;
};

export type CashflowPlusStatsOpportunityInputDtoCountAggregate = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
};

export type CashflowPlusStatsOpportunityInputDtoEdge = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CashflowPlusStatsOpportunityInputDto */
  node: CashflowPlusStatsOpportunityInputDto;
};

export type CashflowPlusStatsOpportunityInputDtoMaxAggregate = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type CashflowPlusStatsOpportunityInputDtoMinAggregate = {
  __typename?: 'CashflowPlusStatsOpportunityInputDtoMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type CashflowPlusStatsResponseDto = {
  __typename?: 'CashflowPlusStatsResponseDto';
  discountsAndRebates: Array<CashflowPlusStatsDiscountsAndRebatesDto>;
};

export type ChannelType =
  | 'EMAIL'
  | 'SMS'
  | 'WHATSAPP';

/** Audit action for cleanup non-paid buyer mappings operation */
export type CleanupNonPaidMappingsAuditAction =
  | 'WCM_OTHER_NON_PAID_USERS_MAPPINGS_DELETED_BECAUSE_OF_FIRST_ENRICHED_FILE_UPLOAD';

export type CleanupOtherWcmNonPaidMappingsForBuyerUsersInput = {
  /** UUID of the actor user performing the cleanup */
  actorUserUuid: Scalars['String']['input'];
  /** Audit action for the cleanup operation */
  auditAction: CleanupNonPaidMappingsAuditAction;
  /** If true, validates that the provided buyer is a Trial buyer before performing cleanup. Skips cleanup if buyer is not Trial type. */
  cleanupOnlyIfProvidedBuyerIsTrial?: InputMaybe<Scalars['Boolean']['input']>;
  /** UUID of the buyer to clean up other non-paid mappings for */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput = {
  __typename?: 'CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput';
  /** Number of other non-paid buyer mappings deleted for non-C2FO users associated with the given buyer */
  deletedCount: Scalars['Int']['output'];
  /** UUIDs of the users affected */
  userUuids: Array<Scalars['String']['output']>;
};

export type ClearingStatsInput = {
  makerUuids?: Array<Scalars['String']['input']>;
  marketUuids?: Array<Scalars['String']['input']>;
  orgUuids?: Array<Scalars['String']['input']>;
};

export type ClearingStatsOutput = {
  __typename?: 'ClearingStatsOutput';
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedCompanies: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedTakersCount: Scalars['Float']['output'];
  notAcceptedWeightedYield: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  weightedClearedYield: Scalars['Float']['output'];
};

/**
 * A Communication channel contains information about a type of communication preference for a user.
 * It contains information on the communication medium and how often it can be used for communication.
 * The backing data source is the ODS API.
 */
export type CommunicationChannel = {
  __typename?: 'CommunicationChannel';
  channel: Scalars['String']['output'];
  communicationPreference: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
  frequencyValue?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type CommunicationChannelConnection = {
  __typename?: 'CommunicationChannelConnection';
  /** Array of nodes. */
  nodes: Array<CommunicationChannel>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type CommunicationChannelEnum =
  | 'EMAIL'
  | 'SMS'
  | 'WHATSAPP';

export type CommunicationChannelFilter = {
  and?: InputMaybe<Array<CommunicationChannelFilter>>;
  channel?: InputMaybe<StringFieldComparison>;
  communicationPreference?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CommunicationChannelFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type CommunicationChannelSort = {
  direction: SortDirection;
  field: CommunicationChannelSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CommunicationChannelSortFields =
  | 'channel'
  | 'communicationPreference'
  | 'uuid';

export type CommunicationChannelUpdateFilter = {
  and?: InputMaybe<Array<CommunicationChannelUpdateFilter>>;
  channel?: InputMaybe<StringFieldComparison>;
  communicationPreference?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CommunicationChannelUpdateFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

/**
 * Communication Preference is an object from the ODS API containing information
 * about a user's settings regarding communication, including the channels for communication,
 * (such as email, sms, whatsapp) and how frequently they prefer to be contacted. The backing
 * data source is the ODS API.
 */
export type CommunicationPreference = {
  __typename?: 'CommunicationPreference';
  authServiceUuid: Scalars['String']['output'];
  channels: Array<CommunicationChannel>;
  communicationType: CommunicationPreferenceType;
  notificationKey: Scalars['String']['output'];
  notificationValue: Scalars['JSON']['output'];
  uuid: Scalars['String']['output'];
};


/**
 * Communication Preference is an object from the ODS API containing information
 * about a user's settings regarding communication, including the channels for communication,
 * (such as email, sms, whatsapp) and how frequently they prefer to be contacted. The backing
 * data source is the ODS API.
 */
export type CommunicationPreferenceChannelsArgs = {
  filter?: CommunicationChannelFilter;
  sorting?: Array<CommunicationChannelSort>;
};

export type CommunicationPreferenceFilter = {
  and?: InputMaybe<Array<CommunicationPreferenceFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  notificationKey?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CommunicationPreferenceFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type CommunicationPreferenceFrequency =
  | 'BIANNUAL'
  | 'BIWEEKLY'
  | 'DAILY'
  | 'MONTHLY'
  | 'NEVER'
  | 'QUARTERLY'
  | 'WEEKLY'
  | 'YEARLY';

export type CommunicationPreferenceSort = {
  direction: SortDirection;
  field: CommunicationPreferenceSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CommunicationPreferenceSortFields =
  | 'authServiceUuid'
  | 'notificationKey'
  | 'uuid';

export type CommunicationPreferenceType =
  | 'ALWAYS'
  | 'MARKETING'
  | 'TRANSACTIONAL';

export type CommunicationPreferenceUpdateFilter = {
  and?: InputMaybe<Array<CommunicationPreferenceUpdateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  notificationKey?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CommunicationPreferenceUpdateFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type CompanyGroup = {
  __typename?: 'CompanyGroup';
  companyGroupName: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  epCompanyGroupUuid?: Maybe<Scalars['String']['output']>;
  programUuid: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyGroupFilter = {
  and?: InputMaybe<Array<CompanyGroupFilter>>;
  or?: InputMaybe<Array<CompanyGroupFilter>>;
  programUuid: StringFieldComparison;
};

export type CompanyGroupInput = {
  companyGroupUuid: Scalars['String']['input'];
  isDsf: Scalars['Boolean']['input'];
};

export type CompanyGroupSort = {
  direction: SortDirection;
  field: CompanyGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CompanyGroupSortFields =
  | 'programUuid';

export type CompanyIdGroupOutputResponse = {
  __typename?: 'CompanyIdGroupOutputResponse';
  message: Scalars['String']['output'];
};

export type CompanyIdUpload = {
  __typename?: 'CompanyIdUpload';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  makerDataCenter: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  processed: Scalars['Boolean']['output'];
  programUuid: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  naics?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CompanyIntersectionSortField =
  | 'COMPANY_GROUP'
  | 'COMPANY_ID'
  | 'CURRENCY'
  | 'LOCATION'
  | 'SUPPLIER_NAME';

export type ContentfulOutput = {
  __typename?: 'ContentfulOutput';
  locale: Scalars['String']['output'];
  successStory1Url?: Maybe<Scalars['String']['output']>;
  successStory2Url?: Maybe<Scalars['String']['output']>;
};

/** The transaction amounts may be requested in a single currency. If a toCurrency is provided as a filter and the convertedCurrency object is requested, the convertedCurrency object will be returned for all amounts in the transaction converted from the original currency of the taker maker clear record to the provided currency in the filter.  */
export type ConvertedCurrency = {
  __typename?: 'ConvertedCurrency';
  /** The (desired) currency in which amounts have been converted to. */
  currency: Scalars['String']['output'];
  /** The sum of taker market clear `cleared_discounted_amount` in this transaction converted to the provided toCurrency. Must include depositAmount in the transactionAggregate sum in order to receive a converted sum. */
  depositAmount?: Maybe<Scalars['Float']['output']>;
  /** The sum of taker market clear `cleared_earn` in this transaction converted to the provided toCurrency. Must include discountAmount in the transactionAggregate sum in order to receive a converted sum. */
  discountAmount?: Maybe<Scalars['Float']['output']>;
  /** Contains the currency that was converted from, and the rate used in order to reach the desired currency (as defined in the desired currency field). */
  exchangeRate: TransactionCurrencyMap;
  /** The sum of taker market clear `cleared_invoice_amount` in this transaction converted to the provided toCurrency. Must include invoiceAmount in the transactionAggregate sum in order to receive a converted sum. */
  invoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ConvertedCurrencyInput = {
  /** The (desired) currency in which amounts have been converted to. */
  currency: Scalars['String']['input'];
  /** The sum of taker market clear `cleared_discounted_amount` in this transaction converted to the provided toCurrency. Must include depositAmount in the transactionAggregate sum in order to receive a converted sum. */
  depositAmount?: InputMaybe<Scalars['Float']['input']>;
  /** The sum of taker market clear `cleared_earn` in this transaction converted to the provided toCurrency. Must include discountAmount in the transactionAggregate sum in order to receive a converted sum. */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Contains the currency that was converted from, and the rate used in order to reach the desired currency (as defined in the desired currency field). */
  exchangeRate: TransactionCurrencyMapInput;
  /** The sum of taker market clear `cleared_invoice_amount` in this transaction converted to the provided toCurrency. Must include invoiceAmount in the transactionAggregate sum in order to receive a converted sum. */
  invoiceAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateAgreementInput = {
  cmsId: Scalars['String']['input'];
  marketId: Scalars['ID']['input'];
};

export type CreateBuyerAppDivisionReportingCurrenciesInput = {
  /** currency */
  currency: Scalars['String']['input'];
  /** Division Name */
  divisionName: Scalars['String']['input'];
  /** Division UUID */
  divisionUuid: Scalars['String']['input'];
  /** Report Type */
  reportType: Report_Type;
};

export type CreateBuyerAppEverafterBuyerConfig = {
  accountId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
  divisionUuid: Scalars['String']['input'];
  embedLocationId: Scalars['String']['input'];
  personaName: Scalars['String']['input'];
  workspaceId: Scalars['String']['input'];
};

export type CreateBuyerReportingCurrenciesInput = {
  /** Custom currency configured for the buyer */
  currency: Scalars['String']['input'];
  /** Organization name */
  organizationName: Scalars['String']['input'];
  /** Organization UUID */
  organizationUuid: Scalars['String']['input'];
};

/**
 * This is the input required to create a new Communication Preference for a user.
 * The backing data source is the ODS API.
 */
export type CreateCommunicationPreferenceInput = {
  communicationChannel?: InputMaybe<CommunicationChannelEnum>;
  communicationFrequency?: InputMaybe<CommunicationPreferenceFrequency>;
  communicationFrequencyValue?: InputMaybe<Scalars['String']['input']>;
  communicationType?: InputMaybe<CommunicationPreferenceType>;
  notificationKey: Scalars['String']['input'];
  notificationValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateCompanyGroupInput = {
  companyGroupName: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
  qualifiedSupplierInput: Array<QualifiedSupplierInput>;
};

export type CreateCompanyGroupOutput = {
  __typename?: 'CreateCompanyGroupOutput';
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CreateCustomAgreementInput = {
  /** Name of the agreement */
  agreementName: Scalars['String']['input'];
  /** Content of the agreement */
  content: Scalars['String']['input'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['input'];
  /** Jira Reference required for agreement creation */
  jiraReference: Scalars['String']['input'];
  /** Path is a combination of region, country and locale */
  path: Scalars['String']['input'];
  /** Status of the agreement */
  status: Scalars['String']['input'];
  /** Title of the agreement */
  title: Scalars['String']['input'];
};

export type CreateCustomAgreementResponse = {
  __typename?: 'CreateCustomAgreementResponse';
  message: Scalars['String']['output'];
};

export type CreateCustomGroup = {
  /** Date the group was created. */
  created: Scalars['DateTime']['input'];
  /** Designates if the opportunity associated with this group should be preselected. */
  isPreselected: Scalars['Boolean']['input'];
  /** List of grouped division / market combos */
  items?: InputMaybe<Array<CustomGroupEmbeddedItem>>;
  /** Maker organization UUID for the group. */
  makerOrganizationUuid: Scalars['String']['input'];
  /** AuthServiceUuid of the last person to modify the group. */
  modifiedBy: Scalars['String']['input'];
  /** Customer display name describing the grouping of takers / markets */
  name: Scalars['String']['input'];
  /** Additional notes on the grouping. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Description of why these takers / markets are grouped together. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Date the group was updated. */
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique identifier for this custom group */
  uuid: Scalars['ID']['input'];
};

export type CreateCustomGroupItem = {
  /** Date the group was created. */
  created: Scalars['DateTime']['input'];
  /** AuthServiceUuid of the person that added this taker / market. */
  createdBy: Scalars['String']['input'];
  /** The associated group. */
  groupUuid?: InputMaybe<Scalars['String']['input']>;
  /** The associated market. */
  marketUuid: Scalars['String']['input'];
  /** The associated taker. */
  takerUuid: Scalars['String']['input'];
  /** Unique identifier for this custom group item */
  uuid: Scalars['ID']['input'];
};

export type CreateCustomerLinkingRequestInput = {
  /** Any additional information that will help us with users request */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Some companies have a different name on their buyer documentation than what is publicly shared */
  businessName?: InputMaybe<Scalars['String']['input']>;
  /** Customer currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Oustanding amount receivable from customer */
  outstandingAR?: InputMaybe<Scalars['Float']['input']>;
  uniqueCustomerUuid: Scalars['String']['input'];
  vendorId: Array<Scalars['String']['input']>;
};

export type CreateCustomerLinkingRequestResponse = {
  __typename?: 'CreateCustomerLinkingRequestResponse';
  /** uuid for a linking request */
  uuid: Scalars['String']['output'];
};

export type CreateFunderCalculationsInput = {
  funderUuid: Scalars['String']['input'];
  interestCalcOutputStrategy: Scalars['String']['input'];
  paymentMethods: Scalars['String']['input'];
  priceTypes: Scalars['String']['input'];
  rateSelectionStrategy: Scalars['String']['input'];
};

export type CreateFunderCurrenciesInput = {
  bankingDays: Scalars['Float']['input'];
  currencyLookupId: Scalars['Float']['input'];
  funderUuid: Scalars['String']['input'];
  rateSource: Scalars['String']['input'];
  refRateFloor: Scalars['Float']['input'];
  referenceRate: Scalars['String']['input'];
};

export type CreateFunderFeedbackConfigInputDto = {
  funderUuid: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isInvoiceAmountComputed: Scalars['Boolean']['input'];
};

export type CreateFunderGeographiesInput = {
  funderUuid: Scalars['String']['input'];
  geographyLookupId: Scalars['Float']['input'];
  includeExclude: Scalars['String']['input'];
};

export type CreateFunderLegalSetupInput = {
  agreementType: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
  termsAndConditionsUrl: Scalars['String']['input'];
};

export type CreateManyAgreementAuditsInput = {
  /** Array of records to create */
  agreementAudits: Array<AgreementAuditInput>;
};

export type CreateManyAgreementsInput = {
  /** Array of records to create */
  agreements: Array<CreateAgreementInput>;
};

export type CreateManyBuyerAppDivisionRegionsInput = {
  /** Array of records to create */
  buyerAppDivisionRegions: Array<BuyerAppDivisionRegionInput>;
};

export type CreateManyBuyerAppDivisionReportingCurrenciesInput = {
  /** Array of records to create */
  buyerAppDivisionReportingCurrencies: Array<CreateBuyerAppDivisionReportingCurrenciesInput>;
};

export type CreateManyBuyerAppDivisionsUsersRolesInput = {
  /** Array of records to create */
  buyerAppDivisionsUsersRoles: Array<BuyerAppDivisionsUsersRolesInput>;
};

export type CreateManyBuyerAppDualAuthorizationRolesInput = {
  /** Array of records to create */
  buyerAppDualAuthorizationRoles: Array<BuyerAppDualAuthorizationRolesInput>;
};

export type CreateManyBuyerReportingCurrenciesInput = {
  /** Array of records to create */
  buyerReportingCurrencies: Array<CreateBuyerReportingCurrenciesInput>;
};

export type CreateManyCommunicationChannelsInput = {
  /** Array of records to create */
  communicationChannels: Array<InputCommunicationChannel>;
};

export type CreateManyCommunicationPreferencesInput = {
  /** Array of records to create */
  communicationPreferences: Array<CreateCommunicationPreferenceInput>;
};

export type CreateManyCustomGroupItemsInput = {
  /** Array of records to create */
  customGroupItems: Array<CreateCustomGroupItem>;
};

export type CreateManyFunderVariablesInput = {
  /** Array of records to create */
  funderVariables: Array<FunderVariableInput>;
};

export type CreateManyRecordGroupColumnDtosInput = {
  /** Array of records to create */
  recordGroupColumnDtos: Array<CreateRecordGroupColumnDto>;
};

export type CreateManyWcmUserBuyerMappingDetailsInput = {
  /** User buyer mapping details, max limit 50 */
  wcmUserBuyerMappingDetails: Array<WcmUserBuyerMapping>;
};

export type CreateOneActionableOfferScheduleInput = {
  /** The record to create */
  actionableOfferSchedule: ActionableOfferScheduleInput;
};

export type CreateOneAgreementAuditInput = {
  /** The record to create */
  agreementAudit: AgreementAuditInput;
};

export type CreateOneAgreementInput = {
  /** The record to create */
  agreement: CreateAgreementInput;
};

export type CreateOneBuyerAppEverafterBuyerConfigInput = {
  /** The record to create */
  buyerAppEverafterBuyerConfig: CreateBuyerAppEverafterBuyerConfig;
};

export type CreateOneCommunicationChannelInput = {
  /** The record to create */
  communicationChannel: InputCommunicationChannel;
};

export type CreateOneCommunicationPreferenceInput = {
  /** The record to create */
  communicationPreference: CreateCommunicationPreferenceInput;
};

export type CreateOneCustomGroupInput = {
  /** The record to create */
  customGroup: CreateCustomGroup;
};

export type CreateOneDraftRequestInput = {
  /** The record to create */
  draftRequest: DraftRequestInput;
};

export type CreateOneExpressAcceptPriceDiscoveryRequestInput = {
  /** The record to create */
  expressAcceptPriceDiscoveryRequest: ExpressAcceptPriceDiscoveryRequestInput;
};

export type CreateOneFunderDeliverySettingsDtoInput = {
  /** The record to create */
  funderDeliverySettingsDto: FunderDeliverySettingsInputDto;
};

export type CreateOneFunderFeedbackConfigInput = {
  /** The record to create */
  funderFeedbackConfig: CreateFunderFeedbackConfigInputDto;
};

export type CreateOneFunderFileInput = {
  buyerGeneratedUseForReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  deliverySettings: FunderFileDeliverySettingsInput;
  fileNameFormat: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funder: Scalars['String']['input'];
  funderFileType: Scalars['String']['input'];
  reconColumnDetails?: InputMaybe<ReconColumnDetailsInput>;
  serializer: SerializerSettingsInput;
  subType: Scalars['String']['input'];
  writerType: Scalars['String']['input'];
};

export type CreateOneFunderInput = {
  name: Scalars['String']['input'];
};

export type CreateOneFunderNotificationConfigInput = {
  email: Array<Scalars['String']['input']>;
  funder: Scalars['String']['input'];
  funderFiles: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneFunderVariableInput = {
  /** The record to create */
  funderVariable: FunderVariableInput;
};

export type CreateOneOneTimeCashFlowPlusRequestInput = {
  /** The record to create */
  oneTimeCashFlowPlusRequest: OneTimeCashFlowPlusRequestInputDto;
};

export type CreateOneOneTimePriceDiscoveryRequestInput = {
  /** The record to create */
  oneTimePriceDiscoveryRequest: OneTimePriceDiscoveryRequestInput;
};

export type CreateOneOneTimeStaticRateRequestInput = {
  /** The record to create */
  oneTimeStaticRateRequest: OneTimeStaticRateRequestInputDto;
};

export type CreateOnePreferredTermInAppRequestInput = {
  /** The record to create */
  preferredTermInAppRequest: PreferredTermInAppRequestInput;
};

export type CreateOnePreferredTermRequestInput = {
  /** The record to create */
  preferredTermRequest: PreferredTermRequestInput;
};

export type CreateOnePricingSuggestionInput = {
  /** The record to create */
  pricingSuggestion: CreatePricingSuggestionInput;
};

export type CreateOneRecordGroupColumnDtoInput = {
  /** The record to create */
  recordGroupColumnDto: CreateRecordGroupColumnDto;
};

export type CreateOneRecurringBenchmarkRateRequestInput = {
  /** The record to create */
  recurringBenchmarkRateRequest: RecurringBenchmarkRateRequestInputDto;
};

export type CreateOneRecurringPriceDiscoveryRequestInput = {
  /** The record to create */
  recurringPriceDiscoveryRequest: RecurringPriceDiscoveryRequestInput;
};

export type CreateOneRecurringStaticRateRequestInput = {
  /** The record to create */
  recurringStaticRateRequest: RecurringStaticRateRequestInputDto;
};

export type CreateOutOfNetworkCustomerInput = {
  /** Any additional information that will help us with users request */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Approximate amount receivable from customer */
  approximateAmountReceivable?: InputMaybe<Scalars['Int']['input']>;
  /** Customer currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user would consider being a reference for C2FO with this customer */
  isContactReference: Scalars['Boolean']['input'];
  /** Customer name */
  name: Scalars['String']['input'];
  /** Customer website url */
  websiteUrl: Scalars['String']['input'];
};

export type CreateOutOfNetworkCustomerRequestInput = {
  /** Any additional information that will help us with users request */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Approximate amount receivable from customer */
  approximateAmountReceivable?: InputMaybe<Scalars['Int']['input']>;
  /** Customer currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user would consider being a reference for C2FO with this customer */
  isContactReference: Scalars['Boolean']['input'];
  /** Customer uuid for which request is being created */
  outOfNetworkCustomerUuid: Scalars['String']['input'];
};

export type CreateOutOfNetworkCustomerRequestResponse = {
  __typename?: 'CreateOutOfNetworkCustomerRequestResponse';
  /** UUID of created request */
  uuid: Scalars['String']['output'];
};

export type CreateOutOfNetworkCustomerResponse = {
  __typename?: 'CreateOutOfNetworkCustomerResponse';
  /** UUID of created out-of-network customer */
  uuid: Scalars['String']['output'];
};

export type CreatePassword = {
  __typename?: 'CreatePassword';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Basic users personal information. */
export type CreatePersonalInfoInput = {
  address: CreateUserAddressInput;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: Role;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePreferredOfferConfigInput = {
  /** Salesforce account ID */
  accountId: Scalars['String']['input'];
  /** Flag indicating whether or not account can edit invoices on an active preferred offer */
  canEditInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uuid associated with the user updating the config record */
  updatedBy: Scalars['String']['input'];
};

/**
 * This is the input required to create a new Pricing Suggestion for an offer.
 * The backing data source is the DataScience's Pricing API.
 */
export type CreatePricingSuggestionInput = {
  isActionableOffer?: InputMaybe<Scalars['Boolean']['input']>;
  offerType: Scalars['String']['input'];
  suggestionType?: InputMaybe<Scalars['String']['input']>;
  takerMarkets: Array<TakerMarket>;
};

export type CreateProgramFileSetDetails = {
  filterColumn: Scalars['String']['input'];
  funderFileType?: InputMaybe<FunderFileType>;
  name: Scalars['String']['input'];
  paymentWriterType: Scalars['String']['input'];
};

export type CreateProgramInput = {
  funderUuid: Scalars['ID']['input'];
  makerUuid: Scalars['ID']['input'];
  organizationUuid: Scalars['ID']['input'];
  programName: Scalars['String']['input'];
};

export type CreateRecordGroupColumnDto = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy: Scalars['Boolean']['input'];
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig?: InputMaybe<MergeConfigInput>;
  recordGroupId: Scalars['String']['input'];
  serializerConfig?: InputMaybe<SerializerColumnSettingsInput>;
  sortBy: Scalars['Boolean']['input'];
  transformationConfig?: InputMaybe<Scalars['JSON']['input']>;
  uuid: Scalars['String']['input'];
};

export type CreateRecordGroupColumnInputDto = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy: Scalars['Boolean']['input'];
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig?: InputMaybe<MergeConfigInput>;
  recordGroupId?: InputMaybe<Scalars['String']['input']>;
  serializerConfig?: InputMaybe<SerializerColumnSettingsInput>;
  sortBy?: InputMaybe<Scalars['Boolean']['input']>;
  transformationConfig?: InputMaybe<Scalars['JSON']['input']>;
};

export type CreateRecordGroupInput = {
  funderFileTemplateId: Scalars['String']['input'];
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  recordGroupColumns: Array<CreateRecordGroupColumnInputDto>;
  recordGroupColumnsToRemove?: InputMaybe<Array<Scalars['String']['input']>>;
  rgOrder: Scalars['Float']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSupplierMembershipInput = {
  /** Id of the salesforce account the user is associated to. */
  accountId: Scalars['String']['input'];
  /** Billing frequency the user selects for the membership. Ex: MONTHLY, QUARTERLY, YEARLY */
  billingFrequency?: InputMaybe<BillingFrequency>;
  /** the corresponding Stripe-assigned Subscription ID. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if an account is eligible for membership. Default: false */
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offer builder flow that we want the user to put in experiment. EX: FLOW_1_PARTIAL, FLOW_2_DETAIL. Default: FLOW_1_PARTIAL */
  offerBuilderType?: InputMaybe<OfferBuilderType>;
  /** status of membership payment. Ex: NOT_APPLICABLE, PAID, PENDING, FAILED, CANCELLED. Default: NOT_APPLICABLE */
  paymentStatus?: InputMaybe<PaymentStatus>;
  /** Membership plan of the user that we want this user to put in experiment. Ex: BASIC, STANDARD, PREMIUM. Default: BASIC */
  plan?: InputMaybe<MembershipPlan>;
  /** Status of the membership. Ex: ACTIVE, PENDING, INACTIVE. Default: INACTIVE */
  status?: InputMaybe<MembershipStatus>;
};

/** Requires a country code to help with data placement */
export type CreateUserAddressInput = {
  /** The 3 digit ISO-3166 code for country. We attempt to cleanse whatever is sent in into a supported code. */
  country: Scalars['String']['input'];
  /** Zip or postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Information required to creating a user. Keep this slim. */
export type CreateUserInput = {
  createdBy: Scalars['String']['input'];
  createdSource: Scalars['String']['input'];
  divisionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  emailAddress: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  needsPasswordReset?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  personalInfo: CreatePersonalInfoInput;
  registration?: InputMaybe<RegistrationInfoInput>;
};

export type CreateUserMutationResponse = MutationResponse & {
  __typename?: 'CreateUserMutationResponse';
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type CreateUsersViaWcmInput = {
  /** List of users to create */
  users: Array<UserInputViaWcm>;
};

export type CreateUsersViaWcmOutput = {
  __typename?: 'CreateUsersViaWcmOutput';
  /** Number of users that already existed (200) */
  alreadyExisted: Scalars['Float']['output'];
  /** Number of failed user creations */
  failedCreations: Scalars['Float']['output'];
  /** Number of newly created users (201) */
  newlyCreated: Scalars['Float']['output'];
  /** Number of users onboarded to WCM */
  onboardedToWcm: Scalars['Float']['output'];
  /** Total number of users processed */
  totalUsers: Scalars['Float']['output'];
  /** List of created users with their results */
  users: Array<CreatedUserViaWcm>;
};

export type CreateWcmBuyerExclusionRemarkInput = {
  remark: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmCustomAttributeValueInput = {
  /** The value to add to the custom attribute */
  value: Scalars['String']['input'];
};

export type CreateWcmDomainBuyerMappingsInput = {
  /** Array of buyer UUIDs to map to the domain */
  buyerUuids: Array<Scalars['String']['input']>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type CreateWcmMasterBuyerList = {
  /** WCM Buyer Type */
  buyerType?: InputMaybe<Wcm_Buyer_Type>;
  /** WCM buyer data center */
  dataCenter: Scalars['String']['input'];
  /** WCM buyer name */
  wcmBuyerName: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmNewUserRegistrationInput = {
  businessEmail: Scalars['String']['input'];
  businessPhone?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Wcm_User_Roles_For_Registration_Request;
};

export type CreateWcmNewUserRegistrationResponse = {
  __typename?: 'CreateWcmNewUserRegistrationResponse';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
};

export type CreateWcmPlanWaveInput = {
  /** Wave end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Wave name */
  name: Scalars['String']['input'];
  /** Owner of the wave */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Wave start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateWcmRoleWithAdminLevelPermissionsInput = {
  permissionNames: Array<Scalars['String']['input']>;
  roleName: Scalars['String']['input'];
  userAuthUuid: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmRolesInput = {
  managedByC2foUsers?: InputMaybe<Scalars['Boolean']['input']>;
  permissionIds: Array<Scalars['ID']['input']>;
  roleName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmSupplierGroupNoteInput = {
  /** Note content */
  content: Scalars['String']['input'];
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type CreateWcmWcmRolesOutput = {
  __typename?: 'CreateWcmWcmRolesOutput';
  created: Scalars['Boolean']['output'];
};

export type CreatedUserViaWcm = {
  __typename?: 'CreatedUserViaWcm';
  /** User email address */
  emailAddress: Scalars['String']['output'];
  /** Error message if operation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Whether user was newly created (true) or already existed (false) */
  isNewlyCreated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user needs password reset */
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Whether user was onboarded to WCM */
  onboardedToWcm?: Maybe<Scalars['Boolean']['output']>;
  /** User password */
  password?: Maybe<Scalars['String']['output']>;
  /** Whether operation was successful */
  success: Scalars['Boolean']['output'];
  /** User UUID */
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CryptographicSettings = {
  __typename?: 'CryptographicSettings';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  keys: Array<Scalars['String']['output']>;
  useBuyerKeys?: Maybe<Scalars['Boolean']['output']>;
};

export type CurrenciesDto = {
  __typename?: 'CurrenciesDto';
  currencies: Array<Scalars['String']['output']>;
};

/** Defines a single currency exchange rate that was used to convert the original invoice amount(s) to the desired currency. */
export type CurrencyMap = {
  __typename?: 'CurrencyMap';
  /** The currency an opportunity was converted from. */
  currency: Scalars['String']['output'];
  /** The exchange rate used to convert the original currency to the desired currency. */
  rate: Scalars['Float']['output'];
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate before opaque cursor */
  before?: InputMaybe<Scalars['ConnectionCursor']['input']>;
  /** Paginate first */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Paginate last */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomAgreement = {
  __typename?: 'CustomAgreement';
  /** Name of the agreement stored in S3 */
  agreementName: Scalars['String']['output'];
  /** Timestamp of creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** IP address of the creator */
  createdByIpAddress: Scalars['String']['output'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['output'];
  /** Reference ticket to create the agreement */
  jiraReference: Scalars['String']['output'];
  /** Latest version ID of the agreement */
  latestVersionId: Scalars['String']['output'];
  /** s3 path combined from region, country and locale */
  path: Scalars['String']['output'];
  /** Status of the agreement (draft, stage, or live) */
  status: AgreementStatusEnum;
  /** Timestamp of the last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** UUID of the custom agreement */
  uuid: Scalars['String']['output'];
};

export type CustomAgreementVersionHistory = {
  __typename?: 'CustomAgreementVersionHistory';
  /** Timestamp of the last update */
  updatedAt: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** Version ID of the agreement */
  versionId: Scalars['String']['output'];
};

export type CustomAgreementWithContent = {
  __typename?: 'CustomAgreementWithContent';
  /** Name of the agreement stored in S3 */
  agreementName: Scalars['String']['output'];
  /** Title of the agreement */
  agreementTitle: Scalars['String']['output'];
  /** Content of the agreement */
  content: Scalars['String']['output'];
  /** Timestamp of creation */
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  /** IP address of the creator */
  createdByIpAddress: Scalars['String']['output'];
  /** Is agreement for 3rd party funders */
  is3rdPartyAgreement: Scalars['Boolean']['output'];
  /** Reference ticket to create the agreement */
  jiraReference: Scalars['String']['output'];
  /** Latest version ID of the agreement */
  latestVersionId: Scalars['String']['output'];
  /** s3 path combined from region, country and locale */
  path: Scalars['String']['output'];
  /** Status of the agreement (draft, stage, or live) */
  status: AgreementStatusEnum;
  /** Timestamp of the last update */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** IP address of the last updater */
  updatedByIpAddress?: Maybe<Scalars['String']['output']>;
  /** UUID of the custom agreement */
  uuid: Scalars['String']['output'];
};

export type CustomAttributeInfo = {
  __typename?: 'CustomAttributeInfo';
  /** Display name of the custom attribute */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute */
  internalName: Scalars['String']['output'];
  /** Value assigned to the custom attribute, null if unassigned */
  value?: Maybe<Scalars['String']['output']>;
  /** ID of the value assigned to the custom attribute, null if unassigned */
  valueId?: Maybe<Scalars['Int']['output']>;
};

export type CustomAttributeValueDto = {
  __typename?: 'CustomAttributeValueDto';
  /** Number of spend assignments using this value (informational only) */
  assignmentCount: Scalars['Int']['output'];
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

export type CustomAttributeValueResponseDto = {
  __typename?: 'CustomAttributeValueResponseDto';
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

/** A custom group allows group item like taker / market combinations together based on the supplier's organization. */
export type CustomGroup = {
  __typename?: 'CustomGroup';
  /** Date the group was created. */
  created: Scalars['DateTime']['output'];
  /** Designates if the opportunity associated with this group should be preselected. */
  isPreselected: Scalars['Boolean']['output'];
  items: Array<CustomGroupItem>;
  itemsAggregate: Array<CustomGroupItemsAggregateResponse>;
  /** Maker organization UUID for the group. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** AuthServiceUuid of the last person to modify the group. */
  modifiedBy: Scalars['String']['output'];
  /** Customer display name describing the grouping of takers / markets */
  name: Scalars['String']['output'];
  /** Additional notes on the grouping. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Description of why these takers / markets are grouped together. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Date the group was updated. */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for this custom group */
  uuid: Scalars['ID']['output'];
};


/** A custom group allows group item like taker / market combinations together based on the supplier's organization. */
export type CustomGroupItemsArgs = {
  sorting?: Array<CustomGroupItemSort>;
};


/** A custom group allows group item like taker / market combinations together based on the supplier's organization. */
export type CustomGroupItemsAggregateArgs = {
  filter?: InputMaybe<CustomGroupItemAggregateFilter>;
};

export type CustomGroupAggregateFilter = {
  and?: InputMaybe<Array<CustomGroupAggregateFilter>>;
  items?: InputMaybe<CustomGroupAggregateFilterCustomGroupItemAggregateFilter>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupAggregateFilter>>;
  takerUuid?: InputMaybe<CustomGroupTakerUuidFilterComparison>;
  uuid?: InputMaybe<IdFilterComparison>;
};

export type CustomGroupAggregateFilterCustomGroupItemAggregateFilter = {
  and?: InputMaybe<Array<CustomGroupAggregateFilterCustomGroupItemAggregateFilter>>;
  groupUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupAggregateFilterCustomGroupItemAggregateFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type CustomGroupAggregateGroupBy = {
  __typename?: 'CustomGroupAggregateGroupBy';
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CustomGroupAggregateResponse = {
  __typename?: 'CustomGroupAggregateResponse';
  count?: Maybe<CustomGroupCountAggregate>;
  groupBy?: Maybe<CustomGroupAggregateGroupBy>;
  max?: Maybe<CustomGroupMaxAggregate>;
  min?: Maybe<CustomGroupMinAggregate>;
};

export type CustomGroupConnection = {
  __typename?: 'CustomGroupConnection';
  /** Array of edges. */
  edges: Array<CustomGroupEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CustomGroupCountAggregate = {
  __typename?: 'CustomGroupCountAggregate';
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type CustomGroupDeleteResponse = {
  __typename?: 'CustomGroupDeleteResponse';
  /** Date the group was created. */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Designates if the opportunity associated with this group should be preselected. */
  isPreselected?: Maybe<Scalars['Boolean']['output']>;
  /** List of grouped division / market combos */
  items?: Maybe<Array<CustomGroupEmbeddedItemOutput>>;
  /** Maker organization UUID for the group. */
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  /** AuthServiceUuid of the last person to modify the group. */
  modifiedBy?: Maybe<Scalars['String']['output']>;
  /** Customer display name describing the grouping of takers / markets */
  name?: Maybe<Scalars['String']['output']>;
  /** Additional notes on the grouping. */
  notes?: Maybe<Scalars['String']['output']>;
  /** Description of why these takers / markets are grouped together. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Date the group was updated. */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for this custom group */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CustomGroupEdge = {
  __typename?: 'CustomGroupEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CustomGroup */
  node: CustomGroup;
};

/** Reference for embedding a CustomGroupItem inside  a CustomGroup */
export type CustomGroupEmbeddedItem = {
  /** Associated market. */
  marketUuid: Scalars['String']['input'];
  /** Associated taker. */
  takerUuid: Scalars['String']['input'];
};

export type CustomGroupEmbeddedItemOutput = {
  __typename?: 'CustomGroupEmbeddedItemOutput';
  /** Associated market. */
  marketUuid: Scalars['String']['output'];
  /** Associated taker. */
  takerUuid: Scalars['String']['output'];
};

export type CustomGroupFilter = {
  and?: InputMaybe<Array<CustomGroupFilter>>;
  items?: InputMaybe<CustomGroupFilterCustomGroupItemFilter>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupFilter>>;
  takerUuid?: InputMaybe<CustomGroupTakerUuidFilterComparison>;
  uuid?: InputMaybe<IdFilterComparison>;
};

export type CustomGroupFilterCustomGroupItemFilter = {
  and?: InputMaybe<Array<CustomGroupFilterCustomGroupItemFilter>>;
  groupUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupFilterCustomGroupItemFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

/** The taker / market relationship included in a custom group. */
export type CustomGroupItem = {
  __typename?: 'CustomGroupItem';
  /** Date the group was created. */
  created: Scalars['DateTime']['output'];
  /** AuthServiceUuid of the person that added this taker / market. */
  createdBy: Scalars['String']['output'];
  /** The associated group. */
  groupUuid?: Maybe<Scalars['String']['output']>;
  /** The associated market. */
  marketUuid: Scalars['String']['output'];
  /** The associated taker. */
  takerUuid: Scalars['String']['output'];
  /** Unique identifier for this custom group item */
  uuid: Scalars['ID']['output'];
};

export type CustomGroupItemAggregateFilter = {
  and?: InputMaybe<Array<CustomGroupItemAggregateFilter>>;
  groupUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupItemAggregateFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type CustomGroupItemConnection = {
  __typename?: 'CustomGroupItemConnection';
  /** Array of edges. */
  edges: Array<CustomGroupItemEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type CustomGroupItemDeleteFilter = {
  and?: InputMaybe<Array<CustomGroupItemDeleteFilter>>;
  groupUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupItemDeleteFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type CustomGroupItemDeleteResponse = {
  __typename?: 'CustomGroupItemDeleteResponse';
  /** Date the group was created. */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** AuthServiceUuid of the person that added this taker / market. */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The associated group. */
  groupUuid?: Maybe<Scalars['String']['output']>;
  /** The associated market. */
  marketUuid?: Maybe<Scalars['String']['output']>;
  /** The associated taker. */
  takerUuid?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this custom group item */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CustomGroupItemEdge = {
  __typename?: 'CustomGroupItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the CustomGroupItem */
  node: CustomGroupItem;
};

export type CustomGroupItemFilter = {
  and?: InputMaybe<Array<CustomGroupItemFilter>>;
  groupUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<CustomGroupItemFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type CustomGroupItemSort = {
  direction: SortDirection;
  field: CustomGroupItemSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CustomGroupItemSortFields =
  | 'groupUuid'
  | 'marketUuid'
  | 'takerUuid';

export type CustomGroupItemsAggregateGroupBy = {
  __typename?: 'CustomGroupItemsAggregateGroupBy';
  groupUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type CustomGroupItemsAggregateResponse = {
  __typename?: 'CustomGroupItemsAggregateResponse';
  count?: Maybe<CustomGroupItemsCountAggregate>;
  groupBy?: Maybe<CustomGroupItemsAggregateGroupBy>;
  max?: Maybe<CustomGroupItemsMaxAggregate>;
  min?: Maybe<CustomGroupItemsMinAggregate>;
};

export type CustomGroupItemsCountAggregate = {
  __typename?: 'CustomGroupItemsCountAggregate';
  groupUuid?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
};

export type CustomGroupItemsMaxAggregate = {
  __typename?: 'CustomGroupItemsMaxAggregate';
  groupUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type CustomGroupItemsMinAggregate = {
  __typename?: 'CustomGroupItemsMinAggregate';
  groupUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type CustomGroupMaxAggregate = {
  __typename?: 'CustomGroupMaxAggregate';
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CustomGroupMinAggregate = {
  __typename?: 'CustomGroupMinAggregate';
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CustomGroupSort = {
  direction: SortDirection;
  field: CustomGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type CustomGroupSortFields =
  | 'makerOrganizationUuid'
  | 'takerUuid'
  | 'uuid';

export type CustomGroupTakerUuidFilterComparison = {
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CustomerDetails = {
  __typename?: 'CustomerDetails';
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  makerDisplayName?: Maybe<Scalars['String']['output']>;
  makerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
};

export type CustomerInput = {
  field?: IdentityFieldType;
  id: Scalars['String']['input'];
};

export type CustomerLinkingRequest = {
  __typename?: 'CustomerLinkingRequest';
  /** URL pointing to the Buyer's logo in PNG format. */
  customerLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Name for this customer, suitable for display to suppliers. */
  customerName: Scalars['String']['output'];
  customerUuid: Scalars['String']['output'];
  /** Status of corresponding salesforce ticket. */
  requestStatus?: Maybe<LinkingRequestStatus>;
  /** Date on which the linking request was created. */
  requestedOnDate: Scalars['DateTime']['output'];
  /** Case number of the salesforce ticket created on linking request. */
  salesforceCaseNumber?: Maybe<Scalars['String']['output']>;
};

export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  buyerInfo: BuyerInfoResponse;
  customerTraits: CustomerTraits;
};

export type CustomerTraits = {
  __typename?: 'CustomerTraits';
  /** Amounts receivable of highest AP buyer of customer */
  arForHighestApBuyerUsd?: Maybe<Scalars['Float']['output']>;
  authServiceUuid: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** UUID of highest AP buyer of customer */
  highestApBuyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  journeyPhase?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  /** Eligible invoice count for highest AP buyer of customer */
  numberOfEligibleInvoicesForHighestApBuyer?: Maybe<Scalars['Float']['output']>;
  /** Term sheet details */
  termSheet?: Maybe<TermSheetDto>;
  treatment?: Maybe<Treatment>;
};

export type CustomerTraitsResponse = {
  __typename?: 'CustomerTraitsResponse';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  experiments: Array<Maybe<Experiment>>;
  /** Amounts receivable of highest AP buyer of customer */
  highest_buyer_eligible_ap_amount?: Maybe<Scalars['Float']['output']>;
  /** Eligible invoice count for highest AP buyer of customer */
  highest_buyer_eligible_invoice_count?: Maybe<Scalars['Float']['output']>;
  /** UUID of highest AP buyer of customer */
  highest_buyer_uuid?: Maybe<Scalars['String']['output']>;
  journey_phase?: Maybe<Scalars['String']['output']>;
  lead_source?: Maybe<Scalars['String']['output']>;
  /** Division UUID of highest AP buyer of customer */
  microsite_buyer_division_uuid?: Maybe<Scalars['String']['output']>;
  /** Supplier account name */
  sfdc_account_name?: Maybe<Scalars['String']['output']>;
  /** Term sheet details */
  term_sheet?: Maybe<TermSheet>;
};

export type Dbt_Model =
  | 'BUYER_SUPPLIER_COUNT'
  | 'CORE_METRICS_BY_MARKET'
  | 'DPE_ANALYSIS'
  | 'NETWORK_GROWTH'
  | 'NEW_VS_REPEAT_PARTICIPANTS'
  | 'PARTICIPATION_SUMMARY'
  | 'REPEAT_VS_NEW_INCOME'
  | 'REPEAT_VS_NEW_LOADED_AP'
  | 'SCF_DISCLOSURE'
  | 'TOTAL_VS_NEW_SUPPLIERS';

export type DataMigrationOutput = {
  __typename?: 'DataMigrationOutput';
  message: Scalars['String']['output'];
};

export type DateFieldComparison = {
  between?: InputMaybe<DateFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  notBetween?: InputMaybe<DateFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime']['input'];
  upper: Scalars['DateTime']['input'];
};

export type DayOfWeek =
  | 'FRIDAY'
  | 'MONDAY'
  | 'SATURDAY'
  | 'SUNDAY'
  | 'THURSDAY'
  | 'TUESDAY'
  | 'WEDNESDAY';

export type DefaultNotificationKeys = {
  __typename?: 'DefaultNotificationKeys';
  EMAIL: Array<Scalars['String']['output']>;
  SMS: Array<Scalars['String']['output']>;
  WHATSAPP: Array<Scalars['String']['output']>;
};

/**
 * Default Preferences is an object from the ODS API containing information
 * about a the default preferences for a channel.
 */
export type DefaultPreferences = {
  __typename?: 'DefaultPreferences';
  notificationKeys: DefaultNotificationKeys;
};

export type DeleteBuyerAppDualAuthInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be deleted */
  dualAuthId: Scalars['ID']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type DeleteManyBuyerAppDivisionReportingCurrenciesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDivisionReportingCurrenciesDeleteFilter;
};

export type DeleteManyBuyerAppDivisionsUsersRolesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDivisionsUsersRolesDeleteFilter;
};

export type DeleteManyBuyerAppDualAuthorizationRolesInput = {
  /** Filter to find records to delete */
  filter: BuyerAppDualAuthorizationRolesDeleteFilter;
};

export type DeleteManyBuyerReportingCurrenciesInput = {
  /** Filter to find records to delete */
  filter: BuyerReportingCurrenciesDeleteFilter;
};

export type DeleteManyCustomGroupItemsInput = {
  /** Filter to find records to delete */
  filter: CustomGroupItemDeleteFilter;
};

export type DeleteManyFunderVariablesInput = {
  /** Filter to find records to delete */
  filter: FunderVariableDeleteFilter;
};

export type DeleteManyRecordGroupColumnDtosInput = {
  /** Filter to find records to delete */
  filter: RecordGroupColumnDtoDeleteFilter;
};

export type DeleteManyResponse = {
  __typename?: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int']['output'];
};

export type DeleteManyWcmBuyerUserMappingOutput = {
  __typename?: 'DeleteManyWcmBuyerUserMappingOutput';
  deletedCount: Scalars['Float']['output'];
  deletedWcmUserBuyerMappingDetails: Array<WcmBuyerUserMappingOutput>;
};

export type DeleteManyWcmMasterBuyerListsInput = {
  /** Filter to find records to delete */
  filter: WcmMasterBuyerListDeleteFilter;
};

export type DeleteManyWcmUserBuyerMappingDetailsInput = {
  /** User buyer mapping details, max limit 50 */
  wcmUserBuyerMappingDetails: Array<WcmUserBuyerMapping>;
};

export type DeleteOneActionableOfferScheduleInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneBuyerAppDivisionRegionInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCustomGroupInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneCustomGroupItemInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneFunderFeedbackConfigInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneFunderVariableInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteOneRecordGroupColumnDtoInput = {
  /** The id of the record to delete. */
  id: Scalars['ID']['input'];
};

export type DeleteProfileImage = {
  accountId: Scalars['String']['input'];
};

export type DeleteProfileImageResponse = {
  __typename?: 'DeleteProfileImageResponse';
  accountId: Scalars['String']['output'];
};

export type DeleteWcmBuyerExclusionRemarkInput = {
  id: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type DeleteWcmCustomAttributeValueResponse = {
  __typename?: 'DeleteWcmCustomAttributeValueResponse';
  /** Array of deleted values with their IDs */
  deletedValues: Array<DeletedCustomAttributeValue>;
  /** Confirmation message */
  message: Scalars['String']['output'];
  /** Whether the deletion was successful */
  success: Scalars['Boolean']['output'];
};

export type DeleteWcmRoleInput = {
  roleId: Scalars['ID']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type DeleteWcmRoleOutput = {
  __typename?: 'DeleteWcmRoleOutput';
  deleted: Scalars['Boolean']['output'];
};

export type DeleteWcmUsersInput = {
  userUuids: Array<Scalars['String']['input']>;
};

export type DeleteWcmUsersOutput = {
  __typename?: 'DeleteWcmUsersOutput';
  message: Scalars['String']['output'];
  totalUsersOffBoarded: Scalars['Float']['output'];
};

export type DeletedCustomAttributeValue = {
  __typename?: 'DeletedCustomAttributeValue';
  /** ID of the deleted value */
  id: Scalars['Int']['output'];
  /** Value that was deleted */
  value: Scalars['String']['output'];
};

export type DeliverySetting = {
  __typename?: 'DeliverySetting';
  fileName: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderName: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  programName: Scalars['String']['output'];
  settings: Settings;
};

export type DeliverySettingsOutput = {
  __typename?: 'DeliverySettingsOutput';
  deliverySettings: Array<DeliverySetting>;
};

export type Direction =
  | 'ASC'
  | 'DESC';

/**
 * The low level business entity that pays invoices (maker/buyer),
 * receives payment for invoices (taker/supplier), or both.
 * An organization can contain many divisions.
 * The backing data source is the `division` table.
 * NOTE: When querying for a single division by ID, the id field takes the division uuid as input.
 */
export type Division = {
  __typename?: 'Division';
  /** The Account for the Division. */
  account?: Maybe<Account>;
  /** The account this division belongs to. */
  accountId?: Maybe<Scalars['String']['output']>;
  annualSpend?: Maybe<Scalars['Float']['output']>;
  companyInfo?: Maybe<Scalars['JSON']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  eslap?: Maybe<Scalars['JSON']['output']>;
  eslapId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  /** Is the company a buyer (customer). A division can only be a supplier or buyer not both. */
  isBuyer?: Maybe<Scalars['Boolean']['output']>;
  /** Is the company a supplier (vendor). A division can only be a supplier or buyer not both. */
  isSupplier?: Maybe<Scalars['Boolean']['output']>;
  naics?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  revenue?: Maybe<Scalars['Float']['output']>;
  /** List of services to include */
  serviceScope?: Maybe<Scalars['String']['output']>;
  /** SRM user associated with this Division through the Account assignment. */
  srm?: Maybe<Srm>;
  takerConfigurationHistories: DivisionTakerConfigurationHistoriesConnection;
  taxId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
  /** Division UUID */
  uuid: Scalars['String']['output'];
  wfcId?: Maybe<Scalars['Float']['output']>;
};


/**
 * The low level business entity that pays invoices (maker/buyer),
 * receives payment for invoices (taker/supplier), or both.
 * An organization can contain many divisions.
 * The backing data source is the `division` table.
 * NOTE: When querying for a single division by ID, the id field takes the division uuid as input.
 */
export type DivisionTakerConfigurationHistoriesArgs = {
  filter?: TakerConfigurationHistoryFilter;
  paging?: CursorPaging;
  sorting?: Array<TakerConfigurationHistorySort>;
};

export type DivisionConnection = {
  __typename?: 'DivisionConnection';
  /** Array of edges. */
  edges: Array<DivisionEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DivisionEdge = {
  __typename?: 'DivisionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Division */
  node: Division;
};

export type DivisionFilter = {
  and?: InputMaybe<Array<DivisionFilter>>;
  eslapId?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<NumberFieldComparison>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DivisionFilter>>;
  organizationId?: InputMaybe<StringFieldComparison>;
  serviceScope?: InputMaybe<DivisionServiceScopeFilterComparison>;
  taxId?: InputMaybe<StringFieldComparison>;
  users?: InputMaybe<DivisionFilterUserFilter>;
  uuid?: InputMaybe<StringFieldComparison>;
  wfcId?: InputMaybe<NumberFieldComparison>;
};

export type DivisionFilterUserFilter = {
  and?: InputMaybe<Array<DivisionFilterUserFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<DivisionFilterUserFilter>>;
};

export type DivisionServiceScopeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DivisionSort = {
  direction: SortDirection;
  field: DivisionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type DivisionSortFields =
  | 'eslapId'
  | 'id'
  | 'name'
  | 'organizationId'
  | 'serviceScope'
  | 'taxId'
  | 'uuid'
  | 'wfcId';

export type DivisionTakerConfigurationHistoriesConnection = {
  __typename?: 'DivisionTakerConfigurationHistoriesConnection';
  /** Array of edges. */
  edges: Array<TakerConfigurationHistoryEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DivisionUser = {
  __typename?: 'DivisionUser';
  /** The date at which the user was associated to the division. */
  created?: Maybe<Scalars['DateTime']['output']>;
  divisionId: Scalars['Float']['output'];
  nodeId: Scalars['ID']['output'];
  /** The date at which the association to the division was last modified. */
  updated?: Maybe<Scalars['DateTime']['output']>;
  user: C2FoUser;
  userId: Scalars['Float']['output'];
};

export type DraftOfferStatus =
  | 'CANCELLED'
  | 'EXPIRED'
  | 'INELIGIBLE'
  | 'OFFER_SUBMITTED'
  | 'READY_FOR_SUBMISSION';

/**
 * A draft request for early payment against invoices in one or more opportunities. These requests are utilized
 * by SRM home, actionable offers, and potentially more use cases in the future. Actual requests are
 * later submitted based on the details contained in a draft request.
 */
export type DraftRequest = {
  __typename?: 'DraftRequest';
  /** Auth Service UUID of the user the draft request has been built for. Used for querying my draft offers. */
  authServiceUuid: Scalars['String']['output'];
  /** The timestamp at which the draft was submitted */
  created: Scalars['DateTime']['output'];
  /** The type of draft request based on the workflow type initiating it */
  draftType: DraftType;
  /** The timestamp at which the draft will no longer be considered eligible to act upon.  If now() > expiration_date, then an EXPIRED status will be returned for draft. Defaults to 24 hours from draft submission. */
  expirationDate: Scalars['DateTime']['output'];
  /** Identifier for draft request */
  id: Scalars['ID']['output'];
  /** List of opportunities this draft request is for */
  opportunityUuids: Array<Scalars['String']['output']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23. Includes spread and reference rate for PREFERRED_TERM requests with a REF (Reference) rate. */
  rate?: Maybe<Scalars['Float']['output']>;
  /** The name of the source that defines the variable rate associated to a PREFERRED_TERM REF rateType draft. */
  rateSourceName?: Maybe<Scalars['String']['output']>;
  /** Type of rate of this offer. Either APR, DISC (Discount) or REF (Reference) */
  rateType?: Maybe<RateType>;
  /** FK of the request submitted for the draft */
  requestId?: Maybe<Scalars['String']['output']>;
  /** List of taker markets this draft request is for. These are filtered out from opportunities taker markets based off request option */
  requestOptionTakerMarkets: Array<DraftRequestTakerMarket>;
  /** Request options of the draft request */
  requestOptions: Array<DraftRequestOptions>;
  /** Spread added to this request. Only valid for Preferred Term. */
  spread?: Maybe<Scalars['Float']['output']>;
  /** The current status of the draft request */
  status: DraftRequestStatus;
  /** Auth service uuid user (SRM) submitting the draft request */
  submitter: Scalars['String']['output'];
  /** The system (application) submitting the draft request */
  submitterSystemName?: Maybe<Scalars['String']['output']>;
  /** DateTime at which a preferred term expires. Only valid for Preferred Term. */
  termExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The request type of this draft request */
  type: RequestType;
  /** The timestamp at which the draft was updated */
  updated: Scalars['DateTime']['output'];
};

export type DraftRequestConnection = {
  __typename?: 'DraftRequestConnection';
  /** Array of edges. */
  edges: Array<DraftRequestEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type DraftRequestEdge = {
  __typename?: 'DraftRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the DraftRequest */
  node: DraftRequest;
};

export type DraftRequestFilter = {
  and?: InputMaybe<Array<DraftRequestFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<DraftRequestFilter>>;
  status?: InputMaybe<DraftRequestStatusFilterComparison>;
};

export type DraftRequestInput = {
  /** Auth service uuid the draft has been created for */
  authServiceUuid: Scalars['String']['input'];
  /** The type of draft being submitted */
  draftType: DraftType;
  /** DateTime at which the draft expires */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Array of opportunity UUIDs that this draft has been created for */
  opportunityUuids: Array<Scalars['String']['input']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Type of rate of this request. Either APR, DISC (Discount) or REF (Reference) */
  rateType?: InputMaybe<RateType>;
  /** Spread added to this request. Only valid for Preferred Term. */
  spread?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the SRM/Owner submitting the draft offer */
  submitter: Scalars['String']['input'];
  /** DateTime at which a preferred term expires. Only valid for Preferred Term. If the date is invalid such as, Feb 31, it will autocorrect to a valid date such as, March 2 */
  termExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The type of request */
  type: RequestType;
};

export type DraftRequestOptions =
  | 'ExpressAcceptPriceDiscovery'
  | 'OneTimeBenchmarkRate'
  | 'OneTimeCashFlowPlus'
  | 'OneTimePriceDiscovery'
  | 'OneTimeStaticRate'
  | 'PreferredTerm'
  | 'RecurringBenchmarkRate'
  | 'RecurringPriceDiscovery'
  | 'RecurringStaticRate';

export type DraftRequestSort = {
  direction: SortDirection;
  field: DraftRequestSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type DraftRequestSortFields =
  | 'authServiceUuid'
  | 'id'
  | 'status';

export type DraftRequestStatus =
  | 'CANCELLED'
  | 'EXPIRED'
  | 'INELIGIBLE'
  | 'READY_FOR_SUBMISSION'
  | 'REQUEST_SUBMITTED';

export type DraftRequestStatusFilterComparison = {
  eq?: InputMaybe<DraftRequestStatus>;
  gt?: InputMaybe<DraftRequestStatus>;
  gte?: InputMaybe<DraftRequestStatus>;
  iLike?: InputMaybe<DraftRequestStatus>;
  in?: InputMaybe<Array<DraftRequestStatus>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<DraftRequestStatus>;
  lt?: InputMaybe<DraftRequestStatus>;
  lte?: InputMaybe<DraftRequestStatus>;
  neq?: InputMaybe<DraftRequestStatus>;
  notILike?: InputMaybe<DraftRequestStatus>;
  notIn?: InputMaybe<Array<DraftRequestStatus>>;
  notLike?: InputMaybe<DraftRequestStatus>;
};

export type DraftRequestTakerMarket = {
  __typename?: 'DraftRequestTakerMarket';
  marketUuid: Scalars['String']['output'];
  takerUuid: Scalars['String']['output'];
};

export type DraftType =
  | 'ABANDONED_CART_OFFER'
  | 'ACTIONABLE_OFFER'
  | 'SRM_INITIATED';

export type EarlyPayBuyerOrganization = {
  __typename?: 'EarlyPayBuyerOrganization';
  buyerDivisionName: Scalars['String']['output'];
  buyerDivisionUuid: Scalars['String']['output'];
  buyerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  makerOrganizationName: Scalars['String']['output'];
  makerOrganizationUuid: Scalars['String']['output'];
  marketingMakerName?: Maybe<Scalars['String']['output']>;
};

export type EarlyPayBuyerOrganizationReponse = {
  __typename?: 'EarlyPayBuyerOrganizationReponse';
  nodes: Array<EarlyPayBuyerOrganization>;
};

export type EarlyPayDivision = {
  __typename?: 'EarlyPayDivision';
  account?: Maybe<Account>;
  addressInfo?: Maybe<AddressInfo>;
  companyInfo?: Maybe<CompanyInfo>;
  created?: Maybe<Scalars['String']['output']>;
  divisionUsers?: Maybe<Array<DivisionUser>>;
  id: Scalars['Int']['output'];
  marketing?: Maybe<MarketingDivisionInfo>;
  markets: EarlyPayDivisionMarketsConnection;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  organization: EarlyPayOrganization;
  supplierClears: EarlyPayDivisionSupplierClearsConnection;
  supplierMarketStats: EarlyPayDivisionSupplierMarketStatsConnection;
  uuid: Scalars['String']['output'];
};


export type EarlyPayDivisionMarketsArgs = {
  filter?: EarlyPayMarketDeepFilter;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayMarketSort>;
};


export type EarlyPayDivisionSupplierClearsArgs = {
  filter?: EarlyPaySupplierClearDeepFilter;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPaySupplierClearSort>;
};


export type EarlyPayDivisionSupplierMarketStatsArgs = {
  filter?: EarlyPaySupplierStatsDeepFilter;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPaySupplierStatsSort>;
};

export type EarlyPayDivisionDeepFilter = {
  and?: InputMaybe<Array<EarlyPayDivisionDeepFilter>>;
  id?: InputMaybe<EarlyPayDivisionIdFilterComparison>;
  markets?: InputMaybe<EarlyPayMarketDeepFilter>;
  or?: InputMaybe<Array<EarlyPayDivisionDeepFilter>>;
  supplierClears?: InputMaybe<EarlyPaySupplierClearDeepFilter>;
  supplierMarketStats?: InputMaybe<EarlyPaySupplierStatsDeepFilter>;
  uuid?: InputMaybe<EarlyPayDivisionUuidFilterComparison>;
};

export type EarlyPayDivisionIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EarlyPayDivisionMarketsConnection = {
  __typename?: 'EarlyPayDivisionMarketsConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPayMarket>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayDivisionOffsetConnection = {
  __typename?: 'EarlyPayDivisionOffsetConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPayDivision>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayDivisionSort = {
  direction: SortDirection;
  field: EarlyPayDivisionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPayDivisionSortFields =
  | 'id'
  | 'uuid';

export type EarlyPayDivisionSupplierClearsConnection = {
  __typename?: 'EarlyPayDivisionSupplierClearsConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPaySupplierClear>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayDivisionSupplierMarketStatsConnection = {
  __typename?: 'EarlyPayDivisionSupplierMarketStatsConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPaySupplierStats>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayDivisionUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayDraftOfferDto = {
  __typename?: 'EarlyPayDraftOfferDto';
  /** Auth Service UUID of the user the draft offer has been built for. */
  authServiceUuid: Scalars['String']['output'];
  /** The timestamp at which the draft was submitted */
  created: Scalars['DateTime']['output'];
  /** The type of draft offer based on the workflow type initiating it */
  draftType: EnterpriseDraftType;
  /** The timestamp at which the draft will no longer be considered eligible to act upon. If now() > expiration_date, then an EXPIRED status will be returned for draft. Defaults to 24 hours from draft submission. */
  expirationDate: Scalars['DateTime']['output'];
  frequency: Frequency;
  marketUuid: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  /** Rate this offer is placed against as a percentage. Ex: 1.23% = 1.23. Includes spread and reference rate for PREFERRED_TERM offer with a REF (Reference) rate. */
  rate?: Maybe<Scalars['Float']['output']>;
  /** Type of rate of this offer. Either APR, DISC (Discount) or REF (Reference) */
  rateType?: Maybe<Rate>;
  /** Spread added to this draft. Only valid for Preferred Term. */
  spread?: Maybe<Scalars['Float']['output']>;
  /** The current status of the draft offer. */
  status: DraftOfferStatus;
  /** Auth service uuid user (SRM) submitting the draft offer */
  submitterAuthServiceUuid: Scalars['String']['output'];
  /** The system (application) submitting the draft offer */
  submitterSystemName?: Maybe<Scalars['String']['output']>;
  supplierDivisionUuids: Array<Scalars['String']['output']>;
  /** FK of the takerConfigHistoryId(s) created from submitting this draft */
  takerConfigHistoryIds?: Maybe<Array<Scalars['String']['output']>>;
  termExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  type: EnterpriseOfferType;
  /** The timestamp at which the draft was updated */
  updated: Scalars['DateTime']['output'];
  /** Identifier for draft offer */
  uuid: Scalars['ID']['output'];
};

export type EarlyPayDraftOfferInputDto = {
  /** Auth service uuid the draft has been created for */
  authServiceUuid: Scalars['String']['input'];
  /** The type of draft being submitted */
  draftType: EnterpriseDraftType;
  /** DateTime at which the draft expires. Default is 24 hours from now. */
  expirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Market UUID that this draft has been created for. */
  marketUuid: Scalars['String']['input'];
  /** Rate this offer is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Type of rate of this offer. Either APR, DISC (Discount) or REF (Reference) */
  rateType?: InputMaybe<Rate>;
  /** Spread added to this offer. Only valid for Preferred Term. */
  spread?: InputMaybe<Scalars['Float']['input']>;
  /** UUID of the SRM/Owner submitting the draft offer */
  submitterAuthServiceUuid: Scalars['String']['input'];
  /** Array of supplier division UUIDs that this draft has been created for. They must all be in the same market, and for the market provided in marketUuid. */
  supplierDivisionUuids: Array<Scalars['String']['input']>;
  /** DateTime at which a preferred term expires. Only valid for Preferred Term. If the date is invalid such as, Feb 31, it will autocorrect to a valid date such as, March 2 */
  termExpirationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The type of offer the draft is being created for */
  type: EnterpriseOfferType;
};

export type EarlyPayMarket = {
  __typename?: 'EarlyPayMarket';
  buyerDivision?: Maybe<EarlyPayDivision>;
  currency: Scalars['String']['output'];
  features: Array<MarketFeature>;
  fundingPartnerMarket?: Maybe<FundingPartnerMarket>;
  id: Scalars['Int']['output'];
  isDiscountOnly: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isTpf: Scalars['Boolean']['output'];
  marketType: Scalars['String']['output'];
  maxApr?: Maybe<Scalars['Float']['output']>;
  maxDiscount?: Maybe<Scalars['Float']['output']>;
  nextClearTime?: Maybe<Scalars['DateTime']['output']>;
  nodeId: Scalars['ID']['output'];
  payDate?: Maybe<Scalars['DateTime']['output']>;
  pricing?: Maybe<PricingType>;
  productType?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};


export type EarlyPayMarketFeaturesArgs = {
  filter?: MarketFeatureFilter;
  sorting?: Array<MarketFeatureSort>;
};

export type EarlyPayMarketCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayMarketDeepFilter = {
  and?: InputMaybe<Array<EarlyPayMarketDeepFilter>>;
  currency?: InputMaybe<EarlyPayMarketCurrencyFilterComparison>;
  fundingPartnerMarket?: InputMaybe<FundingPartnerMarketDeepFilter>;
  id?: InputMaybe<EarlyPayMarketIdFilterComparison>;
  isDiscountOnly?: InputMaybe<EarlyPayMarketIsDiscountOnlyFilterComparison>;
  isEnabled?: InputMaybe<EarlyPayMarketIsEnabledFilterComparison>;
  isTpf?: InputMaybe<EarlyPayMarketIsTpfFilterComparison>;
  marketType?: InputMaybe<EarlyPayMarketMarketTypeFilterComparison>;
  or?: InputMaybe<Array<EarlyPayMarketDeepFilter>>;
  payDate?: InputMaybe<DateFieldComparison>;
  productType?: InputMaybe<EarlyPayMarketProductTypeFilterComparison>;
  uuid?: InputMaybe<EarlyPayMarketUuidFilterComparison>;
};

export type EarlyPayMarketIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EarlyPayMarketIsDiscountOnlyFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarlyPayMarketIsEnabledFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarlyPayMarketIsTpfFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarlyPayMarketMarketTypeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayMarketOffsetConnection = {
  __typename?: 'EarlyPayMarketOffsetConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPayMarket>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayMarketProductTypeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayMarketSort = {
  direction: SortDirection;
  field: EarlyPayMarketSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPayMarketSortFields =
  | 'currency'
  | 'id'
  | 'isDiscountOnly'
  | 'isEnabled'
  | 'isTpf'
  | 'marketType'
  | 'payDate'
  | 'productType'
  | 'uuid';

export type EarlyPayMarketUuidFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** An opportunity represents a group of invoices from a particular buyer that can have an offer placed on them. */
export type EarlyPayOpportunity = {
  __typename?: 'EarlyPayOpportunity';
  /** The authServiceUuid of the User who is tied to the opportunity */
  authServiceUuid: Scalars['String']['output'];
  /** Benchmark Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  benchmarkRateStats?: Maybe<BenchmarkRateStats>;
  /** The buyer division uuid */
  buyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  /** CashFlow Plus Stats */
  cashFlowPlusStats?: Maybe<Array<CashFlowPlusStats>>;
  /** Currency of the opportunity after conversion was done. */
  convertedCurrency?: Maybe<Scalars['String']['output']>;
  /** The original currency of the opportunity before any conversion was done. */
  currency: Scalars['String']['output'];
  /** Custom group for opportunities. */
  customGroup?: Maybe<OpportunityCustomGroup>;
  /** Unique identifier for customer */
  customerUuid: Scalars['String']['output'];
  /** Exchange rate from the opportunitiy's original currency to the converted currency. */
  exchangeRateToConvertedCurrency?: Maybe<Scalars['Float']['output']>;
  /** Invoice summary data associated with this opportunity */
  invoiceSummary: InvoiceSummary;
  /** Indicates if this opportunity is eligible for CashFlow+ */
  isCashFlowPlusEligible: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is open or closed for offers */
  isClosed: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is currently part of any active offers */
  isInActiveOffer: Scalars['Boolean']['output'];
  /** Indicates whether this opportunity was created through a creation endpoint. */
  isManuallyCreated: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is eligible for preferred term */
  isPreferredEligible: Scalars['Boolean']['output'];
  /** Whether an opportunity should default to selected as defined within the custom group. */
  isPreselected: Scalars['Boolean']['output'];
  /** Maker organization UUID for this opportunities parent customer. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Calculated name of the opportunity using the custom group if set. */
  opportunityName?: Maybe<Scalars['String']['output']>;
  /** Information about the pricing related to this opportunity [StaticRate, BenchmarkRate, PriceDiscovery] */
  priceType: PriceType;
  /** Reference Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  referenceRateStats?: Maybe<ReferenceRateStats>;
  /** Request Options array. This contains a list of enums that indicate the type of opportunity and any special conditions. Example: A PreferredTerm entry indicates a preferred offer can be placed on this opportunity */
  requestOptions?: Maybe<Array<RequestOptions>>;
  /** TakersMarkets data associated with this opportunity */
  takersMarkets: Array<EarlyPayOpportunityTakersMarket>;
  /** Type of the opportunity, either PRICE_DISCOVERY or STATIC_RATE */
  type: OpportunityType;
  /** Unique identifier for this opportunity */
  uuid: Scalars['ID']['output'];
};

export type EarlyPayOpportunityAggregateFilter = {
  and?: InputMaybe<Array<EarlyPayOpportunityAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<EarlyPayOpportunityBuyerUuidFilterComparison>;
  currency?: InputMaybe<EarlyPayOpportunityCurrencyFilterComparison>;
  customerUuid?: InputMaybe<EarlyPayOpportunityCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<EarlyPayOpportunityDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  or?: InputMaybe<Array<EarlyPayOpportunityAggregateFilter>>;
  type?: InputMaybe<OpportunityTypeFilterComparison>;
  uuid?: InputMaybe<EarlyPayOpportunityUuidFilterComparison>;
};

export type EarlyPayOpportunityAggregateGroupBy = {
  __typename?: 'EarlyPayOpportunityAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type EarlyPayOpportunityAggregateResponse = {
  __typename?: 'EarlyPayOpportunityAggregateResponse';
  count?: Maybe<EarlyPayOpportunityCountAggregate>;
  groupBy?: Maybe<EarlyPayOpportunityAggregateGroupBy>;
  max?: Maybe<EarlyPayOpportunityMaxAggregate>;
  min?: Maybe<EarlyPayOpportunityMinAggregate>;
};

export type EarlyPayOpportunityBuyerUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayOpportunityConnection = {
  __typename?: 'EarlyPayOpportunityConnection';
  /** Array of edges. */
  edges: Array<EarlyPayOpportunityEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type EarlyPayOpportunityCountAggregate = {
  __typename?: 'EarlyPayOpportunityCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  buyerUuid?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  customerUuid?: Maybe<Scalars['Int']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type EarlyPayOpportunityCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayOpportunityCustomerUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayOpportunityDesiredCurrencyForMultipleCurrenciesFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type EarlyPayOpportunityEdge = {
  __typename?: 'EarlyPayOpportunityEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EarlyPayOpportunity */
  node: EarlyPayOpportunity;
};

export type EarlyPayOpportunityFilter = {
  and?: InputMaybe<Array<EarlyPayOpportunityFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<EarlyPayOpportunityBuyerUuidFilterComparison>;
  currency?: InputMaybe<EarlyPayOpportunityCurrencyFilterComparison>;
  customerUuid?: InputMaybe<EarlyPayOpportunityCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<EarlyPayOpportunityDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  or?: InputMaybe<Array<EarlyPayOpportunityFilter>>;
  type?: InputMaybe<OpportunityTypeFilterComparison>;
  uuid?: InputMaybe<EarlyPayOpportunityUuidFilterComparison>;
};

export type EarlyPayOpportunityMaxAggregate = {
  __typename?: 'EarlyPayOpportunityMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type EarlyPayOpportunityMinAggregate = {
  __typename?: 'EarlyPayOpportunityMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type EarlyPayOpportunitySort = {
  direction: SortDirection;
  field: EarlyPayOpportunitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPayOpportunitySortFields =
  | 'authServiceUuid'
  | 'buyerUuid'
  | 'currency'
  | 'customerUuid'
  | 'desiredCurrencyForMultipleCurrencies'
  | 'type'
  | 'uuid';

/** TakersMarkets data associated with an opportunity */
export type EarlyPayOpportunityTakersMarket = {
  __typename?: 'EarlyPayOpportunityTakersMarket';
  /** the dpe associated with the opportunity takers_markets data. This is calculated by dividing the eligibleDpeWeightedSum by the eligibleInvoiceAmount */
  dpe?: Maybe<Scalars['Float']['output']>;
  /** the eligibleDpeWeightedSum associated with the opportunity takers_markets data. */
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  /** the eligibleInvoiceAmount associated with the opportunity takers_markets data. */
  eligibleInvoiceAmount: Scalars['Float']['output'];
  /** the eligible invoice amount in USD associated with the opportunity takers_markets data. Null when we have no exchange rate. */
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** the original eligibleInvoiceCount associated with the opportunity takers_markets data. */
  eligibleInvoiceCount: Scalars['Float']['output'];
  /** Indicates if this taker market is eligible for preferred term */
  isPreferredEligible: Scalars['Boolean']['output'];
  /** the market_id associated with the opportunity takers_markets data. */
  marketId: Scalars['Float']['output'];
  /** indicates whether the market is enabled for the given takers_market */
  marketIsEnabled: Scalars['Boolean']['output'];
  /** the marketNextClearTime associated with the opportunity takers_markets data. */
  marketNextClearTime?: Maybe<Scalars['String']['output']>;
  /** the market_uuid associated with the opportunity takers_markets data. */
  marketUuid: Scalars['String']['output'];
  /** The product type of the TakersMarket as it was originally represented in the takers_markets database. This is will be null for a price discovery market, or one of SCF_ON_DEMAND or SCF_ALWAYS_ON for static rate */
  productType?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for a request associated with this particular takers_market */
  requestUuid?: Maybe<Scalars['String']['output']>;
  /** the taker_id associated with the opportunity takers_markets data. */
  takerId: Scalars['Float']['output'];
  /** the taker_uuid associated with the opportunity takers_markets data. */
  takerUuid: Scalars['String']['output'];
};

export type EarlyPayOpportunityUuidFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type EarlyPayOrganization = {
  __typename?: 'EarlyPayOrganization';
  addressInfo?: Maybe<OrganizationAddressInfo>;
  companyInfo?: Maybe<CompanyInfo>;
  divisions: EarlyPayOrganizationDivisionsConnection;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};


export type EarlyPayOrganizationDivisionsArgs = {
  filter?: EarlyPayDivisionDeepFilter;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayDivisionSort>;
};

export type EarlyPayOrganizationDeepFilter = {
  and?: InputMaybe<Array<EarlyPayOrganizationDeepFilter>>;
  divisions?: InputMaybe<EarlyPayDivisionDeepFilter>;
  id?: InputMaybe<EarlyPayOrganizationIdFilterComparison>;
  or?: InputMaybe<Array<EarlyPayOrganizationDeepFilter>>;
  uuid?: InputMaybe<EarlyPayOrganizationUuidFilterComparison>;
};

export type EarlyPayOrganizationDivisionsConnection = {
  __typename?: 'EarlyPayOrganizationDivisionsConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPayDivision>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayOrganizationIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EarlyPayOrganizationOffsetConnection = {
  __typename?: 'EarlyPayOrganizationOffsetConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPayOrganization>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPayOrganizationSort = {
  direction: SortDirection;
  field: EarlyPayOrganizationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPayOrganizationSortFields =
  | 'id'
  | 'uuid';

export type EarlyPayOrganizationUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPayRequest = {
  __typename?: 'EarlyPayRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** The name of the source that defines the variable rate associated to a PREFERRED_TERM REF rateType request. */
  rateSourceName?: Maybe<Scalars['String']['output']>;
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  /** Spread associated to a PREFERRED_TERM request. */
  spread?: Maybe<Scalars['Float']['output']>;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** DateTime at which a PREFERRED_TERM request expires. */
  termExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type EarlyPayRequestConnection = {
  __typename?: 'EarlyPayRequestConnection';
  /** Array of edges. */
  edges: Array<EarlyPayRequestEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type EarlyPayRequestDivisionUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type EarlyPayRequestEdge = {
  __typename?: 'EarlyPayRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EarlyPayRequest */
  node: EarlyPayRequest;
};

export type EarlyPayRequestFilter = {
  and?: InputMaybe<Array<EarlyPayRequestFilter>>;
  divisionUuid?: InputMaybe<EarlyPayRequestDivisionUuidFilterComparison>;
  id?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<EarlyPayRequestFilter>>;
  requesterId?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<EarlyPayRequestStatusFilterComparison>;
  toCurrency?: InputMaybe<StringFieldComparison>;
  type?: InputMaybe<RequestTypeFilterComparison>;
};

/** Provides info for what operations can be done on a request */
export type EarlyPayRequestRestrictions = {
  __typename?: 'EarlyPayRequestRestrictions';
  /**
   * True if this request can be edited
   * @deprecated Not granular enough. See the action specific properties to determine what actions can be taken on this request.
   */
  isEditable: Scalars['Boolean']['output'];
  /** True if this request supports editing invoices, false otherwise. */
  isInvoicesEditable: Scalars['Boolean']['output'];
  /** True if this request can be paused */
  isPausable: Scalars['Boolean']['output'];
  /** True if this request supports editing the rate, false otherwise. */
  isRateEditable: Scalars['Boolean']['output'];
  /** True if this request can be withdrawn */
  isWithdrawable: Scalars['Boolean']['output'];
};

export type EarlyPayRequestSort = {
  direction: SortDirection;
  field: EarlyPayRequestSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPayRequestSortFields =
  | 'divisionUuid'
  | 'id'
  | 'requesterId'
  | 'status'
  | 'toCurrency'
  | 'type';

/** Statistical information about the request.Market conditions and other factors affect the completion of the request and invoices/amounts may have changed.These statistics capture the up to date information for the request. */
export type EarlyPayRequestStats = {
  __typename?: 'EarlyPayRequestStats';
  /** The total discount across the accepted invoices (USD). Null when there was no exchange rate to USD for this currency. */
  acceptedDiscountSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total weighted sum of the discount across accepted invoices (USD).Null when there was no exchange rate to USD for this currency. */
  acceptedDiscountWeightedSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total amount of the accepted invoices in this request (USD), Null when there was no exchange rate to USD for this currency. */
  acceptedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The total count of accepted invoices in ths request. */
  acceptedInvoiceCount: Scalars['Float']['output'];
  /** Average values for stats across the entire request */
  averageStatDetails?: Maybe<AverageStatDetails>;
  /** The total discount across the awarded invoices (USD). Null when there was no exchange rate to USD for this currency. */
  awardedDiscountSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total amount of the awarded invoices in this request (USD), Null when there was not exchange rate to USD for this currency. */
  awardedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The total count of awarded invoices in ths request. */
  awardedInvoiceCount: Scalars['Float']['output'];
  /**
   * The total discount across the clearing invoices (USD). Null when there was no exchange rate to USD for this currency.To get the total discount (%) divide by the clearingInvoiceAmountUsd.
   * clearing = accepted + awarded
   * discount = sum(invoice.earn)
   */
  clearingDiscountSumUsd?: Maybe<Scalars['Float']['output']>;
  /**
   * Total amount of the clearing invoices in this request (USD). Null when there was no exchange rate to USD for this currency.
   * clearing = accepted + awarded
   */
  clearingInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Total count of the clearing invoices in this request. (clearing = accepted + awarded) */
  clearingInvoiceCount: Scalars['Float']['output'];
  /** The total discount across the eligible invoices (USD). Null when there was no exchange rate to USD for this currency. */
  eligibleDiscountSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total amount of the eligible invoices in this request (USD). Null when there was no exchange rate to USD for this currency. */
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Total count of the eligible invoices in this request */
  eligibleInvoiceCount: Scalars['Float']['output'];
  /** Estimated success rate for this request being accepted. This value is in decimal format where 1.0 = 100% . Nullable when the type of the request is not supported. */
  estimatedSuccessRate?: Maybe<Scalars['Float']['output']>;
  /** UUID associated with the stats row in the database. This is separate from the request UUID */
  id: Scalars['String']['output'];
  /** Maximum date that suppliers will receive funds after being awarded. Null when there are no taker markets with a good funds date in this request */
  maxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  /** Total amount of the not accepted invoices in this request (USD). Null when there was no exchange rate to USD for this currency. */
  notAcceptedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Total count of the not accepted invoices in this request */
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  /** Next market clear time across all takers markets in this request. Null when there are no taker markets with a clear time in this opportunity. */
  requestDeadline?: Maybe<Scalars['String']['output']>;
  /** Contains request stats converted to a single (provided) currency. This value may be null if exchange rate service is unavailable, or if a currency on an opportunity is invalid. By default, values will be converted to USD if a toCurrency fillter is not provided.  */
  toCurrency?: Maybe<ToCurrency>;
};

export type EarlyPayRequestStatusFilterComparison = {
  eq?: InputMaybe<RequestStatus>;
  in?: InputMaybe<Array<RequestStatus>>;
  neq?: InputMaybe<RequestStatus>;
  notIn?: InputMaybe<Array<RequestStatus>>;
};

export type EarlyPaySupplierClear = {
  __typename?: 'EarlyPaySupplierClear';
  clearedAprWeightedAverage: Scalars['Float']['output'];
  clearedAprWeightedSum: Scalars['Float']['output'];
  clearedDiscountWeightedAverage: Scalars['Float']['output'];
  clearedDiscountWeightedSum: Scalars['Float']['output'];
  clearedDiscountedAmount: Scalars['Float']['output'];
  clearedDpeWeightedAverage: Scalars['Float']['output'];
  clearedDpeWeightedSum: Scalars['Float']['output'];
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedInvoiceCount: Scalars['Int']['output'];
  clearedYield: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  market: EarlyPayMarket;
  nodeId: Scalars['ID']['output'];
  payDate?: Maybe<Scalars['DateTime']['output']>;
  supplierDivision: EarlyPayDivision;
  uuid: Scalars['String']['output'];
};

export type EarlyPaySupplierClearDeepFilter = {
  and?: InputMaybe<Array<EarlyPaySupplierClearDeepFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  id?: InputMaybe<EarlyPaySupplierClearIdFilterComparison>;
  isPendingClear?: InputMaybe<EarlyPaySupplierClearIsPendingClearFilterComparison>;
  market?: InputMaybe<EarlyPayMarketDeepFilter>;
  or?: InputMaybe<Array<EarlyPaySupplierClearDeepFilter>>;
  supplierDivision?: InputMaybe<EarlyPayDivisionDeepFilter>;
};

export type EarlyPaySupplierClearIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EarlyPaySupplierClearIsPendingClearFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EarlyPaySupplierClearOffsetConnection = {
  __typename?: 'EarlyPaySupplierClearOffsetConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPaySupplierClear>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPaySupplierClearSort = {
  direction: SortDirection;
  field: EarlyPaySupplierClearSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPaySupplierClearSortFields =
  | 'created'
  | 'id'
  | 'isPendingClear';

export type EarlyPaySupplierStats = {
  __typename?: 'EarlyPaySupplierStats';
  accepted: AcceptedStats;
  awarded: AwardedStats;
  currency: Scalars['String']['output'];
  divisionUsers?: Maybe<Array<DivisionUser>>;
  eligible: EligibleStats;
  goodFundsDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  market?: Maybe<EarlyPayMarket>;
  nodeId: Scalars['ID']['output'];
  notAccepted: NotAcceptedStats;
  offer?: Maybe<OfferConfig>;
  offerTypes?: Maybe<Offers>;
  supplierBuyerId: Scalars['String']['output'];
  supplierDivision?: Maybe<EarlyPayDivision>;
  supplierExcluded: SupplierExcludedStats;
  uuid: Scalars['String']['output'];
};

export type EarlyPaySupplierStatsCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EarlyPaySupplierStatsDeepFilter = {
  and?: InputMaybe<Array<EarlyPaySupplierStatsDeepFilter>>;
  currency?: InputMaybe<EarlyPaySupplierStatsCurrencyFilterComparison>;
  eligibleInvoiceAmount?: InputMaybe<EarlyPaySupplierStatsEligibleInvoiceAmountFilterComparison>;
  eligibleInvoiceCount?: InputMaybe<EarlyPaySupplierStatsEligibleInvoiceCountFilterComparison>;
  id?: InputMaybe<EarlyPaySupplierStatsIdFilterComparison>;
  market?: InputMaybe<EarlyPayMarketDeepFilter>;
  marketId?: InputMaybe<NumberFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  offer?: InputMaybe<OfferConfigDeepFilter>;
  or?: InputMaybe<Array<EarlyPaySupplierStatsDeepFilter>>;
  supplierDivision?: InputMaybe<EarlyPayDivisionDeepFilter>;
  supplierDivisionId?: InputMaybe<NumberFieldComparison>;
  supplierDivisionUuid?: InputMaybe<StringFieldComparison>;
};

export type EarlyPaySupplierStatsEligibleInvoiceAmountFilterComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type EarlyPaySupplierStatsEligibleInvoiceCountFilterComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type EarlyPaySupplierStatsIdFilterComparison = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type EarlyPaySupplierStatsOffsetConnection = {
  __typename?: 'EarlyPaySupplierStatsOffsetConnection';
  /** Array of nodes. */
  nodes: Array<EarlyPaySupplierStats>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type EarlyPaySupplierStatsSort = {
  direction: SortDirection;
  field: EarlyPaySupplierStatsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type EarlyPaySupplierStatsSortFields =
  | 'currency'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'id'
  | 'marketId'
  | 'marketUuid'
  | 'supplierDivisionId'
  | 'supplierDivisionUuid';

export type EligibleStats = {
  __typename?: 'EligibleStats';
  adjustedAmount: Scalars['Float']['output'];
  aprWeightedAvg: Scalars['Float']['output'];
  aprWeightedSum: Scalars['Float']['output'];
  discountWeightedAvg: Scalars['Float']['output'];
  discountWeightedSum: Scalars['Float']['output'];
  dpeWeightedAvg: Scalars['Float']['output'];
  dpeWeightedSum: Scalars['Float']['output'];
  earn: Scalars['Float']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  yield: Scalars['Float']['output'];
};

export type EmailResponseDetails = {
  __typename?: 'EmailResponseDetails';
  fromEmail: Scalars['String']['output'];
  fromName: Scalars['String']['output'];
  locale?: Maybe<SupportedLocales>;
  template?: Maybe<EmailTemplateName>;
  templateData?: Maybe<Scalars['JSON']['output']>;
  toEmail?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
};

export type EmailResponseDto = {
  __typename?: 'EmailResponseDto';
  didSend?: Maybe<Scalars['Boolean']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  emailSend?: Maybe<EmailResponseDetails>;
  emailSubject?: Maybe<Scalars['String']['output']>;
};

export type EmailSendInput = {
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<EmailTemplateName>;
  templateData?: InputMaybe<Scalars['JSON']['input']>;
  toEmail: Scalars['String']['input'];
  toName: Scalars['String']['input'];
};

export type EmailTemplateName =
  | 'arx_customer_invitation'
  | 'arx_vendor_invitation'
  | 'c2fo_award'
  | 'c2fo_basic'
  | 'c2fo_billing_buyer_netsuite_mapping_alert'
  | 'c2fo_billing_buyer_tier_reset_alert'
  | 'c2fo_buyer_award_file'
  | 'c2fo_buyer_invitation'
  | 'c2fo_credit_note'
  | 'c2fo_division_linked_failure_calendly'
  | 'c2fo_division_linked_failure_email_link'
  | 'c2fo_division_linked_success'
  | 'c2fo_fast_track'
  | 'c2fo_file_bundle'
  | 'c2fo_file_download'
  | 'c2fo_funding_partner_file_delivery_notification'
  | 'c2fo_internal'
  | 'c2fo_invitation'
  | 'c2fo_low_rate'
  | 'c2fo_magic_login'
  | 'c2fo_not_right_contact'
  | 'c2fo_password_expired'
  | 'c2fo_password_reminder'
  | 'c2fo_password_reset'
  | 'c2fo_report_download'
  | 'c2fo_transactional'
  | 'c2fo_verify_user_email'
  | 'capfin_invoice_charge_back'
  | 'capfin_invoice_past_due'
  | 'capfin_invoice_removal'
  | 'capfin_operations_summary'
  | 'capfin_proposal_confirmation'
  | 'capfin_sup_client_approved'
  | 'capfin_sup_term_sheet_approved'
  | 'early_pay_offer_accepted'
  | 'early_pay_offer_submitted'
  | 'early_pay_offer_withdrawn'
  | 'empty_template'
  | 'example'
  | 'marcus_loc_verify_email';

export type EncryptionSetting = {
  __typename?: 'EncryptionSetting';
  cryptographicSettings: CryptographicSettings;
  fileName: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
};

export type EncryptionSettingsOutput = {
  __typename?: 'EncryptionSettingsOutput';
  encryptionSettings: Array<EncryptionSetting>;
};

export type EnterpriseDraftType =
  | 'SRM_INITIATED';

export type EnterpriseOfferType =
  | 'PREFERRED'
  | 'PRICE_DISCOVERY';

export type Error = {
  __typename?: 'Error';
  /** An HTTP status code if an underlying service gives us one. */
  code?: Maybe<Scalars['String']['output']>;
  msg?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
};

export type EstimatedAprDto = {
  __typename?: 'EstimatedAPRDto';
  estimatedApr?: Maybe<Scalars['Float']['output']>;
  rateSources: Array<EstimatedAprRateSource>;
};

export type EstimatedAprInputBodyDto = {
  authServiceUuid: Scalars['String']['input'];
  /** Opportunity UUID to calculate the estimated rate for */
  opportunityUuid?: InputMaybe<Scalars['String']['input']>;
  /** Taker markets to calculate the estimated rate for. Must all be part of the same marketUuid */
  takersMarkets?: InputMaybe<Array<EstimatedAprTakerMarketInput>>;
  /** Determines whether the rate source should include any spread(s) defined by the cashpool or not. */
  useCashPoolSpread?: Scalars['Boolean']['input'];
};

export type EstimatedAprInputDto = {
  __typename?: 'EstimatedAPRInputDto';
  authServiceUuid: Scalars['String']['output'];
  /** Opportunity UUID to calculate the estimated rate for */
  opportunityUuid?: Maybe<Scalars['String']['output']>;
  /** Taker markets to calculate the estimated rate for. Must all be part of the same marketUuid */
  takersMarkets?: Maybe<Array<EstimatedAprTakerMarket>>;
  /** Determines whether the rate source should include any spread(s) defined by the cashpool or not. */
  useCashPoolSpread: Scalars['Boolean']['output'];
};

export type EstimatedAprInputDtoAggregateFilter = {
  and?: InputMaybe<Array<EstimatedAprInputDtoAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<EstimatedAprInputDtoAggregateFilter>>;
};

export type EstimatedAprInputDtoAggregateGroupBy = {
  __typename?: 'EstimatedAPRInputDtoAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type EstimatedAprInputDtoAggregateResponse = {
  __typename?: 'EstimatedAPRInputDtoAggregateResponse';
  count?: Maybe<EstimatedAprInputDtoCountAggregate>;
  groupBy?: Maybe<EstimatedAprInputDtoAggregateGroupBy>;
  max?: Maybe<EstimatedAprInputDtoMaxAggregate>;
  min?: Maybe<EstimatedAprInputDtoMinAggregate>;
};

export type EstimatedAprInputDtoCountAggregate = {
  __typename?: 'EstimatedAPRInputDtoCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
};

export type EstimatedAprInputDtoEdge = {
  __typename?: 'EstimatedAPRInputDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the EstimatedAPRInputDto */
  node: EstimatedAprInputDto;
};

export type EstimatedAprInputDtoMaxAggregate = {
  __typename?: 'EstimatedAPRInputDtoMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type EstimatedAprInputDtoMinAggregate = {
  __typename?: 'EstimatedAPRInputDtoMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
};

export type EstimatedAprRateSource = {
  __typename?: 'EstimatedAPRRateSource';
  /** Amount of AP (weighted) contributing to estimatedAPR */
  amount?: Maybe<Scalars['Float']['output']>;
  marketUuid: Scalars['String']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateSourceName?: Maybe<Scalars['String']['output']>;
};

export type EstimatedAprTakerMarket = {
  __typename?: 'EstimatedAPRTakerMarket';
  marketUuid: Scalars['String']['output'];
  takerUuid: Scalars['String']['output'];
};

export type EstimatedAprTakerMarketInput = {
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type ExclusionSettings = {
  __typename?: 'ExclusionSettings';
  excludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
};

export type Experiment = {
  __typename?: 'Experiment';
  name: Scalars['String']['output'];
  treatment: Scalars['String']['output'];
};

/**
 * A one time request for early payment against invoices in one or more opportunities.
 * Express accept requests are considered for acceptance once and then automatically turned off.
 * The rate of discount is given to the user based on market conditions, and is high enough to have a very high (but not guaranteed) chance of acceptance.
 */
export type ExpressAcceptPriceDiscoveryRequest = {
  __typename?: 'ExpressAcceptPriceDiscoveryRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type ExpressAcceptPriceDiscoveryRequestEdge = {
  __typename?: 'ExpressAcceptPriceDiscoveryRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ExpressAcceptPriceDiscoveryRequest */
  node: ExpressAcceptPriceDiscoveryRequest;
};

export type ExpressAcceptPriceDiscoveryRequestInput = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['input'];
  /** Type of rate of this request. Either APR or DISC (Discount) */
  rateType: RateType;
};

export type File_History_Status =
  | 'COMPLETED'
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING';

export type File_Upload_Status =
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'UPLOADED';

export type FetchCompanyGroupOutputDto = {
  __typename?: 'FetchCompanyGroupOutputDto';
  companyGroupName: Scalars['String']['output'];
  companyGroupUuid: Scalars['String']['output'];
  isDsf: Scalars['Boolean']['output'];
};

export type FetchCompanyGroupsIntersectionFilters = {
  companyId?: InputMaybe<StringComparison>;
  currency?: InputMaybe<StringComparison>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<StringComparison>;
  supplierName?: InputMaybe<StringComparison>;
};

export type FetchCompanyGroupsIntersectionInput = {
  filters?: InputMaybe<FetchCompanyGroupsIntersectionFilters>;
  leftCompanyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging?: InputMaybe<FetchCompanyGroupsIntersectionPaging>;
  rightCompanyGroupUuid: Scalars['String']['input'];
  sorting: FetchCompanyGroupsIntersectionSorting;
};

export type FetchCompanyGroupsIntersectionOutput = {
  __typename?: 'FetchCompanyGroupsIntersectionOutput';
  supplierDetails: Array<SupplierIntersectionDetails>;
  totalCount: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FetchCompanyGroupsIntersectionPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type FetchCompanyGroupsIntersectionSorting = {
  orderBy?: Direction;
  sortingField?: CompanyIntersectionSortField;
};

export type FetchUniqueCurrenciesLocationsForCgIntersectionInput = {
  leftCompanyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  rightCompanyGroupUuid: Scalars['String']['input'];
};

export type FetchWcmSupplierSegmentConfigInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type FetchWcmSupplierSegmentConfigOutput = {
  __typename?: 'FetchWcmSupplierSegmentConfigOutput';
  /** Maximum spend value across all supplier groups */
  maxGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend value across all supplier groups */
  minGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend for strategic suppliers */
  strategicMinSpend?: Maybe<Scalars['Float']['output']>;
  /** Maximum spend for tail suppliers */
  tailMaxSpend?: Maybe<Scalars['Float']['output']>;
};

export type FileCampaignInput = {
  file: ActionableOfferScheduleFileInput;
  isDebugMode?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  offerType?: OfferType;
  srmHomeUserUuid?: InputMaybe<Scalars['String']['input']>;
};

export type FileConfigurationV1 = {
  __typename?: 'FileConfigurationV1';
  fileSettingsUuid?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNo: Scalars['Float']['output'];
  subType: Scalars['String']['output'];
};

export type FileSetSettingsConfigurationV1 = {
  __typename?: 'FileSetSettingsConfigurationV1';
  fileSetSettingsUuid?: Maybe<Scalars['String']['output']>;
  fileSettings?: Maybe<Array<FileConfigurationV1>>;
  writerType?: Maybe<Scalars['String']['output']>;
};

export type FilterCriteria = {
  __typename?: 'FilterCriteria';
  filterColumn: Scalars['String']['output'];
  filterValue: Scalars['String']['output'];
};

export type FilterCriteriaDetails = {
  __typename?: 'FilterCriteriaDetails';
  filterCriteria: FilterCriteria;
  filterVariables?: Maybe<Array<Variable>>;
  variables?: Maybe<Array<Variable>>;
};

export type FloatFieldComparison = {
  between?: InputMaybe<FloatFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<FloatFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type FormatPreferences = Node & {
  __typename?: 'FormatPreferences';
  aggregateCurrencyFormat?: Maybe<Scalars['String']['output']>;
  dateDisplayFormat?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  numberDisplayFormat?: Maybe<Scalars['String']['output']>;
  useCustomFormatting: Scalars['Boolean']['output'];
};

export type FormatPreferencesInput = {
  aggregateCurrencyFormat?: InputMaybe<Scalars['String']['input']>;
  dateDisplayFormat?: InputMaybe<Scalars['String']['input']>;
  numberDisplayFormat?: InputMaybe<Scalars['String']['input']>;
  useCustomFormatting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Frequency =
  | 'ONE_TIME'
  | 'RECURRING';

export type Funder = {
  __typename?: 'Funder';
  created: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderBuyer = {
  __typename?: 'FunderBuyer';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  makerDataCenter: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  organizationUuid: Scalars['String']['output'];
  programEntity?: Maybe<Program>;
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderBuyerConnection = {
  __typename?: 'FunderBuyerConnection';
  /** Array of edges. */
  edges: Array<FunderBuyerEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderBuyerEdge = {
  __typename?: 'FunderBuyerEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderBuyer */
  node: FunderBuyer;
};

export type FunderBuyerFilter = {
  and?: InputMaybe<Array<FunderBuyerFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  makerDataCenter?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderBuyerFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
  programEntity?: InputMaybe<FunderBuyerFilterProgramFilter>;
};

export type FunderBuyerFilterProgramFilter = {
  and?: InputMaybe<Array<FunderBuyerFilterProgramFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderBuyerFilterProgramFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderBuyerProgramFileSetOutput = {
  __typename?: 'FunderBuyerProgramFileSetOutput';
  basePaymentConfig: Scalars['JSON']['output'];
  funderUuid: Scalars['String']['output'];
  makerUuid: Scalars['String']['output'];
  programsData: Array<ProgramsData>;
};

export type FunderBuyerSort = {
  direction: SortDirection;
  field: FunderBuyerSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderBuyerSortFields =
  | 'funderUuid'
  | 'makerDataCenter'
  | 'makerUuid'
  | 'organizationUuid';

export type FunderCalculations = {
  __typename?: 'FunderCalculations';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  interestCalcOutputStrategy: Scalars['String']['output'];
  paymentMethods: Scalars['String']['output'];
  priceTypes: Scalars['String']['output'];
  rateSelectionStrategy: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderCalculationsConnection = {
  __typename?: 'FunderCalculationsConnection';
  /** Array of edges. */
  edges: Array<FunderCalculationsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderCalculationsEdge = {
  __typename?: 'FunderCalculationsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderCalculations */
  node: FunderCalculations;
};

export type FunderCalculationsFilter = {
  and?: InputMaybe<Array<FunderCalculationsFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  interestCalcOutputStrategy?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderCalculationsFilter>>;
  rateSelectionStrategy?: InputMaybe<StringFieldComparison>;
};

export type FunderCalculationsOutput = {
  __typename?: 'FunderCalculationsOutput';
  interestCalcOutputStrategy: Scalars['String']['output'];
  paymentMethods: Scalars['String']['output'];
  priceTypes: Scalars['String']['output'];
  rateSelectionStrategy: Scalars['String']['output'];
};

export type FunderCalculationsSort = {
  direction: SortDirection;
  field: FunderCalculationsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderCalculationsSortFields =
  | 'funderUuid'
  | 'interestCalcOutputStrategy'
  | 'rateSelectionStrategy';

export type FunderConnection = {
  __typename?: 'FunderConnection';
  /** Array of edges. */
  edges: Array<FunderEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderCurrencies = {
  __typename?: 'FunderCurrencies';
  bankingDays: Scalars['Float']['output'];
  created: Scalars['DateTime']['output'];
  currencyLookupId: Scalars['Float']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  rateSource: Scalars['String']['output'];
  refRateFloor: Scalars['Float']['output'];
  referenceRate: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderCurrenciesFilter = {
  and?: InputMaybe<Array<FunderCurrenciesFilter>>;
  bankingDays?: InputMaybe<NumberFieldComparison>;
  currencyLookupId?: InputMaybe<NumberFieldComparison>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderCurrenciesFilter>>;
  rateSource?: InputMaybe<StringFieldComparison>;
  refRateFloor?: InputMaybe<NumberFieldComparison>;
  referenceRate?: InputMaybe<StringFieldComparison>;
};

export type FunderCurrenciesOutput = {
  __typename?: 'FunderCurrenciesOutput';
  bankingDays: Scalars['Float']['output'];
  currencyLookupId: Scalars['Float']['output'];
  rateSource: Scalars['String']['output'];
  refRateFloor: Scalars['Float']['output'];
  referenceRate: Scalars['String']['output'];
};

export type FunderCurrenciesSort = {
  direction: SortDirection;
  field: FunderCurrenciesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderCurrenciesSortFields =
  | 'bankingDays'
  | 'currencyLookupId'
  | 'funderUuid'
  | 'rateSource'
  | 'refRateFloor'
  | 'referenceRate';

export type FunderDeliverySettingsDto = {
  __typename?: 'FunderDeliverySettingsDto';
  created: Scalars['DateTime']['output'];
  fdsAuthId?: Maybe<Scalars['String']['output']>;
  fdsLocationId?: Maybe<Scalars['String']['output']>;
  fdsLocationName?: Maybe<Scalars['String']['output']>;
  fdsLocationUri?: Maybe<Scalars['String']['output']>;
  fundingPartnerUuid: Scalars['String']['output'];
  isBuyerAddress: Scalars['Boolean']['output'];
  isInternal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderDeliverySettingsDtoConnection = {
  __typename?: 'FunderDeliverySettingsDtoConnection';
  /** Array of edges. */
  edges: Array<FunderDeliverySettingsDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderDeliverySettingsDtoEdge = {
  __typename?: 'FunderDeliverySettingsDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderDeliverySettingsDto */
  node: FunderDeliverySettingsDto;
};

export type FunderDeliverySettingsDtoFilter = {
  and?: InputMaybe<Array<FunderDeliverySettingsDtoFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  fundingPartnerUuid?: InputMaybe<StringFieldComparison>;
  isBuyerAddress?: InputMaybe<BooleanFieldComparison>;
  isInternal?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FunderDeliverySettingsDtoFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderDeliverySettingsDtoSort = {
  direction: SortDirection;
  field: FunderDeliverySettingsDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderDeliverySettingsDtoSortFields =
  | 'created'
  | 'fundingPartnerUuid'
  | 'isBuyerAddress'
  | 'isInternal'
  | 'status'
  | 'uuid';

export type FunderDeliverySettingsInputDto = {
  fdsAuthId: Scalars['String']['input'];
  fdsLocationId: Scalars['String']['input'];
  fdsLocationName: Scalars['String']['input'];
  fdsLocationUri: Scalars['String']['input'];
  fundingPartnerUuid: Scalars['String']['input'];
  isBuyerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type FunderEdge = {
  __typename?: 'FunderEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Funder */
  node: Funder;
};

export type FunderFeedbackConfig = {
  __typename?: 'FunderFeedbackConfig';
  created: Scalars['DateTime']['output'];
  funder?: Maybe<Funder>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isInvoiceAmountComputed: Scalars['Boolean']['output'];
  updated: Scalars['DateTime']['output'];
};

export type FunderFeedbackConfigConnection = {
  __typename?: 'FunderFeedbackConfigConnection';
  /** Array of edges. */
  edges: Array<FunderFeedbackConfigEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFeedbackConfigDeleteResponse = {
  __typename?: 'FunderFeedbackConfigDeleteResponse';
  created?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isInvoiceAmountComputed?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type FunderFeedbackConfigEdge = {
  __typename?: 'FunderFeedbackConfigEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFeedbackConfig */
  node: FunderFeedbackConfig;
};

export type FunderFeedbackConfigFilter = {
  and?: InputMaybe<Array<FunderFeedbackConfigFilter>>;
  funder?: InputMaybe<FunderFeedbackConfigFilterFunderFilter>;
  id?: InputMaybe<IdFilterComparison>;
  isEnabled?: InputMaybe<BooleanFieldComparison>;
  isInvoiceAmountComputed?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<FunderFeedbackConfigFilter>>;
};

export type FunderFeedbackConfigFilterFunderFilter = {
  and?: InputMaybe<Array<FunderFeedbackConfigFilterFunderFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFeedbackConfigFilterFunderFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFeedbackConfigSort = {
  direction: SortDirection;
  field: FunderFeedbackConfigSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFeedbackConfigSortFields =
  | 'id'
  | 'isEnabled'
  | 'isInvoiceAmountComputed';

export type FunderFile = {
  __typename?: 'FunderFile';
  buyerGeneratedReconColumnConfig?: Maybe<ReconColumnDetails>;
  buyerGeneratedUseForReconciliation?: Maybe<Scalars['Boolean']['output']>;
  created: Scalars['DateTime']['output'];
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  funder: Scalars['String']['output'];
  funderFileDeliverySettings?: Maybe<FunderFileDeliveryDto>;
  funderFileType: Scalars['String']['output'];
  serialNo?: Maybe<Scalars['Float']['output']>;
  settings?: Maybe<SerializerSettingsOuput>;
  subType: Scalars['String']['output'];
  supplierFilterName: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  writerType: Scalars['String']['output'];
};

export type FunderFileColumnMaster = {
  __typename?: 'FunderFileColumnMaster';
  columnName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  groupByEnabled: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderFileColumnMasterConnection = {
  __typename?: 'FunderFileColumnMasterConnection';
  /** Array of nodes. */
  nodes: Array<FunderFileColumnMaster>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileColumnMasterFilter = {
  and?: InputMaybe<Array<FunderFileColumnMasterFilter>>;
  columnName?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileColumnMasterFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileColumnMasterSort = {
  direction: SortDirection;
  field: FunderFileColumnMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileColumnMasterSortFields =
  | 'columnName'
  | 'uuid';

export type FunderFileConnection = {
  __typename?: 'FunderFileConnection';
  /** Array of edges. */
  edges: Array<FunderFileEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileDeliveryDto = {
  __typename?: 'FunderFileDeliveryDto';
  delayInSeconds?: Maybe<Scalars['Float']['output']>;
  funderFileTemplateId: Scalars['String']['output'];
  funderTargetLocation?: Maybe<Scalars['String']['output']>;
  useBuyerLocation?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type FunderFileDeliveryDtoConnection = {
  __typename?: 'FunderFileDeliveryDtoConnection';
  /** Array of edges. */
  edges: Array<FunderFileDeliveryDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderFileDeliveryDtoEdge = {
  __typename?: 'FunderFileDeliveryDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFileDeliveryDto */
  node: FunderFileDeliveryDto;
};

export type FunderFileDeliveryDtoFilter = {
  and?: InputMaybe<Array<FunderFileDeliveryDtoFilter>>;
  funderFileTemplateId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileDeliveryDtoFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileDeliveryDtoSort = {
  direction: SortDirection;
  field: FunderFileDeliveryDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileDeliveryDtoSortFields =
  | 'funderFileTemplateId'
  | 'uuid';

export type FunderFileDeliverySettingsInput = {
  allowWeekendDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  delayInSeconds?: InputMaybe<Scalars['Float']['input']>;
  delivery?: InputMaybe<Scalars['String']['input']>;
  funderSourceLocation?: InputMaybe<Scalars['String']['input']>;
  funderTargetLocation?: InputMaybe<Scalars['String']['input']>;
  nextDayDeliveryTime?: InputMaybe<Scalars['String']['input']>;
  nextDayDeliveryTimezone?: InputMaybe<Scalars['String']['input']>;
  useBuyerLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FunderFileEdge = {
  __typename?: 'FunderFileEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFile */
  node: FunderFile;
};

export type FunderFileFilter = {
  and?: InputMaybe<Array<FunderFileFilter>>;
  funder?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileFilter>>;
  updatedBy?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileNotification = {
  __typename?: 'FunderFileNotification';
  funderFile: Scalars['String']['output'];
  funderFileTemplate: FunderFile;
  uuid: Scalars['String']['output'];
};

export type FunderFileNotificationEdge = {
  __typename?: 'FunderFileNotificationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderFileNotification */
  node: FunderFileNotification;
};

export type FunderFileNotificationFilter = {
  and?: InputMaybe<Array<FunderFileNotificationFilter>>;
  funderFile?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFileNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderFileNotificationSort = {
  direction: SortDirection;
  field: FunderFileNotificationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileNotificationSortFields =
  | 'funderFile'
  | 'uuid';

export type FunderFileSort = {
  direction: SortDirection;
  field: FunderFileSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderFileSortFields =
  | 'funder'
  | 'updatedBy'
  | 'uuid';

export type FunderFileSummary = {
  __typename?: 'FunderFileSummary';
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type FunderFileType =
  | 'BUYER_GENERATED'
  | 'FEEDBACK'
  | 'MATURITY'
  | 'PAYMENT';

export type FunderFilter = {
  and?: InputMaybe<Array<FunderFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderFilter>>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderGeographies = {
  __typename?: 'FunderGeographies';
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  geographyLookupId: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  includeExclude: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderGeographiesFilter = {
  and?: InputMaybe<Array<FunderGeographiesFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  geographyLookupId?: InputMaybe<NumberFieldComparison>;
  includeExclude?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderGeographiesFilter>>;
};

export type FunderGeographiesOutput = {
  __typename?: 'FunderGeographiesOutput';
  geographyLookupId: Scalars['Float']['output'];
  includeExclude: Scalars['String']['output'];
};

export type FunderGeographiesSort = {
  direction: SortDirection;
  field: FunderGeographiesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderGeographiesSortFields =
  | 'funderUuid'
  | 'geographyLookupId'
  | 'includeExclude';

export type FunderLegalAgreement = {
  __typename?: 'FunderLegalAgreement';
  agreementType: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  funderUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
};

export type FunderLegalAgreementConnection = {
  __typename?: 'FunderLegalAgreementConnection';
  /** Array of edges. */
  edges: Array<FunderLegalAgreementEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderLegalAgreementEdge = {
  __typename?: 'FunderLegalAgreementEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderLegalAgreement */
  node: FunderLegalAgreement;
};

export type FunderLegalAgreementFilter = {
  agreementType?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<FunderLegalAgreementFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderLegalAgreementFilter>>;
  termsAndConditionsUrl?: InputMaybe<StringFieldComparison>;
};

export type FunderLegalAgreementSort = {
  direction: SortDirection;
  field: FunderLegalAgreementSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderLegalAgreementSortFields =
  | 'agreementType'
  | 'funderUuid'
  | 'termsAndConditionsUrl';

export type FunderLegalSetupOutput = {
  __typename?: 'FunderLegalSetupOutput';
  agreementType: Scalars['String']['output'];
  termsAndConditionsUrl: Scalars['String']['output'];
};

export type FunderNotification = {
  __typename?: 'FunderNotification';
  created: Scalars['DateTime']['output'];
  email: Array<Scalars['String']['output']>;
  funder: Scalars['String']['output'];
  funderFileNotificationSettings: Array<FunderFileNotification>;
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};


export type FunderNotificationFunderFileNotificationSettingsArgs = {
  filter?: FunderFileNotificationFilter;
  sorting?: Array<FunderFileNotificationSort>;
};

export type FunderNotificationConnection = {
  __typename?: 'FunderNotificationConnection';
  /** Array of edges. */
  edges: Array<FunderNotificationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderNotificationEdge = {
  __typename?: 'FunderNotificationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderNotification */
  node: FunderNotification;
};

export type FunderNotificationFilter = {
  and?: InputMaybe<Array<FunderNotificationFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  funder?: InputMaybe<StringFieldComparison>;
  funderFileNotificationSettings?: InputMaybe<FunderNotificationFilterFunderFileNotificationFilter>;
  or?: InputMaybe<Array<FunderNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderNotificationFilterFunderFileNotificationFilter = {
  and?: InputMaybe<Array<FunderNotificationFilterFunderFileNotificationFilter>>;
  funderFile?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderNotificationFilterFunderFileNotificationFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderNotificationSort = {
  direction: SortDirection;
  field: FunderNotificationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderNotificationSortFields =
  | 'created'
  | 'funder'
  | 'uuid';

export type FunderSort = {
  direction: SortDirection;
  field: FunderSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderSortFields =
  | 'name'
  | 'status'
  | 'uuid';

export type FunderSummary = {
  __typename?: 'FunderSummary';
  files: Array<FunderFileSummary>;
  uuid: Scalars['String']['output'];
};

export type FunderVariable = {
  __typename?: 'FunderVariable';
  funderId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FunderVariableConnection = {
  __typename?: 'FunderVariableConnection';
  /** Array of edges. */
  edges: Array<FunderVariableEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type FunderVariableDeleteFilter = {
  and?: InputMaybe<Array<FunderVariableDeleteFilter>>;
  funderId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderVariableDeleteFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderVariableDeleteResponse = {
  __typename?: 'FunderVariableDeleteResponse';
  funderId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FunderVariableEdge = {
  __typename?: 'FunderVariableEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the FunderVariable */
  node: FunderVariable;
};

export type FunderVariableFilter = {
  and?: InputMaybe<Array<FunderVariableFilter>>;
  funderId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<FunderVariableFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type FunderVariableInput = {
  funderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FunderVariableSort = {
  direction: SortDirection;
  field: FunderVariableSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FunderVariableSortFields =
  | 'funderId'
  | 'uuid';

export type FundingPartner = {
  __typename?: 'FundingPartner';
  divisionsUsers?: Maybe<Array<FundingPartnerDivisionsUsers>>;
  name: Scalars['String']['output'];
  nodeId: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type FundingPartnerDeepFilter = {
  and?: InputMaybe<Array<FundingPartnerDeepFilter>>;
  or?: InputMaybe<Array<FundingPartnerDeepFilter>>;
  uuid?: InputMaybe<FundingPartnerUuidFilterComparison>;
};

export type FundingPartnerDivisionsUsers = {
  __typename?: 'FundingPartnerDivisionsUsers';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  hasAcceptedTermsAndConditions: Scalars['Boolean']['output'];
  nodeId: Scalars['ID']['output'];
  termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type FundingPartnerDivisionsUsersAuthServiceUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FundingPartnerDivisionsUsersDeepFilter = {
  and?: InputMaybe<Array<FundingPartnerDivisionsUsersDeepFilter>>;
  authServiceUuid?: InputMaybe<FundingPartnerDivisionsUsersAuthServiceUuidFilterComparison>;
  divisionUuid?: InputMaybe<FundingPartnerDivisionsUsersDivisionUuidFilterComparison>;
  or?: InputMaybe<Array<FundingPartnerDivisionsUsersDeepFilter>>;
};

export type FundingPartnerDivisionsUsersDivisionUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FundingPartnerDivisionsUsersOffsetConnection = {
  __typename?: 'FundingPartnerDivisionsUsersOffsetConnection';
  /** Array of nodes. */
  nodes: Array<FundingPartnerDivisionsUsers>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
};

export type FundingPartnerDivisionsUsersSort = {
  direction: SortDirection;
  field: FundingPartnerDivisionsUsersSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type FundingPartnerDivisionsUsersSortFields =
  | 'authServiceUuid'
  | 'divisionUuid';

export type FundingPartnerMarket = {
  __typename?: 'FundingPartnerMarket';
  fundingPartner?: Maybe<FundingPartner>;
  nodeId: Scalars['ID']['output'];
  termsUrl?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type FundingPartnerMarketDeepFilter = {
  and?: InputMaybe<Array<FundingPartnerMarketDeepFilter>>;
  fundingPartner?: InputMaybe<FundingPartnerDeepFilter>;
  marketUuid?: InputMaybe<FundingPartnerMarketMarketUuidFilterComparison>;
  or?: InputMaybe<Array<FundingPartnerMarketDeepFilter>>;
};

export type FundingPartnerMarketMarketUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FundingPartnerUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GenericResponseDto = {
  __typename?: 'GenericResponseDto';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type GetBuyerAppEverafterEmbedUrlInput = {
  divisionUuid: Scalars['String']['input'];
  embedLocationUrl: Scalars['String']['input'];
};

export type GetBuyerAppUserPreferenceInput = {
  /** Preference name */
  preferenceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetBuyerAppUserPreferenceOutput = {
  __typename?: 'GetBuyerAppUserPreferenceOutput';
  /** User preferences */
  preferences: Array<BuyerAppUserPreference>;
};

export type GetIncomeOverTime = {
  aggregationLevel: AggregationLevel;
  currency: Scalars['String']['input'];
  groupBy: GroupByTimePeriod;
  organizeDataOnMakerLevel?: InputMaybe<Scalars['Boolean']['input']>;
  timeRange: TimeRange;
  uuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetOutOfNetworkNewCustomerRequestResponse = {
  __typename?: 'GetOutOfNetworkNewCustomerRequestResponse';
  /** Additional information provided while making the new customer request. */
  additionalInformation?: Maybe<Scalars['String']['output']>;
  /** Approximate amount of the customers outstanding receivables. */
  approximateAR?: Maybe<Scalars['Float']['output']>;
  /** Time of creation of the new customer request. */
  created: Scalars['DateTime']['output'];
  /** currency of the customers outstanding receivables. */
  currency?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the customer is a contact reference. */
  isContactReference: Scalars['Boolean']['output'];
  /** Name of the requested customer . */
  name: Scalars['String']['output'];
  salesforceCaseId: Scalars['String']['output'];
  /** Status of the new customer request. */
  status: Scalars['String']['output'];
  /** Unique identifier for the new customer request. */
  uuid: Scalars['String']['output'];
  /** Website URL of the customer's business. */
  websiteUrl: Scalars['String']['output'];
};

export type GetSupplierMembershipOutput = {
  __typename?: 'GetSupplierMembershipOutput';
  /** Id of the salesforce account the user is associated to. */
  accountId: Scalars['String']['output'];
  /** Billing frequency the user selects for the membership. Ex: MONTHLY, QUARTERLY, YEARLY */
  billingFrequency?: Maybe<BillingFrequency>;
  /** the corresponding Stripe-assigned Subscription ID. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** UUID of the membership. */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicates if an account is eligible for membership. Default: false */
  isEligible: Scalars['Boolean']['output'];
  /** Offer builder flow that we want the user to put in experiment. EX: FLOW_1_PARTIAL, FLOW_2_DETAIL. Default: FLOW_1_PARTIAL */
  offerBuilderType?: Maybe<OfferBuilderType>;
  /** status of membership payment. Ex: NOT_APPLICABLE, PAID, PENDING, FAILED, CANCELLED. Default: NOT_APPLICABLE */
  paymentStatus?: Maybe<PaymentStatus>;
  /** Membership plan of the user that we want this user to put in experiment. Ex: BASIC, STANDARD, PREMIUM. Default: BASIC */
  plan?: Maybe<MembershipPlan>;
  /** Status of the membership. Ex: ACTIVE, PENDING, INACTIVE. Default: INACTIVE */
  status: MembershipStatus;
  /** Date when trial membership is going to end */
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type GetWcmAggregatedSpendsInput = {
  /** Aggregators for data grouping (min: 1, max: 3). Can be enum values or custom attributes (custom_attribute_1, etc.) */
  aggregators: Array<Scalars['String']['input']>;
  /** List of benchmarking strategies to use for aggregated spends. Must be one of the defined BenchmarkingStrategies (excluding custom). */
  benchmarkingStrategies?: InputMaybe<Array<Benchmarking_Strategies_With_Harmonization>>;
  filters: WcmAggregatedSpendsFilters;
  paging: WcmAggregatedSpendsPaging;
  /** Whether to show target terms in the response */
  showTargetTerms?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<GetWcmAggregatedSpendsSorting>;
};

export type GetWcmAggregatedSpendsOutput = {
  __typename?: 'GetWcmAggregatedSpendsOutput';
  spendsData: Array<WcmAggregatedSpends>;
  totalRows: Scalars['Float']['output'];
};

export type GetWcmAggregatedSpendsSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type GetWcmBenchmarkConfigInput = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBenchmarkCountryRegulationsInput = {
  /** Currency code */
  currency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerFileConfigsInput = {
  /** Transaction UUID */
  transactionUuid: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerFileConfigsOutput = {
  __typename?: 'GetWcmBuyerFileConfigsOutput';
  /** Benchmark strategy configuration */
  benchmarkStrategyConfig: BenchmarkStrategyOutput;
  /** Economic value */
  economicValueConfig: Scalars['Float']['output'];
  /** Supplier segmentation rules */
  supplierSegmentationConfig: SupplierSegmentationConfig;
  /** Transaction UUID */
  transactionUuid: Scalars['String']['output'];
};

export type GetWcmBuyerUserDetailsForAdmin = {
  __typename?: 'GetWcmBuyerUserDetailsForAdmin';
  total: Scalars['Float']['output'];
  users: Array<WcmBuyerUserDetailsForAdmin>;
};

export type GetWcmBuyerUsersInput = {
  paging: WcmBuyerUsersDetailsPaging;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerUsersOutput = {
  __typename?: 'GetWcmBuyerUsersOutput';
  total: Scalars['Float']['output'];
  users: Array<WcmBuyerUser>;
};

export type GetWcmBuyersUsersCountInput = {
  /** Filter by WCM buyer UUIDs */
  wcmBuyerUuids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetWcmExclusionsConfigInput = {
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmNegotiationsInput = {
  /** Array of vendor variant IDs to get negotiations for */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

export type GetWcmPlansForSupplierGroupInput = {
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** Vendor Variant ID */
  vendorVariantId: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmPlansInput = {
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmRegistrationRequest = {
  __typename?: 'GetWcmRegistrationRequest';
  /** Business email */
  businessEmail: Scalars['String']['output'];
  /** Business phone */
  businessPhone?: Maybe<Scalars['String']['output']>;
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Created date */
  created: Scalars['DateTime']['output'];
  /** First name */
  firstName: Scalars['String']['output'];
  /** Registration request ID */
  id: Scalars['ID']['output'];
  /** Last name */
  lastName: Scalars['String']['output'];
  /** User role */
  role: Scalars['String']['output'];
  /** Registration request status */
  status: Scalars['String']['output'];
  /** Updated date */
  updated: Scalars['DateTime']['output'];
};

export type GetWcmRegistrationRequestsFilter = {
  /** Array of registration request IDs (max 100) */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by registration request status */
  status?: InputMaybe<Wcm_User_Self_Registration_Request_Status>;
};

export type GetWcmRegistrationRequestsInput = {
  /** Filter criteria */
  filter?: InputMaybe<GetWcmRegistrationRequestsFilter>;
  /** Number of items to return (max: 100, min: 1) */
  limit: Scalars['Float']['input'];
  /** Number of items to skip (default: 0) */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** Sort criteria */
  sort?: InputMaybe<GetWcmRegistrationRequestsSort>;
};

export type GetWcmRegistrationRequestsResponse = {
  __typename?: 'GetWcmRegistrationRequestsResponse';
  /** Number of items returned */
  count: Scalars['Float']['output'];
  /** List of registration requests */
  requests?: Maybe<Array<GetWcmRegistrationRequest>>;
  /** Total number of registration requests matching the criteria */
  total: Scalars['Float']['output'];
};

export type GetWcmRegistrationRequestsSort = {
  /** Field to sort by */
  field: Wcm_User_Self_Registration_Order_By;
  /** Sort order */
  order: Order_Type;
};

export type GetWcmSegmentConversionRateInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSupplierGroupNotesInput = {
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSupplierHealthMetricsInput = {
  /** Supplier Profile Common Filters */
  filters?: InputMaybe<WcmSupplierProfileCommonFilters>;
  /** Supplier ID (entity ID) */
  supplierId: Scalars['Float']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmSuppliersBenchmarkStrategyBySegmentInput = {
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmUserPreferenceInput = {
  /** Preference name */
  preferenceName?: InputMaybe<Scalars['String']['input']>;
};

export type GetWcmUserPreferenceOutput = {
  __typename?: 'GetWcmUserPreferenceOutput';
  /** User preferences */
  preferences: Array<WcmUserPreference>;
};

export type GlobalOfferInputDto = {
  /** Determines whether offers should be enabled or not. Allowed null when both rate and type are set. */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** todo. */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** todo. */
  type?: InputMaybe<Rate>;
};

export type GlobalOfferInputTransformerValidation = {
  __typename?: 'GlobalOfferInputTransformerValidation';
  /** List of all validation errors. */
  errorReasons?: Maybe<Array<Scalars['String']['output']>>;
  /** Indicates that the existing offer is configured for Discount bidding, but discount rate is missing. */
  existingOfferDiscountBiddingButDiscountMissing: Scalars['Boolean']['output'];
  /** Indicates whether the existing offer is missing rates */
  existingOfferMissingRates: Scalars['Boolean']['output'];
  /** Indicates that the existing offer is not configured for Discount bidding, but apr rate is missing. */
  existingOfferNotDiscountBiddingButAprMissing: Scalars['Boolean']['output'];
  /** Indicates that the funding partners agreements have not been signed for specified market by this supplier. */
  fundingPartnerUnregistered: Scalars['Boolean']['output'];
  /** Indicates whether the takers market is valid for global offer. */
  isValid: Scalars['Boolean']['output'];
  /** Indicates that the takers market is configured for Discount only, but global offer was for APR. */
  marketIsDiscountOnlyAndAPRInput: Scalars['Boolean']['output'];
  /** Indicates whether the takers market is missing both max apr and max discount rates */
  marketSettingsMissingRates: Scalars['Boolean']['output'];
  /** Indicates that the latest supplier api agreements have not been signed for specified market by this supplier. */
  marketTermsNotSigned: Scalars['Boolean']['output'];
};

export type GlobalOfferResultFailureDatumDto = {
  __typename?: 'GlobalOfferResultFailureDatumDto';
  error?: Maybe<Scalars['String']['output']>;
  marketUuid: Scalars['String']['output'];
  supplierDivisionUuid: Scalars['String']['output'];
};

export type GlobalOfferResultSuccessDatumDto = {
  __typename?: 'GlobalOfferResultSuccessDatumDto';
  marketUuid: Scalars['String']['output'];
  supplierDivisionUuid: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type GlobalOfferResultValidationErrorsDatumDto = {
  __typename?: 'GlobalOfferResultValidationErrorsDatumDto';
  marketUuid: Scalars['String']['output'];
  supplierDivisionUuid: Scalars['String']['output'];
  validation?: Maybe<GlobalOfferInputTransformerValidation>;
};

export type GroupByDto = {
  aggregationLevels?: InputMaybe<Array<HistoryInfoAggregationLevelEnums>>;
  timePeriod?: InputMaybe<GroupByTimePeriod>;
};

export type GroupByTimePeriod =
  | 'ALL'
  | 'DAY'
  | 'MONTH'
  | 'QUARTER'
  | 'WEEK'
  | 'YEAR';

export type GroupableFieldsType = ByMakerOrgCustomGroupUuid;

export type GroupedByOpportunityUuidTakerConfigsInputDto = {
  opportunityAuthServiceUuid: Scalars['String']['input'];
  opportunityUuid: Scalars['String']['input'];
  takerConfigs: Array<MigratableTakerConfigInputDto>;
};

/** An opportunity represents a group of invoices from a particular buyer that can have an offer placed on them. */
export type GroupedOpportunity = {
  __typename?: 'GroupedOpportunity';
  /** The authServiceUuid of the User who is tied to the opportunity */
  authServiceUuid: Scalars['String']['output'];
  /** Benchmark Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  benchmarkRateStats?: Maybe<BenchmarkRateStats>;
  /** The buyer division uuid */
  buyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  /** CashFlow Plus Stats */
  cashFlowPlusStats?: Maybe<Array<CashFlowPlusStats>>;
  /** Currency of the opportunity after conversion was done. */
  convertedCurrency?: Maybe<Scalars['String']['output']>;
  /** Currency the opportunity was converted to when considering opportunities across groups */
  convertedCurrencyAcrossGroups?: Maybe<Scalars['String']['output']>;
  /** The original currency of the opportunity before any conversion was done. */
  currency: Scalars['String']['output'];
  /** Custom group for opportunities. */
  customGroup?: Maybe<OpportunityCustomGroup>;
  /** Unique identifier for customer */
  customerUuid: Scalars['String']['output'];
  /** Exchange rate from the opportunitiy's original currency to the converted currency. */
  exchangeRateToConvertedCurrency?: Maybe<Scalars['Float']['output']>;
  /** Exchange rate used when converting this opportunity to convertedCurrencyAcrossGroups */
  exchangeRateToConvertedCurrencyAcrossGroups?: Maybe<Scalars['Float']['output']>;
  /** Invoice summary data associated with this opportunity */
  invoiceSummary: InvoiceSummaryOpportunityGroups;
  /** Indicates if this opportunity is eligible for CashFlow+ */
  isCashFlowPlusEligible: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is open or closed for offers */
  isClosed: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is currently part of any active offers */
  isInActiveOffer: Scalars['Boolean']['output'];
  /** Indicates whether this opportunity was created through a creation endpoint. */
  isManuallyCreated: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is eligible for preferred term */
  isPreferredEligible: Scalars['Boolean']['output'];
  /** Whether an opportunity should default to selected as defined within the custom group. */
  isPreselected: Scalars['Boolean']['output'];
  /** Name for this customer, suitable for display to suppliers. */
  makerDisplayName: Scalars['String']['output'];
  /** URL pointing to the Buyer's logo in PNG format. */
  makerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  /** Maker organization UUID for this opportunities parent customer. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Calculated name of the opportunity using the custom group if set. */
  opportunityName?: Maybe<Scalars['String']['output']>;
  /** Information about the pricing related to this opportunity [StaticRate, BenchmarkRate, PriceDiscovery] */
  priceType: PriceType;
  /** Reference Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  referenceRateStats?: Maybe<ReferenceRateStats>;
  /** Request Options array. This contains a list of enums that indicate the type of opportunity and any special conditions. Example: A PreferredTerm entry indicates a preferred offer can be placed on this opportunity */
  requestOptions?: Maybe<Array<RequestOptions>>;
  /** TakersMarkets data associated with this opportunity */
  takersMarkets: Array<EarlyPayOpportunityTakersMarket>;
  /** Type of the opportunity, either PRICE_DISCOVERY or STATIC_RATE */
  type: OpportunityType;
  /** Unique identifier for this opportunity */
  uuid: Scalars['ID']['output'];
};

/** GroupedOpportunityData */
export type GroupedOpportunityData = {
  __typename?: 'GroupedOpportunityData';
  /** The method in which the opportunities were grouped by. [GroupByMakerOrgCustomGroupUuid] */
  groupedBy: GroupableFieldsType;
  /** List of opportunities  that make up this grouping. */
  opportunities: Array<GroupedOpportunity>;
  /** List of opportunities uuids that make up this grouped list of opportunities. */
  opportunityUuids: Array<Scalars['String']['output']>;
};

export type GroupedOpportunityDataAggregateFilter = {
  and?: InputMaybe<Array<GroupedOpportunityDataAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  currency?: InputMaybe<GroupedOpportunityDataCurrencyFilterComparison>;
  customerUuid?: InputMaybe<GroupedOpportunityDataCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<GroupedOpportunityDataDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  groupBy?: InputMaybe<GroupedOpportunityDataGroupByFilterComparison>;
  makerOrganizationUuid?: InputMaybe<GroupedOpportunityDataMakerOrganizationUuidFilterComparison>;
  or?: InputMaybe<Array<GroupedOpportunityDataAggregateFilter>>;
  type?: InputMaybe<GroupedOpportunityDataTypeFilterComparison>;
  uuid?: InputMaybe<GroupedOpportunityDataUuidFilterComparison>;
};

export type GroupedOpportunityDataAggregateGroupBy = {
  __typename?: 'GroupedOpportunityDataAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<OpportunityGroupByType>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type GroupedOpportunityDataAggregateResponse = {
  __typename?: 'GroupedOpportunityDataAggregateResponse';
  count?: Maybe<GroupedOpportunityDataCountAggregate>;
  groupBy?: Maybe<GroupedOpportunityDataAggregateGroupBy>;
  max?: Maybe<GroupedOpportunityDataMaxAggregate>;
  min?: Maybe<GroupedOpportunityDataMinAggregate>;
};

export type GroupedOpportunityDataConnection = {
  __typename?: 'GroupedOpportunityDataConnection';
  /** Array of edges. */
  edges: Array<GroupedOpportunityDataEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type GroupedOpportunityDataCountAggregate = {
  __typename?: 'GroupedOpportunityDataCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  customerUuid?: Maybe<Scalars['Int']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['Int']['output']>;
  groupBy?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type GroupedOpportunityDataCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupedOpportunityDataCustomerUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupedOpportunityDataDesiredCurrencyForMultipleCurrenciesFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type GroupedOpportunityDataEdge = {
  __typename?: 'GroupedOpportunityDataEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the GroupedOpportunityData */
  node: GroupedOpportunityData;
};

export type GroupedOpportunityDataFilter = {
  and?: InputMaybe<Array<GroupedOpportunityDataFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  currency?: InputMaybe<GroupedOpportunityDataCurrencyFilterComparison>;
  customerUuid?: InputMaybe<GroupedOpportunityDataCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<GroupedOpportunityDataDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  groupBy?: InputMaybe<GroupedOpportunityDataGroupByFilterComparison>;
  makerOrganizationUuid?: InputMaybe<GroupedOpportunityDataMakerOrganizationUuidFilterComparison>;
  or?: InputMaybe<Array<GroupedOpportunityDataFilter>>;
  type?: InputMaybe<GroupedOpportunityDataTypeFilterComparison>;
  uuid?: InputMaybe<GroupedOpportunityDataUuidFilterComparison>;
};

export type GroupedOpportunityDataGroupByFilterComparison = {
  eq?: InputMaybe<OpportunityGroupByType>;
};

export type GroupedOpportunityDataMakerOrganizationUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupedOpportunityDataMaxAggregate = {
  __typename?: 'GroupedOpportunityDataMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<OpportunityGroupByType>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type GroupedOpportunityDataMinAggregate = {
  __typename?: 'GroupedOpportunityDataMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<OpportunityGroupByType>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type GroupedOpportunityDataSort = {
  direction: SortDirection;
  field: GroupedOpportunityDataSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type GroupedOpportunityDataSortFields =
  | 'authServiceUuid'
  | 'currency'
  | 'customerUuid'
  | 'desiredCurrencyForMultipleCurrencies'
  | 'groupBy'
  | 'makerOrganizationUuid'
  | 'type'
  | 'uuid';

export type GroupedOpportunityDataTypeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GroupedOpportunityDataUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type HistoryData = {
  __typename?: 'HistoryData';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedYield?: Maybe<Scalars['Float']['output']>;
  clearedAprAvg?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmountAvgByPayDate?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId?: Maybe<Scalars['Float']['output']>;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  makerMarketClearIdsForFundedMarkets?: Maybe<Array<Scalars['Float']['output']>>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  marketUuids?: Maybe<Array<Scalars['String']['output']>>;
  maxClearedApr?: Maybe<Scalars['Float']['output']>;
  minClearedApr?: Maybe<Scalars['Float']['output']>;
  organizationUuid?: Maybe<Scalars['String']['output']>;
  participatingSuppliersCount?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  payDatesCount?: Maybe<Scalars['Float']['output']>;
  totalSuppliersCount?: Maybe<Scalars['Float']['output']>;
};

export type HistoryInfoAggregationLevelEnums =
  | 'CURRENCY'
  | 'DIVISION'
  | 'MARKET'
  | 'ORGANIZATION'
  | 'PAY_DATE';

export type HistoryInfoFilters = {
  clearedInvoiceAmount?: InputMaybe<NumberComparison>;
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  isPendingClear?: InputMaybe<Scalars['Boolean']['input']>;
  markets: Array<MarketDetails>;
  startDate: Scalars['DateTime']['input'];
};

export type HistoryInfoInput = {
  filters: HistoryInfoFilters;
  paging: Paging;
  sorting: Sorting;
};

export type HistoryInfoOutput = {
  __typename?: 'HistoryInfoOutput';
  history?: Maybe<Array<HistoryData>>;
  totalRows?: Maybe<Scalars['Float']['output']>;
};

export type IdFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  iLike?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notILike?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  notLike?: InputMaybe<Scalars['ID']['input']>;
};

export type Invoice_Type =
  | 'ELIGIBLE'
  | 'INELIGIBLE';

export type IdentityFieldType =
  | 'auth_service_uuid';

export type IncludeExcludeWcmSuppliersInputDto = {
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: InputMaybe<Scalars['String']['input']>;
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of supplier IDs explicitly not selected (excluded) */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Exclusion Remark id */
  exclusionRemarkId?: InputMaybe<Scalars['Float']['input']>;
  operationType: Supplier_Operation_Type;
  reason: Scalars['String']['input'];
  /** List of supplier IDs selected for inclusion or exclusion */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type IncludeExcludeWcmSuppliersOutput = {
  __typename?: 'IncludeExcludeWcmSuppliersOutput';
  status: Scalars['Boolean']['output'];
};

export type IncomeOverTimeReturnType = {
  __typename?: 'IncomeOverTimeReturnType';
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedYield: Scalars['Float']['output'];
  created: Scalars['String']['output'];
  makerUuid?: Maybe<Scalars['String']['output']>;
  weightedAvgDesiredAprSum: Scalars['Float']['output'];
};

export type InitiateActionableOfferDto = {
  __typename?: 'InitiateActionableOfferDto';
  accountsCount: Scalars['Int']['output'];
};

export type InitiateActionableOfferInput = {
  authServiceUuid: Scalars['String']['input'];
  currentDate: Scalars['String']['input'];
  isDebugMode: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  occurrenceType?: Occurrence;
  offerType?: OfferType;
  offerUuid: Scalars['String']['input'];
  segmentId: Scalars['String']['input'];
  srmHomeUserUuid?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** The input object for creating communication channel associated with a communication preference */
export type InputCommunicationChannel = {
  channel?: InputMaybe<Scalars['String']['input']>;
  communicationPreferenceUuid: Scalars['String']['input'];
  frequency?: InputMaybe<Scalars['String']['input']>;
  frequencyValue?: InputMaybe<Scalars['String']['input']>;
};

/** The input object for updating communication channel associated with a communication preference */
export type InputCommunicationChannelUpdate = {
  channel?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  frequencyValue?: InputMaybe<Scalars['String']['input']>;
};

export type IntFieldComparison = {
  between?: InputMaybe<IntFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  notBetween?: InputMaybe<IntFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int']['input'];
  upper: Scalars['Int']['input'];
};

export type InvoiceEditDataDto = {
  /** May be used to EXCLUDE or INCLUDE all invoices */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** Invoice amount, to be used as a range with amountTo */
  amountFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Amount range used in an INCLUSIVE search to apply invoice operations. Defaults to undefined, but will default to 0 if amountSearchTo is supplied */
  amountSearchFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Amount range used in an INCLUSIVE search to apply invoice operations. Defaults to undefined, but will default to 999999999999999 if amountSearchFrom is supplied */
  amountSearchTo?: InputMaybe<Scalars['Float']['input']>;
  /** Invoice amount, to be used as a range with amountFrom */
  amountTo?: InputMaybe<Scalars['Float']['input']>;
  /** Company Id associated with invoices to include */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Lower bound of number of days before original due date, to to be used as a range with daysPaidEarlyTo */
  daysPaidEarlyFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Days paid early range used in an INCLUSIVE search to apply invoice operations. Defaults to undefined, but will default to 0 if daysPaidEarlySearchTo is  applied */
  daysPaidEarlySearchFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Days paid early range used in an INCLUSIVE search to apply invoice operations. Defaults to undefined, but will default to 999999999999999 if daysPaidEarlySearchFrom is  applied */
  daysPaidEarlySearchTo?: InputMaybe<Scalars['Float']['input']>;
  /** Upper bound of number of days before original due date, to to be used as a range with daysPaidEarlyFrom */
  daysPaidEarlyTo?: InputMaybe<Scalars['Float']['input']>;
  /** When an invoice is deposited, to to be used as a range with earlyPayDateTo */
  earlyPayDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** When an invoice is deposited, to to be used as a range with earlyPayDateFrom */
  earlyPayDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** When an invoice is awarded buyer is informed, to be used as a range with earlyPaymentSentTo */
  earlyPaymentSentFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** When an invoice is awarded buyer is informed, to be used as a range with earlyPaymentSentFrom */
  earlyPaymentSentTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Invoice taker_excluded status to apply invoice operations/filters. Defaults to ALL */
  invoiceStatusSearch?: InputMaybe<Scalars['String']['input']>;
  /** The operation to be used with th provided input. INCLUDE includes invoice(s). EXCLUDE excludes invoice(s) */
  operation: InvoiceEditOperation;
  /** Opportunity Uuid associated to this invoice edit. */
  opportunityUuid: Scalars['String']['input'];
  /** Original Due date for a given invoice, to be used as a range with originalDueDateTo */
  originalDueDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Original Due date for a given invoice, to be used as a range with originalDueDateFrom */
  originalDueDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** List of invoices by voucher ID to include in the operation */
  voucherIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Voucher ID to search for in the invoice operation. This searches instead of requiring an exact match on voucherId. */
  voucherSearchText?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceEditOperation =
  | 'EXCLUDE'
  | 'INCLUDE';

export type InvoiceStatsFilterForMarket = {
  dateGroupBy: GroupByTimePeriod;
  marketUuid: Scalars['String']['input'];
  timeRange: TimeRange;
};

export type InvoiceStatsOutput = {
  __typename?: 'InvoiceStatsOutput';
  aggEligibleInvoiceAmount: Scalars['Float']['output'];
  aggNewAdjustmentAmount: Scalars['Float']['output'];
  aggNewAdjustmentCount: Scalars['Float']['output'];
  aggNewInvoiceAmount: Scalars['Float']['output'];
  aggNewInvoiceCount: Scalars['Float']['output'];
  aggParticipatingInvoiceAmount: Scalars['Float']['output'];
  aggRegisteredInvoiceAmount: Scalars['Float']['output'];
  aggUnpaidInvoiceAmount: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
};

/** Aggregate statistics for the eligible invoices in this opportunity */
export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  /** Total weighted sum of all the invoice amounts in this opportunity (original currency). Calculated by multiplying each invoice amount by the DPE and adding them. */
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  /** Total weighted sum of all the invoice amounts in this opportunity (converted currency) */
  eligibleDpeWeightedSumConverted?: Maybe<Scalars['Float']['output']>;
  /**
   * Total weighted sum of all the invoice amounts in this opportunity (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleDpeWeightedSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total eligible amount of the invoice bundle (original currency) */
  eligibleInvoiceAmount: Scalars['Float']['output'];
  /** Total eligible amount of the invoice bundle (converted currency) */
  eligibleInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /**
   * Total eligible amount of the invoice bundle (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Number of eligible invoices in this opportunity */
  eligibleInvoiceCount: Scalars['Float']['output'];
  /** Furthest future date a supplier would get paid if they placed a successful offer on this opportunity (Ex: '2021-06-30') */
  maxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  /** The next market clear time (nearest future) across all takers_markets that make up this opportunity (Ex: '2021-06-22T16:00:00.000Z') */
  requestDeadline?: Maybe<Scalars['String']['output']>;
  /** The amount of invoices currently excluded by the supplier (original currency) */
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  /** The amount of invoices currently excluded by the supplier (converted currency) */
  takerExcludedInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of invoices currently excluded by the supplier (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  takerExcludedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The count of invoices currently excluded by the supplier */
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (original currency, eligible + excluded) */
  totalEarlyPayInvoiceAmount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (converted currency, eligible + excluded) */
  totalEarlyPayInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /**
   * The total amount of invoices that could participate in early pay (US Dollar, eligible + excluded)
   *  Null if no conversion rate to USD was found
   */
  totalEarlyPayInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The total count of invoices that could participate in early pay (eligible + excluded) */
  totalEarlyPayInvoiceCount: Scalars['Float']['output'];
};

export type InvoiceSummaryOpportunityGroups = {
  __typename?: 'InvoiceSummaryOpportunityGroups';
  /** Total weighted sum of all the invoice amounts in this opportunity (original currency). Calculated by multiplying each invoice amount by the DPE and adding them. */
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  /** Total weighted sum of all the invoice amounts in this opportunity (converted currency) */
  eligibleDpeWeightedSumConverted?: Maybe<Scalars['Float']['output']>;
  /** Total weighted sum of all the invoices in this opportunity (converted currency across groups) */
  eligibleDpeWeightedSumConvertedAcrossGroups?: Maybe<Scalars['Float']['output']>;
  /**
   * Total weighted sum of all the invoice amounts in this opportunity (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleDpeWeightedSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total eligible amount of the invoice bundle (original currency) */
  eligibleInvoiceAmount: Scalars['Float']['output'];
  /** Total eligible amount of the invoice bundle (converted currency) */
  eligibleInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** Total eligible amount of the invoice bundle (converted currency across groups) */
  eligibleInvoiceAmountConvertedAcrossGroups?: Maybe<Scalars['Float']['output']>;
  /**
   * Total eligible amount of the invoice bundle (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Number of eligible invoices in this opportunity */
  eligibleInvoiceCount: Scalars['Float']['output'];
  /** Furthest future date a supplier would get paid if they placed a successful offer on this opportunity (Ex: '2021-06-30') */
  maxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  /** The next market clear time (nearest future) across all takers_markets that make up this opportunity (Ex: '2021-06-22T16:00:00.000Z') */
  requestDeadline?: Maybe<Scalars['String']['output']>;
  /** The amount of invoices currently excluded by the supplier (original currency) */
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  /** The amount of invoices currently excluded by the supplier (converted currency) */
  takerExcludedInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** The amount of invoices currently excluded by the supplier (converted currency across groups) */
  takerExcludedInvoiceAmountConvertedAcrossGroups?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of invoices currently excluded by the supplier (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  takerExcludedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The count of invoices currently excluded by the supplier */
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (original currency, eligible + excluded) */
  totalEarlyPayInvoiceAmount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (converted currency, eligible + excluded) */
  totalEarlyPayInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** The total amount of invoices that could participate in early pay (converted currency across groups, eligible + excluded) */
  totalEarlyPayInvoiceAmountConvertedAcrossGroups?: Maybe<Scalars['Float']['output']>;
  /**
   * The total amount of invoices that could participate in early pay (US Dollar, eligible + excluded)
   *  Null if no conversion rate to USD was found
   */
  totalEarlyPayInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The total count of invoices that could participate in early pay (eligible + excluded) */
  totalEarlyPayInvoiceCount: Scalars['Float']['output'];
};

export type JourneyParamResponse = {
  __typename?: 'JourneyParamResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  authServiceUuid: Scalars['String']['output'];
  emailAddress: Scalars['String']['output'];
  isBuyerDivisionLinked: Scalars['Boolean']['output'];
  isBuyerProvided: Scalars['Boolean']['output'];
  isHighConfidenceNBPC: Scalars['Boolean']['output'];
  isOfferPlacedInPast: Scalars['Boolean']['output'];
  journeyPhase?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  newExperienceEnabled?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['Float']['output'];
  termsCondsFlag: Scalars['Boolean']['output'];
  treatment?: Maybe<Treatment>;
  userPreferredLocale?: Maybe<Scalars['String']['output']>;
};

export type LeadSource = {
  __typename?: 'LeadSource';
  isBuyerProvided: Scalars['Boolean']['output'];
  salesforceDetails: SalesforceDetails;
};

export type LinkingRequestStatus =
  | 'FAILED'
  | 'IN_PROGRESS'
  | 'LINKED'
  | 'PROCESSING';

export type LiveMarketStatsData = {
  __typename?: 'LiveMarketStatsData';
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedTakerCount?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedTakerCount?: Maybe<Scalars['Float']['output']>;
  blendedClearingInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  blendedClearingYieldWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearingAp?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  eligibleAp?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  nonClearingAp?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedTakerCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYieldWeightedSum?: Maybe<Scalars['Float']['output']>;
  participatingAp?: Maybe<Scalars['Float']['output']>;
  participatingWithApCount?: Maybe<Scalars['Float']['output']>;
  thirdPartyBlendedClearingInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  thirdPartyNotAcceptedInvoiceAmountDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
};

export type LiveMarketStatsInput = {
  allMarketUuids?: Array<Scalars['String']['input']>;
  fundedMarketUuids?: Array<Scalars['String']['input']>;
};

export type LocationsDto = {
  __typename?: 'LocationsDto';
  locations: Array<Scalars['String']['output']>;
};

export type LoginHistory = {
  __typename?: 'LoginHistory';
  application?: Maybe<Application>;
  authType: Scalars['String']['output'];
  created: Scalars['String']['output'];
  userUuid: Scalars['ID']['output'];
};

export type LookupConfigValues = {
  __typename?: 'LookupConfigValues';
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  lookupMaster?: Maybe<LookupMaster>;
  lookupMasterId: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
  userUuid: Scalars['Float']['output'];
};

export type LookupConfigValuesFilter = {
  and?: InputMaybe<Array<LookupConfigValuesFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  displayName?: InputMaybe<StringFieldComparison>;
  lookupMaster?: InputMaybe<LookupConfigValuesFilterLookupMasterFilter>;
  lookupMasterId?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<LookupConfigValuesFilter>>;
  userUuid?: InputMaybe<NumberFieldComparison>;
};

export type LookupConfigValuesFilterLookupMasterFilter = {
  and?: InputMaybe<Array<LookupConfigValuesFilterLookupMasterFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LookupConfigValuesFilterLookupMasterFilter>>;
};

export type LookupConfigValuesSort = {
  direction: SortDirection;
  field: LookupConfigValuesSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type LookupConfigValuesSortFields =
  | 'code'
  | 'displayName'
  | 'lookupMasterId'
  | 'userUuid';

export type LookupMaster = {
  __typename?: 'LookupMaster';
  code: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updated: Scalars['DateTime']['output'];
};

export type LookupMasterConnection = {
  __typename?: 'LookupMasterConnection';
  /** Array of edges. */
  edges: Array<LookupMasterEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type LookupMasterEdge = {
  __typename?: 'LookupMasterEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the LookupMaster */
  node: LookupMaster;
};

export type LookupMasterFilter = {
  and?: InputMaybe<Array<LookupMasterFilter>>;
  code?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<LookupMasterFilter>>;
};

export type LookupMasterSort = {
  direction: SortDirection;
  field: LookupMasterSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type LookupMasterSortFields =
  | 'code';

export type MakerMarketClear = {
  __typename?: 'MakerMarketClear';
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate: Scalars['DateTime']['output'];
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  clearedAprWeightedAvg: Scalars['Float']['output'];
  clearedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount: Scalars['Float']['output'];
  clearedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  clearedDpeWeightedSum: Scalars['Float']['output'];
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedTakerCount: Scalars['Float']['output'];
  clearedYield?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  dataCenterCode: Scalars['String']['output'];
  exchangeRates?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of `created` */
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated in favor of `updated` */
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketAwardEventId?: Maybe<Scalars['Float']['output']>;
  marketCashPool?: Maybe<Scalars['Float']['output']>;
  marketId: Scalars['Int']['output'];
  marketReturnAmount: Scalars['Float']['output'];
  marketUuid: Scalars['String']['output'];
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedDpe?: Maybe<Scalars['Float']['output']>;
  maxClearedApr?: Maybe<Scalars['Float']['output']>;
  maxClearedDpe?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedDpe?: Maybe<Scalars['Float']['output']>;
  minClearedApr?: Maybe<Scalars['Float']['output']>;
  minClearedDpe?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg: Scalars['Float']['output'];
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearAggregateFilter = {
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<MakerMarketClearAggregateFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<FloatFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  legacyDbCreated?: InputMaybe<DateFieldComparison>;
  legacyDbUpdated?: InputMaybe<DateFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketReturnAmount?: InputMaybe<FloatFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<FloatFieldComparison>;
  or?: InputMaybe<Array<MakerMarketClearAggregateFilter>>;
  payDate?: InputMaybe<DateFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type MakerMarketClearAggregateGroupBy = {
  __typename?: 'MakerMarketClearAggregateGroupBy';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPendingClear?: Maybe<Scalars['Boolean']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearAggregateResponse = {
  __typename?: 'MakerMarketClearAggregateResponse';
  avg?: Maybe<MakerMarketClearAvgAggregate>;
  count?: Maybe<MakerMarketClearCountAggregate>;
  groupBy?: Maybe<MakerMarketClearAggregateGroupBy>;
  max?: Maybe<MakerMarketClearMaxAggregate>;
  min?: Maybe<MakerMarketClearMinAggregate>;
  sum?: Maybe<MakerMarketClearSumAggregate>;
};

export type MakerMarketClearAvgAggregate = {
  __typename?: 'MakerMarketClearAvgAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type MakerMarketClearConnection = {
  __typename?: 'MakerMarketClearConnection';
  /** Array of edges. */
  edges: Array<MakerMarketClearEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type MakerMarketClearCountAggregate = {
  __typename?: 'MakerMarketClearCountAggregate';
  acceptedEarn?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  acceptedYield?: Maybe<Scalars['Int']['output']>;
  awardDate?: Maybe<Scalars['Int']['output']>;
  awardedEarn?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  awardedYield?: Maybe<Scalars['Int']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPendingClear?: Maybe<Scalars['Int']['output']>;
  legacyDbCreated?: Maybe<Scalars['Int']['output']>;
  legacyDbUpdated?: Maybe<Scalars['Int']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  notAcceptedYield?: Maybe<Scalars['Int']['output']>;
  payDate?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type MakerMarketClearEdge = {
  __typename?: 'MakerMarketClearEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the MakerMarketClear */
  node: MakerMarketClear;
};

export type MakerMarketClearFilter = {
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<MakerMarketClearFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<FloatFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  created?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  legacyDbCreated?: InputMaybe<DateFieldComparison>;
  legacyDbUpdated?: InputMaybe<DateFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketReturnAmount?: InputMaybe<FloatFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<FloatFieldComparison>;
  or?: InputMaybe<Array<MakerMarketClearFilter>>;
  payDate?: InputMaybe<DateFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type MakerMarketClearMaxAggregate = {
  __typename?: 'MakerMarketClearMaxAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearMinAggregate = {
  __typename?: 'MakerMarketClearMinAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legacyDbCreated?: Maybe<Scalars['DateTime']['output']>;
  legacyDbUpdated?: Maybe<Scalars['DateTime']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type MakerMarketClearSort = {
  direction: SortDirection;
  field: MakerMarketClearSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type MakerMarketClearSortFields =
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardDate'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'clearedDiscountedAmount'
  | 'created'
  | 'currency'
  | 'dataCenterCode'
  | 'id'
  | 'isPendingClear'
  | 'legacyDbCreated'
  | 'legacyDbUpdated'
  | 'makerId'
  | 'makerUuid'
  | 'marketId'
  | 'marketReturnAmount'
  | 'marketUuid'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'payDate'
  | 'updated';

export type MakerMarketClearSumAggregate = {
  __typename?: 'MakerMarketClearSumAggregate';
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  marketReturnAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type MakersTakersOrganizations = {
  __typename?: 'MakersTakersOrganizations';
  /** @deprecated Deprecated in favor of `divisionId` */
  buyerSupplierId?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  divisionId?: Maybe<Scalars['String']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Deprecated in favor of `makerId` */
  makerDivisionId?: Maybe<Scalars['Int']['output']>;
  makerDivisionUuid?: Maybe<Scalars['String']['output']>;
  makerId: Scalars['Int']['output'];
  makerOrganizationId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of `takerId` */
  takerDivisionId?: Maybe<Scalars['Int']['output']>;
  takerId: Scalars['Int']['output'];
  takerOrganizationId?: Maybe<Scalars['Int']['output']>;
  takerOrganizationUuid?: Maybe<Scalars['String']['output']>;
};

export type MakersTakersOrganizationsConnection = {
  __typename?: 'MakersTakersOrganizationsConnection';
  /** Array of edges. */
  edges: Array<MakersTakersOrganizationsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type MakersTakersOrganizationsEdge = {
  __typename?: 'MakersTakersOrganizationsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the MakersTakersOrganizations */
  node: MakersTakersOrganizations;
};

export type MakersTakersOrganizationsFilter = {
  and?: InputMaybe<Array<MakersTakersOrganizationsFilter>>;
  buyerSupplierId?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  isImported?: InputMaybe<BooleanFieldComparison>;
  makerDivisionId?: InputMaybe<IntFieldComparison>;
  makerDivisionUuid?: InputMaybe<StringFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationId?: InputMaybe<IntFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<MakersTakersOrganizationsFilter>>;
  takerDivisionId?: InputMaybe<IntFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerOrganizationId?: InputMaybe<IntFieldComparison>;
  takerOrganizationUuid?: InputMaybe<StringFieldComparison>;
};

export type MakersTakersOrganizationsSort = {
  direction: SortDirection;
  field: MakersTakersOrganizationsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type MakersTakersOrganizationsSortFields =
  | 'buyerSupplierId'
  | 'dataCenterCode'
  | 'isImported'
  | 'makerDivisionId'
  | 'makerDivisionUuid'
  | 'makerId'
  | 'makerOrganizationId'
  | 'makerOrganizationUuid'
  | 'takerDivisionId'
  | 'takerId'
  | 'takerOrganizationId'
  | 'takerOrganizationUuid';

export type MarketDetails = {
  excludeIncome?: Scalars['Boolean']['input'];
  excludeYield?: Scalars['Boolean']['input'];
  isFunderMarket?: Scalars['Boolean']['input'];
  marketUuid: Scalars['String']['input'];
};

export type MarketFeature = {
  __typename?: 'MarketFeature';
  feature: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
};

export type MarketFeatureFeatureFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MarketFeatureFilter = {
  and?: InputMaybe<Array<MarketFeatureFilter>>;
  feature?: InputMaybe<MarketFeatureFeatureFilterComparison>;
  or?: InputMaybe<Array<MarketFeatureFilter>>;
};

export type MarketFeatureSort = {
  direction: SortDirection;
  field: MarketFeatureSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type MarketFeatureSortFields =
  | 'feature';

export type MarketSettingsInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
};

export type MarketSettingsOutput = {
  __typename?: 'MarketSettingsOutput';
  /** Adjustment Tolerance for the market */
  adjTolerance?: Maybe<Scalars['Float']['output']>;
  /** Cash Replenishment Schedule for the market cash pool */
  cashPoolSchedule: CashPoolScheduleOutput;
  /** Cash Pool Settings for the market cash pool */
  cashPoolSettings: CashPoolSettingsOutput;
  /** Market Currency */
  currency: Scalars['String']['output'];
  /** Dual Authorization Pending Requests for the market settings */
  dualAuthorizations: BuyerAppMarketSettingsDualAuthorizationOutput;
  /** Market Uuid */
  marketUuid: Scalars['String']['output'];
  /** Reserve settings for the market */
  reserveSettings: ReserveSettingsOutput;
  /** Restriction settings for the market */
  restriction: RestrictionSettingsOutput;
};

export type MarketStatsData = {
  __typename?: 'MarketStatsData';
  blendedClearingEarn: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  divisionId?: Maybe<Scalars['Int']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  divisionUuid?: Maybe<Scalars['String']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid: Scalars['String']['output'];
  marketYield: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  productType?: Maybe<Scalars['String']['output']>;
};

export type MarketStatsInput = {
  makerUuids: Array<Scalars['String']['input']>;
};

export type MarketingDivisionInfo = {
  __typename?: 'MarketingDivisionInfo';
  buyerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
};

export type MembershipPlan =
  | 'BASIC'
  | 'PREMIUM'
  | 'STANDARD';

export type MembershipStatus =
  | 'ACTIVE'
  | 'INACTIVE'
  | 'PENDING'
  | 'TRIAL';

export type MergeConfigInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  mergeOperation: Scalars['String']['input'];
};

export type MergeConfigOutput = {
  __typename?: 'MergeConfigOutput';
  config?: Maybe<Scalars['JSON']['output']>;
  mergeOperation: Scalars['String']['output'];
};

export type MigratableTakerConfigInputDto = {
  authServiceUuid: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  divisionUuid: Scalars['String']['input'];
  excludeNewInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscountBidding: Scalars['Boolean']['input'];
  marketId: Scalars['Float']['input'];
  marketUuid: Scalars['String']['input'];
  opportunityUuid: Scalars['String']['input'];
  originalTakerConfig?: InputMaybe<OriginalTakerConfigInputDto>;
  takerId: Scalars['Float']['input'];
};

export type MoveSuppliersInput = {
  companyIds: Array<Scalars['String']['input']>;
  fromCompanyGroup: CompanyGroupInput;
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  toCompanyGroup: CompanyGroupInput;
};

/** For multi-node responses */
export type MultiMutationResponse = {
  /** HTTP Status Code of the Response */
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  /** For developers not for frontend */
  message: Scalars['String']['output'];
  nodes?: Maybe<Array<Maybe<Node>>>;
  /** True/False if the mutation worked. Patial success will show true */
  success: Scalars['Boolean']['output'];
};

/** For multi-node responses */
export type MultiQueryResponse = {
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  nodes?: Maybe<Array<Maybe<Node>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateMembershipTrial: SupplierMembership;
  addItemsToCustomGroup: CustomGroup;
  addOneTakersMarketToRequest?: Maybe<Scalars['ID']['output']>;
  /** Add suppliers to an existing WCM plan */
  addSuppliersToWcmPlan: WcmSuppliersOperationResponse;
  /** Add suppliers to a WCM plan wave */
  addSuppliersToWcmPlanWave: WcmSuppliersOperationResponse;
  /** Adds a user to divisions. It will return ALL divisions the users is on, not just the divisions added. This can partially work because of DC failures. If you care about failures then look at the errors response. */
  addUserToDivisions?: Maybe<CreateUserMutationResponse>;
  /** API to assign default roles to the user on the given division */
  assignDefaultBuyerAppDivisionsUsersRolesToUser: Array<BuyerAppDivisionsUsersRoles>;
  /** Mutation to clean up mappings to other non-paid buyers for non-C2FO users associated with a given buyer */
  cleanupOtherWcmNonPaidMappingForBuyerUsers: CleanupOtherWcmNonPaidMappingsForBuyerUsersOutput;
  cloneFileTemplate: FunderFile;
  createAbandonedCartOffer: AbandonedCartOfferDto;
  /** create a new account config - fails if one already exists for the account. */
  createAccountConfig?: Maybe<AccountConfig>;
  createBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  createBuyerAppManyDivisionRegions: Array<BuyerAppDivisionRegion>;
  /** API to create reserve of the market */
  createBuyerAppMarketReserve: ReserveSettingsUnionBuyerAppDualAuthorization;
  /** API to update company Group mapping for suppliers */
  createCompanyGroup: CreateCompanyGroupOutput;
  createCustomAgreement: CreateCustomAgreementResponse;
  createCustomerLinkingRequests: Array<CreateCustomerLinkingRequestResponse>;
  createEarlyPayDraftOffer: EarlyPayDraftOfferDto;
  /** Mutation to create file set along with its default settings */
  createFileSetSettings: SummaryDetails;
  createManyAgreementAudits: Array<AgreementAudit>;
  createManyAgreements: Array<Agreement>;
  createManyBuyerAppDivisionsUsersRoles: Array<BuyerAppDivisionsUsersRoles>;
  createManyBuyerAppDualAuthorizationRoles: Array<BuyerAppDualAuthorizationRoles>;
  createManyBuyerReportingCurrencies: Array<BuyerReportingCurrencies>;
  createManyCommunicationChannels: Array<CommunicationChannel>;
  createManyCommunicationPreferences: Array<CommunicationPreference>;
  createManyCustomGroupItems: Array<CustomGroupItem>;
  createManyDivisionReportingCurrencies: Array<BuyerAppDivisionReportingCurrencies>;
  createManyFunderVariables: Array<FunderVariable>;
  createManyRecordGroupColumnDtos: Array<RecordGroupColumnDto>;
  /** Create multiple buyer mappings for a domain */
  createManyWcmDomainBuyerMappings: WcmDomainConfigResponse;
  /** Mutation to create multiple WCM master buyers by wcm admin */
  createManyWcmMasterBuyersDetails: Array<WcmMasterBuyerList>;
  /** Mutation to add multiple buyers and users mapping by wcm admin */
  createManyWcmUserBuyerMappingDetails: Array<WcmBuyerUserMappingOutput>;
  /** API to create new funder-currencies */
  createMultipleFunderCurrencies: Array<FunderCurrenciesOutput>;
  /** API to create new funder-geographies */
  createMultipleFunderGeographies: Array<FunderGeographiesOutput>;
  createOneActionableOfferSchedule: ActionableOfferSchedule;
  createOneAgreement: Agreement;
  createOneAgreementAudit: AgreementAudit;
  createOneCommunicationChannel: CommunicationChannel;
  createOneCommunicationPreference: CommunicationPreference;
  createOneCustomGroup: CustomGroup;
  createOneDraftRequest: DraftRequest;
  createOneExpressAcceptPriceDiscoveryRequest: ExpressAcceptPriceDiscoveryRequest;
  /** API to create new funder */
  createOneFunder: Funder;
  /** API to create new funder-calculations */
  createOneFunderCalculations: FunderCalculationsOutput;
  createOneFunderDeliverySettingsDto: FunderDeliverySettingsDto;
  createOneFunderFeedbackConfig: FunderFeedbackConfig;
  createOneFunderFile: FunderFile;
  /** API to create new funder-legal-aggrement */
  createOneFunderLegalAgreement: FunderLegalSetupOutput;
  createOneFunderNotification: FunderNotification;
  createOneFunderVariable: FunderVariable;
  createOneOneTimeCashFlowPlusRequest: OneTimeCashFlowPlusRequest;
  createOneOneTimePriceDiscoveryRequest: OneTimePriceDiscoveryRequest;
  createOneOneTimeStaticRateRequest: OneTimeStaticRateRequest;
  createOneOutOfNetworkCustomer: CreateOutOfNetworkCustomerResponse;
  createOneOutOfNetworkCustomerRequest: CreateOutOfNetworkCustomerRequestResponse;
  createOnePreferredTermInAppRequest: PreferredTermInAppRequest;
  createOnePreferredTermRequest: PreferredTermRequest;
  createOnePricingSuggestion: PricingSuggestion;
  createOneRecordGroup: RecordGroup;
  createOneRecordGroupColumnDto: RecordGroupColumnDto;
  createOneRecurringBenchmarkRateRequest: RecurringBenchmarkRateRequest;
  createOneRecurringPriceDiscoveryRequest: RecurringPriceDiscoveryRequest;
  createOneRecurringStaticRateRequest: RecurringStaticRateRequest;
  createPassword: CreatePassword;
  createPreferredOfferConfig: PreferredOfferConfigResponse;
  /** API to create a new program */
  createProgram: ProgramDefaultResponse;
  createSupplierMembership: SupplierMembership;
  createUser: RegistrationUser;
  /** Mutation to create users via WCM with optional WCM onboarding */
  createUsersViaWcm: CreateUsersViaWcmOutput;
  /** Mutation to create buyer exclusion remark */
  createWcmBuyerExclusionRemark: WcmBuyerExclusionRemarkOutput;
  /** Create a new value for a custom attribute */
  createWcmCustomAttributeValue: CustomAttributeValueResponseDto;
  /** Create a new WCM plan */
  createWcmPlan: WcmPlanOutput;
  /** Create a new WCM plan wave */
  createWcmPlanWave: WcmPlanWaveOutput;
  /** Mutation to create wcm roles with admin level permissions by wcm admin */
  createWcmRoleWithAdminLevelPermissions: CreateWcmWcmRolesOutput;
  /** Mutation to create wcm roles by buyer permission manager */
  createWcmRoles: CreateWcmWcmRolesOutput;
  /** Create a new note for a supplier group */
  createWcmSupplierGroupNote: WcmSupplierGroupNote;
  /** Create a new wcm user registration request */
  createWcmUserRegistrationRequest: CreateWcmNewUserRegistrationResponse;
  /** API to unload buyer reporting dbt model data from s3 to buyer db */
  dbtUnloadBuyerAppReportData: BuyerAppBuyerReportsDbtUnloadOutput;
  /** Unload Navigator DBT model data from S3 to PostgreSQL */
  dbtUnloadNavigatorData: NavigatorUnloadOutput;
  /** API to soft delete buyer app dual auth entry */
  deleteBuyerAppDualAuth: BuyerAppDualAuthorization;
  deleteBuyerAppOneDivisionRegion: BuyerAppDivisionRegionDeleteResponse;
  deleteManyBuyerAppDivisionsUsersRoles: DeleteManyResponse;
  deleteManyBuyerAppDualAuthorizationRoles: DeleteManyResponse;
  deleteManyBuyerReportingCurrencies: DeleteManyResponse;
  deleteManyCustomGroupItems: DeleteManyResponse;
  deleteManyDivisionReportingCurrencies: DeleteManyResponse;
  deleteManyFunderVariables: DeleteManyResponse;
  deleteManyRecordGroupColumnDtos: DeleteManyResponse;
  /** Delete multiple buyer mappings for a domain */
  deleteManyWcmDomainBuyerMappings: WcmDomainConfigResponse;
  deleteManyWcmMasterBuyersDetails: DeleteManyResponse;
  /** Mutation to delete multiple buyers and users mapping by wcm admin */
  deleteManyWcmUserBuyerMappingDetails: DeleteManyWcmBuyerUserMappingOutput;
  deleteMarketSettingsRoles: DataMigrationOutput;
  deleteOneActionableOfferSchedule: ActionableOfferScheduleDeleteResponse;
  deleteOneCustomGroup: CustomGroupDeleteResponse;
  deleteOneCustomGroupItem: CustomGroupItemDeleteResponse;
  deleteOneFunderFeedbackConfig: FunderFeedbackConfigDeleteResponse;
  deleteOneFunderVariable: FunderVariableDeleteResponse;
  deleteOneRecordGroupColumnDto: RecordGroupColumnDtoDeleteResponse;
  deleteProfileImage: DeleteProfileImageResponse;
  deleteSupplierMembership: Scalars['Boolean']['output'];
  /** Mutation to delete buyer exclusion remark */
  deleteWcmBuyerExclusionRemark: WcmBuyerExclusionRemarkOutput;
  /** Delete custom attribute value(s) - accepts array of IDs for single or bulk delete (CASCADE deletes all related assignments) */
  deleteWcmCustomAttributeValues: DeleteWcmCustomAttributeValueResponse;
  /** Delete a WCM plan */
  deleteWcmPlan: WcmOperationMessageOutput;
  /** Delete a WCM plan wave */
  deleteWcmPlanWave: WcmOperationMessageOutput;
  /** Mutation to delete wcm role */
  deleteWcmRole: DeleteWcmRoleOutput;
  /** Mutation to delete WCM users with cascading deletes for wcm admin */
  deleteWcmUsersAdmin: DeleteWcmUsersOutput;
  editInvoicesOneEarlyPayRequest: Scalars['ID']['output'];
  /** Edits the rate of a single early pay request. Only PRICE_DISCOVERY requests can have their rate edited */
  editRateOneEarlyPayRequest: Scalars['ID']['output'];
  /** API to enable and disable program fileset for a given program fileset uuid */
  enableProgramFileSet: ProgramDefaultResponse;
  /** Forgets 1...100 users by email address. This will remove the user's PII from C2FO */
  forgetUsers?: Maybe<UserMutationResponse>;
  generateMagicLoginUrl: Scalars['String']['output'];
  importDataFromCSV: DataMigrationOutput;
  /** Mutation to include or exclude suppliers */
  includeExcludeWcmSuppliers: IncludeExcludeWcmSuppliersOutput;
  initiateActionableOffer: InitiateActionableOfferDto;
  /** get or create default preferences for a user */
  loadDefaultPreferences: Array<CommunicationPreference>;
  markOfferAsDeletedAndInactive: ScheduleMarkAsDelete;
  markStopStatusOfOngoingCampaign: ScheduleMarkAsStop;
  /** Migrates provided Taker Configs to Recurring Price Discovery Request(s) */
  migratePriceDiscoveryRequests: Scalars['ID']['output'];
  /** Migrates provided Taker Configs to Recurring Static Benchmark Request(s) */
  migrateStaticBenchmarkRequests: Scalars['ID']['output'];
  /** API to move suppliers from one company group to another */
  moveSuppliersAcrossCompanyGroups: CompanyIdGroupOutputResponse;
  /** optin to a communication channel for a user */
  optInToChannel: Array<CommunicationPreference>;
  /** Opt out of all communication preferences for a User */
  optOutAllCommunicationPreferences: OptOutCommunicationPreferencesResponse;
  /** API to pin/unpin suppliersr */
  pinUnpinSuppliers: CompanyIdGroupOutputResponse;
  publishAgreement: CreateCustomAgreementResponse;
  raasSetPassword: SetPasswordOutput;
  raasUpdateUser: UpdateUserOutput;
  registerUser: RegistrationUser;
  registerUserViaFormSubmission: RegisterMicrositeUserResponse;
  removeItemsFromCustomGroup: CustomGroup;
  /** Remove suppliers from an existing WCM plan */
  removeSuppliersFromWcmPlan: WcmSuppliersOperationResponse;
  /** Remove suppliers from a WCM plan wave */
  removeSuppliersFromWcmPlanWave: WcmSuppliersOperationResponse;
  /** Enables authorized users to reverse an early pay request including Express Accept and Card Promotions. */
  reverseOneEarlyPayRequest: Scalars['ID']['output'];
  runCampaign: InitiateActionableOfferDto;
  runCampaignForAccounts: GenericResponseDto;
  runCampaignViaFile: GenericResponseDto;
  /** API to notify all buyer app users via email about the monthly report being ready for access */
  sendBuyerReportEmails: BuyerAppBuyerReportEmailOutput;
  sendCommunication: OmnichannelCommunicationResponseDto;
  sendSegmentEventCommunication: OmnichannelCommunicationResponseDto;
  /** Admin API to set buyer audit config type and static file count */
  setBuyerAuditConfig: ProgramAuditConfigOutput;
  setItemsOnCustomGroup: CustomGroup;
  setPriceDiscoveryGlobalOffer: PriceDiscoveryGlobalOfferResultDto;
  /** Mutation to set access validity expiry date for WCM users by wcm admin */
  setWcmUserAccessValidity: SetWcmUserAccessValidityOutput;
  softDeleteAgreements: Scalars['Boolean']['output'];
  submitBenchmarkOffer: Scalars['String']['output'];
  submitOfferFromDraft: Array<Scalars['String']['output']>;
  submitPreferredOffer: Array<Scalars['String']['output']>;
  submitPriceDiscoveryOffer: Scalars['String']['output'];
  submitStaticOffer: Scalars['String']['output'];
  /** Mutation to subscribe subprocessors notification */
  subscribeBuyerAppSubprocessorsNotification: BuyerAppSubprocessorsSubscription;
  /** API to sync DSF company Group */
  syncDsfCompanyGroup: CreateCompanyGroupOutput;
  /** Grabs users in C2FO DB with no authServiceUuid and creates them in the User Auth DB. Then it syncs those Auth Service UUIDs back to the C2FO DB. This needs to be run in all data-centers. */
  syncUsersToUserAuthService?: Maybe<SyncUsersResponse>;
  /** Sync a WCM plan with the latest transaction */
  syncWcmPlanWithLatestTransaction: SyncWcmPlanResponse;
  toggleOffer: ToggleOffer;
  /** Pauses a single early pay request and removes it from playing in the market. Only RECURRING_* requests are supported. If a request is paused it can later be unpaused without needing to recreate the entire request. */
  togglePauseOneEarlyPayRequest: Scalars['ID']['output'];
  unforgetUser?: Maybe<CreateUserMutationResponse>;
  /** Mutation to unsubscribe subprocessors notification */
  unsubscribeBuyerAppSubprocessorsNotification: Scalars['Boolean']['output'];
  /** Mutation to update wcm suppliers group benchmarking strategy */
  updateBenchmarkingStrategyForWcmSuppliersGroup: UpdateWcmSupplierGroupBenchmarkingStrategyOutput;
  /** API to update adjustment tolerance of the market */
  updateBuyerAppAdjustmentToleranceSettings: AdjustmentToleranceUnionBuyerAppDualAuthorization;
  /** API to update minimum income settings of the market */
  updateBuyerAppAprSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  /** API to update cash pool settings of the market */
  updateBuyerAppCashPoolSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  updateBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  /** API to update exclusion status of invoices */
  updateBuyerAppInvoices: Array<UpdateBuyerAppInvoiceOutput>;
  updateBuyerAppManyDivisionRegions: UpdateManyResponse;
  /** API to update reserve of the market */
  updateBuyerAppMarketReserve: ReserveSettingsUnionBuyerAppDualAuthorization;
  /** API to update restriction of the market */
  updateBuyerAppMarketRestriction: RestrictionUnionBuyerAppDualAuthorization;
  /** API to update minimum income settings of the market */
  updateBuyerAppMinEarnSettings: CashPoolSettingsUnionBuyerAppDualAuthorization;
  /** API to update buyer audit config */
  updateBuyerAuditConfig: BuyerAuditConfigDefaultResponse;
  /** Muatation to update buyer delivery location */
  updateBuyerDeliveryLocation: UpdateBuyerDeliveryLocationOutput;
  /** API to update company Group mapping for suppliers */
  updateCompanyGroupForSuppliers: CompanyIdGroupOutputResponse;
  updateCustomAgreement: CreateCustomAgreementResponse;
  /** Mutation to update file settings for a file type */
  updateFileSetSettings: ProgramFileSetSettings;
  updateManyCommunicationChannels: UpdateManyResponse;
  updateManyCommunicationPreferences: UpdateManyResponse;
  /** Muatation to update delivery setting - timezone and deliveryTime */
  updateManyFileDeliverSettings: Array<UpdateDeliverySettingsOutput>;
  updateManyQualifiedSuppliers: UpdateManyResponse;
  /** API to update existing funder-currencies data */
  updateMultipleFunderCurrencies: Array<FunderCurrenciesOutput>;
  /** API to update existing funder-geographies */
  updateMultipleFunderGeographies: Array<FunderGeographiesOutput>;
  updateMultipleRecordGroupInput: Array<RecordGroup>;
  updateOneActionableOfferSchedule: ActionableOfferSchedule;
  updateOneCommunicationChannel: CommunicationChannel;
  updateOneCommunicationPreference: CommunicationPreference;
  updateOneCustomGroup: CustomGroup;
  /** API to update existing funder */
  updateOneFunder: Funder;
  /** API to update existing funder-calculations */
  updateOneFunderCalculations: FunderCalculationsOutput;
  updateOneFunderDeliverySettingsDto: FunderDeliverySettingsDto;
  updateOneFunderFeedbackConfig: FunderFeedbackConfig;
  updateOneFunderFile: FunderFile;
  /** API to update existing funder-legal-agreement */
  updateOneFunderLegalAgreement: FunderLegalSetupOutput;
  updateOneFunderNotification: FunderNotification;
  updateOneOutOfNetworkCustomer: UpdateOutOfNetworkCustomerResponse;
  updateOneOutOfNetworkCustomerRequest: UpdateOutOfNetworkCustomerRequestResponse;
  updateOneQualifiedSupplier: QualifiedSupplier;
  updateOneRecordGroup: RecordGroup;
  updateOneRecordGroupColumnDto: RecordGroupColumnDto;
  updatePreferredOfferConfig: PreferredOfferConfigResponse;
  updateProfileImage: UpdateProfileImageResponse;
  /** API to update program fileset table for a given program fileset uuid */
  updateProgramFileSetConfigurations: ProgramFileSetResponse;
  updateRecordGroupColumns: Array<RecordGroupColumnDto>;
  updateSupplierMembership: SupplierMembership;
  updateUser: RegistrationUser;
  /** Update or add buyer configuration */
  updateWcmBuyerConfig: BuyerAppBuyerConfigResponse;
  /** Mutation to update buyer exclusion remark */
  updateWcmBuyerExclusionRemark: UpdateWcmBuyerExclusionRemarkOutput;
  /** Mutation to update a buyer type from Trial to Paid and clean up non-paid buyer mappings, and user access expiry date for non-C2FO users */
  updateWcmBuyerTypeToPaid: UpdateWcmBuyerTypeToPaidOutput;
  /** Update a custom attribute definition */
  updateWcmCustomAttributeDefinition: WcmCustomAttributeDefinitionResponse;
  /** Mutation to update custom attribute for selected suppliers */
  updateWcmCustomAttributeForSuppliers: UpdateWcmCustomAttributeForSuppliersOutput;
  /** Update an existing custom attribute value */
  updateWcmCustomAttributeValue: UpdateCustomAttributeValueResponseDto;
  /** Mutation to update supplier diversity status */
  updateWcmDiversityStatus: UpdateWcmDiversityStatusOutput;
  /** Mutation to update file status */
  updateWcmEnrichedFileStatus: UpdateFileStatusOutput;
  /** Replace the buyer NAICS exclusion set and return the recomposed editor payload. */
  updateWcmNaicsExclusions: WcmNaicsExclusions;
  /** Update Wcm Naics Payment Terms */
  updateWcmNaicsPaymentTerms: UpdateWcmNaicsPaymentTermsOutput;
  /** Mutation to update payment terms version */
  updateWcmPaymentTermsVersion: UpdateWcmPaymentTermsVersionOutput;
  /** Update an existing WCM plan */
  updateWcmPlan: WcmPlanOutput;
  /** Update an existing WCM plan wave */
  updateWcmPlanWave: WcmPlanWaveOutput;
  /** Mutation to update wcm role permissions by buyer permission manager */
  updateWcmRolePermissions: UpdateWcmRolePermissionsOutput;
  /** Mutation to update wcm role users by buyer permission manager */
  updateWcmRoleUsers: UpdateWcmRoleUsersOutput;
  /** Edit an existing supplier-group note. Only the most recent note for the group may be edited. */
  updateWcmSupplierGroupNote: WcmSupplierGroupNote;
  /** Mutation to update wcm supplier segment config */
  updateWcmSupplierSegmentConfig: UpdateWcmSupplierSegmentConfigOutput;
  /** Mutation to bulk update supplier attributes */
  updateWcmSuppliers: UpdateWcmSuppliersOutput;
  /** Mutation to update benchmark strategy for suppliers */
  updateWcmSuppliersBenchmarkStrategy: UpdateWcmSuppliersBenchmarkStrategyOutput;
  /** Mutation to update benchmark strategy for suppliers by segment */
  updateWcmSuppliersBenchmarkStrategyBySegment: UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput;
  /** Update status of registration request by id */
  updateWcmUserRegistrationStatus: UpdateWcmUserRegistrationRequestResponse;
  /** API to upsert the division roles showIncome and showYield */
  upsertBuyerAppDivisionRoles: BuyerAppDivisionRolesOutput;
  upsertBuyerAppFileHistory: BuyerAppFileHistoryUpsertOutput;
  /** Mutation to upsert market taker configuration data. */
  upsertBuyerAppMarketTakerConfiguration: UpsertBuyerAppMarketTakerConfigurationOutput;
  /** API to update market taker reserve setting */
  upsertBuyerAppMarketTakerReserveSettings: BuyerAppUpdateMarketTakerReserveOutput;
  /** Creates or updates a buyer-platform user preference (JWT user scope). */
  upsertBuyerAppUserPreference: UpsertBuyerAppUserPreferenceOutput;
  upsertOneTakerConfiguration: TakerConfiguration;
  /** Upsert WCM Benchmark Config */
  upsertWcmBenchmarkConfig: WcmBenchmarkConfigOutput;
  /** Upsert WCM Benchmark Country Regulations */
  upsertWcmBenchmarkCountryRegulations: WcmBenchmarkCountryRegulationsOutput;
  /** Upsert domain configuration (create or update) */
  upsertWcmDomainConfig: WcmDomainConfigResponse;
  /** Upsert Wcm Economic Value Config */
  upsertWcmEconomicValueConfig: WcmEconomicValueConfigOutput;
  /** Upsert Wcm Exclusions Config */
  upsertWcmExclusionsConfig: WcmExclusionsConfigOutput;
  /** Upsert a new WCM supplier negotiation */
  upsertWcmNegotiation: WcmNegotiationOutput;
  /** Create or update multiple negotiation status-to-phase mappings */
  upsertWcmNegotiationStatusPhaseMappings: WcmStatusPhaseMappings;
  /** Upsert WCM negotiations for multiple supplier entities */
  upsertWcmNegotiations: WcmNegotiationsOutput;
  /** Upsert Wcm Segment Conversion Rate Config */
  upsertWcmSegmentConversionRate: WcmSegmentConversionRateConfigOutput;
  /** This mutation is used to create or update user preference settings */
  upsertWcmUserPreference: UpsertWcmUserPreferenceOutput;
  /** Mutation to add or update wcm users by wcm admin */
  upsertWcmUsers: UpsertWcmUsersOutput;
  /** Create a new user. This will add the user to User Auth and User PII stores. */
  user?: Maybe<CreateUserMutationResponse>;
  userReconcile?: Maybe<UserMutationResponse>;
  /** Update users info. This will update all backing services, User Auth, C2FO, PII. */
  users?: Maybe<UserMutationResponse>;
  /** Delete a conversation and all its messages. */
  wcmInsightsDeleteConversation: WcmInsightsDeleteResultDto;
  /** Submit feedback for an assistant message. */
  wcmInsightsFeedback: WcmInsightsFeedbackResultDto;
  /** Submit a question to WCM Insights. */
  wcmInsightsQuery: WcmInsightsQueryResultDto;
  /** Withdraws all manual awards for a given offer. If the offer exists within Request-API, and is of Manual Award type (EXPRESS_ACCEPT_PRICE_DISCOVERY,ONE_TIME_CASH_FLOW_PLUS), the request will also be withdrawn. */
  withdrawManualAwardsForOfferUuid: Scalars['ID']['output'];
  /** Withdraws a single early pay request and removes it from playing in the market. All request types except for CashFlow+ and Express Accept are supported. Once a request is withdrawn it will need to be recreated through one of the submit mutations. */
  withdrawOneEarlyPayRequest: Scalars['ID']['output'];
};


export type MutationActivateMembershipTrialArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationAddItemsToCustomGroupArgs = {
  input: AddItemsToCustomGroupInput;
};


export type MutationAddOneTakersMarketToRequestArgs = {
  inputDto: TakerMarketReplacementInput;
};


export type MutationAddSuppliersToWcmPlanArgs = {
  input: AddSuppliersInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationAddSuppliersToWcmPlanWaveArgs = {
  input: AddSuppliersInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationAddUserToDivisionsArgs = {
  authServiceUuid: Scalars['ID']['input'];
  divisionUuids: Array<Scalars['ID']['input']>;
};


export type MutationAssignDefaultBuyerAppDivisionsUsersRolesToUserArgs = {
  input: AssignDefaultBuyerAppDivisionsUsersRolesToUserInput;
};


export type MutationCleanupOtherWcmNonPaidMappingForBuyerUsersArgs = {
  input: CleanupOtherWcmNonPaidMappingsForBuyerUsersInput;
};


export type MutationCloneFileTemplateArgs = {
  existingFunderFileId: Scalars['String']['input'];
  funderId: Scalars['String']['input'];
};


export type MutationCreateAbandonedCartOfferArgs = {
  input: AbandonedCartOfferInput;
};


export type MutationCreateAccountConfigArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationCreateBuyerAppEverafterBuyerConfigArgs = {
  input: CreateOneBuyerAppEverafterBuyerConfigInput;
};


export type MutationCreateBuyerAppManyDivisionRegionsArgs = {
  input: CreateManyBuyerAppDivisionRegionsInput;
};


export type MutationCreateBuyerAppMarketReserveArgs = {
  input: BuyerAppCreateReserveInputDto;
};


export type MutationCreateCompanyGroupArgs = {
  createCompanyGroupInput: CreateCompanyGroupInput;
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateFromCompanyGroups: Scalars['Boolean']['input'];
};


export type MutationCreateCustomAgreementArgs = {
  createCustomAgreementInput: CreateCustomAgreementInput;
};


export type MutationCreateCustomerLinkingRequestsArgs = {
  input: Array<CreateCustomerLinkingRequestInput>;
};


export type MutationCreateEarlyPayDraftOfferArgs = {
  earlyPayDraftOffer: EarlyPayDraftOfferInputDto;
};


export type MutationCreateFileSetSettingsArgs = {
  fileSetDetails: CreateProgramFileSetDetails;
  funderUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};


export type MutationCreateManyAgreementAuditsArgs = {
  input: CreateManyAgreementAuditsInput;
};


export type MutationCreateManyAgreementsArgs = {
  input: CreateManyAgreementsInput;
};


export type MutationCreateManyBuyerAppDivisionsUsersRolesArgs = {
  input: CreateManyBuyerAppDivisionsUsersRolesInput;
};


export type MutationCreateManyBuyerAppDualAuthorizationRolesArgs = {
  input: CreateManyBuyerAppDualAuthorizationRolesInput;
};


export type MutationCreateManyBuyerReportingCurrenciesArgs = {
  input: CreateManyBuyerReportingCurrenciesInput;
};


export type MutationCreateManyCommunicationChannelsArgs = {
  input: CreateManyCommunicationChannelsInput;
};


export type MutationCreateManyCommunicationPreferencesArgs = {
  input: CreateManyCommunicationPreferencesInput;
};


export type MutationCreateManyCustomGroupItemsArgs = {
  input: CreateManyCustomGroupItemsInput;
};


export type MutationCreateManyDivisionReportingCurrenciesArgs = {
  input: CreateManyBuyerAppDivisionReportingCurrenciesInput;
};


export type MutationCreateManyFunderVariablesArgs = {
  input: CreateManyFunderVariablesInput;
};


export type MutationCreateManyRecordGroupColumnDtosArgs = {
  input: CreateManyRecordGroupColumnDtosInput;
};


export type MutationCreateManyWcmDomainBuyerMappingsArgs = {
  input: CreateWcmDomainBuyerMappingsInput;
};


export type MutationCreateManyWcmMasterBuyersDetailsArgs = {
  input: Array<CreateWcmMasterBuyerList>;
};


export type MutationCreateManyWcmUserBuyerMappingDetailsArgs = {
  input: CreateManyWcmUserBuyerMappingDetailsInput;
};


export type MutationCreateMultipleFunderCurrenciesArgs = {
  inputs: Array<CreateFunderCurrenciesInput>;
};


export type MutationCreateMultipleFunderGeographiesArgs = {
  inputs: Array<CreateFunderGeographiesInput>;
};


export type MutationCreateOneActionableOfferScheduleArgs = {
  input: CreateOneActionableOfferScheduleInput;
};


export type MutationCreateOneAgreementArgs = {
  input: CreateOneAgreementInput;
};


export type MutationCreateOneAgreementAuditArgs = {
  input: CreateOneAgreementAuditInput;
};


export type MutationCreateOneCommunicationChannelArgs = {
  input: CreateOneCommunicationChannelInput;
};


export type MutationCreateOneCommunicationPreferenceArgs = {
  input: CreateOneCommunicationPreferenceInput;
};


export type MutationCreateOneCustomGroupArgs = {
  input: CreateOneCustomGroupInput;
};


export type MutationCreateOneDraftRequestArgs = {
  input: CreateOneDraftRequestInput;
};


export type MutationCreateOneExpressAcceptPriceDiscoveryRequestArgs = {
  input: CreateOneExpressAcceptPriceDiscoveryRequestInput;
};


export type MutationCreateOneFunderArgs = {
  input: CreateOneFunderInput;
};


export type MutationCreateOneFunderCalculationsArgs = {
  input: CreateFunderCalculationsInput;
};


export type MutationCreateOneFunderDeliverySettingsDtoArgs = {
  input: CreateOneFunderDeliverySettingsDtoInput;
};


export type MutationCreateOneFunderFeedbackConfigArgs = {
  input: CreateOneFunderFeedbackConfigInput;
};


export type MutationCreateOneFunderFileArgs = {
  input: CreateOneFunderFileInput;
};


export type MutationCreateOneFunderLegalAgreementArgs = {
  input: CreateFunderLegalSetupInput;
};


export type MutationCreateOneFunderNotificationArgs = {
  input: CreateOneFunderNotificationConfigInput;
};


export type MutationCreateOneFunderVariableArgs = {
  input: CreateOneFunderVariableInput;
};


export type MutationCreateOneOneTimeCashFlowPlusRequestArgs = {
  input: CreateOneOneTimeCashFlowPlusRequestInput;
};


export type MutationCreateOneOneTimePriceDiscoveryRequestArgs = {
  input: CreateOneOneTimePriceDiscoveryRequestInput;
};


export type MutationCreateOneOneTimeStaticRateRequestArgs = {
  input: CreateOneOneTimeStaticRateRequestInput;
};


export type MutationCreateOneOutOfNetworkCustomerArgs = {
  input: CreateOutOfNetworkCustomerInput;
};


export type MutationCreateOneOutOfNetworkCustomerRequestArgs = {
  input: CreateOutOfNetworkCustomerRequestInput;
};


export type MutationCreateOnePreferredTermInAppRequestArgs = {
  input: CreateOnePreferredTermInAppRequestInput;
};


export type MutationCreateOnePreferredTermRequestArgs = {
  input: CreateOnePreferredTermRequestInput;
};


export type MutationCreateOnePricingSuggestionArgs = {
  input: CreateOnePricingSuggestionInput;
};


export type MutationCreateOneRecordGroupArgs = {
  input: CreateRecordGroupInput;
};


export type MutationCreateOneRecordGroupColumnDtoArgs = {
  input: CreateOneRecordGroupColumnDtoInput;
};


export type MutationCreateOneRecurringBenchmarkRateRequestArgs = {
  input: CreateOneRecurringBenchmarkRateRequestInput;
};


export type MutationCreateOneRecurringPriceDiscoveryRequestArgs = {
  input: CreateOneRecurringPriceDiscoveryRequestInput;
};


export type MutationCreateOneRecurringStaticRateRequestArgs = {
  input: CreateOneRecurringStaticRateRequestInput;
};


export type MutationCreatePasswordArgs = {
  password: Scalars['String']['input'];
};


export type MutationCreatePreferredOfferConfigArgs = {
  createPreferredOfferConfigInput: CreatePreferredOfferConfigInput;
};


export type MutationCreateProgramArgs = {
  createProgramInput: CreateProgramInput;
};


export type MutationCreateSupplierMembershipArgs = {
  supplierMembership: CreateSupplierMembershipInput;
};


export type MutationCreateUserArgs = {
  input: RegistrationUserInput;
  makerOrgUuid: Scalars['String']['input'];
};


export type MutationCreateUsersViaWcmArgs = {
  input: CreateUsersViaWcmInput;
};


export type MutationCreateWcmBuyerExclusionRemarkArgs = {
  input: CreateWcmBuyerExclusionRemarkInput;
};


export type MutationCreateWcmCustomAttributeValueArgs = {
  currency: Scalars['String']['input'];
  input: CreateWcmCustomAttributeValueInput;
  internalName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmPlanArgs = {
  input: WcmCreatePlanInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmPlanWaveArgs = {
  input: CreateWcmPlanWaveInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationCreateWcmRoleWithAdminLevelPermissionsArgs = {
  input: CreateWcmRoleWithAdminLevelPermissionsInput;
};


export type MutationCreateWcmRolesArgs = {
  input: CreateWcmRolesInput;
};


export type MutationCreateWcmSupplierGroupNoteArgs = {
  input: CreateWcmSupplierGroupNoteInput;
};


export type MutationCreateWcmUserRegistrationRequestArgs = {
  input: CreateWcmNewUserRegistrationInput;
};


export type MutationDbtUnloadBuyerAppReportDataArgs = {
  input: BuyerAppBuyerReportsDbtUnloadInput;
};


export type MutationDbtUnloadNavigatorDataArgs = {
  input: NavigatorUnloadInput;
};


export type MutationDeleteBuyerAppDualAuthArgs = {
  input: DeleteBuyerAppDualAuthInput;
};


export type MutationDeleteBuyerAppOneDivisionRegionArgs = {
  input: DeleteOneBuyerAppDivisionRegionInput;
};


export type MutationDeleteManyBuyerAppDivisionsUsersRolesArgs = {
  input: DeleteManyBuyerAppDivisionsUsersRolesInput;
};


export type MutationDeleteManyBuyerAppDualAuthorizationRolesArgs = {
  input: DeleteManyBuyerAppDualAuthorizationRolesInput;
};


export type MutationDeleteManyBuyerReportingCurrenciesArgs = {
  input: DeleteManyBuyerReportingCurrenciesInput;
};


export type MutationDeleteManyCustomGroupItemsArgs = {
  input: DeleteManyCustomGroupItemsInput;
};


export type MutationDeleteManyDivisionReportingCurrenciesArgs = {
  input: DeleteManyBuyerAppDivisionReportingCurrenciesInput;
};


export type MutationDeleteManyFunderVariablesArgs = {
  input: DeleteManyFunderVariablesInput;
};


export type MutationDeleteManyRecordGroupColumnDtosArgs = {
  input: DeleteManyRecordGroupColumnDtosInput;
};


export type MutationDeleteManyWcmDomainBuyerMappingsArgs = {
  input: WcmDeleteDomainBuyerMappingsInput;
};


export type MutationDeleteManyWcmMasterBuyersDetailsArgs = {
  input: DeleteManyWcmMasterBuyerListsInput;
};


export type MutationDeleteManyWcmUserBuyerMappingDetailsArgs = {
  input: DeleteManyWcmUserBuyerMappingDetailsInput;
};


export type MutationDeleteOneActionableOfferScheduleArgs = {
  input: DeleteOneActionableOfferScheduleInput;
};


export type MutationDeleteOneCustomGroupArgs = {
  input: DeleteOneCustomGroupInput;
};


export type MutationDeleteOneCustomGroupItemArgs = {
  input: DeleteOneCustomGroupItemInput;
};


export type MutationDeleteOneFunderFeedbackConfigArgs = {
  input: DeleteOneFunderFeedbackConfigInput;
};


export type MutationDeleteOneFunderVariableArgs = {
  input: DeleteOneFunderVariableInput;
};


export type MutationDeleteOneRecordGroupColumnDtoArgs = {
  input: DeleteOneRecordGroupColumnDtoInput;
};


export type MutationDeleteProfileImageArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteSupplierMembershipArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationDeleteWcmBuyerExclusionRemarkArgs = {
  input: DeleteWcmBuyerExclusionRemarkInput;
};


export type MutationDeleteWcmCustomAttributeValuesArgs = {
  currency: Scalars['String']['input'];
  internalName: Scalars['String']['input'];
  valueIds: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmPlanArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmPlanWaveArgs = {
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationDeleteWcmRoleArgs = {
  input: DeleteWcmRoleInput;
};


export type MutationDeleteWcmUsersAdminArgs = {
  input: DeleteWcmUsersInput;
};


export type MutationEditInvoicesOneEarlyPayRequestArgs = {
  id: Scalars['ID']['input'];
  invoiceOperations: Array<InvoiceEditDataDto>;
};


export type MutationEditRateOneEarlyPayRequestArgs = {
  id: Scalars['ID']['input'];
  isRateAveraged?: InputMaybe<Scalars['Boolean']['input']>;
  newRate: Scalars['Float']['input'];
  newRateType: RateType;
};


export type MutationEnableProgramFileSetArgs = {
  isEnabled: Scalars['Boolean']['input'];
  programFileSetUuid: Scalars['String']['input'];
};


export type MutationForgetUsersArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
};


export type MutationGenerateMagicLoginUrlArgs = {
  authUuid?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImportDataFromCsvArgs = {
  filePath: Scalars['String']['input'];
  isUpdateDualAuth: Scalars['Boolean']['input'];
  tableName: Scalars['String']['input'];
};


export type MutationIncludeExcludeWcmSuppliersArgs = {
  input: IncludeExcludeWcmSuppliersInputDto;
};


export type MutationInitiateActionableOfferArgs = {
  input: InitiateActionableOfferInput;
};


export type MutationMarkOfferAsDeletedAndInactiveArgs = {
  update: ScheduleMarkAsDeleteInput;
};


export type MutationMarkStopStatusOfOngoingCampaignArgs = {
  update: ScheduleMarkAsStopInput;
};


export type MutationMigratePriceDiscoveryRequestsArgs = {
  input: Array<GroupedByOpportunityUuidTakerConfigsInputDto>;
};


export type MutationMigrateStaticBenchmarkRequestsArgs = {
  input: Array<GroupedByOpportunityUuidTakerConfigsInputDto>;
};


export type MutationMoveSuppliersAcrossCompanyGroupsArgs = {
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateCompanyIdGroupInput: MoveSuppliersInput;
};


export type MutationOptInToChannelArgs = {
  channel: Scalars['String']['input'];
};


export type MutationOptOutAllCommunicationPreferencesArgs = {
  optOutArgs?: InputMaybe<OptOutCommunicationPreferencesRequest>;
};


export type MutationPinUnpinSuppliersArgs = {
  updateCompanyIdGroupInput: PinUnpinSuppliersInput;
};


export type MutationPublishAgreementArgs = {
  agreementUuid: Scalars['String']['input'];
};


export type MutationRaasSetPasswordArgs = {
  input: SetPasswordInput;
};


export type MutationRaasUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationRegisterUserArgs = {
  businessDetails?: InputMaybe<BusinessDetailsInput>;
  input: RegistrationUserInput;
  journeyType?: InputMaybe<Scalars['String']['input']>;
  leadingMakerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationRegisterUserViaFormSubmissionArgs = {
  registrationInput: RegisterUserViaMicrositeInfo;
};


export type MutationRemoveItemsFromCustomGroupArgs = {
  input: RemoveItemsFromCustomGroupInput;
};


export type MutationRemoveSuppliersFromWcmPlanArgs = {
  input: RemoveSuppliersInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationRemoveSuppliersFromWcmPlanWaveArgs = {
  input: RemoveSuppliersInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationReverseOneEarlyPayRequestArgs = {
  id: Scalars['ID']['input'];
  makerOrganizationUuid: Scalars['ID']['input'];
  marketUuid?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  requesterId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRunCampaignArgs = {
  campaign: CampaignInput;
};


export type MutationRunCampaignForAccountsArgs = {
  campaign: AccountsCampaignInput;
};


export type MutationRunCampaignViaFileArgs = {
  campaign: FileCampaignInput;
};


export type MutationSendBuyerReportEmailsArgs = {
  input: BuyerAppBuyerReportsEmailsInput;
};


export type MutationSendCommunicationArgs = {
  omnichannelCommunicationInput: OmnichannelCommunicationInput;
};


export type MutationSendSegmentEventCommunicationArgs = {
  segmentEventInput: SegmentEventInput;
};


export type MutationSetBuyerAuditConfigArgs = {
  setBuyerAuditConfig: SetBuyerAuditConfigDto;
};


export type MutationSetItemsOnCustomGroupArgs = {
  input: SetItemsOnCustomGroupInput;
};


export type MutationSetPriceDiscoveryGlobalOfferArgs = {
  input: GlobalOfferInputDto;
};


export type MutationSetWcmUserAccessValidityArgs = {
  input: SetWcmUserAccessValidityInput;
};


export type MutationSoftDeleteAgreementsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationSubmitBenchmarkOfferArgs = {
  offer: BenchmarkOfferInput;
};


export type MutationSubmitOfferFromDraftArgs = {
  offer: OfferFromDraftInput;
};


export type MutationSubmitPreferredOfferArgs = {
  offer: PreferredOfferInput;
};


export type MutationSubmitPriceDiscoveryOfferArgs = {
  offer: PriceDiscoveryOfferInput;
};


export type MutationSubmitStaticOfferArgs = {
  offer: StaticOfferInput;
};


export type MutationSubscribeBuyerAppSubprocessorsNotificationArgs = {
  input: SubscribeBuyerAppSubprocessorsNotificationInput;
};


export type MutationSyncDsfCompanyGroupArgs = {
  syncDsfCompanyGroupInput: SyncDsfCompanyGroupInput;
};


export type MutationSyncUsersToUserAuthServiceArgs = {
  filters?: InputMaybe<UserSyncInput>;
};


export type MutationSyncWcmPlanWithLatestTransactionArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationToggleOfferArgs = {
  marketUuid: Scalars['String']['input'];
  supplierDivisionUuid: Scalars['String']['input'];
};


export type MutationTogglePauseOneEarlyPayRequestArgs = {
  id: Scalars['ID']['input'];
  shouldPause: Scalars['Boolean']['input'];
};


export type MutationUnforgetUserArgs = {
  emailAddress: Scalars['String']['input'];
};


export type MutationUnsubscribeBuyerAppSubprocessorsNotificationArgs = {
  id: Scalars['Float']['input'];
};


export type MutationUpdateBenchmarkingStrategyForWcmSuppliersGroupArgs = {
  input: UpdateWcmSupplierGroupBenchmarkingStrategyInputDto;
};


export type MutationUpdateBuyerAppAdjustmentToleranceSettingsArgs = {
  input: BuyerAppAdjustmentToleranceInputDto;
};


export type MutationUpdateBuyerAppAprSettingsArgs = {
  input: BuyerAppAprSettingsInput;
};


export type MutationUpdateBuyerAppCashPoolSettingsArgs = {
  input: BuyerAppCashPoolSettingsInput;
};


export type MutationUpdateBuyerAppEverafterBuyerConfigArgs = {
  input: UpdateOneBuyerAppEverafterBuyerConfigInput;
};


export type MutationUpdateBuyerAppInvoicesArgs = {
  input: UpdateBuyerAppInvoiceInput;
};


export type MutationUpdateBuyerAppManyDivisionRegionsArgs = {
  input: UpdateManyBuyerAppDivisionRegionsInput;
};


export type MutationUpdateBuyerAppMarketReserveArgs = {
  input: UpdateReserveInputDto;
};


export type MutationUpdateBuyerAppMarketRestrictionArgs = {
  input: BuyerAppRestrictionInput;
};


export type MutationUpdateBuyerAppMinEarnSettingsArgs = {
  input: BuyerAppMinEarnSettingsInput;
};


export type MutationUpdateBuyerAuditConfigArgs = {
  updateBuyerAuditConfig: BuyerAuditConfigDto;
};


export type MutationUpdateBuyerDeliveryLocationArgs = {
  input: UpdateBuyerDeliveryLocationInput;
};


export type MutationUpdateCompanyGroupForSuppliersArgs = {
  deleteEmptyCompanyGroup: Scalars['Boolean']['input'];
  updateCompanyIdGroupInput: UpdateCompanyIdGroupInput;
  updateFromCompanyGroups: Scalars['Boolean']['input'];
};


export type MutationUpdateCustomAgreementArgs = {
  agreementUuid: Scalars['String']['input'];
  update: CreateCustomAgreementInput;
};


export type MutationUpdateFileSetSettingsArgs = {
  fileSetSettingsUuid: Scalars['String']['input'];
  programFileSetSettings: UpdateProgramFileSetSettings;
};


export type MutationUpdateManyCommunicationChannelsArgs = {
  input: UpdateManyCommunicationChannelsInput;
};


export type MutationUpdateManyCommunicationPreferencesArgs = {
  input: UpdateManyCommunicationPreferencesInput;
};


export type MutationUpdateManyFileDeliverSettingsArgs = {
  inputs: Array<UpdateDeliverySettingsInput>;
};


export type MutationUpdateManyQualifiedSuppliersArgs = {
  input: UpdateManyQualifiedSuppliersInput;
};


export type MutationUpdateMultipleFunderCurrenciesArgs = {
  inputs: Array<UpdateFunderCurrenciesInput>;
};


export type MutationUpdateMultipleFunderGeographiesArgs = {
  inputs: Array<UpdateFunderGeographiesInput>;
};


export type MutationUpdateMultipleRecordGroupInputArgs = {
  input: Array<UpdateMultipleRecordGroupInput>;
};


export type MutationUpdateOneActionableOfferScheduleArgs = {
  input: UpdateOneActionableOfferScheduleInput;
};


export type MutationUpdateOneCommunicationChannelArgs = {
  input: UpdateOneCommunicationChannelInput;
};


export type MutationUpdateOneCommunicationPreferenceArgs = {
  input: UpdateOneCommunicationPreferenceInput;
};


export type MutationUpdateOneCustomGroupArgs = {
  input: UpdateOneCustomGroupInput;
};


export type MutationUpdateOneFunderArgs = {
  input: UpdateOneFunderInput;
};


export type MutationUpdateOneFunderCalculationsArgs = {
  input: UpdateFunderCalculationsInput;
};


export type MutationUpdateOneFunderDeliverySettingsDtoArgs = {
  input: UpdateOneFunderDeliverySettingsDtoInput;
};


export type MutationUpdateOneFunderFeedbackConfigArgs = {
  input: UpdateOneFunderFeedbackConfigInput;
};


export type MutationUpdateOneFunderFileArgs = {
  input: UpdateOneFunderFileInput;
};


export type MutationUpdateOneFunderLegalAgreementArgs = {
  input: UpdateFunderLegalSetupInput;
};


export type MutationUpdateOneFunderNotificationArgs = {
  input: UpdateOneFunderNotificationConfigInput;
};


export type MutationUpdateOneOutOfNetworkCustomerArgs = {
  id: Scalars['String']['input'];
  update: UpdateOutOfNetworkCustomerInput;
};


export type MutationUpdateOneOutOfNetworkCustomerRequestArgs = {
  id: Scalars['String']['input'];
  update: UpdateOutOfNetworkCustomerRequestInput;
};


export type MutationUpdateOneQualifiedSupplierArgs = {
  input: UpdateOneQualifiedSupplierInput;
};


export type MutationUpdateOneRecordGroupArgs = {
  input: UpdateOneRecordGroupInput;
};


export type MutationUpdateOneRecordGroupColumnDtoArgs = {
  input: UpdateOneRecordGroupColumnDtoInput;
};


export type MutationUpdatePreferredOfferConfigArgs = {
  updatePreferredOfferConfigInput: UpdatePreferredOfferConfigInput;
};


export type MutationUpdateProfileImageArgs = {
  profileImage: UpdateProfileImage;
};


export type MutationUpdateProgramFileSetConfigurationsArgs = {
  programFileSetUuid: Scalars['String']['input'];
  updateFilterCriteriaDetails: UpdateProgramFileSetInput;
};


export type MutationUpdateRecordGroupColumnsArgs = {
  input: Array<UpdateRecordGroupColumnInput>;
};


export type MutationUpdateSupplierMembershipArgs = {
  accountId: Scalars['String']['input'];
  supplierMembership: UpdateSupplierMembershipInput;
};


export type MutationUpdateUserArgs = {
  input: RegistrationUserInput;
};


export type MutationUpdateWcmBuyerConfigArgs = {
  input: UpdateBuyerAppBuyerConfigInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmBuyerExclusionRemarkArgs = {
  input: UpdateWcmBuyerExclusionRemarkInput;
};


export type MutationUpdateWcmBuyerTypeToPaidArgs = {
  input: UpdateWcmBuyerTypeToPaidInput;
};


export type MutationUpdateWcmCustomAttributeDefinitionArgs = {
  currency: Scalars['String']['input'];
  input: UpdateWcmCustomAttributeDefinitionInput;
  internalName: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmCustomAttributeForSuppliersArgs = {
  input: UpdateWcmCustomAttributeForSuppliersInput;
};


export type MutationUpdateWcmCustomAttributeValueArgs = {
  currency: Scalars['String']['input'];
  input: UpdateWcmCustomAttributeValueInput;
  internalName: Scalars['String']['input'];
  valueId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmDiversityStatusArgs = {
  input: UpdateWcmDiversityStatusInput;
};


export type MutationUpdateWcmEnrichedFileStatusArgs = {
  input: UpdateFileStatusInput;
};


export type MutationUpdateWcmNaicsExclusionsArgs = {
  input: WcmUpdateNaicsExclusionsInput;
};


export type MutationUpdateWcmNaicsPaymentTermsArgs = {
  input: UpdateWcmNaicsPaymentTermsInput;
};


export type MutationUpdateWcmPaymentTermsVersionArgs = {
  input: UpdateWcmPaymentTermsVersionInput;
};


export type MutationUpdateWcmPlanArgs = {
  input: WcmUpdatePlanInput;
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmPlanWaveArgs = {
  input: UpdateWcmPlanWaveInput;
  planId: Scalars['Int']['input'];
  waveId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpdateWcmRolePermissionsArgs = {
  input: UpdateWcmRolesPermissionsInput;
};


export type MutationUpdateWcmRoleUsersArgs = {
  input: UpdateWcmRoleUsersInput;
};


export type MutationUpdateWcmSupplierGroupNoteArgs = {
  input: UpdateWcmSupplierGroupNoteInput;
};


export type MutationUpdateWcmSupplierSegmentConfigArgs = {
  input: UpdateWcmSupplierSegmentConfigInput;
};


export type MutationUpdateWcmSuppliersArgs = {
  input: UpdateWcmSuppliersInput;
};


export type MutationUpdateWcmSuppliersBenchmarkStrategyArgs = {
  input: UpdateWcmSuppliersBenchmarkStrategyInput;
};


export type MutationUpdateWcmSuppliersBenchmarkStrategyBySegmentArgs = {
  input: UpdateWcmSuppliersBenchmarkStrategyBySegmentInput;
};


export type MutationUpdateWcmUserRegistrationStatusArgs = {
  input: UpdateWcmUserRegistrationRequestInput;
};


export type MutationUpsertBuyerAppDivisionRolesArgs = {
  DivisionRolesUpsertInput: BuyerAppUpsertDivisionRolesInput;
};


export type MutationUpsertBuyerAppFileHistoryArgs = {
  FileHistoryUpsertInput: BuyerAppFileHistoryUpsertInput;
};


export type MutationUpsertBuyerAppMarketTakerConfigurationArgs = {
  input: UpsertBuyerAppMarketTakerConfigurationInput;
};


export type MutationUpsertBuyerAppMarketTakerReserveSettingsArgs = {
  input: BuyerAppUpdateMarketTakerReserveInput;
};


export type MutationUpsertBuyerAppUserPreferenceArgs = {
  input: UpsertBuyerAppUserPreferenceInput;
};


export type MutationUpsertOneTakerConfigurationArgs = {
  input: UpsertOneTakerConfigurationInput;
};


export type MutationUpsertWcmBenchmarkConfigArgs = {
  input: UpsertWcmBenchmarkConfigInput;
};


export type MutationUpsertWcmBenchmarkCountryRegulationsArgs = {
  input: UpsertWcmBenchmarkCountryRegulationsInput;
};


export type MutationUpsertWcmDomainConfigArgs = {
  input: UpsertWcmDomainConfigInput;
};


export type MutationUpsertWcmEconomicValueConfigArgs = {
  input: UpsertWcmEconomicValueConfigInput;
};


export type MutationUpsertWcmExclusionsConfigArgs = {
  input: UpsertWcmExclusionsConfigInput;
};


export type MutationUpsertWcmNegotiationArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmNegotiationInput;
  vendorVariantId: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmNegotiationStatusPhaseMappingsArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmStatusPhaseMappingsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmNegotiationsArgs = {
  currency: Scalars['String']['input'];
  input: UpsertWcmNegotiationsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type MutationUpsertWcmSegmentConversionRateArgs = {
  input: UpsertWcmSegmentConversionRateInput;
};


export type MutationUpsertWcmUserPreferenceArgs = {
  input: UpsertWcmUserPreferenceInput;
};


export type MutationUpsertWcmUsersArgs = {
  input: UpsertWcmUsersInput;
};


export type MutationUserArgs = {
  user: CreateUserInput;
};


export type MutationUserReconcileArgs = {
  authServiceUuids: Array<Scalars['ID']['input']>;
};


export type MutationUsersArgs = {
  users?: InputMaybe<Array<UserInput>>;
};


export type MutationWcmInsightsDeleteConversationArgs = {
  input: WcmInsightsDeleteConversationInputDto;
};


export type MutationWcmInsightsFeedbackArgs = {
  input: WcmInsightsFeedbackInputDto;
};


export type MutationWcmInsightsQueryArgs = {
  input: WcmInsightsQueryInputDto;
};


export type MutationWithdrawManualAwardsForOfferUuidArgs = {
  makerOrganizationUuid: Scalars['ID']['input'];
  offerUuid: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  requesterId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationWithdrawOneEarlyPayRequestArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For mutation responses */
export type MutationResponse = {
  /** HTTP Status Code of the Response */
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  /** For developers not for frontend */
  message: Scalars['String']['output'];
  /** True/False if the mutation worked. Patial success will show true */
  success: Scalars['Boolean']['output'];
};

export type Non_Clearing_Top_Offers_Order_Level =
  | 'ELIGIBLE_INVOICE_AMOUNT'
  | 'NOT_ACCEPTED_DPE_WEIGHTED_AVG'
  | 'NOT_ACCEPTED_EARN'
  | 'NOT_ACCEPTED_INVOICE_AMOUNT'
  | 'NOT_ACCEPTED_YIELD';

/** Whether an excluded NAICS code comes from the C2FO default set or buyer customisation */
export type NaicsExclusionSource =
  | 'CUSTOM'
  | 'DEFAULT';

/** Navigator DBT models for S3 to PostgreSQL data sync */
export type NavigatorDbtModel =
  | 'CAPIQ_ANNUAL_REPORT'
  | 'NAICS_GLOBAL_PAYMENT_TERMS'
  | 'NAICS_REGIONAL_PAYMENT_TERMS'
  | 'PENDULUM_ALL_NAICS_2022'
  | 'PENDULUM_PACA_EXCLUSION_FLAGS'
  | 'REGULATED_COUNTRY_TERMS';

export type NavigatorUnloadInput = {
  /** Optional file name to override the default (e.g., 20260324_000). Useful for retrying failed jobs. */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Array of Navigator models to unload from S3 */
  models: Array<NavigatorDbtModel>;
};

export type NavigatorUnloadOutput = {
  __typename?: 'NavigatorUnloadOutput';
  /** Message describing the result */
  message?: Maybe<Scalars['String']['output']>;
  /** Status of the unload operation */
  status: Scalars['Boolean']['output'];
};

export type NewSuppliers = {
  __typename?: 'NewSuppliers';
  companyGroupName: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
};

export type NewTakerMarketInput = {
  /** Id of the market */
  marketId: Scalars['Float']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Id of the taker */
  takerId: Scalars['Float']['input'];
  /** UUID of the taker */
  takerUuid: Scalars['String']['input'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotAcceptedStats = {
  __typename?: 'NotAcceptedStats';
  adjustedAmount: Scalars['Float']['output'];
  aprWeightedAvg: Scalars['Float']['output'];
  aprWeightedSum: Scalars['Float']['output'];
  discountAmount: Scalars['Float']['output'];
  discountWeightedAvg: Scalars['Float']['output'];
  discountWeightedSum: Scalars['Float']['output'];
  dpeWeightedAvg: Scalars['Float']['output'];
  dpeWeightedSum: Scalars['Float']['output'];
  earn: Scalars['Float']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
  yield: Scalars['Float']['output'];
};

/** Notification Keys is an object from the ODS API containing all unique notification keys */
export type NotificationKeys = {
  __typename?: 'NotificationKeys';
  notificationKeys: Array<Scalars['String']['output']>;
};

export type NumberComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberFieldComparison = {
  between?: InputMaybe<NumberFieldComparisonBetween>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notBetween?: InputMaybe<NumberFieldComparisonBetween>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float']['input'];
  upper: Scalars['Float']['input'];
};

export type Order_Type =
  | 'ASC'
  | 'DESC';

export type Occurrence =
  | 'INSTANT'
  | 'ONE_TIME'
  | 'RECURRING';

export type OccurrenceFilterComparison = {
  eq?: InputMaybe<Occurrence>;
  gt?: InputMaybe<Occurrence>;
  gte?: InputMaybe<Occurrence>;
  iLike?: InputMaybe<Occurrence>;
  in?: InputMaybe<Array<Occurrence>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Occurrence>;
  lt?: InputMaybe<Occurrence>;
  lte?: InputMaybe<Occurrence>;
  neq?: InputMaybe<Occurrence>;
  notILike?: InputMaybe<Occurrence>;
  notIn?: InputMaybe<Array<Occurrence>>;
  notLike?: InputMaybe<Occurrence>;
};

export type OfferBuilderType =
  | 'FLOW_1_PARTIAL'
  | 'FLOW_2_DETAIL';

export type OfferConfig = {
  __typename?: 'OfferConfig';
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  disableAfterMarketClearsDate?: Maybe<Scalars['DateTime']['output']>;
  divisionId: Scalars['Int']['output'];
  exclusionSettings?: Maybe<ExclusionSettings>;
  id: Scalars['Float']['output'];
  isDiscountBidding: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isReferenceRateBidding?: Maybe<Scalars['Boolean']['output']>;
  marketId: Scalars['Int']['output'];
  maxApr?: Maybe<Scalars['Float']['output']>;
  maxDiscount?: Maybe<Scalars['Float']['output']>;
  nodeId: Scalars['ID']['output'];
  offerType?: Maybe<Scalars['String']['output']>;
  offerUuid?: Maybe<Scalars['String']['output']>;
  rateInfo?: Maybe<OfferRateUnion>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type OfferConfigCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferConfigDeepFilter = {
  and?: InputMaybe<Array<OfferConfigDeepFilter>>;
  currency?: InputMaybe<OfferConfigCurrencyFilterComparison>;
  id?: InputMaybe<OfferConfigIdFilterComparison>;
  isEnabled?: InputMaybe<OfferConfigIsEnabledFilterComparison>;
  offerType?: InputMaybe<OfferConfigOfferTypeFilterComparison>;
  or?: InputMaybe<Array<OfferConfigDeepFilter>>;
  uuid?: InputMaybe<OfferConfigUuidFilterComparison>;
};

export type OfferConfigIdFilterComparison = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type OfferConfigIsEnabledFilterComparison = {
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferConfigOfferTypeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferConfigUuidFilterComparison = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type OfferFromDraftInput = {
  draftId: Scalars['String']['input'];
};

export type OfferRateUnion = BenchmarkRateInfo | PreferredRateInfo;

export type OfferType =
  | 'ONE_TIME'
  | 'REPEATING';

export type Offers = BenchmarkOffer | PriceDiscoveryOffer | StaticOffer;

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
};

export type OffsetPaging = {
  /** Limit the number of records returned */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Offset to start returning records from */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OmnichannelCommunicationDto = {
  __typename?: 'OmnichannelCommunicationDto';
  callerServiceName: Scalars['String']['output'];
  channelType: ChannelType;
  created: Scalars['DateTime']['output'];
  requestUuid: Scalars['String']['output'];
  templateData: Scalars['JSON']['output'];
  templateId: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  uuid: Scalars['String']['output'];
};

export type OmnichannelCommunicationDtoConnection = {
  __typename?: 'OmnichannelCommunicationDtoConnection';
  /** Array of edges. */
  edges: Array<OmnichannelCommunicationDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type OmnichannelCommunicationDtoEdge = {
  __typename?: 'OmnichannelCommunicationDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OmnichannelCommunicationDto */
  node: OmnichannelCommunicationDto;
};

export type OmnichannelCommunicationDtoFilter = {
  and?: InputMaybe<Array<OmnichannelCommunicationDtoFilter>>;
  or?: InputMaybe<Array<OmnichannelCommunicationDtoFilter>>;
  templateId?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type OmnichannelCommunicationDtoSort = {
  direction: SortDirection;
  field: OmnichannelCommunicationDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type OmnichannelCommunicationDtoSortFields =
  | 'templateId'
  | 'uuid';

export type OmnichannelCommunicationInput = {
  emailRequest?: InputMaybe<Array<EmailSendInput>>;
  smsRequest?: InputMaybe<Array<SmsRequestInput>>;
};

export type OmnichannelCommunicationResponseDto = {
  __typename?: 'OmnichannelCommunicationResponseDto';
  emailResponse?: Maybe<EmailResponseDto>;
  emailSend: Scalars['String']['output'];
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  whatsappSend: Scalars['String']['output'];
};

/**
 * A one time CashFlow+ request for early payment against invoices in one or more opportunities. These requests are placed only on the invoices that were in the opportunity
 * at the time the request was made. New invoices are not automatically added. Rate will be determined by the calculator. The full early pay amount will always be fully accepted and loaded onto the suppliers CashFlow+ Card.
 */
export type OneTimeCashFlowPlusRequest = {
  __typename?: 'OneTimeCashFlowPlusRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type OneTimeCashFlowPlusRequestEdge = {
  __typename?: 'OneTimeCashFlowPlusRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OneTimeCashFlowPlusRequest */
  node: OneTimeCashFlowPlusRequest;
};

export type OneTimeCashFlowPlusRequestInputDto = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
};

/**
 * A one time request for early payment against invoices in one or more opportunities. These requests are placed only on the invoices that were in the opportunity
 * at the time the request was made. New invoices are not automatically added. Invoices are accepted for early payment based on the supplier's requested rate of
 * discount and how many days early the invoice would be paid. The minimum accepted price is dynamically determined by comparing the buyer's desired returns
 * against a blended rate across multiple supplier requests.
 */
export type OneTimePriceDiscoveryRequest = {
  __typename?: 'OneTimePriceDiscoveryRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type OneTimePriceDiscoveryRequestEdge = {
  __typename?: 'OneTimePriceDiscoveryRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OneTimePriceDiscoveryRequest */
  node: OneTimePriceDiscoveryRequest;
};

export type OneTimePriceDiscoveryRequestInput = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['input'];
  /** Type of rate of this request. Either APR or DISC (Discount) */
  rateType: RateType;
};

/**
 * A one time request for early payment against invoices in an opportunity.
 * These requests are placed only on the invoices that were in the opportunity at the time the request was made. New invoices are not automatically added. Invoices are accepted for early payment against a static reference rate.
 */
export type OneTimeStaticRateRequest = {
  __typename?: 'OneTimeStaticRateRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type OneTimeStaticRateRequestEdge = {
  __typename?: 'OneTimeStaticRateRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the OneTimeStaticRateRequest */
  node: OneTimeStaticRateRequest;
};

export type OneTimeStaticRateRequestInputDto = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** An opportunity UUID that this request will be placed against */
  opportunityUuid: Scalars['String']['input'];
};

export type Opportunity = {
  __typename?: 'Opportunity';
  /** Contains information about benchmark rate if the opportunity submitted was of priceType BENCHMMARK_RATE */
  benchmarkRateDetails?: Maybe<BenchmarkRateDetails>;
  /**
   * The total discount across the clearing invoices for a given opportunity. To get the total discount (%) divide by the clearingInvoiceAmount.
   *  This value may be null if stats have not been calculated for the request,
   * clearing = accepted + awarded
   * discount = sum(invoice.earn)
   */
  clearingDiscountSum?: Maybe<Scalars['Float']['output']>;
  /**
   * Total amount of the clearing invoices in this opportunity.
   * clearing = accepted + awarded
   * This value may be null if stats have not been calculated for the request,
   */
  clearingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Total count of the clearing invoices in this opportunity. (clearing = accepted + awarded)
   *  This value may be null if stats have not been calculated for the request,
   */
  clearingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  /** Currency code for all invoices in this opportunity, e.g. USD */
  currency: Scalars['String']['output'];
  /** Unique identifier of the customer this opportunity is for. */
  customerUuid: Scalars['String']['output'];
  /** Eligibile AP being requested for early payment. This value may be null if stats have not been calculated for the request, */
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  /** Number of eligible invoices in this request. */
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  /** Maximum date that suppliers will receive funds after being awarded for this opportunity. Null when there are no taker markets with a good funds date in this opportunity */
  goodFundsDate?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this opportunity was created through a creation endpoint. */
  isManuallyCreated: Scalars['Boolean']['output'];
  /** The makerDisplayName at the time of request. */
  makerDisplayName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier of the buyer this opportunity is for. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Calculated name of the opportunity using the custom group if set. */
  opportunityName?: Maybe<Scalars['String']['output']>;
  /** Next market clear time across all takers markets in this request. Null when there are no taker markets with a clear time in this opportunity. */
  requestDeadline?: Maybe<Scalars['String']['output']>;
  /** Number invoices currently excluded by the supplier in this request */
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  /** @deprecated This field is being deprecated. It is a holdover for the invoice-revamp project. Do not use this field, as it will be removed in the near future. */
  takersMarketsForPricingServiceInvoiceEdits?: Maybe<Array<RequestTakersMarketsForPricingServiceInvoiceEdits>>;
  /** Unique identifier for this opportunity. */
  uuid?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this opportunity was submitted with eligibleInvoiceAmount of 0 in the invoiceSummary */
  wasSubmittedWithZeroAP?: Maybe<Scalars['Boolean']['output']>;
};

/** Pared down Custom Group object for embedding in opportunities. */
export type OpportunityCustomGroup = {
  __typename?: 'OpportunityCustomGroup';
  /** Designates if the opportunity associated with this group should be preselected. */
  isPreselected?: Maybe<Scalars['Boolean']['output']>;
  /** Customer display name describing the grouping of takers / markets */
  name?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this custom group */
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type OpportunityGroupByType =
  | 'MAKER_ORG_CUSTOM_GROUP_UUID';

export type OpportunityInput = {
  /** Contains information about benchmark rate if the opportunity submitted was of priceType BENCHMMARK_RATE */
  benchmarkRateDetails?: InputMaybe<BenchmarkRateDetailsInput>;
  /**
   * The total discount across the clearing invoices for a given opportunity. To get the total discount (%) divide by the clearingInvoiceAmount.
   *  This value may be null if stats have not been calculated for the request,
   * clearing = accepted + awarded
   * discount = sum(invoice.earn)
   */
  clearingDiscountSum?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Total amount of the clearing invoices in this opportunity.
   * clearing = accepted + awarded
   * This value may be null if stats have not been calculated for the request,
   */
  clearingInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Total count of the clearing invoices in this opportunity. (clearing = accepted + awarded)
   *  This value may be null if stats have not been calculated for the request,
   */
  clearingInvoiceCount?: InputMaybe<Scalars['Float']['input']>;
  /** Currency code for all invoices in this opportunity, e.g. USD */
  currency: Scalars['String']['input'];
  /** Unique identifier of the customer this opportunity is for. */
  customerUuid: Scalars['String']['input'];
  /** Eligibile AP being requested for early payment. This value may be null if stats have not been calculated for the request, */
  eligibleInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Number of eligible invoices in this request. */
  eligibleInvoiceCount?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum date that suppliers will receive funds after being awarded for this opportunity. Null when there are no taker markets with a good funds date in this opportunity */
  goodFundsDate?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this opportunity was created through a creation endpoint. */
  isManuallyCreated?: Scalars['Boolean']['input'];
  /** The makerDisplayName at the time of request. */
  makerDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** Unique identifier of the buyer this opportunity is for. */
  makerOrganizationUuid: Scalars['String']['input'];
  /** Calculated name of the opportunity using the custom group if set. */
  opportunityName?: InputMaybe<Scalars['String']['input']>;
  /** Next market clear time across all takers markets in this request. Null when there are no taker markets with a clear time in this opportunity. */
  requestDeadline?: InputMaybe<Scalars['String']['input']>;
  /** Number invoices currently excluded by the supplier in this request */
  takerExcludedInvoiceCount?: InputMaybe<Scalars['Float']['input']>;
  /** Unique identifier for this opportunity. */
  uuid?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this opportunity was submitted with eligibleInvoiceAmount of 0 in the invoiceSummary */
  wasSubmittedWithZeroAP?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OpportunityType =
  | 'PRICE_DISCOVERY'
  | 'STATIC_RATE';

export type OpportunityTypeFilterComparison = {
  eq?: InputMaybe<OpportunityType>;
  gt?: InputMaybe<OpportunityType>;
  gte?: InputMaybe<OpportunityType>;
  iLike?: InputMaybe<OpportunityType>;
  in?: InputMaybe<Array<OpportunityType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<OpportunityType>;
  lt?: InputMaybe<OpportunityType>;
  lte?: InputMaybe<OpportunityType>;
  neq?: InputMaybe<OpportunityType>;
  notILike?: InputMaybe<OpportunityType>;
  notIn?: InputMaybe<Array<OpportunityType>>;
  notLike?: InputMaybe<OpportunityType>;
};

/**
 * A mutation response when opting out of all communication channels. The list of
 * channels opted out of will be returned. The backing data source is the ODS API.
 */
export type OptOutCommunicationPreferencesRequest = {
  channel?: InputMaybe<Scalars['String']['input']>;
  notificationKey?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A mutation response when opting out of all communication channels. The list of
 * channels opted out of will be returned. The backing data source is the ODS API.
 */
export type OptOutCommunicationPreferencesResponse = {
  __typename?: 'OptOutCommunicationPreferencesResponse';
  channels: Array<Scalars['String']['output']>;
};

export type Order =
  | 'asc'
  | 'desc';

export type OrderByDto = {
  orderLevel: OrderLevelEnums;
  orderType?: OrderTypeEnums;
};

export type OrderLevelEnums =
  | 'PAY_DATE';

export type OrderTypeEnums =
  | 'ASC'
  | 'DESC';

export type OrgStatsData = {
  __typename?: 'OrgStatsData';
  acceptedAp: Scalars['Float']['output'];
  acceptedDpe: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid: Scalars['String']['output'];
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  notAcceptedDpe: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
};

export type OrgStatsInput = {
  aggregationLevel?: AggregationLevelWithMarketType;
  currency?: Scalars['String']['input'];
  marketType?: InputMaybe<Scalars['String']['input']>;
  uuids?: Array<Scalars['String']['input']>;
};

export type OrganizationAddressInfo = {
  __typename?: 'OrganizationAddressInfo';
  country?: Maybe<Scalars['String']['output']>;
};

export type OriginalTakerConfigInputDto = {
  created?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  disable_after_market_clears_date?: InputMaybe<Scalars['String']['input']>;
  disable_after_num_market_clears?: InputMaybe<Scalars['Float']['input']>;
  disable_at?: InputMaybe<Scalars['String']['input']>;
  division_id?: InputMaybe<Scalars['Float']['input']>;
  exclusion_settings?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  is_discount_bidding?: InputMaybe<Scalars['Boolean']['input']>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_migrated_to_early_pay_offer?: InputMaybe<Scalars['Boolean']['input']>;
  is_reference_rate_bidding?: InputMaybe<Scalars['Boolean']['input']>;
  last_updated_by?: InputMaybe<Scalars['Float']['input']>;
  market_id?: InputMaybe<Scalars['Float']['input']>;
  max_apr?: InputMaybe<Scalars['Float']['input']>;
  max_discount?: InputMaybe<Scalars['Float']['input']>;
  min_bid?: InputMaybe<Scalars['Float']['input']>;
  offer_type?: InputMaybe<Scalars['String']['input']>;
  offer_uuid?: InputMaybe<Scalars['String']['input']>;
  set_by_global_offer?: InputMaybe<Scalars['Boolean']['input']>;
  spread?: InputMaybe<Scalars['Float']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OutOfNetworkCustomer = {
  __typename?: 'OutOfNetworkCustomer';
  /** Whether the current user voted for this customer */
  isVoted: Scalars['Boolean']['output'];
  /** Customer name */
  name: Scalars['String']['output'];
  /** Unique identifier */
  uuid: Scalars['String']['output'];
  /** How many times this customer is requested by unique users */
  voteCount: Scalars['Int']['output'];
  /** Customer website url */
  websiteUrl: Scalars['String']['output'];
};

export type OverrideConfig = {
  __typename?: 'OverrideConfig';
  fileNames: Array<SerializerOverride>;
  filesetFunderOverrides: Array<Variable>;
  filesetSecretOverrides: Array<SecretOverride>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']['output']>;
};

export type Paging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type Payload = {
  __typename?: 'Payload';
  access?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserToken>;
};

export type PaymentStatus =
  | 'CANCELLED'
  | 'FAILED'
  | 'NOT_APPLICABLE'
  | 'PAID'
  | 'PENDING';

/** The Personal Identifiable Information (PII) that is currently in the C2FO DB user table. */
export type PersonalInfo = Node & {
  __typename?: 'PersonalInfo';
  address?: Maybe<Address>;
  arDepartmentEmailAddress?: Maybe<Scalars['String']['output']>;
  c2foDbId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  contactPreference?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fiscalYearEnd?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** A new value for capturing Role. We have set categories. Similar to title but not free form. */
  role?: Maybe<Role>;
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Free form entry for the user to explain their title */
  title?: Maybe<Scalars['String']['output']>;
};

/** Any user personal details, nothing app specific */
export type PersonalInfoInput = {
  address?: InputMaybe<UserAddressInput>;
  arDepartmentEmailAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyWebsite?: InputMaybe<Scalars['String']['input']>;
  contactPreference?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  smstoggle?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PinUnpinSuppliersInput = {
  companyIds: Array<Scalars['String']['input']>;
  makerUuid: Scalars['String']['input'];
  pinSupplier: Scalars['Boolean']['input'];
};

export type PlanAllSelectedOptions = {
  /** Additional filters to apply when all suppliers are selected */
  additionalFilters: AllSelectedFiltersInput;
  /** List of vendor master IDs explicitly not selected for operation */
  deselectedVendorVariantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Must be true to indicate all suppliers are selected */
  value?: Scalars['Boolean']['input'];
};

/** Response object for preferred offer config service. For GET queries, we will return default (false) config values if an account is not found. UpdatedBy, created, and updated fields will also default to null values if no account is found. */
export type PreferredOfferConfigResponse = {
  __typename?: 'PreferredOfferConfigResponse';
  /** Salesforce account ID to associated with config record */
  accountId: Scalars['String']['output'];
  /** Flag indicating whether or not account can edit invoices on an active preferred offer. In the event that an account config is not found, we will return a default false value */
  canEditInvoices: Scalars['Boolean']['output'];
  /** Timestamp indicating when the record was created. In the event that an account config is not found, we will return a default null value */
  created?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp indicating when the record was last updated. In the event that an account config is not found, we will return a default null value */
  updated?: Maybe<Scalars['DateTime']['output']>;
  /** Uuid associated with the user that last updated the config. In the event that an account config is not found, we will return a default null value */
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PreferredOfferInput = {
  draftId: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  supplierDivisionUuids: Array<Scalars['String']['input']>;
};

export type PreferredRateInfo = {
  __typename?: 'PreferredRateInfo';
  rateSourceName: Scalars['String']['output'];
  referenceRate: Scalars['Float']['output'];
  spread?: Maybe<Scalars['Float']['output']>;
  totalRate: Scalars['Float']['output'];
};

/** An in app preferred term request is a time bounded request for early payment, selected by a user in-app. New invoices are automatically added and accepted at a fixed rate/discount for a period of time (ex: 60 , 90 days). */
export type PreferredTermInAppRequest = {
  __typename?: 'PreferredTermInAppRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** The name of the source that defines the variable rate associated to a PREFERRED_TERM REF rateType request. */
  rateSourceName?: Maybe<Scalars['String']['output']>;
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  /** Spread associated to a PREFERRED_TERM request. */
  spread?: Maybe<Scalars['Float']['output']>;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** DateTime at which a PREFERRED_TERM request expires. */
  termExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type PreferredTermInAppRequestEdge = {
  __typename?: 'PreferredTermInAppRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the PreferredTermInAppRequest */
  node: PreferredTermInAppRequest;
};

export type PreferredTermInAppRequestInput = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['input'];
  /** Type of rate of this request. Either APR or DISC (Discount) */
  rateType: RateType;
  /** DateTime at which a PREFERRED_TERM request expires. */
  termExpirationDate: Scalars['DateTime']['input'];
};

/** A preferred term request is a time bounded request for early payment. These requests are initiated by SRM and sent to the supplier for approval. New invoices are automatically added and accepted at a fixed rate/discount for a period of time (ex: 60 , 90 days). */
export type PreferredTermRequest = {
  __typename?: 'PreferredTermRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** The name of the source that defines the variable rate associated to a PREFERRED_TERM REF rateType request. */
  rateSourceName?: Maybe<Scalars['String']['output']>;
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  /** Spread associated to a PREFERRED_TERM request. */
  spread?: Maybe<Scalars['Float']['output']>;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** DateTime at which a PREFERRED_TERM request expires. */
  termExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type PreferredTermRequestEdge = {
  __typename?: 'PreferredTermRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the PreferredTermRequest */
  node: PreferredTermRequest;
};

export type PreferredTermRequestInput = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
};

export type PriceDiscoveryGlobalOfferResultDto = {
  __typename?: 'PriceDiscoveryGlobalOfferResultDto';
  /** A list of uuids representing taker configs that were unsuccessful in being created/updated */
  failures?: Maybe<Array<GlobalOfferResultFailureDatumDto>>;
  /** A list of uuids representing the successfully updated taker configs */
  successes?: Maybe<Array<GlobalOfferResultSuccessDatumDto>>;
  /** A list of validation errors that explains why takers markets were skipped when being updated/created in the global offer. */
  validationErrors?: Maybe<Array<GlobalOfferResultValidationErrorsDatumDto>>;
};

export type PriceDiscoveryOffer = {
  __typename?: 'PriceDiscoveryOffer';
  options: Array<PriceDiscoveryOptions>;
  /** Reference Rate Stats are only available for a preferred market that is not in offer, has manual-award-availability, and has preferredCashPoolEligibility. */
  referenceRateStats?: Maybe<ReferenceRateStatistics>;
  type: Pricing;
};

export type PriceDiscoveryOfferInput = {
  draftId?: InputMaybe<Scalars['String']['input']>;
  excludeNewInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  expireOn?: InputMaybe<Scalars['String']['input']>;
  frequency: Frequency;
  marketUuid: Scalars['String']['input'];
  maxApr?: InputMaybe<Scalars['Float']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  rateType: Rate;
  supplierDivisionUuid: Scalars['String']['input'];
};

export type PriceDiscoveryOptions =
  | 'CASHFLOW_PLUS'
  | 'EXPRESS_ACCEPT'
  | 'PREFERRED'
  | 'PRICE_DISCOVERY';

export type PriceDiscoveryPricing = {
  __typename?: 'PriceDiscoveryPricing';
  nodeId: Scalars['ID']['output'];
  type: Pricing;
};

export type PriceDiscoveryRate = {
  __typename?: 'PriceDiscoveryRate';
  type: Scalars['String']['output'];
};

export type PriceType = BenchmarkRate | PriceDiscoveryRate | StaticRate;

export type Pricing =
  | 'BENCHMARK'
  | 'PRICE_DISCOVERY'
  | 'STATIC';

/**
 * Pricing Suggestion is an object from the DataScience's Pricing API containing information
 * about a given offer's pricing suggestion, including the rate, slider numbers, whether or not to show express
 * accept, et al. The backing data source is the DataScience's Pricing API.
 */
export type PricingSuggestion = {
  __typename?: 'PricingSuggestion';
  clearedDpeSum?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  created: Scalars['DateTime']['output'];
  expressAcceptRate?: Maybe<Scalars['Float']['output']>;
  fallbackRatesUsed: Scalars['Boolean']['output'];
  highSlider: Scalars['Float']['output'];
  highSliderOuter?: Maybe<Scalars['Float']['output']>;
  inSliderExperiment?: Maybe<Scalars['Boolean']['output']>;
  lowSlider: Scalars['Float']['output'];
  lowSliderOuter?: Maybe<Scalars['Float']['output']>;
  projectedClearingPercentage?: Maybe<Scalars['Float']['output']>;
  showAverageDiscount?: Maybe<Scalars['Boolean']['output']>;
  showExpressAccept: Scalars['Boolean']['output'];
  suggestedRate?: Maybe<Scalars['Float']['output']>;
  suggestedRateType?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type PricingSuggestionEdge = {
  __typename?: 'PricingSuggestionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the PricingSuggestion */
  node: PricingSuggestion;
};

export type PricingType = BenchmarkPricing | PriceDiscoveryPricing | StaticPricing;

export type Profile = {
  __typename?: 'Profile';
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  traits?: Maybe<Scalars['JSONObject']['output']>;
};

export type ProfileImage = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  displayCoordinates?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  s3Url?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileImageResponse = {
  __typename?: 'ProfileImageResponse';
  accountId?: Maybe<Scalars['String']['output']>;
  displayCoordinates?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
};

export type ProfileInput = {
  customer: CustomerInput;
  traits: Array<Scalars['String']['input']>;
};

export type Program = {
  __typename?: 'Program';
  created: Scalars['DateTime']['output'];
  funderBuyer?: Maybe<FunderBuyer>;
  funderBuyerUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramAuditConfigOutput = {
  __typename?: 'ProgramAuditConfigOutput';
  created: Scalars['DateTime']['output'];
  effectiveTillDate?: Maybe<Scalars['DateTime']['output']>;
  fileCount: Scalars['Float']['output'];
  makerUuid: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramConnection = {
  __typename?: 'ProgramConnection';
  /** Array of edges. */
  edges: Array<ProgramEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type ProgramDefaultResponse = {
  __typename?: 'ProgramDefaultResponse';
  message: Scalars['String']['output'];
};

export type ProgramEdge = {
  __typename?: 'ProgramEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the Program */
  node: Program;
};

export type ProgramFileConfig = {
  __typename?: 'ProgramFileConfig';
  buyerGeneratedUseForReconciliation?: Maybe<Scalars['Boolean']['output']>;
  deliverySettings?: Maybe<ProgramFileDeliverySettings>;
  fileNameFormat: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  filesetUuid: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  funderUuid: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  reconColumnDetails?: Maybe<ReconColumnDetails>;
  schedulingSettings?: Maybe<ProgramFileSchedulingSettings>;
  subType: Scalars['String']['output'];
};

export type ProgramFileDeliverySettings = {
  __typename?: 'ProgramFileDeliverySettings';
  deliveryLocationName?: Maybe<Scalars['String']['output']>;
  deliveryLocationUri?: Maybe<Scalars['String']['output']>;
};

export type ProgramFileSchedulingSettings = {
  __typename?: 'ProgramFileSchedulingSettings';
  deliveryMethod?: Maybe<Scalars['String']['output']>;
  deliveryTime?: Maybe<Scalars['String']['output']>;
  isDeliveryEnabled?: Maybe<Scalars['Boolean']['output']>;
  loadWindowEndTime?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type ProgramFileSetResponse = {
  __typename?: 'ProgramFileSetResponse';
  filterCriteria: ProgramSetFilterCriteriaDto;
  variables: Array<ProgramSetVariableDto>;
};

export type ProgramFileSetSettings = {
  __typename?: 'ProgramFileSetSettings';
  fileSetSettingsUuid: Scalars['String']['output'];
  programFileSettings: Array<ProgramFileSettings>;
  writerType: Scalars['String']['output'];
};

export type ProgramFileSetsOutputV1 = {
  __typename?: 'ProgramFileSetsOutputV1';
  programFileSets: Array<ProgramFilesetConfigurationV1>;
};

export type ProgramFileSettings = {
  __typename?: 'ProgramFileSettings';
  fileSettingsUuid?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  serialNo: Scalars['Float']['output'];
  subType: Scalars['String']['output'];
};

export type ProgramFileset = {
  __typename?: 'ProgramFileset';
  created: Scalars['DateTime']['output'];
  filterCriteria: FilterCriteria;
  name: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ProgramFilesetConfigurationV1 = {
  __typename?: 'ProgramFilesetConfigurationV1';
  feedbackFileConfiguration: FileSetSettingsConfigurationV1;
  filterCriteriaDetails: FilterCriteriaDetails;
  maturityFileConfiguration: FileSetSettingsConfigurationV1;
  paymentFileConfiguration: FileSetSettingsConfigurationV1;
  summaryDetails: SummaryDetails;
};

export type ProgramFilesetFilter = {
  and?: InputMaybe<Array<ProgramFilesetFilter>>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilesetFilter>>;
  programUuid?: InputMaybe<StringFieldComparison>;
  status?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramFilesetSort = {
  direction: SortDirection;
  field: ProgramFilesetSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ProgramFilesetSortFields =
  | 'name'
  | 'programUuid'
  | 'status'
  | 'uuid';

export type ProgramFilter = {
  and?: InputMaybe<Array<ProgramFilter>>;
  funderBuyer?: InputMaybe<ProgramFilterFunderBuyerFilter>;
  name?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramFilterFunderBuyerFilter = {
  and?: InputMaybe<Array<ProgramFilterFunderBuyerFilter>>;
  funderUuid?: InputMaybe<StringFieldComparison>;
  makerDataCenter?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<ProgramFilterFunderBuyerFilter>>;
  organizationUuid?: InputMaybe<StringFieldComparison>;
};

export type ProgramSetFilterCriteriaDto = {
  __typename?: 'ProgramSetFilterCriteriaDto';
  filterColumn: Scalars['String']['output'];
  filterValue: Scalars['String']['output'];
};

export type ProgramSetVariableDto = {
  __typename?: 'ProgramSetVariableDto';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ProgramSort = {
  direction: SortDirection;
  field: ProgramSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ProgramSortFields =
  | 'name'
  | 'uuid';

export type QualifiedSupplier = {
  __typename?: 'QualifiedSupplier';
  companyGroupUuid?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyIdUploads: CompanyIdUpload;
  companyName?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isPinned: Scalars['Boolean']['output'];
  isValid: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  makerId?: Maybe<Scalars['Float']['output']>;
  makerUuid: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updated: Scalars['DateTime']['output'];
  updatedBy: Scalars['String']['output'];
  uploadUuid: Scalars['String']['output'];
};

export type QualifiedSupplierConnection = {
  __typename?: 'QualifiedSupplierConnection';
  /** Array of edges. */
  edges: Array<QualifiedSupplierEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type QualifiedSupplierEdge = {
  __typename?: 'QualifiedSupplierEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the QualifiedSupplier */
  node: QualifiedSupplier;
};

export type QualifiedSupplierFilter = {
  and?: InputMaybe<Array<QualifiedSupplierFilter>>;
  companyId?: InputMaybe<StringFieldComparison>;
  companyIdUploads?: InputMaybe<QualifiedSupplierFilterCompanyIdUploadFilter>;
  currency?: InputMaybe<StringFieldComparison>;
  location?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierFilter>>;
  supplierName?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type QualifiedSupplierFilterCompanyIdUploadFilter = {
  and?: InputMaybe<Array<QualifiedSupplierFilterCompanyIdUploadFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierFilterCompanyIdUploadFilter>>;
};

export type QualifiedSupplierInput = {
  companyGroupUuid: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  qualifiedSupplierId: Scalars['Float']['input'];
};

export type QualifiedSupplierSort = {
  direction: SortDirection;
  field: QualifiedSupplierSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type QualifiedSupplierSortFields =
  | 'companyId'
  | 'currency'
  | 'location'
  | 'makerUuid'
  | 'supplierName'
  | 'updated';

export type QualifiedSupplierUpdateFilter = {
  and?: InputMaybe<Array<QualifiedSupplierUpdateFilter>>;
  companyId?: InputMaybe<StringFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  location?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<QualifiedSupplierUpdateFilter>>;
  supplierName?: InputMaybe<StringFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  actionableOfferSchedule: ActionableOfferSchedule;
  actionableOfferScheduleHistories: ActionableOfferScheduleHistoryConnection;
  actionableOfferScheduleTags: ActionableOfferScheduleTagsConnection;
  actionableOfferSchedules: ActionableOfferScheduleConnection;
  activationOfferSummary: ActivationOfferSummaryResponse;
  agreement: Agreement;
  agreementAudit: AgreementAudit;
  agreementAudits: AgreementAuditConnection;
  agreements: AgreementConnection;
  allTakersMarkets: Array<TakersMarketsNoPage>;
  buyer: Buyer;
  /** API to fetch all divisions users roles */
  buyerAppDivisionsUsersRoles: BuyerAppDivisionsUsersRolesOutput;
  /** API to check if dual auth is enabled for the given division */
  buyerAppDualAuthEnabled: BuyerAppDualAuthorizationRolesEnabledOutput;
  buyerAppRoles: BuyerAppRoleConnection;
  /** API to query all buyer level configurations for DSF buyer */
  buyerAuditConfigData?: Maybe<ProgramAuditConfigOutput>;
  buyers: Array<Buyer>;
  c2foColumnMaster: C2foColumnMaster;
  c2foColumnMasters: C2foColumnMasterConnection;
  cashFlowPlusStats: CashflowPlusStatsResponseDto;
  cashInvested: Array<CashInvested>;
  cashflowInfo: CashflowInfoResponse;
  cashflowPlusStatsOpportunityInputDtoAggregate: Array<CashflowPlusStatsOpportunityInputDtoAggregateResponse>;
  checkCronStatus: Scalars['Boolean']['output'];
  checkUserIsBuyerProvided: Scalars['Boolean']['output'];
  checkUserLeadSourceIsBuyerProvided: LeadSource;
  communicationChannel: CommunicationChannel;
  communicationChannels: CommunicationChannelConnection;
  communicationPreference: CommunicationPreference;
  communicationPreferences: Array<CommunicationPreference>;
  companyGroup: CompanyGroup;
  companyGroups: Array<CompanyGroup>;
  customAgreementVersionHistory: Array<CustomAgreementVersionHistory>;
  customAgreementWithContent: CustomAgreementWithContent;
  customAgreements: Array<CustomAgreement>;
  customGroup: CustomGroup;
  customGroupAggregate: Array<CustomGroupAggregateResponse>;
  customGroupItems: CustomGroupItemConnection;
  customGroups: CustomGroupConnection;
  customerLinkingRequests: Array<CustomerLinkingRequest>;
  customerProfile: CustomerProfile;
  division: Division;
  divisions: DivisionConnection;
  draftRequests: DraftRequestConnection;
  earlyPayBuyerOrganizations: EarlyPayBuyerOrganizationReponse;
  earlyPayDivision: EarlyPayDivision;
  earlyPayDivisionByUuid: EarlyPayDivision;
  earlyPayDivisions: EarlyPayDivisionOffsetConnection;
  earlyPayDraftOfferByUuid?: Maybe<EarlyPayDraftOfferDto>;
  earlyPayDraftOffers?: Maybe<Array<EarlyPayDraftOfferDto>>;
  earlyPayMarket: EarlyPayMarket;
  earlyPayMarketByUuid: EarlyPayMarket;
  earlyPayMarkets: EarlyPayMarketOffsetConnection;
  earlyPayOpportunities: EarlyPayOpportunityConnection;
  earlyPayOpportunity: EarlyPayOpportunity;
  earlyPayOpportunityAggregate: Array<EarlyPayOpportunityAggregateResponse>;
  earlyPayOrganization: EarlyPayOrganization;
  earlyPayOrganizationByUuid: EarlyPayOrganization;
  earlyPayOrganizations: EarlyPayOrganizationOffsetConnection;
  earlyPayRequests: EarlyPayRequestConnection;
  earlyPaySupplierClears: EarlyPaySupplierClearOffsetConnection;
  earlyPaySupplierStats: EarlyPaySupplierStatsOffsetConnection;
  earlyPayUserSupplierClears: EarlyPaySupplierClearOffsetConnection;
  earlyPayUserSupplierStats: EarlyPaySupplierStatsOffsetConnection;
  estimatedAPRInputDtoAggregate: Array<EstimatedAprInputDtoAggregateResponse>;
  /** API to fetch company group for a maker */
  fetchCompanyGroups: Array<FetchCompanyGroupOutputDto>;
  fetchCompanyGroupsIntersection: FetchCompanyGroupsIntersectionOutput;
  /** API to query suppliers companyId and isPinned data */
  fetchSuppliersForCompanyGroup: SuppliersOutputDto;
  fetchUniqueCurrenciesForCGIntersection: CurrenciesDto;
  fetchUniqueLocationsForCGIntersection: LocationsDto;
  funder: Funder;
  funderBuyer: FunderBuyer;
  funderBuyers: FunderBuyerConnection;
  funderCalculations: FunderCalculationsConnection;
  funderCurrencies: Array<FunderCurrencies>;
  funderDeliverySettingsDto: FunderDeliverySettingsDto;
  funderDeliverySettingsDtos: FunderDeliverySettingsDtoConnection;
  funderFeedbackConfig: FunderFeedbackConfig;
  funderFeedbackConfigs: FunderFeedbackConfigConnection;
  funderFile: FunderFile;
  funderFileColumnMaster: FunderFileColumnMaster;
  funderFileColumnMasters: FunderFileColumnMasterConnection;
  funderFileDeliveryDto: FunderFileDeliveryDto;
  funderFileDeliveryDtos: FunderFileDeliveryDtoConnection;
  funderFiles: FunderFileConnection;
  funderGeographies: Array<FunderGeographies>;
  funderLegalAgreement: FunderLegalAgreement;
  funderLegalAgreements: FunderLegalAgreementConnection;
  funderNotification: FunderNotification;
  funderNotifications: FunderNotificationConnection;
  funderSummary: FunderSummary;
  funderVariable: FunderVariable;
  funderVariables: FunderVariableConnection;
  funders: FunderConnection;
  getAggregateHistoryInfo: HistoryInfoOutput;
  getAggregatedMarketStats: Array<AggregatedMarketsStatsOutput>;
  getAggregatedSuppliersHistoryInfo: SupplierHistoryInfoOutput;
  getBenchmarkReferenceRate: ReferenceRateResponseDto;
  /** API to get the aggregated scf disclosure data grouped at funding partner, currency level for the given timeframe */
  getBuyerAppAggregatedScfDisclosure?: Maybe<Array<BuyerAppAggregatedScfDisclosureOutput>>;
  /** API to get the YoY AP performance report data */
  getBuyerAppApPerformanceReportData?: Maybe<Array<BuyerAppApPerformanceReportOutput>>;
  /** API to get the AP summary data */
  getBuyerAppApSummaryData?: Maybe<Array<BuyerAppApSummaryOutput>>;
  /** API to fetch award history */
  getBuyerAppAwardHistory: BuyerAppMakerMarketClearHistoryOutputDto;
  /** Query to get Awarded Suppliers Info. */
  getBuyerAppAwardedSuppliersHistory: BuyerAppAwardedSuppliersHistoryOutput;
  /** Query to get clear history graph data. */
  getBuyerAppClearHistoryGraph: BuyerAppClearHistoryGraphOutput;
  /** Query to get clear history stats data. */
  getBuyerAppClearHistoryStats: BuyerAppClearHistoryStatsOutput;
  /** Query to get top clearing offers of the given buyer's markets */
  getBuyerAppClearingTopOffers: BuyerAppClearingTopOffersOutput;
  /** API to get the Core Market Metrics data grouped by period */
  getBuyerAppCoreMarketMetricsData?: Maybe<Array<BuyerAppCoreMarketMetricsOutput>>;
  /** API to get the Core Market Metrics data grouped by period for Downloading */
  getBuyerAppCoreMarketMetricsDownloadData?: Maybe<Array<BuyerAppCoreMarketMetricsDownloadOutput>>;
  /** API to get Credit limit and utilisation of divisions */
  getBuyerAppCreditLimit: BuyerAppCreditLimitOutput;
  /** API to get the Cumulative Vendors data */
  getBuyerAppCumulativeVendorsData?: Maybe<Array<BuyerAppCumulativeVendorsDetailsOutput>>;
  getBuyerAppDivisionRegions: Array<BuyerAppDivisionRegion>;
  /** API to get the reporting currencies for the given division uuids and report type */
  getBuyerAppDivisionReportingCurrencies: Array<BuyerAppDivisionReportingCurrenciesOutput>;
  /** API to get the division roles showIncome and showYield */
  getBuyerAppDivisionRoles?: Maybe<BuyerAppDivisionRolesOutput>;
  /** API to get the DPE Analysis data group by period */
  getBuyerAppDpeAnalysisData?: Maybe<Array<BuyerAppDpeAnalysisDetailsOutput>>;
  /** API to get url from everafter for embedding */
  getBuyerAppEverAfterEmbedURL: Scalars['String']['output'];
  getBuyerAppEverafterBuyerConfig: BuyerAppEverafterBuyerConfig;
  getBuyerAppFileHistories: BuyerAppFileHistoryConnection;
  /** Query to get fetch the funder payment stats. */
  getBuyerAppFunderPaymentStats: BuyerAppFunderPaymentStatsOutput;
  /** Query to get live stats data. */
  getBuyerAppLiveStats: BuyerAppLiveStatsOutput;
  /** API to get the monthly scf disclosure data for the given timeframe */
  getBuyerAppMonthlyScfDisclosure?: Maybe<Array<BuyerAppMonthlyScfDisclosureOutput>>;
  /** API to get the Network Growth data */
  getBuyerAppNetworkGrowthData?: Maybe<Array<BuyerAppNetworkGrowthDetailsOutput>>;
  /** Query to get top non clearing offers of the given buyer's markets */
  getBuyerAppNonClearingTopOffers: BuyerAppNonClearingTopOffersOutput;
  /** API to get the Participation Breakdown data */
  getBuyerAppParticipationBreakdownData?: Maybe<Array<BuyerAppParticipationBreakdownDetailsOutput>>;
  /** Query to get performance by currency data */
  getBuyerAppPerformanceByCurrencyData: Array<BuyerAppPerformanceByCurrencyDataOutput>;
  /** Query to get performance by currency stats data */
  getBuyerAppPerformanceByCurrencyStats: BuyerAppPerformanceByCurrencyStatsOutput;
  /** API to fetch recent manual upload files history */
  getBuyerAppRecentManualFileUploadHistory: BuyerAppManualUploadProcessorHistoryOutput;
  /** API to get the repeat and new income data */
  getBuyerAppRepeatVsNewIncome?: Maybe<Array<BuyerAppRepeatVsNewIncomeOutput>>;
  /** API to get the repeat vs new loaded ap data */
  getBuyerAppRepeatVsNewLoadedApData?: Maybe<Array<BuyerAppRepeatVsNewLoadedApOutput>>;
  /** Query to get revenue share graph data. */
  getBuyerAppRevShareGraph: Array<BuyerAppRevShareOutput>;
  /** API to get the scf disclosure timeframe boundaries for all the funders of the divisions */
  getBuyerAppScfDisclosureTimeFrameBoundaries?: Maybe<Array<BuyerAppScfDisclosureTimeframeBoundariesOutput>>;
  /** Query to get adjusted invoices of the given supplier in the buyer's market */
  getBuyerAppSupplierAdjustments: BuyerAppSupplierAdjustmentsOutput;
  /** Query to get supplier clear history data. */
  getBuyerAppSupplierClearHistory: Array<BuyerAppSupplierClearHistoryOutput>;
  /** Query to get supplier details */
  getBuyerAppSupplierDetails: BuyerAppSupplierDetailsOutput;
  /** Query to get invoices of the given supplier in the buyer's market */
  getBuyerAppSupplierInvoices: BuyerAppSupplierInvoicesOutput;
  /** API to get the YoY Supplier performance report data */
  getBuyerAppSupplierPerformanceReportData?: Maybe<Array<BuyerAppSupplierPerformanceReportOutput>>;
  /** Query to get supplier settings data. */
  getBuyerAppSupplierSettings: BuyerAppSupplierSettingsOutput;
  /** Query to get supplier stats */
  getBuyerAppSupplierStats: BuyerAppSupplierStatsOutput;
  /** Query to get suppliers offers data. */
  getBuyerAppSuppliersOffers: BuyerAppSuppliersOffersOutput;
  getBuyerAppUserFilters?: Maybe<Array<BuyerAppUserFiltersOutput>>;
  /** Returns buyer-platform user preferences stored in user_preferences (JWT user scope). */
  getBuyerAppUserPreference: GetBuyerAppUserPreferenceOutput;
  /** API to get the reporting currencies for the given org */
  getBuyerReportingCurrencies: BuyerReportingCurrenciesOutput;
  getCashUsed: Array<CashUsed>;
  getClearingStats: Array<ClearingStatsOutput>;
  getDefaults: DefaultPreferences;
  getEligibleCustomersInfoList: Array<CustomerDetails>;
  /** API to query encryption settings for given funderUuid */
  getEncryptionSettingDetails: EncryptionSettingsOutput;
  /** Calculates estimated APR and returns rate sources for reference rate based opportunities */
  getEstimatedAPRAndRateSources: EstimatedAprDto;
  /** API to query file Delivery settings */
  getFileDeliverySettings: DeliverySettingsOutput;
  /** API to query distinct writer types for a funder */
  getFunderDistinctWriterTypes: WriterTypeOutput;
  getIncomeOverTime: Array<IncomeOverTimeReturnType>;
  getInvoiceStatsForMarket: Array<InvoiceStatsOutput>;
  getLiveMarketStats?: Maybe<Array<LiveMarketStatsData>>;
  getManyBuyerAppBuyerSupplierCounts: Array<BuyerAppBuyerSupplierCounts>;
  getManyBuyerAppSubprocessorsSubscriptionDetails: Array<BuyerAppSubprocessorsSubscription>;
  getManyWcmMasterBuyersDetails: Array<WcmMasterBuyerList>;
  getManyWcmMasterCountryRegionDetails: Array<WcmMasterRegionCountryList>;
  getManyWcmUserBuyerMappingDetails: Array<WcmUserBuyerMappingDetails>;
  getManyWcmUserInformation: Array<WcmUserInformation>;
  /** API to fetch market settings of the market */
  getMarketSettings: MarketSettingsOutput;
  getNotificationKeys: NotificationKeys;
  getPreferredOfferConfig: PreferredOfferConfigResponse;
  getPreferredOfferConfigs: Array<PreferredOfferConfigResponse>;
  getProfileImage: ProfileImageResponse;
  /** API to query program file configurations for a funder and buyer */
  getProgramFileConfigs: Array<ProgramFileConfig>;
  /** API to query all  Fileset level configurations for different file types */
  getProgramFileSetConfigurationsV1: ProgramFileSetsOutputV1;
  /** API to query distinct currencies for a program */
  getProgramUniqueCurrencies: CurrenciesDto;
  /** API to query distinct locations for a program */
  getProgramUniqueLocations: LocationsDto;
  getQualifiedSuppliersForProgram: SupplierDetailsOutput;
  getSalesForceSavedViews: Array<SalesforceSavedViewResponse>;
  getSalesforceDetailsForUser: SalesforceDetails;
  getSegmentsForUser: Array<SegmentsDto>;
  getSupplierMembership: GetSupplierMembershipOutput;
  getSupplierStats: SupplierStats;
  getTakersMarketsStatsForMarket?: Maybe<TakersMarketsStatsForMarket>;
  getUserAuthToken: UserAuthTokenDetails;
  /** Cascading invoice adherence filter facets for monitoring. */
  getWcmAdherenceDynamicInvoiceFilters: WcmAdherenceDynamicInvoiceFilters;
  /** Paged adherence KPI rows grouped by 1..3 supplier dimensions. Each row includes baseline, selected, and delta blocks. */
  getWcmAdherenceKpiByAggregator: WcmAdherenceKpiByAggregatorOutput;
  /** Paged non-comparative adherence KPI rows, one per period bucket optionally nested by 0..3 supplier dimensions, spanning the baseline..selected month range. Each row has plain metric columns; the response also carries range-wide scope totals. */
  getWcmAdherenceKpiByPeriod: WcmAdherenceKpiByPeriodOutput;
  /** Baseline vs selected payment month adherence KPI comparison for monitoring. */
  getWcmAdherenceKpis: WcmAdherenceKpis;
  /** Anchor-driven 12-month adherence trend with rolling averages. */
  getWcmAdherenceTrend: WcmAdherenceTrend;
  /** This query is used to get Wcm Aggregated Tabular Data */
  getWcmAggregatedSpends: GetWcmAggregatedSpendsOutput;
  /** Query to get assignable wcm permissions for a permission manager */
  getWcmAllAssignablePermissionsForPermissionManager: GetWcmRolePermissionsOutput;
  /** This query is used to get the file logs of the user */
  getWcmAllUserFileLogs: Array<WcmAllUserFileLogs>;
  /** Get WCM Benchmark Config for a buyer and currency */
  getWcmBenchmarkConfig?: Maybe<WcmBenchmarkConfigOutput>;
  /** Get WCM Benchmark Country Regulations for a buyer and currency */
  getWcmBenchmarkCountryRegulations: WcmBenchmarkCountryRegulationsOutput;
  /** Query to get all assignable wcm roles for a permission manager */
  getWcmBuyerAllAssignableRolesForPermissionManager: GetWcmBuyerAllAssignableRolesForPermissionManagerOutput;
  /** Get buyer configuration */
  getWcmBuyerConfig: BuyerAppBuyerConfigResponse;
  /** This query is used to fetch enriched file upload history for a buyer-currency */
  getWcmBuyerEnrichedFileUploadHistory: Array<WcmEnrichedFileUploadHistory>;
  /** Query to get buyer exclusion remarks */
  getWcmBuyerExclusionRemarks: Array<WcmBuyerExclusionRemark>;
  /** Query to get supplier configurations for a specific transaction */
  getWcmBuyerFileConfigs: GetWcmBuyerFileConfigsOutput;
  /** This query is used to fetch invoice file upload history for a buyer-currency */
  getWcmBuyerInvoiceFileUploadHistory: Array<WcmInvoiceFileUploadHistory>;
  /** This query is used to get the wcm buyer details */
  getWcmBuyerMetaData: WcmBuyerMetaDataOutput;
  /** Query to get wcm roles for a buyer */
  getWcmBuyerRoles: GetWcmBuyerRolesOutput;
  /** Query to validate if a user has access to a specific WCM buyer */
  getWcmBuyerUserAccess: WcmBuyerUserAccessOutput;
  /** Query to get wcm buyer users */
  getWcmBuyerUsers: GetWcmBuyerUsersOutput;
  /** Query to get wcm buyer users for wcm admin */
  getWcmBuyerUsersForAdmin: GetWcmBuyerUserDetailsForAdmin;
  /** Query to get WCM buyer users count filtered by buyer UUIDs. */
  getWcmBuyersUsersCount: Array<WcmBuyerUsersCountOutput>;
  /** This query is used to get the wcm spend cashflow distribution */
  getWcmCashflowDistribution: Array<WcmCashflowDistributionOutput>;
  /** Get cumulative financial trend data for the Financial Summary screen */
  getWcmCumulativeTrend: Array<WcmCumulativeBucket>;
  /** Get all custom attribute definitions with their unique values across all transactions */
  getWcmCustomAttributes: Array<WcmCustomAttributeResponse>;
  /** Get domain configuration by domain name */
  getWcmDomainConfig: WcmDomainClientConfigOutput;
  /** Fetches locked and updatable column definitions for the column-scoped update flow. */
  getWcmEnrichedSpendUpdatableColumns: WcmEnrichedSpendUpdatableColumns;
  /** This query is used to get the wcm exclusion criteria */
  getWcmExclusionCriteria: WcmExclusionCriteriaOutput;
  /** This query is used to get Wcm Exclusions Config */
  getWcmExclusionsConfig?: Maybe<WcmExclusionsConfigOutput>;
  /** This query is used to fetch suppliers for a transaction */
  getWcmFetchAllSupplier: WcmFetchAllWcmSuppliersOutput;
  /** This query is used to fetch supplier groups for a transaction */
  getWcmFetchAllSupplierGroups: WcmFetchAllSupplierGroupsOutput;
  /** This query is used to fetch suppliers satisfying working capital requirement */
  getWcmGenerateWorkingCapital: WcmGenerateWorkingCapitalOutput;
  /** This query is used to fetch supplier groups satisfying working capital requirement */
  getWcmGenerateWorkingCapitalGroups: WcmGenerateWorkingCapitalGroupsOutput;
  /** This query is used to get the grouped buyer working capital opportunity by supplier dimension */
  getWcmGroupedWorkingCapitalOpportunityByDimension: Array<WcmGroupedWorkingCapitalOpportunityByDimensionOutput>;
  /** List conversations for the current user and buyer. */
  getWcmInsightsConversations: Array<WcmInsightsConversationDto>;
  /** Get messages for a specific conversation. */
  getWcmInsightsMessages: Array<WcmInsightsMessageDto>;
  getWcmMasterBuyerDetail: WcmMasterBuyerList;
  /** Get negotiation snapshot per time bucket for the Financial Summary screen */
  getWcmMonitoringSnapshot: Array<WcmSnapshotBucket>;
  /** Get monitoring stats (headline KPIs) for the Financial Summary screen */
  getWcmMonitoringStats: WcmMonitoringStats;
  /** Composed NAICS exclusion editor payload. */
  getWcmNaicsExclusions: WcmNaicsExclusions;
  /** This query is used to get NAICS suggestions */
  getWcmNaicsSuggestions: Array<WcmGetNaicsSuggestionsOutput>;
  /** Get a WCM supplier negotiation */
  getWcmNegotiation?: Maybe<WcmNegotiationOutput>;
  /** Get all negotiation status-to-phase mappings for a buyer + currency */
  getWcmNegotiationStatusPhaseMappings: Array<WcmStatusPhaseMappingItem>;
  /** Get WCM negotiations for multiple supplier entities */
  getWcmNegotiations: WcmNegotiationsOutput;
  /** This query is used to get the wcm payment terms */
  getWcmPaymentTerms: WcmPaymentTermsOutput;
  /** This query is used to get the payment terms benchmark by supplier dimension */
  getWcmPaymentTermsBenchmark: Array<WcmPaymentTermsBenchmarkOutput>;
  /** This query is used to get the buyer's payment terms details */
  getWcmPaymentTermsLandscape: Array<WcmPaymentTermsLandscapeOutput>;
  /** Get all waves for a WCM plan */
  getWcmPlanWaves: Array<WcmPlanWaveOutput>;
  /** Get all WCM plans for a buyer */
  getWcmPlans: Array<WcmPlanOutput>;
  /** Get all WCM plans for a supplier group */
  getWcmPlansForSupplierGroup: Array<Scalars['String']['output']>;
  /** This query is used to get the details of the supplier profiles of same group of a supplier */
  getWcmSameSupplierGroupEntitiesData: WcmSupplierGroupEntitiesDataOutput;
  /** This query is used to search company financials by name or ticker symbol */
  getWcmSearchCompanyFinancials: Array<WcmSearchCompanyFinancialsOutput>;
  /** This query is used to get NAICS search results */
  getWcmSearchNaics: Array<WcmSearchNaicsOutput>;
  /** This query is used to get Wcm Segment Conversion Rate Config */
  getWcmSegmentConversionRate: WcmSegmentConversionRateConfigOutput;
  /** This query is used to get the buyer's spend analysis details */
  getWcmSpendAnalysisStats: WcmSpendAnalysisStatsOutput;
  /** This query is used to get the buyer's spend distribution details */
  getWcmSpendDistribution: Array<WcmSpendDistributionOutput>;
  /** This query is used to fetch spend filters */
  getWcmSpendDynamicFilters: WcmSpendDynamicFiltersOutput;
  /** Returns a signed S3 URL for the WCM spend file template download */
  getWcmSpendFileTemplateUrl: WcmSpendFileTemplateUrl;
  /** This query is used to get the buyer's spend geo overview */
  getWcmSpendGeoOverview: Array<WcmSpendGeoOverviewOutput>;
  /** This query is used to get the wcm spend stats */
  getWcmStats: WcmStatsOutput;
  /** Fetch every note for a supplier group, sorted newest-first. Only the first item (most recent note) is editable by the user. */
  getWcmSupplierGroupNotes: WcmSupplierGroupNotesOutput;
  /** Get WCM supplier health metrics for a specific supplier */
  getWcmSupplierHealthMetrics?: Maybe<WcmSupplierHealthMetricsOutput>;
  /** This query is used to get the details of the supplier profile */
  getWcmSupplierProfileData: WcmSupplierProfileDataOutput;
  /** This query is used to get Wcm supplier segment Config */
  getWcmSupplierSegmentConfig: FetchWcmSupplierSegmentConfigOutput;
  /** This query is used to get the buyer's suppliers spend overview */
  getWcmSupplierSpendOverview: Array<WcmSupplierSpendOverviewOutput>;
  /** Query to get benchmark strategy for suppliers by segment */
  getWcmSuppliersBenchmarkStrategyBySegment: WcmBenchmarkStrategyBySegmentOutput;
  /** Get negotiation tracking grouped by aggregator dimension (stacked bar chart) */
  getWcmTrackingByAggregator: Array<WcmTrackingByAggregatorGroup>;
  /** Get file upload status for all linked TRIAL WCM buyers of the current user */
  getWcmTrialBuyersFileStatus: Array<WcmBuyerFileStatus>;
  /** This query is used to get the details of the supplier profile */
  getWcmUserFileLogs: Array<WcmUserFileLogs>;
  /** This query is used to get wcm user info */
  getWcmUserInfo: WcmUserInfoOutput;
  /** This query is used to get user preference settings */
  getWcmUserPreference: GetWcmUserPreferenceOutput;
  /** Get list of wcm user registration requests with pagination, filtering, and sorting */
  getWcmUserRegistrationRequests: GetWcmRegistrationRequestsResponse;
  /** This query is used to get the working capital opportunity matrix */
  getWcmWorkingCapitalOpportunityMatrix: Array<WcmWorkingCapitalOpportunityMatrixOutput>;
  groupedOpportunityData: GroupedOpportunityDataConnection;
  groupedOpportunityDataAggregate: Array<GroupedOpportunityDataAggregateResponse>;
  /** Gets login history for a user by uuid. Default limit is 20. Default sort is descending */
  loginHistory?: Maybe<Array<Maybe<LoginHistory>>>;
  lookupConfigValues: Array<LookupConfigValues>;
  lookupMaster: LookupMaster;
  lookupMasters: LookupMasterConnection;
  makerMarketClear: MakerMarketClear;
  makerMarketClearAggregate: Array<MakerMarketClearAggregateResponse>;
  makerMarketClears: MakerMarketClearConnection;
  makersTakersOrganizations: MakersTakersOrganizationsConnection;
  marketStats: Array<MarketStatsData>;
  /** Gets the current logged in user, only queryable from user and admin tokens */
  me?: Maybe<User>;
  newCustomerRequests: Array<GetOutOfNetworkNewCustomerRequestResponse>;
  omnichannelCommunicationDto: OmnichannelCommunicationDto;
  omnichannelCommunicationDtos: OmnichannelCommunicationDtoConnection;
  orgStats: Array<OrgStatsData>;
  /** API to query all program level configurations for a funder buyer. */
  paymentConfigurationalData: FunderBuyerProgramFileSetOutput;
  program: Program;
  programFileset: ProgramFileset;
  programFilesets: Array<ProgramFileset>;
  programs: ProgramConnection;
  qualifiedSupplier: QualifiedSupplier;
  qualifiedSuppliers: QualifiedSupplierConnection;
  recipe: Recipe;
  recipes: Array<Recipe>;
  recordGroup: RecordGroup;
  recordGroupColumnDto: RecordGroupColumnDto;
  recordGroupColumnDtos: Array<RecordGroupColumnDto>;
  recordGroups: RecordGroupConnection;
  referenceRateInputDtoAggregate: Array<ReferenceRateInputDtoAggregateResponse>;
  referenceRateInputDtos: ReferenceRateInputDtoConnection;
  requestsByTakerMarket: RequestsByTakerMarketResponseDto;
  requestsByTakerMarketInputDtos: RequestsByTakerMarketInputDtoConnection;
  retrieveJourneyParams: JourneyParamResponse;
  retrieveProfile?: Maybe<Profile>;
  /** Query to search users by name, email or uuid for wcm admin */
  searchWcmUsers: SearchWcmUsersOutput;
  /** Return an SRM by email address */
  srm?: Maybe<Srm>;
  successStories: ContentfulOutput;
  supplierCustomerAggregate: Array<SupplierCustomerAggregateResponse>;
  supplierCustomers: SupplierCustomerConnection;
  /** Provides customer and opportunity information for the customer select screen in the offer builder */
  supplierCustomersForCustomerSelect: SupplierCustomerSelectScreenResponseConnection;
  supplierFilterDto: SupplierFilterDto;
  supplierFilterDtos: SupplierFilterDtoConnection;
  takerConfiguration: TakerConfiguration;
  takerConfigurationHistories: TakerConfigurationHistoryConnection;
  takerConfigurationHistory: TakerConfigurationHistory;
  takerConfigurations: TakerConfigurationConnection;
  takerMarketClear: TakerMarketClear;
  takerMarketClearAggregate: Array<TakerMarketClearAggregateResponse>;
  takerMarketClears: TakerMarketClearConnection;
  takersMarkets: TakersMarketsConnection;
  takersMarketsAggregate: Array<TakersMarketsAggregateResponse>;
  transaction: Transaction;
  transactionAggregate: Array<TransactionAggregateResponse>;
  transactions: TransactionConnection;
  trendingCustomerRequests: Array<OutOfNetworkCustomer>;
  /** Query to trigger manual award. */
  triggerBuyerAppManualAward: BuyerAppTriggerManualAwardOutput;
  uniqueCustomers: Array<UniqueCustomer>;
  user?: Maybe<User>;
  userByEmailAddress?: Maybe<User>;
  userLookupInSf: UserLookupInSfResponse;
  /** Search for users by name, email address, and uuid - returns a max of 100 users per datacenter. */
  userSearch?: Maybe<UsersResponse>;
  userTreatment: UserTreatment;
  /** A list of users driven from Auth Service Info. Will return null when a user is not found. */
  users?: Maybe<UsersResponse>;
  /** A list of users driven from Auth Service Info. Will return null when a user is not found. */
  usersByEmailAddress?: Maybe<UsersResponse>;
  validateUserExistanceInApp: ValidateUserExistanceInAppResponse;
};


export type QueryAccountArgs = {
  id: Scalars['String']['input'];
};


export type QueryActionableOfferScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryActionableOfferScheduleHistoriesArgs = {
  filter?: ActionableOfferScheduleHistoryFilter;
  paging?: CursorPaging;
  sorting?: Array<ActionableOfferScheduleHistorySort>;
};


export type QueryActionableOfferScheduleTagsArgs = {
  filter?: ActionableOfferScheduleTagsFilter;
  paging?: CursorPaging;
  sorting?: Array<ActionableOfferScheduleTagsSort>;
};


export type QueryActionableOfferSchedulesArgs = {
  filter?: ActionableOfferScheduleFilter;
  paging?: CursorPaging;
  sorting?: Array<ActionableOfferScheduleSort>;
};


export type QueryAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementAuditArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAgreementAuditsArgs = {
  filter?: AgreementAuditFilter;
  paging?: CursorPaging;
  sorting?: Array<AgreementAuditSort>;
};


export type QueryAgreementsArgs = {
  filter?: AgreementFilter;
  paging?: CursorPaging;
  sorting?: Array<AgreementSort>;
};


export type QueryAllTakersMarketsArgs = {
  filter?: TakersMarketsNoPageFilter;
  sorting?: Array<TakersMarketsNoPageSort>;
};


export type QueryBuyerArgs = {
  gatewayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuyerAppDivisionsUsersRolesArgs = {
  filter: BuyerAppDivisionsUsersRolesFilter;
};


export type QueryBuyerAppDualAuthEnabledArgs = {
  input: BuyerAppDualAuthorizationRolesEnabledInput;
};


export type QueryBuyerAppRolesArgs = {
  filter?: BuyerAppRoleFilter;
  paging?: CursorPaging;
  sorting?: Array<BuyerAppRoleSort>;
};


export type QueryBuyerAuditConfigDataArgs = {
  makerUuid: Scalars['String']['input'];
};


export type QueryBuyersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayFind?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayUsercast?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryC2foColumnMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryC2foColumnMastersArgs = {
  filter?: C2foColumnMasterFilter;
  paging?: OffsetPaging;
  sorting?: Array<C2foColumnMasterSort>;
};


export type QueryCashFlowPlusStatsArgs = {
  input: CashflowPlusStatsInputBodyDto;
};


export type QueryCashInvestedArgs = {
  CashInvestedInput: CashInvestedInput;
};


export type QueryCashflowInfoArgs = {
  cashflowInfoInput: CashflowInfoInput;
};


export type QueryCashflowPlusStatsOpportunityInputDtoAggregateArgs = {
  filter?: InputMaybe<CashflowPlusStatsOpportunityInputDtoAggregateFilter>;
};


export type QueryCheckCronStatusArgs = {
  scheduleUuid: Scalars['String']['input'];
};


export type QueryCommunicationChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunicationChannelsArgs = {
  filter?: CommunicationChannelFilter;
  paging?: OffsetPaging;
  sorting?: Array<CommunicationChannelSort>;
};


export type QueryCommunicationPreferenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCommunicationPreferencesArgs = {
  filter?: CommunicationPreferenceFilter;
  sorting?: Array<CommunicationPreferenceSort>;
};


export type QueryCompanyGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyGroupsArgs = {
  filter: CompanyGroupFilter;
  sorting?: Array<CompanyGroupSort>;
};


export type QueryCustomAgreementVersionHistoryArgs = {
  agreementUuid: Scalars['String']['input'];
};


export type QueryCustomAgreementWithContentArgs = {
  agreementUuid: Scalars['String']['input'];
  agreementVersionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomAgreementsArgs = {
  agreementNames?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<AgreementStatusEnum>;
};


export type QueryCustomGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomGroupAggregateArgs = {
  filter?: InputMaybe<CustomGroupAggregateFilter>;
};


export type QueryCustomGroupItemsArgs = {
  filter?: CustomGroupItemFilter;
  paging?: CursorPaging;
  sorting?: Array<CustomGroupItemSort>;
};


export type QueryCustomGroupsArgs = {
  filter?: CustomGroupFilter;
  paging?: CursorPaging;
  sorting?: Array<CustomGroupSort>;
};


export type QueryCustomerProfileArgs = {
  authServiceUuid: Scalars['String']['input'];
};


export type QueryDivisionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDivisionsArgs = {
  filter?: DivisionFilter;
  paging?: CursorPaging;
  sorting?: Array<DivisionSort>;
};


export type QueryDraftRequestsArgs = {
  filter?: DraftRequestFilter;
  paging?: CursorPaging;
  sorting?: Array<DraftRequestSort>;
};


export type QueryEarlyPayDivisionArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryEarlyPayDivisionByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEarlyPayDivisionsArgs = {
  filter?: EarlyPayDivisionDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayDivisionSort>;
};


export type QueryEarlyPayDraftOfferByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEarlyPayMarketArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryEarlyPayMarketByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEarlyPayMarketsArgs = {
  filter?: EarlyPayMarketDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayMarketSort>;
};


export type QueryEarlyPayOpportunitiesArgs = {
  filter?: EarlyPayOpportunityFilter;
  paging?: CursorPaging;
  sorting?: Array<EarlyPayOpportunitySort>;
};


export type QueryEarlyPayOpportunityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEarlyPayOpportunityAggregateArgs = {
  filter?: InputMaybe<EarlyPayOpportunityAggregateFilter>;
};


export type QueryEarlyPayOrganizationArgs = {
  nodeId: Scalars['ID']['input'];
};


export type QueryEarlyPayOrganizationByUuidArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryEarlyPayOrganizationsArgs = {
  filter?: EarlyPayOrganizationDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayOrganizationSort>;
};


export type QueryEarlyPayRequestsArgs = {
  filter?: EarlyPayRequestFilter;
  paging?: CursorPaging;
  sorting?: Array<EarlyPayRequestSort>;
};


export type QueryEarlyPaySupplierClearsArgs = {
  authServiceUuid?: InputMaybe<Scalars['String']['input']>;
  filter?: EarlyPaySupplierClearDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPaySupplierClearSort>;
};


export type QueryEarlyPaySupplierStatsArgs = {
  authServiceUuid?: InputMaybe<Scalars['String']['input']>;
  filter?: EarlyPaySupplierStatsDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  serviceScope?: InputMaybe<Array<Scalars['String']['input']>>;
  sorting?: Array<EarlyPaySupplierStatsSort>;
};


export type QueryEarlyPayUserSupplierClearsArgs = {
  filter?: EarlyPaySupplierClearDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPaySupplierClearSort>;
};


export type QueryEarlyPayUserSupplierStatsArgs = {
  filter?: EarlyPaySupplierStatsDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPaySupplierStatsSort>;
};


export type QueryEstimatedAprInputDtoAggregateArgs = {
  filter?: InputMaybe<EstimatedAprInputDtoAggregateFilter>;
};


export type QueryFetchCompanyGroupsArgs = {
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};


export type QueryFetchCompanyGroupsIntersectionArgs = {
  FetchCompanyGroupsIntersectionInput: FetchCompanyGroupsIntersectionInput;
};


export type QueryFetchSuppliersForCompanyGroupArgs = {
  companyGroupUuid: Scalars['String']['input'];
  isDsf: Scalars['Boolean']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging: SupplierPaging;
};


export type QueryFetchUniqueCurrenciesForCgIntersectionArgs = {
  FetchUniqueCurrenciesForCGIntersectionInput: FetchUniqueCurrenciesLocationsForCgIntersectionInput;
};


export type QueryFetchUniqueLocationsForCgIntersectionArgs = {
  FetchUniqueCurrenciesForCGIntersectionInput: FetchUniqueCurrenciesLocationsForCgIntersectionInput;
};


export type QueryFunderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderBuyerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderBuyersArgs = {
  filter?: FunderBuyerFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderBuyerSort>;
};


export type QueryFunderCalculationsArgs = {
  filter?: FunderCalculationsFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderCalculationsSort>;
};


export type QueryFunderCurrenciesArgs = {
  filter?: FunderCurrenciesFilter;
  sorting?: Array<FunderCurrenciesSort>;
};


export type QueryFunderDeliverySettingsDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderDeliverySettingsDtosArgs = {
  filter?: FunderDeliverySettingsDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderDeliverySettingsDtoSort>;
};


export type QueryFunderFeedbackConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFeedbackConfigsArgs = {
  filter?: FunderFeedbackConfigFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFeedbackConfigSort>;
};


export type QueryFunderFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileColumnMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileColumnMastersArgs = {
  filter?: FunderFileColumnMasterFilter;
  paging?: OffsetPaging;
  sorting?: Array<FunderFileColumnMasterSort>;
};


export type QueryFunderFileDeliveryDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderFileDeliveryDtosArgs = {
  filter?: FunderFileDeliveryDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFileDeliveryDtoSort>;
};


export type QueryFunderFilesArgs = {
  filter?: FunderFileFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderFileSort>;
};


export type QueryFunderGeographiesArgs = {
  filter?: FunderGeographiesFilter;
  sorting?: Array<FunderGeographiesSort>;
};


export type QueryFunderLegalAgreementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderLegalAgreementsArgs = {
  filter?: FunderLegalAgreementFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderLegalAgreementSort>;
};


export type QueryFunderNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderNotificationsArgs = {
  filter?: FunderNotificationFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderNotificationSort>;
};


export type QueryFunderSummaryArgs = {
  id: Scalars['String']['input'];
};


export type QueryFunderVariableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFunderVariablesArgs = {
  filter?: FunderVariableFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderVariableSort>;
};


export type QueryFundersArgs = {
  filter?: FunderFilter;
  paging?: CursorPaging;
  sorting?: Array<FunderSort>;
};


export type QueryGetAggregateHistoryInfoArgs = {
  HistoryInfoInput: HistoryInfoInput;
};


export type QueryGetAggregatedMarketStatsArgs = {
  data: AggregatedMarketsStatsInput;
};


export type QueryGetAggregatedSuppliersHistoryInfoArgs = {
  SupplierHistoryInfoInput: SupplierHistoryInfoInput;
};


export type QueryGetBenchmarkReferenceRateArgs = {
  filter: ReferenceRateInputDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<ReferenceRateInputDtoSort>;
};


export type QueryGetBuyerAppAggregatedScfDisclosureArgs = {
  input: BuyerAppAggregatedScfDisclosureInput;
};


export type QueryGetBuyerAppApPerformanceReportDataArgs = {
  input: BuyerAppApPerformanceReportInput;
};


export type QueryGetBuyerAppApSummaryDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppAwardHistoryArgs = {
  input: BuyerAppMakerMarketClearHistoryInputDto;
};


export type QueryGetBuyerAppAwardedSuppliersHistoryArgs = {
  AwardedSuppliersHistoryInput: BuyerAppAwardedSuppliersHistoryInput;
};


export type QueryGetBuyerAppClearHistoryGraphArgs = {
  input: BuyerAppClearHistoryGraphInput;
};


export type QueryGetBuyerAppClearHistoryStatsArgs = {
  input: BuyerAppClearHistoryStatsInput;
};


export type QueryGetBuyerAppClearingTopOffersArgs = {
  input: BuyerAppClearingTopOffersInput;
};


export type QueryGetBuyerAppCoreMarketMetricsDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppCoreMarketMetricsDownloadDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppCreditLimitArgs = {
  input: BuyerAppCreditLimitInput;
};


export type QueryGetBuyerAppCumulativeVendorsDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppDivisionRegionsArgs = {
  filter?: BuyerAppDivisionRegionFilter;
  sorting?: Array<BuyerAppDivisionRegionSort>;
};


export type QueryGetBuyerAppDivisionReportingCurrenciesArgs = {
  input: BuyerAppDivisionReportingCurrenciesInput;
};


export type QueryGetBuyerAppDivisionRolesArgs = {
  DivisionRolesGetInput: BuyerAppGetDivisionRolesInput;
};


export type QueryGetBuyerAppDpeAnalysisDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppEverAfterEmbedUrlArgs = {
  input: GetBuyerAppEverafterEmbedUrlInput;
};


export type QueryGetBuyerAppEverafterBuyerConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBuyerAppFileHistoriesArgs = {
  filter?: BuyerAppFileHistoryFilter;
  paging?: CursorPaging;
  sorting?: Array<BuyerAppFileHistorySort>;
};


export type QueryGetBuyerAppFunderPaymentStatsArgs = {
  input: BuyerAppFunderPaymentStatsInput;
};


export type QueryGetBuyerAppLiveStatsArgs = {
  input: BuyerAppLiveHistoryStatsInput;
};


export type QueryGetBuyerAppMonthlyScfDisclosureArgs = {
  input: BuyerAppMonthlyScfDisclosureInput;
};


export type QueryGetBuyerAppNetworkGrowthDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppNonClearingTopOffersArgs = {
  input: BuyerAppNonClearingTopOffersInput;
};


export type QueryGetBuyerAppParticipationBreakdownDataArgs = {
  input: BuyerAppBuyerReportsMarketsInput;
};


export type QueryGetBuyerAppPerformanceByCurrencyDataArgs = {
  input: BuyerAppPerformanceByCurrencyDataInput;
};


export type QueryGetBuyerAppPerformanceByCurrencyStatsArgs = {
  input: BuyerAppPerformanceByCurrencyStatsInput;
};


export type QueryGetBuyerAppRecentManualFileUploadHistoryArgs = {
  input: BuyerAppManualUploadProcessorHistoryInput;
};


export type QueryGetBuyerAppRepeatVsNewIncomeArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppRepeatVsNewLoadedApDataArgs = {
  input: BuyerAppBuyerReportsMarketsInputWithCurrency;
};


export type QueryGetBuyerAppRevShareGraphArgs = {
  input: BuyerAppRevShareGraphInput;
};


export type QueryGetBuyerAppScfDisclosureTimeFrameBoundariesArgs = {
  input: BuyerAppScfDisclosureTimeframeBoundariesInput;
};


export type QueryGetBuyerAppSupplierAdjustmentsArgs = {
  input: BuyerAppSupplierAdjustmentsInput;
};


export type QueryGetBuyerAppSupplierClearHistoryArgs = {
  input: BuyerAppSupplierClearHistoryInput;
};


export type QueryGetBuyerAppSupplierDetailsArgs = {
  input: BuyerAppSupplierDetailsInput;
};


export type QueryGetBuyerAppSupplierInvoicesArgs = {
  input: BuyerAppSupplierInvoicesInput;
};


export type QueryGetBuyerAppSupplierPerformanceReportDataArgs = {
  input: BuyerAppSupplierPerformanceReportInput;
};


export type QueryGetBuyerAppSupplierSettingsArgs = {
  input: BuyerAppSupplierSettingsInput;
};


export type QueryGetBuyerAppSupplierStatsArgs = {
  input: BuyerAppSupplierStatsInput;
};


export type QueryGetBuyerAppSuppliersOffersArgs = {
  input: BuyerAppSuppliersOffersInput;
};


export type QueryGetBuyerAppUserPreferenceArgs = {
  input?: InputMaybe<GetBuyerAppUserPreferenceInput>;
};


export type QueryGetBuyerReportingCurrenciesArgs = {
  input: BuyerReportingCurrenciesInput;
};


export type QueryGetCashUsedArgs = {
  CashUsedInput: CashUsedInput;
};


export type QueryGetClearingStatsArgs = {
  ClearingStatsInput: ClearingStatsInput;
};


export type QueryGetDefaultsArgs = {
  channel?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEligibleCustomersInfoListArgs = {
  authServiceUuid: Scalars['String']['input'];
};


export type QueryGetEncryptionSettingDetailsArgs = {
  funderFileTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  funderUuid: Scalars['String']['input'];
};


export type QueryGetEstimatedAprAndRateSourcesArgs = {
  input: EstimatedAprInputBodyDto;
};


export type QueryGetFileDeliverySettingsArgs = {
  fileType?: InputMaybe<Scalars['String']['input']>;
  funderFileTemplateUuid?: InputMaybe<Scalars['String']['input']>;
  programUuid: Scalars['String']['input'];
  subType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFunderDistinctWriterTypesArgs = {
  funderUuid: Scalars['String']['input'];
};


export type QueryGetIncomeOverTimeArgs = {
  data: GetIncomeOverTime;
};


export type QueryGetInvoiceStatsForMarketArgs = {
  filter: InvoiceStatsFilterForMarket;
};


export type QueryGetLiveMarketStatsArgs = {
  LiveMarketStatsInput: LiveMarketStatsInput;
};


export type QueryGetManyBuyerAppBuyerSupplierCountsArgs = {
  filter?: BuyerAppBuyerSupplierCountsFilter;
  sorting?: Array<BuyerAppBuyerSupplierCountsSort>;
};


export type QueryGetManyBuyerAppSubprocessorsSubscriptionDetailsArgs = {
  filter?: BuyerAppSubprocessorsSubscriptionFilter;
  sorting?: Array<BuyerAppSubprocessorsSubscriptionSort>;
};


export type QueryGetManyWcmMasterBuyersDetailsArgs = {
  filter?: WcmMasterBuyerListFilter;
  sorting?: Array<WcmMasterBuyerListSort>;
};


export type QueryGetManyWcmMasterCountryRegionDetailsArgs = {
  filter?: WcmMasterRegionCountryListFilter;
  sorting?: Array<WcmMasterRegionCountryListSort>;
};


export type QueryGetManyWcmUserBuyerMappingDetailsArgs = {
  filter?: WcmUserBuyerMappingDetailsFilter;
  sorting?: Array<WcmUserBuyerMappingDetailsSort>;
};


export type QueryGetManyWcmUserInformationArgs = {
  filter?: WcmUserInformationFilter;
  sorting?: Array<WcmUserInformationSort>;
};


export type QueryGetMarketSettingsArgs = {
  input: MarketSettingsInput;
};


export type QueryGetPreferredOfferConfigArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryGetPreferredOfferConfigsArgs = {
  accountIds: Array<Scalars['String']['input']>;
};


export type QueryGetProfileImageArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryGetProgramFileConfigsArgs = {
  buyerUuid: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funderName: Scalars['String']['input'];
};


export type QueryGetProgramFileSetConfigurationsV1Args = {
  funderUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};


export type QueryGetProgramUniqueCurrenciesArgs = {
  programUuid: Scalars['String']['input'];
};


export type QueryGetProgramUniqueLocationsArgs = {
  programUuid: Scalars['String']['input'];
};


export type QueryGetQualifiedSuppliersForProgramArgs = {
  SupplierDetailsInput: SupplierDetailsInput;
};


export type QueryGetSalesForceSavedViewsArgs = {
  ownerId: Scalars['String']['input'];
};


export type QueryGetSalesforceDetailsForUserArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryGetSegmentsForUserArgs = {
  authServiceUuid: Scalars['String']['input'];
};


export type QueryGetSupplierMembershipArgs = {
  accountId: Scalars['String']['input'];
};


export type QueryGetSupplierStatsArgs = {
  SupplierStatsInput: SupplierStatsInput;
};


export type QueryGetTakersMarketsStatsForMarketArgs = {
  marketUuid: Scalars['String']['input'];
};


export type QueryGetWcmAdherenceDynamicInvoiceFiltersArgs = {
  input: WcmAdherenceDynamicInvoiceFiltersInput;
};


export type QueryGetWcmAdherenceKpiByAggregatorArgs = {
  input: WcmAdherenceKpiByAggregatorInput;
};


export type QueryGetWcmAdherenceKpiByPeriodArgs = {
  input: WcmAdherenceKpiByPeriodInput;
};


export type QueryGetWcmAdherenceKpisArgs = {
  input: WcmAdherenceKpisInput;
};


export type QueryGetWcmAdherenceTrendArgs = {
  input: WcmAdherenceTrendInput;
};


export type QueryGetWcmAggregatedSpendsArgs = {
  input: GetWcmAggregatedSpendsInput;
};


export type QueryGetWcmBenchmarkConfigArgs = {
  input: GetWcmBenchmarkConfigInput;
};


export type QueryGetWcmBenchmarkCountryRegulationsArgs = {
  input: GetWcmBenchmarkCountryRegulationsInput;
};


export type QueryGetWcmBuyerAllAssignableRolesForPermissionManagerArgs = {
  input: GetWcmBuyerAllAssignableRolesForPermissionManagerInput;
};


export type QueryGetWcmBuyerConfigArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmBuyerEnrichedFileUploadHistoryArgs = {
  input: WcmFetchEnrichedFileUploadHistoryInput;
};


export type QueryGetWcmBuyerExclusionRemarksArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmBuyerFileConfigsArgs = {
  input: GetWcmBuyerFileConfigsInput;
};


export type QueryGetWcmBuyerInvoiceFileUploadHistoryArgs = {
  input: WcmFetchInvoiceFileUploadHistoryInput;
};


export type QueryGetWcmBuyerMetaDataArgs = {
  input: WcmBuyerMetaDataInput;
};


export type QueryGetWcmBuyerRolesArgs = {
  input: GetWcmBuyerRolesInput;
};


export type QueryGetWcmBuyerUserAccessArgs = {
  input: WcmBuyerUserAccessInput;
};


export type QueryGetWcmBuyerUsersArgs = {
  input: GetWcmBuyerUsersInput;
};


export type QueryGetWcmBuyerUsersForAdminArgs = {
  input: GetWcmBuyerUsersInput;
};


export type QueryGetWcmBuyersUsersCountArgs = {
  input: GetWcmBuyersUsersCountInput;
};


export type QueryGetWcmCashflowDistributionArgs = {
  input: WcmCashflowDistributionInput;
};


export type QueryGetWcmCumulativeTrendArgs = {
  input: WcmMonitoringCumulativeInput;
};


export type QueryGetWcmCustomAttributesArgs = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmDomainConfigArgs = {
  domain: Scalars['String']['input'];
};


export type QueryGetWcmExclusionCriteriaArgs = {
  input: WcmExclusionCriteriaInput;
};


export type QueryGetWcmExclusionsConfigArgs = {
  input: GetWcmExclusionsConfigInput;
};


export type QueryGetWcmFetchAllSupplierArgs = {
  input: WcmFetchAllSuppliersInput;
};


export type QueryGetWcmFetchAllSupplierGroupsArgs = {
  input: WcmFetchAllSupplierGroupsInput;
};


export type QueryGetWcmGenerateWorkingCapitalArgs = {
  input: WcmGenerateWorkingCapitalInput;
};


export type QueryGetWcmGenerateWorkingCapitalGroupsArgs = {
  input: WcmGenerateWorkingCapitalInput;
};


export type QueryGetWcmGroupedWorkingCapitalOpportunityByDimensionArgs = {
  input: WcmGroupedWorkingCapitalOpportunityByDimensionFilters;
};


export type QueryGetWcmInsightsConversationsArgs = {
  input: WcmInsightsConversationsInputDto;
};


export type QueryGetWcmInsightsMessagesArgs = {
  input: WcmInsightsMessagesInputDto;
};


export type QueryGetWcmMasterBuyerDetailArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWcmMonitoringSnapshotArgs = {
  input: WcmMonitoringSnapshotInput;
};


export type QueryGetWcmMonitoringStatsArgs = {
  input: WcmMonitoringStatsInput;
};


export type QueryGetWcmNaicsExclusionsArgs = {
  input: WcmGetNaicsExclusionsInput;
};


export type QueryGetWcmNaicsSuggestionsArgs = {
  input: WcmGetNaicsSuggestionsInput;
};


export type QueryGetWcmNegotiationArgs = {
  currency: Scalars['String']['input'];
  vendorVariantId: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmNegotiationStatusPhaseMappingsArgs = {
  currency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmNegotiationsArgs = {
  currency: Scalars['String']['input'];
  input: GetWcmNegotiationsInput;
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmPaymentTermsArgs = {
  input: WcmPaymentTermsInput;
};


export type QueryGetWcmPaymentTermsBenchmarkArgs = {
  input: WcmPaymentTermsBenchmarkFilters;
};


export type QueryGetWcmPaymentTermsLandscapeArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmPlanWavesArgs = {
  planId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmPlansArgs = {
  input: GetWcmPlansInput;
};


export type QueryGetWcmPlansForSupplierGroupArgs = {
  input: GetWcmPlansForSupplierGroupInput;
};


export type QueryGetWcmSameSupplierGroupEntitiesDataArgs = {
  input: WcmSupplierGroupEntitiesDataInput;
};


export type QueryGetWcmSearchCompanyFinancialsArgs = {
  input: WcmSearchCompanyFinancialsInput;
};


export type QueryGetWcmSearchNaicsArgs = {
  input: WcmSearchNaicsInput;
};


export type QueryGetWcmSegmentConversionRateArgs = {
  input: GetWcmSegmentConversionRateInput;
};


export type QueryGetWcmSpendAnalysisStatsArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSpendDistributionArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSpendDynamicFiltersArgs = {
  input: WcmSpendDynamicFiltersInput;
};


export type QueryGetWcmSpendFileTemplateUrlArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmSpendGeoOverviewArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmStatsArgs = {
  input: WcmStatsInput;
};


export type QueryGetWcmSupplierGroupNotesArgs = {
  input: GetWcmSupplierGroupNotesInput;
};


export type QueryGetWcmSupplierHealthMetricsArgs = {
  input: GetWcmSupplierHealthMetricsInput;
};


export type QueryGetWcmSupplierProfileDataArgs = {
  input: WcmSupplierProfileDataInput;
};


export type QueryGetWcmSupplierSegmentConfigArgs = {
  input: FetchWcmSupplierSegmentConfigInput;
};


export type QueryGetWcmSupplierSpendOverviewArgs = {
  input: WcmSpendAnalysisInput;
};


export type QueryGetWcmSuppliersBenchmarkStrategyBySegmentArgs = {
  input: GetWcmSuppliersBenchmarkStrategyBySegmentInput;
};


export type QueryGetWcmTrackingByAggregatorArgs = {
  input: WcmMonitoringTrackingByAggregatorInput;
};


export type QueryGetWcmUserFileLogsArgs = {
  wcmBuyerUuid: Scalars['String']['input'];
};


export type QueryGetWcmUserPreferenceArgs = {
  input?: InputMaybe<GetWcmUserPreferenceInput>;
};


export type QueryGetWcmUserRegistrationRequestsArgs = {
  input: GetWcmRegistrationRequestsInput;
};


export type QueryGetWcmWorkingCapitalOpportunityMatrixArgs = {
  input: WcmWorkingCapitalOpportunityMatrixFilters;
};


export type QueryGroupedOpportunityDataArgs = {
  filter?: GroupedOpportunityDataFilter;
  paging?: CursorPaging;
  sorting?: Array<GroupedOpportunityDataSort>;
};


export type QueryGroupedOpportunityDataAggregateArgs = {
  filter?: InputMaybe<GroupedOpportunityDataAggregateFilter>;
};


export type QueryLoginHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
  userUuids: Array<Scalars['ID']['input']>;
};


export type QueryLookupConfigValuesArgs = {
  filter?: LookupConfigValuesFilter;
  sorting?: Array<LookupConfigValuesSort>;
};


export type QueryLookupMasterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLookupMastersArgs = {
  filter?: LookupMasterFilter;
  paging?: CursorPaging;
  sorting?: Array<LookupMasterSort>;
};


export type QueryMakerMarketClearArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMakerMarketClearAggregateArgs = {
  filter?: InputMaybe<MakerMarketClearAggregateFilter>;
};


export type QueryMakerMarketClearsArgs = {
  filter?: MakerMarketClearFilter;
  paging?: CursorPaging;
  sorting?: Array<MakerMarketClearSort>;
};


export type QueryMakersTakersOrganizationsArgs = {
  filter?: MakersTakersOrganizationsFilter;
  paging?: CursorPaging;
  sorting?: Array<MakersTakersOrganizationsSort>;
};


export type QueryMarketStatsArgs = {
  marketStatsInput: MarketStatsInput;
};


export type QueryOmnichannelCommunicationDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOmnichannelCommunicationDtosArgs = {
  filter?: OmnichannelCommunicationDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<OmnichannelCommunicationDtoSort>;
};


export type QueryOrgStatsArgs = {
  orgStatsInput: OrgStatsInput;
};


export type QueryPaymentConfigurationalDataArgs = {
  fileType: Scalars['String']['input'];
  funderUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
};


export type QueryProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramFilesetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProgramFilesetsArgs = {
  filter?: ProgramFilesetFilter;
  sorting?: Array<ProgramFilesetSort>;
};


export type QueryProgramsArgs = {
  filter?: ProgramFilter;
  paging?: CursorPaging;
  sorting?: Array<ProgramSort>;
};


export type QueryQualifiedSupplierArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQualifiedSuppliersArgs = {
  filter?: QualifiedSupplierFilter;
  paging?: CursorPaging;
  sorting?: Array<QualifiedSupplierSort>;
};


export type QueryRecipeArgs = {
  gatewayId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecipesArgs = {
  gatewayBroadcast?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayDcs?: InputMaybe<Array<Scalars['String']['input']>>;
  gatewayFind?: InputMaybe<Scalars['Boolean']['input']>;
  gatewayUsercast?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRecordGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordGroupColumnDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecordGroupColumnDtosArgs = {
  filter?: RecordGroupColumnDtoFilter;
  sorting?: Array<RecordGroupColumnDtoSort>;
};


export type QueryRecordGroupsArgs = {
  filter?: RecordGroupFilter;
  paging?: CursorPaging;
  sorting?: Array<RecordGroupSort>;
};


export type QueryReferenceRateInputDtoAggregateArgs = {
  filter?: InputMaybe<ReferenceRateInputDtoAggregateFilter>;
};


export type QueryReferenceRateInputDtosArgs = {
  filter: ReferenceRateInputDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<ReferenceRateInputDtoSort>;
};


export type QueryRequestsByTakerMarketArgs = {
  filter: RequestsByTakerMarketInputDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<RequestsByTakerMarketInputDtoSort>;
};


export type QueryRequestsByTakerMarketInputDtosArgs = {
  filter: RequestsByTakerMarketInputDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<RequestsByTakerMarketInputDtoSort>;
};


export type QueryRetrieveProfileArgs = {
  input: ProfileInput;
};


export type QuerySearchWcmUsersArgs = {
  input: SearchWcmUsersInput;
};


export type QuerySrmArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QuerySuccessStoriesArgs = {
  locale: Scalars['String']['input'];
};


export type QuerySupplierCustomerAggregateArgs = {
  filter?: InputMaybe<SupplierCustomerAggregateFilter>;
};


export type QuerySupplierCustomersArgs = {
  filter?: SupplierCustomerFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierCustomerSort>;
};


export type QuerySupplierCustomersForCustomerSelectArgs = {
  desiredCurrencyForMultipleCurrencies?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySupplierFilterDtoArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySupplierFilterDtosArgs = {
  filter?: SupplierFilterDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<SupplierFilterDtoSort>;
};


export type QueryTakerConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakerConfigurationHistoriesArgs = {
  filter?: TakerConfigurationHistoryFilter;
  paging?: CursorPaging;
  sorting?: Array<TakerConfigurationHistorySort>;
};


export type QueryTakerConfigurationHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakerConfigurationsArgs = {
  filter?: TakerConfigurationFilter;
  paging?: CursorPaging;
  sorting?: Array<TakerConfigurationSort>;
};


export type QueryTakerMarketClearArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTakerMarketClearAggregateArgs = {
  filter?: InputMaybe<TakerMarketClearAggregateFilter>;
};


export type QueryTakerMarketClearsArgs = {
  filter?: TakerMarketClearFilter;
  paging?: CursorPaging;
  sorting?: Array<TakerMarketClearSort>;
};


export type QueryTakersMarketsArgs = {
  filter?: TakersMarketsFilter;
  paging?: CursorPaging;
  sorting?: Array<TakersMarketsSort>;
};


export type QueryTakersMarketsAggregateArgs = {
  filter?: InputMaybe<TakersMarketsAggregateFilter>;
};


export type QueryTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTransactionAggregateArgs = {
  filter?: InputMaybe<TransactionAggregateFilter>;
};


export type QueryTransactionsArgs = {
  filter?: TransactionFilter;
  paging?: OffsetPaging;
  sorting?: Array<TransactionSort>;
};


export type QueryTrendingCustomerRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  minRequestsCount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTriggerBuyerAppManualAwardArgs = {
  input: BuyerAppTriggerManualAwardInput;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByEmailAddressArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryUserLookupInSfArgs = {
  emailAddress: Scalars['String']['input'];
};


export type QueryUserSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryUserTreatmentArgs = {
  authServiceUuid: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryUsersByEmailAddressArgs = {
  emailAddresses: Array<Scalars['String']['input']>;
};


export type QueryValidateUserExistanceInAppArgs = {
  authUuid?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
};

export type Report_Type =
  | 'SUPPLIER_LEVEL_REPORT';

export type Report_TypeFilterComparison = {
  eq?: InputMaybe<Report_Type>;
  gt?: InputMaybe<Report_Type>;
  gte?: InputMaybe<Report_Type>;
  iLike?: InputMaybe<Report_Type>;
  in?: InputMaybe<Array<Report_Type>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Report_Type>;
  lt?: InputMaybe<Report_Type>;
  lte?: InputMaybe<Report_Type>;
  neq?: InputMaybe<Report_Type>;
  notILike?: InputMaybe<Report_Type>;
  notIn?: InputMaybe<Array<Report_Type>>;
  notLike?: InputMaybe<Report_Type>;
};

export type Rate =
  | 'APR'
  | 'DISC'
  | 'REF';

export type RateType =
  | 'APR'
  | 'DISC'
  | 'REF';

export type Recipe = {
  __typename?: 'Recipe';
  creationDate: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingredients: Array<Scalars['String']['output']>;
  /** This is just a helper to let me know where the data came from. We probably dont want it in production */
  source: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ReconColumnDetails = {
  __typename?: 'ReconColumnDetails';
  batchReferenceColumn?: Maybe<Scalars['String']['output']>;
  companyIdColumn?: Maybe<Scalars['String']['output']>;
  invoiceIdColumn?: Maybe<Scalars['String']['output']>;
  transactionReferenceColumn?: Maybe<Scalars['String']['output']>;
  voucherIdColumn?: Maybe<Scalars['String']['output']>;
};

export type ReconColumnDetailsInput = {
  batchReferenceColumn?: InputMaybe<Scalars['String']['input']>;
  companyIdColumn?: InputMaybe<Scalars['String']['input']>;
  invoiceIdColumn?: InputMaybe<Scalars['String']['input']>;
  transactionReferenceColumn?: InputMaybe<Scalars['String']['input']>;
  voucherIdColumn?: InputMaybe<Scalars['String']['input']>;
};

export type RecordGroup = {
  __typename?: 'RecordGroup';
  funderFileTemplateId: Scalars['String']['output'];
  isBatchRecordGroup: Scalars['Boolean']['output'];
  isTransactionRecordGroup: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  rgOrder: Scalars['Float']['output'];
  uuid: Scalars['String']['output'];
};

export type RecordGroupColumnDto = {
  __typename?: 'RecordGroupColumnDto';
  columnOrder: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  fileColumn?: Maybe<FunderFileColumnMaster>;
  funderFileColumnId: Scalars['String']['output'];
  groupBy: Scalars['Boolean']['output'];
  isBatchColumn: Scalars['Boolean']['output'];
  isInvoiceColumn: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isTransactionColumn: Scalars['Boolean']['output'];
  mergeConfig?: Maybe<MergeConfigOutput>;
  recordGroup?: Maybe<RecordGroup>;
  recordGroupId: Scalars['String']['output'];
  serializerConfig?: Maybe<SerializerColumnSettingsOuput>;
  sortBy: Scalars['Boolean']['output'];
  transformationConfig?: Maybe<Scalars['JSON']['output']>;
  uuid: Scalars['String']['output'];
};

export type RecordGroupColumnDtoDeleteFilter = {
  and?: InputMaybe<Array<RecordGroupColumnDtoDeleteFilter>>;
  or?: InputMaybe<Array<RecordGroupColumnDtoDeleteFilter>>;
  recordGroupId?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupColumnDtoDeleteResponse = {
  __typename?: 'RecordGroupColumnDtoDeleteResponse';
  columnOrder?: Maybe<Scalars['Float']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  funderFileColumnId?: Maybe<Scalars['String']['output']>;
  groupBy?: Maybe<Scalars['Boolean']['output']>;
  isBatchColumn?: Maybe<Scalars['Boolean']['output']>;
  isInvoiceColumn?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  isTransactionColumn?: Maybe<Scalars['Boolean']['output']>;
  mergeConfig?: Maybe<MergeConfigOutput>;
  recordGroupId?: Maybe<Scalars['String']['output']>;
  serializerConfig?: Maybe<SerializerColumnSettingsOuput>;
  sortBy?: Maybe<Scalars['Boolean']['output']>;
  transformationConfig?: Maybe<Scalars['JSON']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type RecordGroupColumnDtoFilter = {
  and?: InputMaybe<Array<RecordGroupColumnDtoFilter>>;
  or?: InputMaybe<Array<RecordGroupColumnDtoFilter>>;
  recordGroupId?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupColumnDtoSort = {
  direction: SortDirection;
  field: RecordGroupColumnDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type RecordGroupColumnDtoSortFields =
  | 'recordGroupId'
  | 'uuid';

export type RecordGroupConnection = {
  __typename?: 'RecordGroupConnection';
  /** Array of edges. */
  edges: Array<RecordGroupEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type RecordGroupEdge = {
  __typename?: 'RecordGroupEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RecordGroup */
  node: RecordGroup;
};

export type RecordGroupFilter = {
  and?: InputMaybe<Array<RecordGroupFilter>>;
  funderFileTemplateId?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RecordGroupFilter>>;
  rgOrder?: InputMaybe<NumberFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type RecordGroupSort = {
  direction: SortDirection;
  field: RecordGroupSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type RecordGroupSortFields =
  | 'funderFileTemplateId'
  | 'rgOrder'
  | 'uuid';

/**
 * An ongoing request for early payment against invoices in an opportunity.
 * Recurring requests continue to be considered for acceptance until the supplier turns them off. New invoices will be automatically added to this request.
 * Invoices are accepted for early payment against a benchmarked reference rate e.g - LIBOR/SOFR
 */
export type RecurringBenchmarkRateRequest = {
  __typename?: 'RecurringBenchmarkRateRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type RecurringBenchmarkRateRequestEdge = {
  __typename?: 'RecurringBenchmarkRateRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RecurringBenchmarkRateRequest */
  node: RecurringBenchmarkRateRequest;
};

export type RecurringBenchmarkRateRequestInputDto = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** An opportunity UUID that this request will be placed against */
  opportunityUuid: Scalars['String']['input'];
};

/**
 * An ongoing request for early payment against invoices in one or more opportunities.
 * Recurring requests continue to be considered for acceptance until the supplier turns them off. New invoices will be automatically added to this request.
 * Invoices are accepted for early payment based on the supplier's requested rate of discount and how many days early the invoice would be paid.
 * The minimum accepted price is dynamically determined by comparing the buyer's desired returns against a blended rate across multiple supplier requests.
 */
export type RecurringPriceDiscoveryRequest = {
  __typename?: 'RecurringPriceDiscoveryRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type RecurringPriceDiscoveryRequestEdge = {
  __typename?: 'RecurringPriceDiscoveryRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RecurringPriceDiscoveryRequest */
  node: RecurringPriceDiscoveryRequest;
};

export type RecurringPriceDiscoveryRequestInput = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** Array of opportunity UUIDs that this request will be placed against */
  opportunityUuids: Array<Scalars['String']['input']>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['input'];
  /** Type of rate of this request. Either APR or DISC (Discount) */
  rateType: RateType;
};

/**
 * An ongoing request for early payment against invoices in an opportunity.
 * Recurring requests continue to be considered for acceptance until the supplier turns them off. New invoices will be automatically added to this request.
 * Invoices are accepted for early payment against a static reference rate.
 */
export type RecurringStaticRateRequest = {
  __typename?: 'RecurringStaticRateRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  stats?: Maybe<EarlyPayRequestStats>;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type RecurringStaticRateRequestEdge = {
  __typename?: 'RecurringStaticRateRequestEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RecurringStaticRateRequest */
  node: RecurringStaticRateRequest;
};

export type RecurringStaticRateRequestInputDto = {
  /** The id of the draft to submit this request against. */
  draftId?: InputMaybe<Scalars['String']['input']>;
  /** Optional list of invoice edits to execute as part of request submission. */
  invoiceOperations?: InputMaybe<Array<InvoiceEditDataDto>>;
  /** An opportunity UUID that this request will be placed against */
  opportunityUuid: Scalars['String']['input'];
};

export type ReferenceRateInputDto = {
  __typename?: 'ReferenceRateInputDto';
  /** Optional Attributes that may be set with different values than exist on the opportunity. */
  override?: Maybe<ReferenceRateOverrideDto>;
};

export type ReferenceRateInputDtoAggregateFilter = {
  and?: InputMaybe<Array<ReferenceRateInputDtoAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  opportunityUuid: ReferenceRateInputDtoOpportunityUuidFilterComparison;
  or?: InputMaybe<Array<ReferenceRateInputDtoAggregateFilter>>;
  override?: InputMaybe<ReferenceRateInputDtoOverrideFilterComparison>;
};

export type ReferenceRateInputDtoAggregateGroupBy = {
  __typename?: 'ReferenceRateInputDtoAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  opportunityUuid?: Maybe<Scalars['String']['output']>;
  override?: Maybe<ReferenceRateOverrideDto>;
};

export type ReferenceRateInputDtoAggregateResponse = {
  __typename?: 'ReferenceRateInputDtoAggregateResponse';
  count?: Maybe<ReferenceRateInputDtoCountAggregate>;
  groupBy?: Maybe<ReferenceRateInputDtoAggregateGroupBy>;
  max?: Maybe<ReferenceRateInputDtoMaxAggregate>;
  min?: Maybe<ReferenceRateInputDtoMinAggregate>;
};

export type ReferenceRateInputDtoConnection = {
  __typename?: 'ReferenceRateInputDtoConnection';
  /** Array of edges. */
  edges: Array<ReferenceRateInputDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ReferenceRateInputDtoCountAggregate = {
  __typename?: 'ReferenceRateInputDtoCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  opportunityUuid?: Maybe<Scalars['Int']['output']>;
  override?: Maybe<Scalars['Int']['output']>;
};

export type ReferenceRateInputDtoEdge = {
  __typename?: 'ReferenceRateInputDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ReferenceRateInputDto */
  node: ReferenceRateInputDto;
};

export type ReferenceRateInputDtoFilter = {
  and?: InputMaybe<Array<ReferenceRateInputDtoFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  opportunityUuid: ReferenceRateInputDtoOpportunityUuidFilterComparison;
  or?: InputMaybe<Array<ReferenceRateInputDtoFilter>>;
  override?: InputMaybe<ReferenceRateInputDtoOverrideFilterComparison>;
};

export type ReferenceRateInputDtoMaxAggregate = {
  __typename?: 'ReferenceRateInputDtoMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  opportunityUuid?: Maybe<Scalars['String']['output']>;
  override?: Maybe<ReferenceRateOverrideDto>;
};

export type ReferenceRateInputDtoMinAggregate = {
  __typename?: 'ReferenceRateInputDtoMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  opportunityUuid?: Maybe<Scalars['String']['output']>;
  override?: Maybe<ReferenceRateOverrideDto>;
};

export type ReferenceRateInputDtoOpportunityUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceRateInputDtoOverrideFilterComparison = {
  eq?: InputMaybe<ReferenceRateOverrideDtoInput>;
};

export type ReferenceRateInputDtoSort = {
  direction: SortDirection;
  field: ReferenceRateInputDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ReferenceRateInputDtoSortFields =
  | 'authServiceUuid'
  | 'opportunityUuid'
  | 'override';

export type ReferenceRateOverrideDto = {
  __typename?: 'ReferenceRateOverrideDto';
  invoiceSummary?: Maybe<ReferenceRateOverrideInvoiceSummary>;
};

export type ReferenceRateOverrideDtoInput = {
  invoiceSummary?: InputMaybe<ReferenceRateOverrideInvoiceSummaryInput>;
};

export type ReferenceRateOverrideInvoiceSummary = {
  __typename?: 'ReferenceRateOverrideInvoiceSummary';
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type ReferenceRateOverrideInvoiceSummaryInput = {
  eligibleDpeWeightedSum?: InputMaybe<Scalars['Float']['input']>;
  eligibleInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ReferenceRateResponseDto = {
  __typename?: 'ReferenceRateResponseDto';
  benchmarkRateStats?: Maybe<BenchmarkRateStats>;
  opportunityUuid: Scalars['String']['output'];
};

export type ReferenceRateStatistics = {
  __typename?: 'ReferenceRateStatistics';
  /** Amount discounted from the opportunity. May be undefined when eligible invoice amount is 0. */
  discount?: Maybe<Scalars['Float']['output']>;
  /** The result of total amount - discount. May be undefined when eligible invoice amount is 0. */
  discountedAmount?: Maybe<Scalars['Float']['output']>;
  /** Estimated rate based on reference rates. */
  estimatedRate: Scalars['Float']['output'];
  /** Name of the rate. For example, SOFR */
  rateName?: Maybe<Scalars['String']['output']>;
};

/** Statistics for opportunities with a Preferred Reference Rate */
export type ReferenceRateStats = {
  __typename?: 'ReferenceRateStats';
  /** Amount discounted from the opportunity. */
  discount: Scalars['Float']['output'];
  /** The result of total amount - discount. */
  discountedAmount: Scalars['Float']['output'];
  /** Estimated rate based on reference rates. */
  estimatedRate: Scalars['Float']['output'];
};

export type RegisterMicrositeUserResponse = {
  __typename?: 'RegisterMicrositeUserResponse';
  emailAddress: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['Float']['output'];
};

export type RegisterUserViaMicrositeInfo = {
  /** Physical address of user registering. Only contains a Country field. */
  address: UserAddress;
  /** Registering user's buyer's division UUID. This should be a value from a division associated with the buyer permalink at the buyer list (https://www.c2fo.com/data/buyer-list.json) */
  buyerDivisionUUID: Scalars['String']['input'];
  /** Name of registering user's buyer. These must match match permalink values associated with divisions in the buyer list (https://www.c2fo.com/data/buyer-list.json) */
  buyerName: Scalars['String']['input'];
  /** URL of the PNG of the registering user's buyer. We suggest matching the 'buyerLogoPngUrl' value associated with the permalink in the buyer list (https://www.c2fo.com/data/buyer-list.json). If none is provided, a C2FO logo will be used. */
  buyerPng?: InputMaybe<Scalars['String']['input']>;
  /** Company of the user registering */
  company: Scalars['String']['input'];
  /** ISO3166-2 country code of user registering. Any ISO3166-2 value will be accepted, but well-supported values are TW, CN, FR, CA, MX, PT, TR, RU, US, IN, GB, AU, IT, DE, ES, NL */
  countryISO2: Scalars['String']['input'];
  /** Internal C2FO source of the user registering */
  createdBy: Scalars['String']['input'];
  /** Name of registering user's buyer as displayed on microsite. We suggest matching the 'name' value associated with the permalink in the buyer list (https://www.c2fo.com/data/buyer-list.json) */
  displayedBuyerName: Scalars['String']['input'];
  /** Email address of user registering */
  emailAddress: Scalars['String']['input'];
  /** First name of user registering */
  firstName: Scalars['String']['input'];
  /** Last name of user registering */
  lastName: Scalars['String']['input'];
  /** Locale of user registering. Must be one of zh_tw, zh_cn, fr, es, pt_br, tr, ru, en, it, de, nl */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of user registering */
  primaryPhoneNumber: Scalars['String']['input'];
  /** Referral source of the user registering (email, etc). Must be one of LETTER, EMAIL, SOCIAL_MEDIA, ONLINE_SEARCH, DIRECT_REFERRAL, EVENT, OTHER, INFLUITIVE, NONE. */
  referralSource?: InputMaybe<Scalars['String']['input']>;
  /** The job role of the registering user. Must be from list CFO, CONTROLLER, CREDIT_MANAGER, FINANCE_DIRECTOR, TREASURER, CEO, PRESIDENT, OWNER_FOUNDER, ACCOUNTING, BOOKKEEPER, ACCOUNTS_RECEIVABLE, OFFICE_MANAGER, OTHER. Will fallback to OTHER */
  role: Scalars['String']['input'];
  /** Has the user agreed to the terms/conditions, true/false. If sending true, ensure the workflow shows the user the terms/conditions. */
  termsCondsFlag?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use the new base URLs for microsite rewrite */
  useNewMicrositeURL?: InputMaybe<Scalars['Boolean']['input']>;
  /** UTM Audience parameter for tracking */
  utmAudience?: InputMaybe<Scalars['String']['input']>;
  /** UTM Campaign parameter for tracking */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** UTM Content parameter for tracking */
  utmContent?: InputMaybe<Scalars['String']['input']>;
  /** UTM Country parameter for tracking */
  utmCountry?: InputMaybe<Scalars['String']['input']>;
  /** UTM Lang parameter for tracking */
  utmLang?: InputMaybe<Scalars['String']['input']>;
  /** UTM Lifecycle parameter for tracking */
  utmLifecycle?: InputMaybe<Scalars['String']['input']>;
  /** UTM Medium parameter for tracking */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** UTM Partner parameter for tracking */
  utmPartner?: InputMaybe<Scalars['String']['input']>;
  /** UTM Region parameter for tracking */
  utmRegion?: InputMaybe<Scalars['String']['input']>;
  /** UTM Series parameter for tracking */
  utmSeries?: InputMaybe<Scalars['String']['input']>;
  /** UTM Source parameter for tracking */
  utmSource?: InputMaybe<Scalars['String']['input']>;
  /** UTM Term parameter for tracking */
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

/** C2FO registration information for a user. Use Auth UUID to look it up. */
export type RegistrationInfo = Node & {
  __typename?: 'RegistrationInfo';
  /** C2FO database ID. BigInt. */
  c2foDbId?: Maybe<Scalars['String']['output']>;
  /** Has the users email been verified */
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID */
  id: Scalars['ID']['output'];
  /** When the user was registered. */
  registrationDate?: Maybe<Scalars['String']['output']>;
  /** What method was used for registration. */
  registrationMethod?: Maybe<Scalars['String']['output']>;
  /** C2FO User status. 0 = new, 1 = new but not completed registration, 2 = completed registration */
  status?: Maybe<Scalars['Int']['output']>;
  /** Has the user accepted terms and conditions. */
  termsCondsFlag?: Maybe<Scalars['Boolean']['output']>;
};

/** C2FO registration information for a user. Use Auth UUID to look it up. */
export type RegistrationInfoInput = {
  /** Has the users email been verified */
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  /** When the user was registered. */
  registrationDate?: InputMaybe<Scalars['String']['input']>;
  /** What method was used for registration. */
  registrationMethod?: InputMaybe<Scalars['String']['input']>;
  /** C2FO User status. 0 = new, 1 = new but not completed registration, 2 = completed registration */
  status?: InputMaybe<Scalars['Int']['input']>;
  /** Has the user accepted terms and conditions. */
  termsCondsFlag?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RegistrationStep =
  | 'ONE_CLICK_PAGE'
  | 'THANK_YOU_PAGE';

export type RegistrationUser = {
  __typename?: 'RegistrationUser';
  arDepartmentEmailAddress?: Maybe<Scalars['String']['output']>;
  authServiceUuid: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  companyWebsite?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  fiscalYearEnd?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  industry?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  nextStep?: Maybe<RegistrationStep>;
  postalCode?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  registrationMethod?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  salesforceRegistrationResponse?: Maybe<SalesforceRegistration>;
  secondaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  termsCondsFlag?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['String']['output'];
};

export type RegistrationUserInput = {
  arDepartmentEmailAddress?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fiscalYearEnd?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  termsCondsFlag: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationUserLookupOutput = {
  __typename?: 'RegistrationUserLookupOutput';
  /** Company of the user registered */
  company?: Maybe<Scalars['String']['output']>;
  /** Email address of the user registered */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** First name of user registering */
  firstName: Scalars['String']['output'];
  /** SF account ID */
  id?: Maybe<Scalars['String']['output']>;
  /** Is the user SF account converted */
  isConverted?: Maybe<Scalars['Boolean']['output']>;
  /** Is the Salesforce account marked as deleted */
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  /** Last name of user registering */
  lastName: Scalars['String']['output'];
  /** Lead Source of the user registered */
  leadSource?: Maybe<Scalars['String']['output']>;
  /** Phone number of user registering */
  primaryPhoneNumber: Scalars['String']['output'];
  /** Date the user registered */
  registrationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Role of user registering */
  role?: Maybe<Scalars['String']['output']>;
  /** UTM Medium parameter of the user registered */
  utmMedium?: Maybe<Scalars['String']['output']>;
  /** Is the user registered verified */
  verifiedUser?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveItemsFromCustomGroupInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type RemoveSuppliersInput = {
  /** All selected configuration */
  allSelected?: InputMaybe<PlanAllSelectedOptions>;
  /** List of vendor variant IDs to remove from the wave */
  vendorVariantIds: Array<Scalars['String']['input']>;
};

export type RepetitionInterval =
  | 'EVERY_FIVE'
  | 'EVERY_FOUR'
  | 'EVERY_ONE'
  | 'EVERY_THREE'
  | 'EVERY_TWO';

export type RepetitionStrategy =
  | 'DAILY'
  | 'MONTHLY'
  | 'WEEKLY';

/**
 * A composite object of a TakerMarket and a Request.
 * The TakerMarket used here is a simplified version of the TakerMarket database schema object.
 */
export type RequestByTakerMarket = {
  __typename?: 'RequestByTakerMarket';
  /** An EarlyPayRequest */
  request: TakerMarketRequest;
  /** TakerMarket associated with the Request */
  takerMarket: TakerMarketObject;
};

export type RequestErrorReason =
  | 'ACTIVATION_FAILED'
  | 'INVOICE_EDIT_FAILED'
  | 'NONE'
  | 'PAUSE_FAILED'
  | 'RATE_EDIT_FAILED'
  | 'UNKNOWN'
  | 'WITHDRAW_FAILED';

export type RequestOptions =
  | 'ExpressAcceptPriceDiscovery'
  | 'OneTimeBenchmarkRate'
  | 'OneTimeCashFlowPlus'
  | 'OneTimePriceDiscovery'
  | 'OneTimeStaticRate'
  | 'PreferredTerm'
  | 'RecurringBenchmarkRate'
  | 'RecurringPriceDiscovery'
  | 'RecurringStaticRate';

export type RequestStatus =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'ERROR'
  | 'INACTIVE'
  | 'INVOICE_EDIT_IN_PROGRESS'
  | 'PAUSED'
  | 'SUBMITTED'
  | 'UNDER_REVIEW';

export type RequestTakersMarketsForPricingServiceInvoiceEdits = {
  __typename?: 'RequestTakersMarketsForPricingServiceInvoiceEdits';
  convertedCurrency?: Maybe<Scalars['String']['output']>;
  convertedEligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  dpe?: Maybe<Scalars['Float']['output']>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  marketUuid: Scalars['String']['output'];
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid: Scalars['String']['output'];
};

export type RequestTakersMarketsForPricingServiceInvoiceEditsInput = {
  convertedCurrency?: InputMaybe<Scalars['String']['input']>;
  convertedEligibleInvoiceAmount?: InputMaybe<Scalars['Float']['input']>;
  dpe?: InputMaybe<Scalars['Float']['input']>;
  marketId?: InputMaybe<Scalars['Float']['input']>;
  marketIsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  marketUuid: Scalars['String']['input'];
  takerId?: InputMaybe<Scalars['Float']['input']>;
  takerUuid: Scalars['String']['input'];
};

export type RequestType =
  | 'EXPRESS_ACCEPT_PRICE_DISCOVERY'
  | 'ONE_TIME_BENCHMARK_RATE'
  | 'ONE_TIME_CASH_FLOW_PLUS'
  | 'ONE_TIME_PRICE_DISCOVERY'
  | 'ONE_TIME_STATIC_RATE'
  | 'PREFERRED_TERM'
  | 'RECURRING_BENCHMARK_RATE'
  | 'RECURRING_PRICE_DISCOVERY'
  | 'RECURRING_STATIC_RATE';

export type RequestTypeFilterComparison = {
  eq?: InputMaybe<RequestType>;
  gt?: InputMaybe<RequestType>;
  gte?: InputMaybe<RequestType>;
  iLike?: InputMaybe<RequestType>;
  in?: InputMaybe<Array<RequestType>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<RequestType>;
  lt?: InputMaybe<RequestType>;
  lte?: InputMaybe<RequestType>;
  neq?: InputMaybe<RequestType>;
  notILike?: InputMaybe<RequestType>;
  notIn?: InputMaybe<Array<RequestType>>;
  notLike?: InputMaybe<RequestType>;
};

export type RequestsByTakerMarketInputDto = {
  __typename?: 'RequestsByTakerMarketInputDto';
  /** The statuses to query by. */
  status?: Maybe<RequestStatus>;
  /** The taker markets to retrieve requests for. */
  takerMarkets: TakerMarketObject;
};

export type RequestsByTakerMarketInputDtoConnection = {
  __typename?: 'RequestsByTakerMarketInputDtoConnection';
  /** Array of edges. */
  edges: Array<RequestsByTakerMarketInputDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RequestsByTakerMarketInputDtoEdge = {
  __typename?: 'RequestsByTakerMarketInputDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the RequestsByTakerMarketInputDto */
  node: RequestsByTakerMarketInputDto;
};

export type RequestsByTakerMarketInputDtoFilter = {
  and?: InputMaybe<Array<RequestsByTakerMarketInputDtoFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<RequestsByTakerMarketInputDtoFilter>>;
  status?: InputMaybe<RequestsByTakerMarketInputDtoStatusFilterComparison>;
  takerMarkets: RequestsByTakerMarketInputDtoFilterTakerMarketObjectFilter;
};

export type RequestsByTakerMarketInputDtoFilterTakerMarketObjectFilter = {
  and?: InputMaybe<Array<RequestsByTakerMarketInputDtoFilterTakerMarketObjectFilter>>;
  marketUuid?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<RequestsByTakerMarketInputDtoFilterTakerMarketObjectFilter>>;
  takerUuid?: InputMaybe<IdFilterComparison>;
};

export type RequestsByTakerMarketInputDtoSort = {
  direction: SortDirection;
  field: RequestsByTakerMarketInputDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type RequestsByTakerMarketInputDtoSortFields =
  | 'authServiceUuid'
  | 'status'
  | 'takerMarkets';

export type RequestsByTakerMarketInputDtoStatusFilterComparison = {
  eq?: InputMaybe<RequestStatus>;
  in?: InputMaybe<Array<RequestStatus>>;
  neq?: InputMaybe<RequestStatus>;
  notIn?: InputMaybe<Array<RequestStatus>>;
};

export type RequestsByTakerMarketResponseDto = {
  __typename?: 'RequestsByTakerMarketResponseDto';
  requestByTakerMarket?: Maybe<Array<RequestByTakerMarket>>;
};

export type ReserveSettingsOutput = {
  __typename?: 'ReserveSettingsOutput';
  /** Priority of Invoice */
  invoicePriority?: Maybe<Scalars['String']['output']>;
  /** Percentage of Reserved amount */
  reservePercentage?: Maybe<Scalars['Float']['output']>;
  /** Reserve ID */
  reserveSettingsId?: Maybe<Scalars['ID']['output']>;
  /** Reserve to be run before adjustment */
  runBeforeAdjustments?: Maybe<Scalars['Boolean']['output']>;
};

export type ReserveSettingsUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | ReserveSettingsOutput;

export type RestrictionSettingsOutput = {
  __typename?: 'RestrictionSettingsOutput';
  /** Max Days Paid Early */
  maxDPE?: Maybe<Scalars['Float']['output']>;
  /** Max Due Date of Invoice */
  maxDueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type RestrictionUnionBuyerAppDualAuthorization = BuyerAppDualAuthorization | RestrictionSettingsOutput;

export type RetrieveProfile = {
  __typename?: 'RetrieveProfile';
  traits: CustomerTraitsResponse;
};

/** The Role for a user. Similar to title but a specific category we give them. */
export type Role =
  | 'ACCOUNTING'
  | 'ACCOUNTS_RECEIVABLE'
  | 'BOOKKEEPER'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'CREDIT_MANAGER'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  /** Deprecated: use OFFICE_MANAGER OR OTHER. Kept around in case anyone has already used this. */
  | 'OFFICE_MANAGER_AND_OTHER'
  | 'OTHER'
  | 'OWNER_FOUNDER'
  | 'PRESIDENT'
  | 'TREASURER';

export type Service_Provider =
  | 'AWS'
  | 'GCP';

export type SmsRequestInput = {
  content: Scalars['JSON']['input'];
  templateId: Scalars['String']['input'];
  title: Scalars['String']['input'];
  toPhoneNumber: Scalars['String']['input'];
};

export type Suppliers_Offers_Advanced_Filter =
  | 'ALL_SUPPLIERS'
  | 'CLEARING_DPE_GTE_10_LT_20'
  | 'CLEARING_DPE_GTE_20_LT_30'
  | 'CLEARING_DPE_GTE_30'
  | 'CLEARING_DPE_LT_10'
  | 'CLEARING_YIELD_GTE_3PCT_LT_6PCT'
  | 'CLEARING_YIELD_GTE_6PCT_LT_9PCT'
  | 'CLEARING_YIELD_GTE_9PCT'
  | 'CLEARING_YIELD_LT_3PCT'
  | 'ELIGIBLE_AP_GTE_400K_LT_800K'
  | 'ELIGIBLE_AP_GTE_800K_LT_1200K'
  | 'ELIGIBLE_AP_GTE_1200K'
  | 'ELIGIBLE_AP_LT_400K'
  | 'HAS_CLEARING_AP'
  | 'HAS_NON_CLEARING_AP'
  | 'HAS_NOT_PLACED_OFFER'
  | 'HAS_PLACED_OFFER'
  | 'NON_CLEARING_DPE_GTE_10_LT_20'
  | 'NON_CLEARING_DPE_GTE_20_LT_30'
  | 'NON_CLEARING_DPE_GTE_30'
  | 'NON_CLEARING_DPE_LT_10'
  | 'NON_CLEARING_YIELD_GTE_3PCT_LT_6PCT'
  | 'NON_CLEARING_YIELD_GTE_6PCT_LT_9PCT'
  | 'NON_CLEARING_YIELD_GTE_9PCT'
  | 'NON_CLEARING_YIELD_LT_3PCT'
  | 'NON_REGISTERED_SUPPLIERS'
  | 'REGISTERED_SUPPLIERS'
  | 'WITHOUT_ELIGIBLE_AP'
  | 'WITH_ELIGIBLE_AP';

export type Suppliers_Offers_Order_Level =
  | 'CLEARING_AP'
  | 'CLEARING_DPE'
  | 'CLEARING_INCOME'
  | 'CLEARING_YIELD'
  | 'ELIGIBLE_AP'
  | 'NON_CLEARING_AP'
  | 'NON_CLEARING_DPE'
  | 'NON_CLEARING_INCOME'
  | 'NON_CLEARING_YIELD';

export type Supplier_Adjustments_Order_Level =
  | 'ADJ_INVOICE_ID'
  | 'AMOUNT'
  | 'DUE_DATE'
  | 'VOUCHER_ID';

export type Supplier_Invoices_Order_Level =
  | 'AMOUNT'
  | 'BLENDED_RETURN_AMOUNT'
  | 'DUE_DATE'
  | 'EARN'
  | 'MIN_DISCOUNT'
  | 'VOUCHER_ID';

export type Supplier_Operation_Type =
  | 'EXCLUDE'
  | 'INCLUDE';

export type SalesforceDetails = {
  __typename?: 'SalesforceDetails';
  salesforceId: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type SalesforceRegistration = {
  __typename?: 'SalesforceRegistration';
  isBuyerProvided?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SalesforceSavedViewResponse = {
  __typename?: 'SalesforceSavedViewResponse';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ScheduleMarkAsDelete = {
  __typename?: 'ScheduleMarkAsDelete';
  uuid: Scalars['String']['output'];
};

export type ScheduleMarkAsDeleteInput = {
  uuid: Scalars['String']['input'];
};

export type ScheduleMarkAsStop = {
  __typename?: 'ScheduleMarkAsStop';
  uuid: Scalars['String']['output'];
};

export type ScheduleMarkAsStopInput = {
  uuid: Scalars['String']['input'];
};

export type ScheduleTagsMappingEntity = {
  __typename?: 'ScheduleTagsMappingEntity';
  offerUuid: Scalars['String']['output'];
  scheduleTagId: Scalars['ID']['output'];
  tag: ActionableOfferScheduleTags;
  tagId: Scalars['Float']['output'];
};

export type ScheduleTagsMappingEntityEdge = {
  __typename?: 'ScheduleTagsMappingEntityEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the ScheduleTagsMappingEntity */
  node: ScheduleTagsMappingEntity;
};

export type ScheduleTagsMappingEntityFilter = {
  and?: InputMaybe<Array<ScheduleTagsMappingEntityFilter>>;
  or?: InputMaybe<Array<ScheduleTagsMappingEntityFilter>>;
  scheduleTagId?: InputMaybe<IdFilterComparison>;
};

export type ScheduleTagsMappingEntitySort = {
  direction: SortDirection;
  field: ScheduleTagsMappingEntitySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type ScheduleTagsMappingEntitySortFields =
  | 'scheduleTagId';

export type SearchWcmUsersInput = {
  /** Filter to return only onboarded users */
  onlyOnboarded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search query for user name, email or uuid */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type SearchWcmUsersOutput = {
  __typename?: 'SearchWcmUsersOutput';
  /** List of users found */
  users: Array<WcmPublicUser>;
};

export type SecretOverride = {
  __typename?: 'SecretOverride';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SegmentEventInput = {
  trackEventData?: InputMaybe<Scalars['JSON']['input']>;
  trackEventName?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentationRules = {
  /** Minimum spend for strategic suppliers */
  strategicMinSpend: Scalars['Float']['input'];
  /** Maximum spend for tail suppliers */
  tailMaxSpend: Scalars['Float']['input'];
};

export type SegmentsDto = {
  __typename?: 'SegmentsDto';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * SelectedCustomer repersent customer(s) that you want to filter opportunities by.
 * This repersents the customers selected by the user when they were building an offer before it was abandoned
 */
export type SelectedCustomer = {
  currency: Scalars['String']['input'];
  makerOrganizationUuid: Scalars['String']['input'];
};

export type SerializerColumnSettingsInput = {
  alignment?: InputMaybe<Scalars['String']['input']>;
  padValue?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

export type SerializerColumnSettingsOuput = {
  __typename?: 'SerializerColumnSettingsOuput';
  alignment?: Maybe<Scalars['String']['output']>;
  padValue?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type SerializerOverride = {
  __typename?: 'SerializerOverride';
  funderFileTemplateUuid: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SerializerSettingsInput = {
  fileSplitting?: InputMaybe<Scalars['Boolean']['input']>;
  maxFileRecords?: InputMaybe<Scalars['String']['input']>;
  maxFileSize?: InputMaybe<Scalars['String']['input']>;
  templateName?: InputMaybe<Scalars['String']['input']>;
  templateURI?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  useCRLF?: InputMaybe<Scalars['Boolean']['input']>;
  writeColumnHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  writeEmptyFile?: InputMaybe<Scalars['Boolean']['input']>;
  writeHeaders?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SerializerSettingsOuput = {
  __typename?: 'SerializerSettingsOuput';
  fileSplitting?: Maybe<Scalars['Boolean']['output']>;
  maxFileRecords?: Maybe<Scalars['String']['output']>;
  maxFileSize?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  templateURI?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  useCRLF?: Maybe<Scalars['Boolean']['output']>;
  writeColumnHeaders?: Maybe<Scalars['Boolean']['output']>;
  writeEmptyFile?: Maybe<Scalars['Boolean']['output']>;
  writeHeaders?: Maybe<Scalars['Boolean']['output']>;
};

export type SetBuyerAuditConfigDto = {
  auditFileCount?: InputMaybe<Scalars['Float']['input']>;
  makerUuid: Scalars['String']['input'];
  type: BuyerAuditConfigType;
};

export type SetItemsOnCustomGroupInput = {
  /** The id of the record. */
  id: Scalars['ID']['input'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']['input']>;
};

export type SetPasswordInput = {
  /** AuthUUID unique id for User */
  authServiceUuid: Scalars['String']['input'];
  /**
   * Password for User Login via Auth Service.
   * Password requirements:
   * 1. Length must be at least 12 characters long.
   */
  password: Scalars['String']['input'];
};

export type SetPasswordOutput = {
  __typename?: 'SetPasswordOutput';
  /** User's email address */
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the last time the user logged in. */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Timestamp of the last time they updated their password. */
  passwordUpdatedOnDate?: Maybe<Scalars['DateTime']['output']>;
  /** Auth Service UUID */
  uuid: Scalars['String']['output'];
};

export type SetWcmUserAccessValidityInput = {
  /** Expiry date in yyyy-mm-dd format (max 30 days from today) */
  expiryDate: Scalars['String']['input'];
  /** User UUIDs for which to set access validity, max limit 200 */
  userUuids: Array<Scalars['String']['input']>;
};

export type SetWcmUserAccessValidityOutput = {
  __typename?: 'SetWcmUserAccessValidityOutput';
  /** Number of users for which access validity was set */
  count: Scalars['Float']['output'];
  /** Message describing the result */
  message: Scalars['String']['output'];
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type Settings = {
  __typename?: 'Settings';
  allowWeekendDelivery?: Maybe<Scalars['Boolean']['output']>;
  delayInSeconds?: Maybe<Scalars['Float']['output']>;
  deliveryLocation: Scalars['String']['output'];
  deliveryLocationName?: Maybe<Scalars['String']['output']>;
  deliveryMethod: Scalars['String']['output'];
  deliveryTime?: Maybe<Scalars['String']['output']>;
  isDeliveryEnabled: Scalars['Boolean']['output'];
  loadWindowEndTime?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  useBuyerLocation: Scalars['Boolean']['output'];
};

/** Sort Directions */
export type SortDirection =
  | 'ASC'
  | 'DESC';

export type SortField =
  | 'COMPANY_GROUP'
  | 'COMPANY_ID'
  | 'CURRENCY'
  | 'LOCATION'
  | 'SUPPLIER_NAME'
  | 'UPLOAD_DATE';

/** Sort Nulls Options */
export type SortNulls =
  | 'NULLS_FIRST'
  | 'NULLS_LAST';

export type Sorting = {
  groupBy: GroupByDto;
  orderBy?: InputMaybe<Array<OrderByDto>>;
};

export type Source =
  | 'CSV'
  | 'LIST'
  | 'SEGMENT';

/** Supplier Relationship Manager (SRM) - SRM's are assigned to SalesForce Accounts. Supplier Divisions are connected to those Accounts. */
export type Srm = {
  __typename?: 'Srm';
  /** A link to the users calendar service. Could be Calendly or Microsoft Bookings. If this field is null then the SRM does not have a calendar link. */
  calendarLink?: Maybe<Scalars['String']['output']>;
  /**
   * Calendly ID - sometimes has bad data. You should rely on th calendlyLink to be clean.
   * @deprecated Calendly is not longer supported. Use calendarLink instead.
   */
  calendlyId?: Maybe<Scalars['String']['output']>;
  /**
   * DEPRECATED: Link to Calendly - if null then calendly is not enabled for the SRM.
   * @deprecated Use calendarLink instead.
   */
  calendlyLink?: Maybe<Scalars['String']['output']>;
  /** The office the SRM works out of. USA-SRM, GBR-SRM, CHN-SRM, IND-SRM, etc. */
  center?: Maybe<Scalars['String']['output']>;
  /** Email Address of the SRM */
  emailAddress: Scalars['String']['output'];
  /** Lets the client know if the SRM was null, and we provide to a fallback. */
  fallback: Scalars['Boolean']['output'];
  /** First name of the SRM */
  firstName?: Maybe<Scalars['String']['output']>;
  /**
   * If calendly is enabled or not. If this is false, then the calendly link is potentially invalid.
   * @deprecated Calendly is not longer supported. There is not replacement boolean field for this. If you want to know if a user has a calendar link then query for `calendarLink`.
   */
  isCalendlyEnabled: Scalars['Boolean']['output'];
  /** Last name of the SRM */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Phone Number of the SRM */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Salesforce specific ID of the SRM */
  salesforceId: Scalars['String']['output'];
  /** The team of the SRM. US-KS-HQ is the most common. IN-MUMBAI, UK-BRISTOL, CN-SUZHOU, etc. */
  team?: Maybe<Scalars['String']['output']>;
  /** Username for SRM - this does not always match the email address. You should use email address for displaying in app. */
  username: Scalars['String']['output'];
};

export type StaticOffer = {
  __typename?: 'StaticOffer';
  apr: Scalars['Float']['output'];
  type: Pricing;
};

export type StaticOfferInput = {
  apr: Scalars['Float']['input'];
  draftId?: InputMaybe<Scalars['String']['input']>;
  excludeNewInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  expireOn?: InputMaybe<Scalars['String']['input']>;
  frequency: Frequency;
  marketUuid: Scalars['String']['input'];
  supplierDivisionUuid: Scalars['String']['input'];
};

export type StaticPricing = {
  __typename?: 'StaticPricing';
  apr: Scalars['Float']['output'];
  nodeId: Scalars['ID']['output'];
  type: Pricing;
};

export type StaticRate = {
  __typename?: 'StaticRate';
  apr: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type Status =
  | 'FAILURE'
  | 'IN_PROGRESS'
  | 'STOPPED'
  | 'SUCCESS';

export type StringComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
};

export type StringFieldComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  iLike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  notILike?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  notLike?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeBuyerAppSubprocessorsNotificationInput = {
  /** Email Address */
  emailAddress: Scalars['String']['input'];
  /** Entity Name */
  entityName: Scalars['String']['input'];
  /** Organization Uuid */
  organizationUuid: Scalars['String']['input'];
  /** Role at Entity */
  role: Scalars['String']['input'];
};

export type SummaryDetails = {
  __typename?: 'SummaryDetails';
  funderFileType?: Maybe<FunderFileType>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * Customer is a view of a buyer from the perspective of a supplier user.
 * The customer links a supplier user to the invoices they have access to manage for a
 * particular buyer by combining taker markets data (automatically filtered by `authServiceUuid`).
 */
export type SupplierCustomer = {
  __typename?: 'SupplierCustomer';
  authServiceUuid: Scalars['String']['output'];
  /** The buyer division uuid */
  buyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  earlyPayOpportunities: Array<EarlyPayOpportunity>;
  earlyPayOpportunitiesAggregate: Array<SupplierCustomerEarlyPayOpportunitiesAggregateResponse>;
  /** Name for this customer, suitable for display to suppliers. */
  makerDisplayName: Scalars['String']['output'];
  /** URL pointing to the Buyer's logo in PNG format. */
  makerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  makerOrganizationName: Scalars['String']['output'];
  makerOrganizationUuid: Scalars['String']['output'];
  /** Unique identifier for this customer */
  uuid: Scalars['String']['output'];
};


/**
 * Customer is a view of a buyer from the perspective of a supplier user.
 * The customer links a supplier user to the invoices they have access to manage for a
 * particular buyer by combining taker markets data (automatically filtered by `authServiceUuid`).
 */
export type SupplierCustomerEarlyPayOpportunitiesArgs = {
  filter?: EarlyPayOpportunityFilter;
  sorting?: Array<EarlyPayOpportunitySort>;
};


/**
 * Customer is a view of a buyer from the perspective of a supplier user.
 * The customer links a supplier user to the invoices they have access to manage for a
 * particular buyer by combining taker markets data (automatically filtered by `authServiceUuid`).
 */
export type SupplierCustomerEarlyPayOpportunitiesAggregateArgs = {
  filter?: InputMaybe<EarlyPayOpportunityAggregateFilter>;
};

export type SupplierCustomerAggregateFilter = {
  and?: InputMaybe<Array<SupplierCustomerAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<SupplierCustomerBuyerUuidFilterComparison>;
  earlyPayOpportunities?: InputMaybe<SupplierCustomerAggregateFilterEarlyPayOpportunityAggregateFilter>;
  makerOrganizationUuid?: InputMaybe<SupplierCustomerMakerOrganizationUuidFilterComparison>;
  or?: InputMaybe<Array<SupplierCustomerAggregateFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type SupplierCustomerAggregateFilterEarlyPayOpportunityAggregateFilter = {
  and?: InputMaybe<Array<SupplierCustomerAggregateFilterEarlyPayOpportunityAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<EarlyPayOpportunityBuyerUuidFilterComparison>;
  currency?: InputMaybe<EarlyPayOpportunityCurrencyFilterComparison>;
  customerUuid?: InputMaybe<EarlyPayOpportunityCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<EarlyPayOpportunityDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  or?: InputMaybe<Array<SupplierCustomerAggregateFilterEarlyPayOpportunityAggregateFilter>>;
  type?: InputMaybe<OpportunityTypeFilterComparison>;
  uuid?: InputMaybe<EarlyPayOpportunityUuidFilterComparison>;
};

export type SupplierCustomerAggregateGroupBy = {
  __typename?: 'SupplierCustomerAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierCustomerAggregateResponse = {
  __typename?: 'SupplierCustomerAggregateResponse';
  count?: Maybe<SupplierCustomerCountAggregate>;
  groupBy?: Maybe<SupplierCustomerAggregateGroupBy>;
  max?: Maybe<SupplierCustomerMaxAggregate>;
  min?: Maybe<SupplierCustomerMinAggregate>;
};

export type SupplierCustomerBuyerUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupplierCustomerConnection = {
  __typename?: 'SupplierCustomerConnection';
  /** Array of edges. */
  edges: Array<SupplierCustomerEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SupplierCustomerCountAggregate = {
  __typename?: 'SupplierCustomerCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  buyerUuid?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type SupplierCustomerEarlyPayOpportunitiesAggregateGroupBy = {
  __typename?: 'SupplierCustomerEarlyPayOpportunitiesAggregateGroupBy';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type SupplierCustomerEarlyPayOpportunitiesAggregateResponse = {
  __typename?: 'SupplierCustomerEarlyPayOpportunitiesAggregateResponse';
  count?: Maybe<SupplierCustomerEarlyPayOpportunitiesCountAggregate>;
  groupBy?: Maybe<SupplierCustomerEarlyPayOpportunitiesAggregateGroupBy>;
  max?: Maybe<SupplierCustomerEarlyPayOpportunitiesMaxAggregate>;
  min?: Maybe<SupplierCustomerEarlyPayOpportunitiesMinAggregate>;
};

export type SupplierCustomerEarlyPayOpportunitiesCountAggregate = {
  __typename?: 'SupplierCustomerEarlyPayOpportunitiesCountAggregate';
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  buyerUuid?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  customerUuid?: Maybe<Scalars['Int']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
};

export type SupplierCustomerEarlyPayOpportunitiesMaxAggregate = {
  __typename?: 'SupplierCustomerEarlyPayOpportunitiesMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type SupplierCustomerEarlyPayOpportunitiesMinAggregate = {
  __typename?: 'SupplierCustomerEarlyPayOpportunitiesMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  desiredCurrencyForMultipleCurrencies?: Maybe<Scalars['String']['output']>;
  type?: Maybe<OpportunityType>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type SupplierCustomerEdge = {
  __typename?: 'SupplierCustomerEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SupplierCustomer */
  node: SupplierCustomer;
};

export type SupplierCustomerFilter = {
  and?: InputMaybe<Array<SupplierCustomerFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<SupplierCustomerBuyerUuidFilterComparison>;
  earlyPayOpportunities?: InputMaybe<SupplierCustomerFilterEarlyPayOpportunityFilter>;
  makerOrganizationUuid?: InputMaybe<SupplierCustomerMakerOrganizationUuidFilterComparison>;
  or?: InputMaybe<Array<SupplierCustomerFilter>>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type SupplierCustomerFilterEarlyPayOpportunityFilter = {
  and?: InputMaybe<Array<SupplierCustomerFilterEarlyPayOpportunityFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  buyerUuid?: InputMaybe<EarlyPayOpportunityBuyerUuidFilterComparison>;
  currency?: InputMaybe<EarlyPayOpportunityCurrencyFilterComparison>;
  customerUuid?: InputMaybe<EarlyPayOpportunityCustomerUuidFilterComparison>;
  desiredCurrencyForMultipleCurrencies?: InputMaybe<EarlyPayOpportunityDesiredCurrencyForMultipleCurrenciesFilterComparison>;
  or?: InputMaybe<Array<SupplierCustomerFilterEarlyPayOpportunityFilter>>;
  type?: InputMaybe<OpportunityTypeFilterComparison>;
  uuid?: InputMaybe<EarlyPayOpportunityUuidFilterComparison>;
};

export type SupplierCustomerMakerOrganizationUuidFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SupplierCustomerMaxAggregate = {
  __typename?: 'SupplierCustomerMaxAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierCustomerMinAggregate = {
  __typename?: 'SupplierCustomerMinAggregate';
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  buyerUuid?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierCustomerSelectInvoiceSummary = {
  __typename?: 'SupplierCustomerSelectInvoiceSummary';
  /** Total weighted sum of all the invoice amounts in this opportunity (original currency). Calculated by multiplying each invoice amount by the DPE and adding them. */
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  /** Total weighted sum of all the invoice amounts in this opportunity (converted currency) */
  eligibleDpeWeightedSumConverted?: Maybe<Scalars['Float']['output']>;
  /** Total weighted sum of all the invoices in this opportunity (converted currency across customers) */
  eligibleDpeWeightedSumConvertedAcrossCustomers?: Maybe<Scalars['Float']['output']>;
  /**
   * Total weighted sum of all the invoice amounts in this opportunity (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleDpeWeightedSumUsd?: Maybe<Scalars['Float']['output']>;
  /** Total eligible amount of the invoice bundle (original currency) */
  eligibleInvoiceAmount: Scalars['Float']['output'];
  /** Total eligible amount of the invoice bundle (converted currency) */
  eligibleInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** Total eligible amount of the invoice bundle (converted currency across customers) */
  eligibleInvoiceAmountConvertedAcrossCustomers?: Maybe<Scalars['Float']['output']>;
  /**
   * Total eligible amount of the invoice bundle (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  eligibleInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** Number of eligible invoices in this opportunity */
  eligibleInvoiceCount: Scalars['Float']['output'];
  /** Furthest future date a supplier would get paid if they placed a successful offer on this opportunity (Ex: '2021-06-30') */
  maxGoodFundsDate?: Maybe<Scalars['String']['output']>;
  /** The next market clear time (nearest future) across all takers_markets that make up this opportunity (Ex: '2021-06-22T16:00:00.000Z') */
  requestDeadline?: Maybe<Scalars['String']['output']>;
  /** The amount of invoices currently excluded by the supplier (original currency) */
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  /** The amount of invoices currently excluded by the supplier (converted currency) */
  takerExcludedInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** The amount of invoices currently excluded by the supplier (converted currency across customers) */
  takerExcludedInvoiceAmountConvertedAcrossCustomers?: Maybe<Scalars['Float']['output']>;
  /**
   * The amount of invoices currently excluded by the supplier (US Dollar)
   *  Null if no conversion rate to USD was found
   */
  takerExcludedInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The count of invoices currently excluded by the supplier */
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (original currency, eligible + excluded) */
  totalEarlyPayInvoiceAmount: Scalars['Float']['output'];
  /** The total amount of invoices that could participate in early pay (converted currency, eligible + excluded) */
  totalEarlyPayInvoiceAmountConverted?: Maybe<Scalars['Float']['output']>;
  /** The total amount of invoices that could participate in early pay (converted currency across customers, eligible + excluded) */
  totalEarlyPayInvoiceAmountConvertedAcrossCustomers?: Maybe<Scalars['Float']['output']>;
  /**
   * The total amount of invoices that could participate in early pay (US Dollar, eligible + excluded)
   *  Null if no conversion rate to USD was found
   */
  totalEarlyPayInvoiceAmountUsd?: Maybe<Scalars['Float']['output']>;
  /** The total count of invoices that could participate in early pay (eligible + excluded) */
  totalEarlyPayInvoiceCount: Scalars['Float']['output'];
};

export type SupplierCustomerSelectOpportunity = {
  __typename?: 'SupplierCustomerSelectOpportunity';
  /** The authServiceUuid of the User who is tied to the opportunity */
  authServiceUuid: Scalars['String']['output'];
  /** Benchmark Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  benchmarkRateStats?: Maybe<BenchmarkRateStats>;
  /** The buyer division uuid */
  buyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  /** CashFlow Plus Stats */
  cashFlowPlusStats?: Maybe<Array<CashFlowPlusStats>>;
  /** Currency of the opportunity after conversion was done. */
  convertedCurrency?: Maybe<Scalars['String']['output']>;
  /** Currency the opportunity was converted to when considering opportunities across customers */
  convertedCurrencyAcrossCustomers?: Maybe<Scalars['String']['output']>;
  /** The original currency of the opportunity before any conversion was done. */
  currency: Scalars['String']['output'];
  /** Custom group for opportunities. */
  customGroup?: Maybe<OpportunityCustomGroup>;
  /** Unique identifier for customer */
  customerUuid: Scalars['String']['output'];
  /** Exchange rate from the opportunitiy's original currency to the converted currency. */
  exchangeRateToConvertedCurrency?: Maybe<Scalars['Float']['output']>;
  /** Exchange rate used when converting this opportunity to convertedCurrencyAcrossCustomers */
  exchangeRateToConvertedCurrencyAcrossCustomers?: Maybe<Scalars['Float']['output']>;
  invoiceSummary: SupplierCustomerSelectInvoiceSummary;
  /** Indicates if this opportunity is eligible for CashFlow+ */
  isCashFlowPlusEligible: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is open or closed for offers */
  isClosed: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is currently part of any active offers */
  isInActiveOffer: Scalars['Boolean']['output'];
  /** Indicates whether this opportunity was created through a creation endpoint. */
  isManuallyCreated: Scalars['Boolean']['output'];
  /** Indicates if this opportunity is eligible for preferred term */
  isPreferredEligible: Scalars['Boolean']['output'];
  /** Whether an opportunity should default to selected as defined within the custom group. */
  isPreselected: Scalars['Boolean']['output'];
  /** Maker organization UUID for this opportunities parent customer. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** Calculated name of the opportunity using the custom group if set. */
  opportunityName?: Maybe<Scalars['String']['output']>;
  /** Information about the pricing related to this opportunity [StaticRate, BenchmarkRate, PriceDiscovery] */
  priceType: PriceType;
  /** Reference Rate statistics for this opportunity. A null value may indicate errors fetching rate information from the rate service. */
  referenceRateStats?: Maybe<ReferenceRateStats>;
  /** Request Options array. This contains a list of enums that indicate the type of opportunity and any special conditions. Example: A PreferredTerm entry indicates a preferred offer can be placed on this opportunity */
  requestOptions?: Maybe<Array<RequestOptions>>;
  /** TakersMarkets data associated with this opportunity */
  takersMarkets: Array<EarlyPayOpportunityTakersMarket>;
  /** Type of the opportunity, either PRICE_DISCOVERY or STATIC_RATE */
  type: OpportunityType;
  /** Unique identifier for this opportunity */
  uuid: Scalars['ID']['output'];
};

export type SupplierCustomerSelectScreenResponse = {
  __typename?: 'SupplierCustomerSelectScreenResponse';
  authServiceUuid: Scalars['String']['output'];
  /** The buyer division uuid */
  buyerDivisionUuid?: Maybe<Scalars['String']['output']>;
  /** Globally unique identifier representing the buyer. */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  earlyPayOpportunities: Array<SupplierCustomerSelectOpportunity>;
  earlyPayOpportunitiesAggregate: Array<SupplierCustomerEarlyPayOpportunitiesAggregateResponse>;
  /** Name for this customer, suitable for display to suppliers. */
  makerDisplayName: Scalars['String']['output'];
  /** URL pointing to the Buyer's logo in PNG format. */
  makerLogoPngUrl?: Maybe<Scalars['String']['output']>;
  makerOrganizationName: Scalars['String']['output'];
  makerOrganizationUuid: Scalars['String']['output'];
  /** Unique identifier for this customer */
  uuid: Scalars['String']['output'];
};


export type SupplierCustomerSelectScreenResponseEarlyPayOpportunitiesAggregateArgs = {
  filter?: InputMaybe<EarlyPayOpportunityAggregateFilter>;
};

export type SupplierCustomerSelectScreenResponseConnection = {
  __typename?: 'SupplierCustomerSelectScreenResponseConnection';
  edges: Array<SupplierCustomerSelectScreenResponseEdge>;
};

export type SupplierCustomerSelectScreenResponseEdge = {
  __typename?: 'SupplierCustomerSelectScreenResponseEdge';
  node: SupplierCustomerSelectScreenResponse;
};

export type SupplierCustomerSort = {
  direction: SortDirection;
  field: SupplierCustomerSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type SupplierCustomerSortFields =
  | 'authServiceUuid'
  | 'buyerUuid'
  | 'makerOrganizationUuid'
  | 'uuid';

export type SupplierDetails = {
  __typename?: 'SupplierDetails';
  companyGroup?: Maybe<Scalars['String']['output']>;
  companyGroupUuid?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  makerId?: Maybe<Scalars['Float']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updatedBy: Scalars['String']['output'];
  uploadDate: Scalars['DateTime']['output'];
};

export type SupplierDetailsFilters = {
  companyGroup?: InputMaybe<StringComparison>;
  companyId?: InputMaybe<StringComparison>;
  currency?: InputMaybe<StringComparison>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<StringComparison>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  supplierName?: InputMaybe<StringComparison>;
};

export type SupplierDetailsInput = {
  filters?: InputMaybe<SupplierDetailsFilters>;
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  paging: SupplierDetailsPaging;
  programUuid: Scalars['String']['input'];
  sorting: SupplierDetailsSorting;
};

export type SupplierDetailsOutput = {
  __typename?: 'SupplierDetailsOutput';
  newSuppliers?: Maybe<Array<NewSuppliers>>;
  supplierDetails?: Maybe<Array<SupplierDetails>>;
  totalCount?: Maybe<Scalars['Float']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SupplierDetailsPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type SupplierDetailsSorting = {
  orderBy?: Direction;
  sortingField?: SortField;
};

export type SupplierExcludedStats = {
  __typename?: 'SupplierExcludedStats';
  adjustedAmount: Scalars['Float']['output'];
  dpeWeightedAvg: Scalars['Float']['output'];
  dpeWeightedSum: Scalars['Float']['output'];
  invoiceAmount: Scalars['Float']['output'];
  invoiceCount: Scalars['Int']['output'];
};

export type SupplierFilterDto = {
  __typename?: 'SupplierFilterDto';
  filterName: Scalars['String']['output'];
};

export type SupplierFilterDtoConnection = {
  __typename?: 'SupplierFilterDtoConnection';
  /** Array of edges. */
  edges: Array<SupplierFilterDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type SupplierFilterDtoEdge = {
  __typename?: 'SupplierFilterDtoEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the SupplierFilterDto */
  node: SupplierFilterDto;
};

export type SupplierFilterDtoFilter = {
  and?: InputMaybe<Array<SupplierFilterDtoFilter>>;
  filterName?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<SupplierFilterDtoFilter>>;
};

export type SupplierFilterDtoSort = {
  direction: SortDirection;
  field: SupplierFilterDtoSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type SupplierFilterDtoSortFields =
  | 'filterName';

export type SupplierHistoryInfo = {
  __typename?: 'SupplierHistoryInfo';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  baseCurrencyClearedEarn?: Maybe<Scalars['Float']['output']>;
  baseCurrencyClearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedDpeAvg?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  clearedInvoiceCounts?: Maybe<Scalars['Float']['output']>;
  clearedYieldAvg?: Maybe<Scalars['Float']['output']>;
  divisionId?: Maybe<Scalars['Float']['output']>;
  firstAwardDate?: Maybe<Scalars['DateTime']['output']>;
  lastAwardDate?: Maybe<Scalars['DateTime']['output']>;
  marketId?: Maybe<Scalars['Float']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerId?: Maybe<Scalars['Float']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type SupplierHistoryInfoAggregationLevel =
  | 'CURRENCY'
  | 'MARKET'
  | 'PAY_DATE'
  | 'TAKER';

export type SupplierHistoryInfoFilters = {
  clearedInvoiceAmount?: InputMaybe<NumberComparison>;
  displayCurrency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  marketUuids: Array<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  takerUuids: Array<Scalars['String']['input']>;
};

export type SupplierHistoryInfoGroupBy = {
  aggregationLevels?: InputMaybe<Array<SupplierHistoryInfoAggregationLevel>>;
  timePeriod?: InputMaybe<GroupByTimePeriod>;
};

export type SupplierHistoryInfoInput = {
  filters: SupplierHistoryInfoFilters;
  paging: SupplierHistoryInfoPaging;
  sorting: SupplierHistoryInfoSorting;
};

export type SupplierHistoryInfoOrderBy = {
  orderLevel: SupplierHistoryInfoOrderLevel;
  orderType?: OrderTypeEnums;
};

export type SupplierHistoryInfoOrderLevel =
  | 'CLEARED_INVOICE_AMOUNT'
  | 'PAY_DATE';

export type SupplierHistoryInfoOutput = {
  __typename?: 'SupplierHistoryInfoOutput';
  history?: Maybe<Array<SupplierHistoryInfo>>;
  totalRows?: Maybe<Scalars['Float']['output']>;
};

export type SupplierHistoryInfoPaging = {
  pageNum?: Scalars['Float']['input'];
  pageSize?: Scalars['Float']['input'];
};

export type SupplierHistoryInfoSorting = {
  groupBy: SupplierHistoryInfoGroupBy;
  orderBy?: InputMaybe<Array<SupplierHistoryInfoOrderBy>>;
};

export type SupplierIntersectionDetails = {
  __typename?: 'SupplierIntersectionDetails';
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SupplierMembership = {
  __typename?: 'SupplierMembership';
  /** Id of the salesforce account the user is associated to. */
  accountId: Scalars['String']['output'];
  /** Billing frequency the user selects for the membership. Ex: MONTHLY, QUARTERLY, YEARLY */
  billingFrequency: Scalars['String']['output'];
  /** the corresponding Stripe-assigned Subscription ID. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** UUID of the membership. */
  id: Scalars['String']['output'];
  /** Indicates if an account is eligible for membership. Default: false */
  isEligible: Scalars['Boolean']['output'];
  /** Offer builder flow that we want the user to put in experiment. EX: FLOW_1_PARTIAL, FLOW_2_DETAIL. Default: FLOW_1_PARTIAL */
  offerBuilderType: Scalars['String']['output'];
  /** status of membership payment. Ex: NOT_APPLICABLE, PAID, PENDING, FAILED, CANCELLED. Default: NOT_APPLICABLE */
  paymentStatus: Scalars['String']['output'];
  /** Membership plan of the user that we want this user to put in experiment. Ex: BASIC, STANDARD, PREMIUM. Default: BASIC */
  plan: Scalars['String']['output'];
  /** Status of the membership. Ex: ACTIVE, PENDING, INACTIVE. Default: INACTIVE */
  status: Scalars['String']['output'];
  /** Date when trial membership is going to end */
  trialEndDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SupplierPaging = {
  limit?: Scalars['Float']['input'];
  offset?: Scalars['Float']['input'];
};

export type SupplierSegmentationConfig = {
  __typename?: 'SupplierSegmentationConfig';
  /** Maximum spend value across all supplier groups */
  maxGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend value across all supplier groups */
  minGroupSpend?: Maybe<Scalars['Float']['output']>;
  /** Minimum spend for strategic suppliers */
  strategicMinSpend: Scalars['Float']['output'];
  /** Maximum spend for tail suppliers */
  tailMaxSpend: Scalars['Float']['output'];
};

export type SupplierStats = {
  __typename?: 'SupplierStats';
  clearingSuppliersCount: Scalars['Int']['output'];
  eligibleSuppliersCount: Scalars['Int']['output'];
  nonClearingSuppliersCount: Scalars['Int']['output'];
  overallTotal: Scalars['Int']['output'];
  overallWithAp: Scalars['Int']['output'];
  overallWithoutAp: Scalars['Int']['output'];
  participatingSuppliersCount: Scalars['Int']['output'];
  participatingTotal: Scalars['Int']['output'];
  participatingWithAp: Scalars['Int']['output'];
  participatingWithoutAp: Scalars['Int']['output'];
  registeredTotal: Scalars['Int']['output'];
  registeredWithAp: Scalars['Int']['output'];
  registeredWithoutAp: Scalars['Int']['output'];
};

export type SupplierStatsInput = {
  marketUuids?: Array<Scalars['String']['input']>;
};

export type SuppliersDataDto = {
  __typename?: 'SuppliersDataDto';
  companyId: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  isPinned: Scalars['Boolean']['output'];
  location?: Maybe<Scalars['String']['output']>;
  supplierName?: Maybe<Scalars['String']['output']>;
};

export type SuppliersOutputDto = {
  __typename?: 'SuppliersOutputDto';
  supplierDetails?: Maybe<Array<SuppliersDataDto>>;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type SupportedLocales =
  | 'de'
  | 'en'
  | 'es'
  | 'fr'
  | 'it'
  | 'ja'
  | 'nl'
  | 'pt'
  | 'pt_br'
  | 'pt_pt'
  | 'ru'
  | 'tr'
  | 'zh_cn'
  | 'zh_tw';

export type SyncDsfCompanyGroupInput = {
  companyGroupName: Scalars['String']['input'];
  companyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};

export type SyncUsersResponse = {
  __typename?: 'SyncUsersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type SyncWcmPlanResponse = {
  __typename?: 'SyncWcmPlanResponse';
  /** Whether the plan was successfully synced */
  isSynced: Scalars['Boolean']['output'];
  /** Sync operation result message */
  message: Scalars['String']['output'];
};

export type Time_Periods =
  | 'DAY'
  | 'MONTH'
  | 'QUARTER'
  | 'WEEK'
  | 'YEAR';

/**
 * Represents an early pay offer on a particular market.
 * Can be either a discount or APR offer. Used for both legacy and new supplier experience offers.
 * The backing data source is the `taker_configuration` table.
 */
export type TakerConfiguration = {
  __typename?: 'TakerConfiguration';
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  disableAfterMarketClearsDate?: Maybe<Scalars['DateTime']['output']>;
  disableAfterNumMarketClears?: Maybe<Scalars['Int']['output']>;
  exclusionSettings: Scalars['String']['output'];
  isDiscountBidding: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isMigratedToEarlyPayOffer: Scalars['Boolean']['output'];
  isReferenceRateBidding?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedBy?: Maybe<Scalars['Int']['output']>;
  marketId: Scalars['Int']['output'];
  maxApr?: Maybe<Scalars['Float']['output']>;
  maxDiscount?: Maybe<Scalars['Float']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  offerUuid?: Maybe<Scalars['ID']['output']>;
  /** List of services to include */
  serviceScope?: Maybe<Scalars['String']['output']>;
  setByGlobalOffer: Scalars['Boolean']['output'];
  spread?: Maybe<Scalars['Int']['output']>;
  takerDivisionId: Scalars['Int']['output'];
  updated?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['ID']['output'];
};

export type TakerConfigurationConnection = {
  __typename?: 'TakerConfigurationConnection';
  /** Array of edges. */
  edges: Array<TakerConfigurationEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TakerConfigurationEdge = {
  __typename?: 'TakerConfigurationEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakerConfiguration */
  node: TakerConfiguration;
};

export type TakerConfigurationFilter = {
  and?: InputMaybe<Array<TakerConfigurationFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  disableAfterMarketClearsDate?: InputMaybe<DateFieldComparison>;
  disableAfterNumMarketClears?: InputMaybe<IntFieldComparison>;
  isDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  isEnabled?: InputMaybe<BooleanFieldComparison>;
  isMigratedToEarlyPayOffer?: InputMaybe<BooleanFieldComparison>;
  isReferenceRateBidding?: InputMaybe<BooleanFieldComparison>;
  lastUpdatedBy?: InputMaybe<IntFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  maxApr?: InputMaybe<NumberFieldComparison>;
  maxDiscount?: InputMaybe<NumberFieldComparison>;
  offerType?: InputMaybe<StringFieldComparison>;
  offerUuid?: InputMaybe<IdFilterComparison>;
  or?: InputMaybe<Array<TakerConfigurationFilter>>;
  serviceScope?: InputMaybe<TakerConfigurationServiceScopeFilterComparison>;
  setByGlobalOffer?: InputMaybe<BooleanFieldComparison>;
  spread?: InputMaybe<IntFieldComparison>;
  takerDivisionId?: InputMaybe<IntFieldComparison>;
  updated?: InputMaybe<DateFieldComparison>;
  uuid?: InputMaybe<IdFilterComparison>;
};

/**
 * Represents an action taken on an early pay offer on a particular market.
 * Offers correspond to a row on the taker_configuration table.
 * The backing data source is the `taker_configuration_history` table.
 */
export type TakerConfigurationHistory = {
  __typename?: 'TakerConfigurationHistory';
  /** The timestamp for when the row was created. */
  created?: Maybe<Scalars['DateTime']['output']>;
  division: Division;
  /** The id of the supplier division from the offer. */
  divisionId?: Maybe<Scalars['Float']['output']>;
  /** The eligible invoice amount in the offer. */
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  /** The number of eligible invoices in the offer. */
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  /** The user ID of the user that last updated the taker configuration. */
  lastUpdatedBy?: Maybe<Scalars['Float']['output']>;
  /** The id of the market from the offer. */
  marketId?: Maybe<Scalars['Float']['output']>;
  /** The unique identifier for the offer the action was taken upon. */
  offerUuid?: Maybe<Scalars['String']['output']>;
  /** List of services to include */
  serviceScope?: Maybe<Scalars['String']['output']>;
  /** The id of the taker configuration to which the recorded action corresponds. */
  takerConfigId?: Maybe<Scalars['Float']['output']>;
  /** Globally unique identifier for a taker_configuration_history row to accomodate multi-db paging. */
  uuid: Scalars['String']['output'];
};

export type TakerConfigurationHistoryConnection = {
  __typename?: 'TakerConfigurationHistoryConnection';
  /** Array of edges. */
  edges: Array<TakerConfigurationHistoryEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TakerConfigurationHistoryEdge = {
  __typename?: 'TakerConfigurationHistoryEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakerConfigurationHistory */
  node: TakerConfigurationHistory;
};

export type TakerConfigurationHistoryFilter = {
  and?: InputMaybe<Array<TakerConfigurationHistoryFilter>>;
  created?: InputMaybe<DateFieldComparison>;
  divisionId?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastUpdatedBy?: InputMaybe<NumberFieldComparison>;
  marketId?: InputMaybe<NumberFieldComparison>;
  offerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TakerConfigurationHistoryFilter>>;
  serviceScope?: InputMaybe<TakerConfigurationHistoryServiceScopeFilterComparison>;
  takerConfigId?: InputMaybe<NumberFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
};

export type TakerConfigurationHistoryServiceScopeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TakerConfigurationHistorySort = {
  direction: SortDirection;
  field: TakerConfigurationHistorySortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakerConfigurationHistorySortFields =
  | 'created'
  | 'divisionId'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'lastUpdatedBy'
  | 'marketId'
  | 'offerUuid'
  | 'serviceScope'
  | 'takerConfigId'
  | 'uuid';

export type TakerConfigurationServiceScopeFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TakerConfigurationSort = {
  direction: SortDirection;
  field: TakerConfigurationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakerConfigurationSortFields =
  | 'created'
  | 'currency'
  | 'disableAfterMarketClearsDate'
  | 'disableAfterNumMarketClears'
  | 'isDiscountBidding'
  | 'isEnabled'
  | 'isMigratedToEarlyPayOffer'
  | 'isReferenceRateBidding'
  | 'lastUpdatedBy'
  | 'marketId'
  | 'maxApr'
  | 'maxDiscount'
  | 'offerType'
  | 'offerUuid'
  | 'serviceScope'
  | 'setByGlobalOffer'
  | 'spread'
  | 'takerDivisionId'
  | 'updated'
  | 'uuid';

/** The input object for Taker Market that is associated to a Pricing Suggestion creation */
export type TakerMarket = {
  dpe: Scalars['Float']['input'];
  invoiceAmountUsd: Scalars['Float']['input'];
  marketUuid: Scalars['String']['input'];
  takerUuid: Scalars['String']['input'];
};

export type TakerMarketClear = {
  __typename?: 'TakerMarketClear';
  acceptedAprWeightedSum: Scalars['Float']['output'];
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  awardedAprWeightedSum: Scalars['Float']['output'];
  clearedAprWeightedSum: Scalars['Float']['output'];
  clearedDiscountWeightedSum: Scalars['Float']['output'];
  clearedDiscountedAmount: Scalars['Float']['output'];
  clearedDpeWeightedSum: Scalars['Float']['output'];
  clearedEarn: Scalars['Float']['output'];
  clearedInvoiceAmount: Scalars['Float']['output'];
  clearedInvoiceCount: Scalars['Float']['output'];
  clearedYield?: Maybe<Scalars['Float']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  currency: Scalars['String']['output'];
  dataCenterCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPendingClear: Scalars['Boolean']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId: Scalars['Int']['output'];
  marketUuid?: Maybe<Scalars['String']['output']>;
  payDate?: Maybe<Scalars['DateTime']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['DateTime']['output']>;
};

export type TakerMarketClearAggregateFilter = {
  and?: InputMaybe<Array<TakerMarketClearAggregateFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  clearedEarn?: InputMaybe<NumberFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TakerMarketClearAggregateFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakerMarketClearAggregateGroupBy = {
  __typename?: 'TakerMarketClearAggregateGroupBy';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isPendingClear?: Maybe<Scalars['Boolean']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearAggregateResponse = {
  __typename?: 'TakerMarketClearAggregateResponse';
  avg?: Maybe<TakerMarketClearAvgAggregate>;
  count?: Maybe<TakerMarketClearCountAggregate>;
  groupBy?: Maybe<TakerMarketClearAggregateGroupBy>;
  max?: Maybe<TakerMarketClearMaxAggregate>;
  min?: Maybe<TakerMarketClearMinAggregate>;
  sum?: Maybe<TakerMarketClearSumAggregate>;
};

export type TakerMarketClearAvgAggregate = {
  __typename?: 'TakerMarketClearAvgAggregate';
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
};

export type TakerMarketClearConnection = {
  __typename?: 'TakerMarketClearConnection';
  /** Array of edges. */
  edges: Array<TakerMarketClearEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type TakerMarketClearCountAggregate = {
  __typename?: 'TakerMarketClearCountAggregate';
  awardDate?: Maybe<Scalars['Int']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  clearedEarn?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isPendingClear?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
};

export type TakerMarketClearEdge = {
  __typename?: 'TakerMarketClearEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakerMarketClear */
  node: TakerMarketClear;
};

export type TakerMarketClearFilter = {
  and?: InputMaybe<Array<TakerMarketClearFilter>>;
  awardDate?: InputMaybe<DateFieldComparison>;
  clearedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  clearedEarn?: InputMaybe<NumberFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  isPendingClear?: InputMaybe<BooleanFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TakerMarketClearFilter>>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakerMarketClearMaxAggregate = {
  __typename?: 'TakerMarketClearMaxAggregate';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearMinAggregate = {
  __typename?: 'TakerMarketClearMinAggregate';
  awardDate?: Maybe<Scalars['DateTime']['output']>;
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakerMarketClearSort = {
  direction: SortDirection;
  field: TakerMarketClearSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakerMarketClearSortFields =
  | 'awardDate'
  | 'clearedDiscountedAmount'
  | 'clearedEarn'
  | 'dataCenterCode'
  | 'id'
  | 'isPendingClear'
  | 'makerUuid'
  | 'marketUuid'
  | 'takerUuid';

export type TakerMarketClearSumAggregate = {
  __typename?: 'TakerMarketClearSumAggregate';
  clearedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  clearedEarn?: Maybe<Scalars['Float']['output']>;
};

export type TakerMarketInput = {
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** UUID of the taker */
  takerUuid: Scalars['String']['input'];
};

export type TakerMarketInputDto = {
  /** Identifier for the Market */
  marketUuid: Scalars['ID']['input'];
  /** Identifier for the Taker */
  takerUuid: Scalars['ID']['input'];
};

export type TakerMarketObject = {
  __typename?: 'TakerMarketObject';
  /** Identifier for the Market */
  marketUuid: Scalars['ID']['output'];
  /** Identifier for the Taker */
  takerUuid: Scalars['ID']['output'];
};

export type TakerMarketReplacementInput = {
  /** The authServiceUuid to apply the 'new' offer */
  authServiceUuid: Scalars['String']['input'];
  /** The replacement taker and market details with additional attributes */
  new: NewTakerMarketInput;
  /** The original taker and market details */
  old: TakerMarketInput;
};

export type TakerMarketRequest = {
  __typename?: 'TakerMarketRequest';
  /** DateTime this request was created. Ex: '2021-10-12 16:32:37.209788' */
  created: Scalars['DateTime']['output'];
  /** List of taker division uuids that this request is against */
  divisions: Array<Scalars['String']['output']>;
  /** Reason that a request is errored */
  errorReason: RequestErrorReason;
  /** Identifier for the request */
  id: Scalars['ID']['output'];
  /** (Optional) Auth Service UUID of the user impersonating the submitting user */
  impersonatorId?: Maybe<Scalars['String']['output']>;
  /** Indicates the offer rate was averaged on the frontend when request was made */
  isRateAveraged?: Maybe<Scalars['Boolean']['output']>;
  /** Auth Service UUID of the user to last modify this request. */
  lastModifiedBy: Scalars['String']['output'];
  /** Auth Service UUID of the impersonating user to last modify this request. */
  lastModifiedByImpersonatorId?: Maybe<Scalars['String']['output']>;
  /** Opportunity information that was saved when submitting a request. This is a subset of the information available from the customer API */
  opportunities: Array<Opportunity>;
  /** Rate this request is placed against as a percentage. Ex: 1.23% = 1.23 */
  rate: Scalars['Float']['output'];
  /** Type of rate of this offer. Either APR or DISC (Discount) */
  rateType?: Maybe<RateType>;
  /** Auth Service UUID of the user submitting the request */
  requesterId: Scalars['String']['output'];
  /** Edit restrictions for this request */
  restrictions: EarlyPayRequestRestrictions;
  /** Status of the request */
  status: RequestStatus;
  /** Type of request, e.g. RECURRING_PRICE_DISCOVERY */
  type: RequestType;
  /** DateTime this request was last updated. Ex: '2021-10-12 16:32:37.209788' */
  updated: Scalars['DateTime']['output'];
};

export type TakersMarkets = {
  __typename?: 'TakersMarkets';
  acceptedAprWeightedAvg: Scalars['Float']['output'];
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg: Scalars['Float']['output'];
  acceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount: Scalars['Float']['output'];
  awardedDpeWeightedAvg: Scalars['Float']['output'];
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  eligibleAprWeightedSum: Scalars['Float']['output'];
  eligibleDpeWeightedAvg: Scalars['Float']['output'];
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  ineligibleEpInvoiceCount: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  makerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  makerExcludedInvoiceAmount: Scalars['Float']['output'];
  makerExcludedInvoiceCount: Scalars['Float']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationId?: Maybe<Scalars['Float']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  matchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  matchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  maxNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg: Scalars['Float']['output'];
  pendingDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  pendingDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  reservedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  reservedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount: Scalars['Float']['output'];
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices: Scalars['Boolean']['output'];
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigOfferType?: Maybe<Scalars['String']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  takerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationId?: Maybe<Scalars['Float']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
  totalAdjustedAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsAggregateFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsAggregateFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsAggregateFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsAggregateGroupBy = {
  __typename?: 'TakersMarketsAggregateGroupBy';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsAggregateResponse = {
  __typename?: 'TakersMarketsAggregateResponse';
  avg?: Maybe<TakersMarketsAvgAggregate>;
  count?: Maybe<TakersMarketsCountAggregate>;
  groupBy?: Maybe<TakersMarketsAggregateGroupBy>;
  max?: Maybe<TakersMarketsMaxAggregate>;
  min?: Maybe<TakersMarketsMinAggregate>;
  sum?: Maybe<TakersMarketsSumAggregate>;
};

export type TakersMarketsAvgAggregate = {
  __typename?: 'TakersMarketsAvgAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsConnection = {
  __typename?: 'TakersMarketsConnection';
  /** Array of edges. */
  edges: Array<TakersMarketsEdge>;
  /** Paging information */
  pageInfo: PageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type TakersMarketsCountAggregate = {
  __typename?: 'TakersMarketsCountAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  acceptedEarn?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  acceptedYield?: Maybe<Scalars['Int']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Int']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  awardedEarn?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  awardedYield?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  dataCenterCode?: Maybe<Scalars['Int']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Int']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Int']['output']>;
  eligibleYield?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Int']['output']>;
  lastClearDate?: Maybe<Scalars['Int']['output']>;
  makerDivisionName?: Maybe<Scalars['Int']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Int']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  makerUuid?: Maybe<Scalars['Int']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['Int']['output']>;
  marketType?: Maybe<Scalars['Int']['output']>;
  marketUuid?: Maybe<Scalars['Int']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Int']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Int']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Int']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  notAcceptedYield?: Maybe<Scalars['Int']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Int']['output']>;
  pendingEarn?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Int']['output']>;
  signedUpCount?: Maybe<Scalars['Int']['output']>;
  takerConfigCreated?: Maybe<Scalars['Int']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['Int']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Int']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Int']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Int']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Int']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Int']['output']>;
  takerConfigUpdated?: Maybe<Scalars['Int']['output']>;
  takerDivisionName?: Maybe<Scalars['Int']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Int']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Int']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Int']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['Int']['output']>;
  takerOrganizationName?: Maybe<Scalars['Int']['output']>;
  takerUuid?: Maybe<Scalars['Int']['output']>;
};

export type TakersMarketsEdge = {
  __typename?: 'TakersMarketsEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor']['output'];
  /** The node containing the TakersMarkets */
  node: TakersMarkets;
};

export type TakersMarketsFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsMaxAggregate = {
  __typename?: 'TakersMarketsMaxAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsMinAggregate = {
  __typename?: 'TakersMarketsMinAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedYield?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode?: Maybe<Scalars['String']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid?: Maybe<Scalars['String']['output']>;
  marketId?: Maybe<Scalars['Int']['output']>;
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType?: Maybe<Scalars['String']['output']>;
  marketUuid?: Maybe<Scalars['String']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices?: Maybe<Scalars['Boolean']['output']>;
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerId?: Maybe<Scalars['Int']['output']>;
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid?: Maybe<Scalars['String']['output']>;
};

export type TakersMarketsNoPage = {
  __typename?: 'TakersMarketsNoPage';
  acceptedAprWeightedAvg: Scalars['Float']['output'];
  acceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg: Scalars['Float']['output'];
  acceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount: Scalars['Float']['output'];
  acceptedDpeWeightedAvg: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedYield?: Maybe<Scalars['Float']['output']>;
  awardedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount: Scalars['Float']['output'];
  awardedDpeWeightedAvg: Scalars['Float']['output'];
  awardedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedYield?: Maybe<Scalars['Float']['output']>;
  bankingDays?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  dataCenterCode: Scalars['String']['output'];
  eligibleAprWeightedSum: Scalars['Float']['output'];
  eligibleDpeWeightedAvg: Scalars['Float']['output'];
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleYield?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  ineligibleEpInvoiceCount: Scalars['Float']['output'];
  isImported?: Maybe<Scalars['Boolean']['output']>;
  lastClearDate?: Maybe<Scalars['DateTime']['output']>;
  makerDivisionName?: Maybe<Scalars['String']['output']>;
  makerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  makerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  makerExcludedInvoiceAmount: Scalars['Float']['output'];
  makerExcludedInvoiceCount: Scalars['Float']['output'];
  makerId?: Maybe<Scalars['Int']['output']>;
  makerOrganizationId?: Maybe<Scalars['Float']['output']>;
  makerOrganizationName?: Maybe<Scalars['String']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  makerUuid: Scalars['String']['output'];
  marketId: Scalars['Int']['output'];
  marketProductType?: Maybe<Scalars['String']['output']>;
  marketType: Scalars['String']['output'];
  marketUuid: Scalars['String']['output'];
  matchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  matchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  maxAcceptedApr?: Maybe<Scalars['Float']['output']>;
  maxAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  maxEligibleDpe?: Maybe<Scalars['Int']['output']>;
  maxNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minEligibleDpe?: Maybe<Scalars['Int']['output']>;
  minNotAcceptedApr?: Maybe<Scalars['Float']['output']>;
  minPendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedAboveMinYield?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedYield?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg: Scalars['Float']['output'];
  pendingDiscountWeightedSum?: Maybe<Scalars['Float']['output']>;
  pendingDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  reservedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  reservedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount: Scalars['Float']['output'];
  takerConfigCreated?: Maybe<Scalars['DateTime']['output']>;
  takerConfigDisableAt?: Maybe<Scalars['DateTime']['output']>;
  takerConfigExcludeNewInvoices: Scalars['Boolean']['output'];
  takerConfigId?: Maybe<Scalars['Int']['output']>;
  takerConfigIsDiscountBidding?: Maybe<Scalars['Boolean']['output']>;
  takerConfigIsEnabled?: Maybe<Scalars['Boolean']['output']>;
  takerConfigMaxApr?: Maybe<Scalars['Float']['output']>;
  takerConfigMaxDiscount?: Maybe<Scalars['Float']['output']>;
  takerConfigOfferType?: Maybe<Scalars['String']['output']>;
  takerConfigUpdated?: Maybe<Scalars['DateTime']['output']>;
  takerDivisionName?: Maybe<Scalars['String']['output']>;
  takerExcludedForTodayInvoiceAmount: Scalars['Float']['output'];
  takerExcludedForTodayInvoiceCount: Scalars['Float']['output'];
  takerExcludedInvoiceAmount: Scalars['Float']['output'];
  takerExcludedInvoiceCount: Scalars['Float']['output'];
  takerId: Scalars['Int']['output'];
  takerMakerId?: Maybe<Scalars['String']['output']>;
  takerOrganizationId?: Maybe<Scalars['Float']['output']>;
  takerOrganizationName?: Maybe<Scalars['String']['output']>;
  takerUuid: Scalars['String']['output'];
  totalAdjustedAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentAmount?: Maybe<Scalars['Float']['output']>;
  unmatchedAdjustmentCount?: Maybe<Scalars['Float']['output']>;
};

export type TakersMarketsNoPageFilter = {
  acceptedAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  acceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  acceptedEarn?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  acceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  acceptedYield?: InputMaybe<NumberFieldComparison>;
  and?: InputMaybe<Array<TakersMarketsNoPageFilter>>;
  awardedDiscountedAmount?: InputMaybe<NumberFieldComparison>;
  awardedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  awardedEarn?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  awardedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  awardedYield?: InputMaybe<NumberFieldComparison>;
  currency?: InputMaybe<StringFieldComparison>;
  dataCenterCode?: InputMaybe<StringFieldComparison>;
  eligibleAprWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  eligibleDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  eligibleInvoiceCount?: InputMaybe<NumberFieldComparison>;
  eligibleYield?: InputMaybe<NumberFieldComparison>;
  id?: InputMaybe<IdFilterComparison>;
  ineligibleEpInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  ineligibleEpInvoiceCount?: InputMaybe<NumberFieldComparison>;
  lastClearDate?: InputMaybe<DateFieldComparison>;
  makerDivisionName?: InputMaybe<StringFieldComparison>;
  makerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  makerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  makerId?: InputMaybe<IntFieldComparison>;
  makerOrganizationName?: InputMaybe<StringFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  makerUuid?: InputMaybe<StringFieldComparison>;
  marketId?: InputMaybe<IntFieldComparison>;
  marketProductType?: InputMaybe<StringFieldComparison>;
  marketType?: InputMaybe<StringFieldComparison>;
  marketUuid?: InputMaybe<StringFieldComparison>;
  maxAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  maxEligibleDpe?: InputMaybe<IntFieldComparison>;
  minEligibleDpe?: InputMaybe<IntFieldComparison>;
  minPendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedAboveMinEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedAvg?: InputMaybe<NumberFieldComparison>;
  notAcceptedDpeWeightedSum?: InputMaybe<NumberFieldComparison>;
  notAcceptedEarn?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  notAcceptedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  notAcceptedYield?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TakersMarketsNoPageFilter>>;
  pendingAprWeightedAvg?: InputMaybe<NumberFieldComparison>;
  pendingEarn?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  pendingInvoiceCount?: InputMaybe<NumberFieldComparison>;
  signedUpCount?: InputMaybe<NumberFieldComparison>;
  takerConfigCreated?: InputMaybe<DateFieldComparison>;
  takerConfigDisableAt?: InputMaybe<DateFieldComparison>;
  takerConfigExcludeNewInvoices?: InputMaybe<BooleanFieldComparison>;
  takerConfigId?: InputMaybe<IntFieldComparison>;
  takerConfigIsDiscountBidding?: InputMaybe<BooleanFieldComparison>;
  takerConfigIsEnabled?: InputMaybe<BooleanFieldComparison>;
  takerConfigMaxApr?: InputMaybe<NumberFieldComparison>;
  takerConfigMaxDiscount?: InputMaybe<NumberFieldComparison>;
  takerConfigUpdated?: InputMaybe<DateFieldComparison>;
  takerDivisionName?: InputMaybe<StringFieldComparison>;
  takerExcludedForTodayInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedForTodayInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceAmount?: InputMaybe<NumberFieldComparison>;
  takerExcludedInvoiceCount?: InputMaybe<NumberFieldComparison>;
  takerId?: InputMaybe<IntFieldComparison>;
  takerMakerId?: InputMaybe<StringFieldComparison>;
  takerOrganizationName?: InputMaybe<StringFieldComparison>;
  takerUuid?: InputMaybe<StringFieldComparison>;
};

export type TakersMarketsNoPageSort = {
  direction: SortDirection;
  field: TakersMarketsNoPageSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakersMarketsNoPageSortFields =
  | 'acceptedAprWeightedAvg'
  | 'acceptedDiscountWeightedAvg'
  | 'acceptedDiscountedAmount'
  | 'acceptedDpeWeightedAvg'
  | 'acceptedDpeWeightedSum'
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardedDiscountedAmount'
  | 'awardedDpeWeightedAvg'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'currency'
  | 'dataCenterCode'
  | 'eligibleAprWeightedSum'
  | 'eligibleDpeWeightedAvg'
  | 'eligibleDpeWeightedSum'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'eligibleYield'
  | 'id'
  | 'ineligibleEpInvoiceAmount'
  | 'ineligibleEpInvoiceCount'
  | 'lastClearDate'
  | 'makerDivisionName'
  | 'makerExcludedForTodayInvoiceAmount'
  | 'makerExcludedForTodayInvoiceCount'
  | 'makerExcludedInvoiceAmount'
  | 'makerExcludedInvoiceCount'
  | 'makerId'
  | 'makerOrganizationName'
  | 'makerOrganizationUuid'
  | 'makerUuid'
  | 'marketId'
  | 'marketProductType'
  | 'marketType'
  | 'marketUuid'
  | 'maxAcceptedInvoiceAmount'
  | 'maxEligibleDpe'
  | 'minEligibleDpe'
  | 'minPendingInvoiceAmount'
  | 'notAcceptedAboveMinEarn'
  | 'notAcceptedDpeWeightedAvg'
  | 'notAcceptedDpeWeightedSum'
  | 'notAcceptedEarn'
  | 'notAcceptedInvoiceAmount'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'pendingAprWeightedAvg'
  | 'pendingEarn'
  | 'pendingInvoiceAmount'
  | 'pendingInvoiceCount'
  | 'signedUpCount'
  | 'takerConfigCreated'
  | 'takerConfigDisableAt'
  | 'takerConfigExcludeNewInvoices'
  | 'takerConfigId'
  | 'takerConfigIsDiscountBidding'
  | 'takerConfigIsEnabled'
  | 'takerConfigMaxApr'
  | 'takerConfigMaxDiscount'
  | 'takerConfigUpdated'
  | 'takerDivisionName'
  | 'takerExcludedForTodayInvoiceAmount'
  | 'takerExcludedForTodayInvoiceCount'
  | 'takerExcludedInvoiceAmount'
  | 'takerExcludedInvoiceCount'
  | 'takerId'
  | 'takerMakerId'
  | 'takerOrganizationName'
  | 'takerUuid';

export type TakersMarketsSort = {
  direction: SortDirection;
  field: TakersMarketsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TakersMarketsSortFields =
  | 'acceptedAprWeightedAvg'
  | 'acceptedDiscountWeightedAvg'
  | 'acceptedDiscountedAmount'
  | 'acceptedDpeWeightedAvg'
  | 'acceptedDpeWeightedSum'
  | 'acceptedEarn'
  | 'acceptedInvoiceAmount'
  | 'acceptedInvoiceCount'
  | 'acceptedYield'
  | 'awardedDiscountedAmount'
  | 'awardedDpeWeightedAvg'
  | 'awardedEarn'
  | 'awardedInvoiceAmount'
  | 'awardedInvoiceCount'
  | 'awardedYield'
  | 'currency'
  | 'dataCenterCode'
  | 'eligibleAprWeightedSum'
  | 'eligibleDpeWeightedAvg'
  | 'eligibleDpeWeightedSum'
  | 'eligibleInvoiceAmount'
  | 'eligibleInvoiceCount'
  | 'eligibleYield'
  | 'id'
  | 'ineligibleEpInvoiceAmount'
  | 'ineligibleEpInvoiceCount'
  | 'lastClearDate'
  | 'makerDivisionName'
  | 'makerExcludedForTodayInvoiceAmount'
  | 'makerExcludedForTodayInvoiceCount'
  | 'makerExcludedInvoiceAmount'
  | 'makerExcludedInvoiceCount'
  | 'makerId'
  | 'makerOrganizationName'
  | 'makerOrganizationUuid'
  | 'makerUuid'
  | 'marketId'
  | 'marketProductType'
  | 'marketType'
  | 'marketUuid'
  | 'maxAcceptedInvoiceAmount'
  | 'maxEligibleDpe'
  | 'minEligibleDpe'
  | 'minPendingInvoiceAmount'
  | 'notAcceptedAboveMinEarn'
  | 'notAcceptedDpeWeightedAvg'
  | 'notAcceptedDpeWeightedSum'
  | 'notAcceptedEarn'
  | 'notAcceptedInvoiceAmount'
  | 'notAcceptedInvoiceCount'
  | 'notAcceptedYield'
  | 'pendingAprWeightedAvg'
  | 'pendingEarn'
  | 'pendingInvoiceAmount'
  | 'pendingInvoiceCount'
  | 'signedUpCount'
  | 'takerConfigCreated'
  | 'takerConfigDisableAt'
  | 'takerConfigExcludeNewInvoices'
  | 'takerConfigId'
  | 'takerConfigIsDiscountBidding'
  | 'takerConfigIsEnabled'
  | 'takerConfigMaxApr'
  | 'takerConfigMaxDiscount'
  | 'takerConfigUpdated'
  | 'takerDivisionName'
  | 'takerExcludedForTodayInvoiceAmount'
  | 'takerExcludedForTodayInvoiceCount'
  | 'takerExcludedInvoiceAmount'
  | 'takerExcludedInvoiceCount'
  | 'takerId'
  | 'takerMakerId'
  | 'takerOrganizationName'
  | 'takerUuid';

export type TakersMarketsStatsForMarket = {
  __typename?: 'TakersMarketsStatsForMarket';
  acceptedAprWeightedSum: Scalars['Float']['output'];
  acceptedDiscountWeightedSum: Scalars['Float']['output'];
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  acceptedEarn: Scalars['Float']['output'];
  acceptedInvoiceAmount: Scalars['Float']['output'];
  acceptedInvoiceCount: Scalars['Float']['output'];
  acceptedTakerCount: Scalars['Float']['output'];
  acceptedYield: Scalars['Float']['output'];
  awardedEarn: Scalars['Float']['output'];
  awardedInvoiceAmount: Scalars['Float']['output'];
  awardedInvoiceCount: Scalars['Float']['output'];
  awardedTakerCount: Scalars['Float']['output'];
  awardedYield: Scalars['Float']['output'];
  bankingDaysWeightedSum: Scalars['Float']['output'];
  cashPoolUsed: Scalars['Float']['output'];
  eligibleInvoiceAmount: Scalars['Float']['output'];
  eligibleInvoiceCount: Scalars['Float']['output'];
  eligibleTakerCount: Scalars['Float']['output'];
  ineligibleEpInvoiceAmount: Scalars['Float']['output'];
  notAcceptedAprWeightedSum: Scalars['Float']['output'];
  notAcceptedDiscountWeightedSum: Scalars['Float']['output'];
  notAcceptedDpeWeightedSum: Scalars['Float']['output'];
  notAcceptedEarn: Scalars['Float']['output'];
  notAcceptedInvoiceAmount: Scalars['Float']['output'];
  notAcceptedInvoiceCount: Scalars['Float']['output'];
  notAcceptedTakerCount: Scalars['Float']['output'];
  notAcceptedYield: Scalars['Float']['output'];
  pendingEarn: Scalars['Float']['output'];
  pendingInvoiceAmount: Scalars['Float']['output'];
  pendingInvoiceCount: Scalars['Float']['output'];
  pendingTakerCount: Scalars['Float']['output'];
};

export type TakersMarketsSumAggregate = {
  __typename?: 'TakersMarketsSumAggregate';
  acceptedAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  acceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  acceptedEarn?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  acceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  awardedDiscountedAmount?: Maybe<Scalars['Float']['output']>;
  awardedDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  awardedEarn?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  awardedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  eligibleAprWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedAvg?: Maybe<Scalars['Float']['output']>;
  eligibleDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  eligibleInvoiceCount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  ineligibleEpInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  makerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  notAcceptedDpeWeightedSum?: Maybe<Scalars['Float']['output']>;
  notAcceptedEarn?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  notAcceptedInvoiceCount?: Maybe<Scalars['Float']['output']>;
  pendingAprWeightedAvg?: Maybe<Scalars['Float']['output']>;
  pendingEarn?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Float']['output']>;
  signedUpCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedForTodayInvoiceCount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceAmount?: Maybe<Scalars['Float']['output']>;
  takerExcludedInvoiceCount?: Maybe<Scalars['Float']['output']>;
};

export type TermSheet = {
  __typename?: 'TermSheet';
  buyer_totals?: Maybe<BuyerTotals>;
  max_days_paid_early?: Maybe<Scalars['Float']['output']>;
  week_of?: Maybe<Scalars['String']['output']>;
};

export type TermSheetDto = {
  __typename?: 'TermSheetDTO';
  avgDaysOutstanding?: Maybe<Scalars['Float']['output']>;
  /** Supplier account name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Date representing the week when the data was calcualted. (first day of that week) */
  dataForWeek?: Maybe<Scalars['String']['output']>;
  /** Days Paid Early */
  dpe?: Maybe<Scalars['Float']['output']>;
  /** Estimated early payment amount */
  estimatedPayment?: Maybe<Scalars['Float']['output']>;
  /** Last week's average rate */
  lastWeekAvgRate?: Maybe<Scalars['Float']['output']>;
  totalInvoiceAmount?: Maybe<Scalars['Float']['output']>;
};

export type TimeRange =
  | 'ALL_TIME'
  | 'PAST_7_DAYS'
  | 'PAST_30_DAYS'
  | 'PAST_60_DAYS'
  | 'PAST_YEAR'
  | 'THIS_QUARTER'
  | 'THIS_QUARTER_TO_DATE'
  | 'THIS_YEAR'
  | 'THIS_YEAR_TO_DATE';

export type ToggleOffer = {
  __typename?: 'ToggleOffer';
  enabled: Scalars['Boolean']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  /** A transaction's `weighted_sum_apr` divided by its `invoice_amount`. */
  aggregatedApr: Scalars['Float']['output'];
  /** A transaction's `weighted_sum_days_paid_early` divided by its `invoice_amount`. */
  aggregatedDaysPaidEarly: Scalars['Float']['output'];
  /** A transaction's `discount_amount` divided by its `invoice_amount`. */
  aggregatedDiscount: Scalars['Float']['output'];
  /** A user's `auth_service_uuid`. */
  authServiceUuid: Scalars['String']['output'];
  /** Used for transaction aggregate amounts to be converted to a single (provided) currency. This value may be null if exchange rate service is unavailable, if no preferred currency was provided, or if the aggregate did not group by currency. */
  convertedCurrency?: Maybe<ConvertedCurrency>;
  /** The taker market clear's  `currency`. */
  currency: Scalars['String']['output'];
  /** A customer's name. */
  customerName: Scalars['String']['output'];
  /** A customer's uuid generated from `marker_organization_uuid` and `auth_service_uuid`. */
  customerUuid: Scalars['String']['output'];
  /** The sum of taker market clear `cleared_discounted_amount`. */
  depositAmount: Scalars['Float']['output'];
  /** The maximum of taker market clear `deposit_date`. */
  depositDate: Scalars['String']['output'];
  /** The sum of taker market clear `cleared_earn`. */
  discountAmount: Scalars['Float']['output'];
  /** The exchange rate to USD of taker market clear `currency` at time of conversion. */
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  /** The sum of taker market clear `cleared_invoice_amount`. */
  invoiceAmount: Scalars['Float']['output'];
  /** The sum of taker market clear `cleared_invoice_count`. */
  invoiceCount: Scalars['Float']['output'];
  /** The taker config history's `is_discount_bidding`. */
  isDiscount: Scalars['Boolean']['output'];
  /** True if at least one taker market clear record of transaction has is_pending_clear = true */
  isPendingClear: Scalars['Boolean']['output'];
  /** The maximum of taker market clear `updated`. */
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** A maker organization's `uuid`. */
  makerOrganizationUuid: Scalars['String']['output'];
  /** The sum of taker configuration history where `is_discount_bidding` is false. */
  numAprOffers: Scalars['Float']['output'];
  /** The sum of taker configuration history where `is_discount_bidding` is true. */
  numDiscountOffers: Scalars['Float']['output'];
  /** Enum member signifying offer product type, including ONE_TIME, REPEATING, PREFERRED_TERM, CASHFLOW_PLUS_ONE_TIME, etc. */
  offerType?: Maybe<Scalars['String']['output']>;
  /** The taker config history's `offer_uuid`. */
  offerUuid: Scalars['String']['output'];
  /** The minimum of taker market clear `pay_date`. */
  paymentInitiatedDate?: Maybe<Scalars['String']['output']>;
  /** The market's `product_type`. */
  productType?: Maybe<Scalars['String']['output']>;
  /** A comma-separated string of all taker market clear `id`s included in the transaction aggregation. */
  takerMarketClearIds: Scalars['String']['output'];
  /** The minimum of taker market clear `created`. */
  transactionClearDate?: Maybe<Scalars['String']['output']>;
  /** A transaction's uuid generated from `customer_uuid`, `currency`, `deposit_date` and `offer_uuid`. */
  uuid: Scalars['String']['output'];
  /** The sum of taker market clear `cleared_apr_weighted_sum`. */
  weightedSumApr: Scalars['Float']['output'];
  /** The sum of taker market clear `cleared_dpe_weighted_sum`. */
  weightedSumDaysPaidEarly: Scalars['Float']['output'];
  /** A transaction's `discount_amount` times its `invoice_amount`. */
  weightedSumDiscount: Scalars['Float']['output'];
};

export type TransactionAggregateFilter = {
  aggregatedApr?: InputMaybe<FloatFieldComparison>;
  aggregatedDaysPaidEarly?: InputMaybe<NumberFieldComparison>;
  aggregatedDiscount?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<TransactionAggregateFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  convertedCurrency?: InputMaybe<TransactionAggregateFilterConvertedCurrencyAggregateFilter>;
  currency?: InputMaybe<StringFieldComparison>;
  customerName?: InputMaybe<StringFieldComparison>;
  customerUuid?: InputMaybe<StringFieldComparison>;
  depositAmount?: InputMaybe<NumberFieldComparison>;
  depositDate?: InputMaybe<StringFieldComparison>;
  discountAmount?: InputMaybe<NumberFieldComparison>;
  invoiceCount?: InputMaybe<NumberFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  offerType?: InputMaybe<StringFieldComparison>;
  offerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TransactionAggregateFilter>>;
  paymentInitiatedDate?: InputMaybe<StringFieldComparison>;
  toCurrency?: InputMaybe<TransactionToCurrencyFilterComparison>;
  transactionClearDate?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
  weightedSumDaysPaidEarly?: InputMaybe<NumberFieldComparison>;
};

export type TransactionAggregateFilterConvertedCurrencyAggregateFilter = {
  and?: InputMaybe<Array<TransactionAggregateFilterConvertedCurrencyAggregateFilter>>;
  depositAmount?: InputMaybe<NumberFieldComparison>;
  discountAmount?: InputMaybe<NumberFieldComparison>;
  invoiceAmount?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TransactionAggregateFilterConvertedCurrencyAggregateFilter>>;
};

export type TransactionAggregateGroupBy = {
  __typename?: 'TransactionAggregateGroupBy';
  aggregatedApr?: Maybe<Scalars['Float']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Float']['output']>;
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  convertedCurrency?: Maybe<ConvertedCurrency>;
  currency?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositDate?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  offerUuid?: Maybe<Scalars['String']['output']>;
  paymentInitiatedDate?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Scalars['String']['output']>;
  transactionClearDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
};

export type TransactionAggregateResponse = {
  __typename?: 'TransactionAggregateResponse';
  avg?: Maybe<TransactionAvgAggregate>;
  count?: Maybe<TransactionCountAggregate>;
  groupBy?: Maybe<TransactionAggregateGroupBy>;
  max?: Maybe<TransactionMaxAggregate>;
  min?: Maybe<TransactionMinAggregate>;
  sum?: Maybe<TransactionSumAggregate>;
};

export type TransactionAvgAggregate = {
  __typename?: 'TransactionAvgAggregate';
  aggregatedApr?: Maybe<Scalars['Float']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Float']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  /** Array of nodes. */
  nodes: Array<Transaction>;
  /** Paging information */
  pageInfo: OffsetPageInfo;
  /** Fetch total count of records */
  totalCount: Scalars['Int']['output'];
};

export type TransactionCountAggregate = {
  __typename?: 'TransactionCountAggregate';
  aggregatedApr?: Maybe<Scalars['Int']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Int']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Int']['output']>;
  authServiceUuid?: Maybe<Scalars['Int']['output']>;
  convertedCurrency?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['Int']['output']>;
  customerUuid?: Maybe<Scalars['Int']['output']>;
  depositAmount?: Maybe<Scalars['Int']['output']>;
  depositDate?: Maybe<Scalars['Int']['output']>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['Int']['output']>;
  offerType?: Maybe<Scalars['Int']['output']>;
  offerUuid?: Maybe<Scalars['Int']['output']>;
  paymentInitiatedDate?: Maybe<Scalars['Int']['output']>;
  toCurrency?: Maybe<Scalars['Int']['output']>;
  transactionClearDate?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['Int']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Int']['output']>;
};

/** Defines a single currency exchange rate that was used to convert the original amount(s) to the desired currency. */
export type TransactionCurrencyMap = {
  __typename?: 'TransactionCurrencyMap';
  /** The currency a transaction was converted from. */
  originalCurrency: Scalars['String']['output'];
  /** The exchange rate used to convert the original currency to the desired currency. */
  rate: Scalars['Float']['output'];
};

export type TransactionCurrencyMapInput = {
  /** The currency a transaction was converted from. */
  originalCurrency: Scalars['String']['input'];
  /** The exchange rate used to convert the original currency to the desired currency. */
  rate: Scalars['Float']['input'];
};

export type TransactionFilter = {
  aggregatedApr?: InputMaybe<FloatFieldComparison>;
  aggregatedDaysPaidEarly?: InputMaybe<NumberFieldComparison>;
  aggregatedDiscount?: InputMaybe<FloatFieldComparison>;
  and?: InputMaybe<Array<TransactionFilter>>;
  authServiceUuid?: InputMaybe<StringFieldComparison>;
  convertedCurrency?: InputMaybe<TransactionFilterConvertedCurrencyFilter>;
  currency?: InputMaybe<StringFieldComparison>;
  customerName?: InputMaybe<StringFieldComparison>;
  customerUuid?: InputMaybe<StringFieldComparison>;
  depositAmount?: InputMaybe<NumberFieldComparison>;
  depositDate?: InputMaybe<StringFieldComparison>;
  discountAmount?: InputMaybe<NumberFieldComparison>;
  invoiceCount?: InputMaybe<NumberFieldComparison>;
  makerOrganizationUuid?: InputMaybe<StringFieldComparison>;
  offerType?: InputMaybe<StringFieldComparison>;
  offerUuid?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<TransactionFilter>>;
  paymentInitiatedDate?: InputMaybe<StringFieldComparison>;
  toCurrency?: InputMaybe<TransactionToCurrencyFilterComparison>;
  transactionClearDate?: InputMaybe<StringFieldComparison>;
  uuid?: InputMaybe<StringFieldComparison>;
  weightedSumDaysPaidEarly?: InputMaybe<NumberFieldComparison>;
};

export type TransactionFilterConvertedCurrencyFilter = {
  and?: InputMaybe<Array<TransactionFilterConvertedCurrencyFilter>>;
  depositAmount?: InputMaybe<NumberFieldComparison>;
  discountAmount?: InputMaybe<NumberFieldComparison>;
  invoiceAmount?: InputMaybe<NumberFieldComparison>;
  or?: InputMaybe<Array<TransactionFilterConvertedCurrencyFilter>>;
};

export type TransactionMaxAggregate = {
  __typename?: 'TransactionMaxAggregate';
  aggregatedApr?: Maybe<Scalars['Float']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Float']['output']>;
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  convertedCurrency?: Maybe<ConvertedCurrency>;
  currency?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositDate?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  offerUuid?: Maybe<Scalars['String']['output']>;
  paymentInitiatedDate?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Scalars['String']['output']>;
  transactionClearDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
};

export type TransactionMinAggregate = {
  __typename?: 'TransactionMinAggregate';
  aggregatedApr?: Maybe<Scalars['Float']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Float']['output']>;
  authServiceUuid?: Maybe<Scalars['String']['output']>;
  convertedCurrency?: Maybe<ConvertedCurrency>;
  currency?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerUuid?: Maybe<Scalars['String']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  depositDate?: Maybe<Scalars['String']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  makerOrganizationUuid?: Maybe<Scalars['String']['output']>;
  offerType?: Maybe<Scalars['String']['output']>;
  offerUuid?: Maybe<Scalars['String']['output']>;
  paymentInitiatedDate?: Maybe<Scalars['String']['output']>;
  toCurrency?: Maybe<Scalars['String']['output']>;
  transactionClearDate?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
};

export type TransactionSort = {
  direction: SortDirection;
  field: TransactionSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type TransactionSortFields =
  | 'aggregatedApr'
  | 'aggregatedDaysPaidEarly'
  | 'aggregatedDiscount'
  | 'authServiceUuid'
  | 'convertedCurrency'
  | 'currency'
  | 'customerName'
  | 'customerUuid'
  | 'depositAmount'
  | 'depositDate'
  | 'discountAmount'
  | 'invoiceCount'
  | 'makerOrganizationUuid'
  | 'offerType'
  | 'offerUuid'
  | 'paymentInitiatedDate'
  | 'toCurrency'
  | 'transactionClearDate'
  | 'uuid'
  | 'weightedSumDaysPaidEarly';

export type TransactionSumAggregate = {
  __typename?: 'TransactionSumAggregate';
  aggregatedApr?: Maybe<Scalars['Float']['output']>;
  aggregatedDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
  aggregatedDiscount?: Maybe<Scalars['Float']['output']>;
  depositAmount?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  invoiceCount?: Maybe<Scalars['Float']['output']>;
  weightedSumDaysPaidEarly?: Maybe<Scalars['Float']['output']>;
};

export type TransactionToCurrencyFilterComparison = {
  eq?: InputMaybe<Scalars['String']['input']>;
};

export type Treatment =
  | 'CONTROL'
  | 'HOLDOUT'
  | 'TEST';

export type Update_Wcm_Role_Users_Action_Type =
  | 'ADD_USERS'
  | 'DELETE_USERS';

/** Unique Customer is a view of a buyer from the perspective of a supplier user. */
export type UniqueCustomer = {
  __typename?: 'UniqueCustomer';
  /** Secondary identifier if Maker organization UUID is common */
  buyerUuid?: Maybe<Scalars['String']['output']>;
  /** URL pointing to the Buyer's logo in PNG format. */
  customerLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Name for this customer, suitable for display to suppliers. */
  customerName: Scalars['String']['output'];
  /** It shows that the user is already linked to this customer. */
  isLinked: Scalars['Boolean']['output'];
  /** count of suppliers that are associated with a customer. */
  linkedUserCount: Scalars['Float']['output'];
  /** Maker organization UUID for this customer, to identify customer in c2fo system */
  makerOrganizationUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type UpdateBuyerAppBuyerConfigInput = {
  /** Configuration name */
  configName: Buyer_Config;
  /** Configuration value (true/false) */
  value: Scalars['Boolean']['input'];
};

export type UpdateBuyerAppEverafterBuyerConfig = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  divisionUuid?: InputMaybe<Scalars['String']['input']>;
  embedLocationId?: InputMaybe<Scalars['String']['input']>;
  personaName?: InputMaybe<Scalars['String']['input']>;
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBuyerAppInvoiceInput = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** array of invoice ids */
  invoiceIds: Array<Scalars['Float']['input']>;
  /** makerExcluded flag for invoices */
  makerExcluded: Scalars['Boolean']['input'];
};

export type UpdateBuyerAppInvoiceOutput = {
  __typename?: 'UpdateBuyerAppInvoiceOutput';
  /** Invoice Id */
  id: Scalars['Float']['output'];
  /** maker excluded flag for invoices */
  makerExcluded: Scalars['Boolean']['output'];
  /** The status of the invoice */
  status: Scalars['String']['output'];
};

export type UpdateBuyerDeliveryLocationInput = {
  deliverySettingsUuid: Scalars['String']['input'];
  funderFileTemplateUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
};

export type UpdateBuyerDeliveryLocationOutput = {
  __typename?: 'UpdateBuyerDeliveryLocationOutput';
  deliverySettingsUuid: Scalars['String']['output'];
  funderFileTemplateUuid: Scalars['String']['output'];
  programUuid: Scalars['String']['output'];
};

/**
 * This is the input required to update a new Communication Preference for a user.
 * The backing data source is the ODS API.
 */
export type UpdateCommunicationPreferenceInput = {
  communicationType?: InputMaybe<CommunicationPreferenceType>;
  notificationValue?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateCompanyIdGroupInput = {
  companyGroupUuid: Scalars['String']['input'];
  makerOrgUuid: Scalars['String']['input'];
  makerUuid: Scalars['String']['input'];
  programUuid: Scalars['String']['input'];
  qualifiedSupplierInput: Array<QualifiedSupplierInput>;
};

export type UpdateCustomAttributeResult = {
  __typename?: 'UpdateCustomAttributeResult';
  /** Number of supplier assignments affected by this operation */
  assignmentsAffected: Scalars['Int']['output'];
  /** Information about the custom attribute that was updated */
  customAttribute: CustomAttributeInfo;
  /** Array of supplier IDs that were impacted by this operation */
  impactedSupplierIds: Array<Scalars['Int']['output']>;
  /** Human-readable message describing the result of the operation */
  message: Scalars['String']['output'];
};

export type UpdateCustomAttributeValueResponseDto = {
  __typename?: 'UpdateCustomAttributeValueResponseDto';
  /** Unique ID of the value mapping */
  id: Scalars['Int']['output'];
  /** The old value of the value mapping */
  oldValue: Scalars['String']['output'];
  /** The actual text value */
  value: Scalars['String']['output'];
};

export type UpdateCustomGroup = {
  /** Date the group was created. */
  created?: InputMaybe<Scalars['DateTime']['input']>;
  /** Designates if the opportunity associated with this group should be preselected. */
  isPreselected?: InputMaybe<Scalars['Boolean']['input']>;
  /** List of grouped division / market combos */
  items?: InputMaybe<Array<CustomGroupEmbeddedItem>>;
  /** Maker organization UUID for the group. */
  makerOrganizationUuid?: InputMaybe<Scalars['String']['input']>;
  /** AuthServiceUuid of the last person to modify the group. */
  modifiedBy?: InputMaybe<Scalars['String']['input']>;
  /** Customer display name describing the grouping of takers / markets */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Additional notes on the grouping. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Description of why these takers / markets are grouped together. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** Date the group was updated. */
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  /** Unique identifier for this custom group */
  uuid?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDeliverySettingsInput = {
  deliveryMethod: Scalars['String']['input'];
  deliveryTime: Variance;
  funderFileTemplateUuid: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isDeliveryEnabled: Scalars['Boolean']['input'];
  programUuid: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDeliverySettingsOutput = {
  __typename?: 'UpdateDeliverySettingsOutput';
  deliveryMethod: Scalars['String']['output'];
  deliveryTime?: Maybe<Scalars['String']['output']>;
  funderFileTemplateUuid: Scalars['String']['output'];
  id: Scalars['Float']['output'];
  isDeliveryEnabled: Scalars['Boolean']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

export type UpdateFileStatusInput = {
  /** Update file action */
  action: Scalars['String']['input'];
  /** Buyer file configurations */
  buyerFileConfigs: BuyerFileConfigs;
  /** File currency */
  fileCurrency: Scalars['String']['input'];
  /** Transaction UUID */
  transactionUuid: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateFileStatusOutput = {
  __typename?: 'UpdateFileStatusOutput';
  /** Status of the file update operation */
  status: Scalars['String']['output'];
};

export type UpdateFunderCalculationsInput = {
  funderUuid: Scalars['String']['input'];
  interestCalcOutputStrategy?: InputMaybe<Scalars['String']['input']>;
  paymentMethods?: InputMaybe<Scalars['String']['input']>;
  priceTypes?: InputMaybe<Scalars['String']['input']>;
  rateSelectionStrategy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderCurrenciesInput = {
  bankingDays?: InputMaybe<Scalars['Float']['input']>;
  currencyLookupId: Scalars['Float']['input'];
  funderUuid: Scalars['String']['input'];
  rateSource: Scalars['String']['input'];
  refRateFloor?: InputMaybe<Scalars['Float']['input']>;
  referenceRate: Scalars['String']['input'];
};

export type UpdateFunderDeliverySettingsInputDto = {
  fdsAuthId?: InputMaybe<Scalars['String']['input']>;
  fdsLocationId?: InputMaybe<Scalars['String']['input']>;
  fdsLocationName?: InputMaybe<Scalars['String']['input']>;
  fdsLocationUri?: InputMaybe<Scalars['String']['input']>;
  isBuyerAddress?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderFeedbackConfigInputDto = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceAmountComputed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFunderGeographiesInput = {
  funderUuid: Scalars['String']['input'];
  geographyLookupId: Scalars['Float']['input'];
  includeExclude?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFunderLegalSetupInput = {
  agreementType?: InputMaybe<Scalars['String']['input']>;
  funderUuid: Scalars['String']['input'];
  termsAndConditionsUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyBuyerAppDivisionRegionsInput = {
  /** Filter used to find fields to update */
  filter: BuyerAppDivisionRegionUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: BuyerAppDivisionRegionUpdateInput;
};

export type UpdateManyCommunicationChannelsInput = {
  /** Filter used to find fields to update */
  filter: CommunicationChannelUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: InputCommunicationChannelUpdate;
};

export type UpdateManyCommunicationPreferencesInput = {
  /** Filter used to find fields to update */
  filter: CommunicationPreferenceUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateCommunicationPreferenceInput;
};

export type UpdateManyQualifiedSuppliersInput = {
  /** Filter used to find fields to update */
  filter: QualifiedSupplierUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateQualifiedSupplier;
};

export type UpdateManyResponse = {
  __typename?: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int']['output'];
};

export type UpdateMultipleRecordGroupInput = {
  funderFileTemplateId: Scalars['String']['input'];
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rgOrder: Scalars['Float']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateOneActionableOfferScheduleInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: ActionableOfferScheduleUpdate;
};

export type UpdateOneBuyerAppEverafterBuyerConfigInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateBuyerAppEverafterBuyerConfig;
};

export type UpdateOneCommunicationChannelInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: InputCommunicationChannelUpdate;
};

export type UpdateOneCommunicationPreferenceInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCommunicationPreferenceInput;
};

export type UpdateOneCustomGroupInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateCustomGroup;
};

export type UpdateOneFunderDeliverySettingsDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateFunderDeliverySettingsInputDto;
};

export type UpdateOneFunderFeedbackConfigInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateFunderFeedbackConfigInputDto;
};

export type UpdateOneFunderFileInput = {
  buyerGeneratedUseForReconciliation?: InputMaybe<Scalars['Boolean']['input']>;
  deliverySettings: FunderFileDeliverySettingsInput;
  fileNameFormat: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
  funder: Scalars['String']['input'];
  funderFileType: Scalars['String']['input'];
  reconColumnDetails?: InputMaybe<ReconColumnDetailsInput>;
  serializer: SerializerSettingsInput;
  subType: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
  writerType: Scalars['String']['input'];
};

export type UpdateOneFunderInput = {
  name: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateOneFunderNotificationConfigInput = {
  email: Array<Scalars['String']['input']>;
  funder: Scalars['String']['input'];
  funderFiles: Array<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type UpdateOneQualifiedSupplierInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateQualifiedSupplier;
};

export type UpdateOneRecordGroupColumnDtoInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateRecordGroupColumnInput;
};

export type UpdateOneRecordGroupInput = {
  /** The id of the record to update */
  id: Scalars['ID']['input'];
  /** The update to apply. */
  update: UpdateRecordGroup;
};

export type UpdateOutOfNetworkCustomerInput = {
  /** Any additional information that will help us with users request */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Approximate amount receivable from customer */
  approximateAmountReceivable?: InputMaybe<Scalars['Int']['input']>;
  /** Customer currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user would consider being a reference for C2FO with this customer */
  isContactReference?: InputMaybe<Scalars['Boolean']['input']>;
  /** Customer name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Customer website url */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutOfNetworkCustomerRequestInput = {
  /** Any additional information that will help us with users request */
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  /** Approximate amount receivable from customer */
  approximateAmountReceivable?: InputMaybe<Scalars['Int']['input']>;
  /** Customer currency */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user would consider being a reference for C2FO with this customer */
  isContactReference?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOutOfNetworkCustomerRequestResponse = {
  __typename?: 'UpdateOutOfNetworkCustomerRequestResponse';
  /** Approximate amount receivable from customer */
  approximateAmountReceivable?: Maybe<Scalars['Int']['output']>;
  /** Customer currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** UUID of updated request */
  uuid: Scalars['String']['output'];
};

export type UpdateOutOfNetworkCustomerResponse = {
  __typename?: 'UpdateOutOfNetworkCustomerResponse';
  /** UUID of updated out-of-network customer */
  uuid: Scalars['String']['output'];
};

export type UpdatePreferredOfferConfigInput = {
  /** Salesforce account ID associated with the config record */
  accountId: Scalars['String']['input'];
  /** Flag indicating whether or not account can edit invoices on an active preferred offer */
  canEditInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Uuid associated with the user making the update */
  updatedBy: Scalars['String']['input'];
};

export type UpdateProfileImage = {
  accountId: Scalars['String']['input'];
  displayCoordinates: Scalars['String']['input'];
};

export type UpdateProfileImageResponse = {
  __typename?: 'UpdateProfileImageResponse';
  accountId: Scalars['String']['output'];
  displayCoordinates: Scalars['String']['output'];
};

export type UpdateProgramFileSetInput = {
  filterCriteria: UpdateProgramSetFilterCriteriaDto;
  filterVariables: Array<UpdateProgramSetVariableDto>;
  variables: Array<UpdateProgramSetVariableDto>;
};

export type UpdateProgramFileSetSettings = {
  programFileSettings: Array<UpdateProgramFileSettings>;
  writerType: Scalars['String']['input'];
};

export type UpdateProgramFileSettings = {
  fileSettingsUuid?: InputMaybe<Scalars['String']['input']>;
  funderFileTemplateUuid: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  name: Variance;
  serialNo: Scalars['Float']['input'];
  subType: Scalars['String']['input'];
};

export type UpdateProgramSetFilterCriteriaDto = {
  filterColumn: Scalars['String']['input'];
  filterValue: Scalars['String']['input'];
};

export type UpdateProgramSetVariableDto = {
  mandatory: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  value: Variance;
};

export type UpdateQualifiedSupplier = {
  companyGroupUuid?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<Scalars['DateTime']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  makerId?: InputMaybe<Scalars['Float']['input']>;
  makerUuid?: InputMaybe<Scalars['String']['input']>;
  supplierName?: InputMaybe<Scalars['String']['input']>;
  takerId?: InputMaybe<Scalars['Float']['input']>;
  takerUuid?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
  uploadUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecordGroup = {
  funderFileTemplateId?: InputMaybe<Scalars['String']['input']>;
  isBatchRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isTransactionRecordGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rgOrder?: InputMaybe<Scalars['Float']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecordGroupColumnInput = {
  columnOrder: Scalars['Float']['input'];
  displayName: Scalars['String']['input'];
  funderFileColumnId: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['Boolean']['input']>;
  isBatchColumn: Scalars['Boolean']['input'];
  isInvoiceColumn: Scalars['Boolean']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isTransactionColumn: Scalars['Boolean']['input'];
  mergeConfig: MergeConfigInput;
  recordGroupId: Scalars['String']['input'];
  serializerConfig: SerializerColumnSettingsInput;
  sortBy?: InputMaybe<Scalars['Boolean']['input']>;
  transformationConfig: Scalars['JSON']['input'];
  uuid: Scalars['String']['input'];
};

export type UpdateSupplierMembershipInput = {
  /** Billing frequency the user selects for the membership. Ex: MONTHLY, QUARTERLY, YEARLY */
  billingFrequency?: InputMaybe<BillingFrequency>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  isEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offer builder flow that we want the user to put in experiment. EX: FLOW_1_PARTIAL, FLOW_2_DETAIL. Default: FLOW_1_PARTIAL */
  offerBuilderType?: InputMaybe<OfferBuilderType>;
  /** status of membership payment. Ex: NOT_APPLICABLE, PAID, PENDING, FAILED, CANCELLED. Default: NOT_APPLICABLE */
  paymentStatus?: InputMaybe<PaymentStatus>;
  /** Membership plan of the user that we want this user to put in experiment. Ex: BASIC, STANDARD, PREMIUM. Default: BASIC */
  plan?: InputMaybe<MembershipPlan>;
  status?: InputMaybe<MembershipStatus>;
};

export type UpdateUserInput = {
  /** AuthUUID of the user registering */
  authServiceUuid: Scalars['String']['input'];
  /** Company of the user registering */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-3166-2 country code. Supported values are TW, CN, FR, CA, MX, PT, TR, RU, US, IN, GB, AU, IT, DE, ES, NL */
  country: Scalars['String']['input'];
  /** Flag indicating if the user's email has been verified. Will generate a Segment event */
  emailVerified: Scalars['Boolean']['input'];
  /** First name of user registering */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of user registering */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Locale of user registering. Must be one of zh_tw, zh_cn, fr, es, pt_br, tr, ru, en, it, de, nl */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of user registering */
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Date the user registered */
  registrationDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The job role of the registering user. Must be from list CFO, CONTROLLER, CREDIT_MANAGER, FINANCE_DIRECTOR, TREASURER, CEO, PRESIDENT, OWNER_FOUNDER, ACCOUNTING, BOOKKEEPER, ACCOUNTS_RECEIVABLE, OFFICE_MANAGER, OTHER. Will fallback to OTHER */
  role: Scalars['String']['input'];
  /** Mobile Phone number of user registering */
  secondaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Flag indicating if the user has accepted terms and conditions. Will generate a Segment event */
  termsCondsFlag: Scalars['Boolean']['input'];
};

export type UpdateUserOutput = {
  __typename?: 'UpdateUserOutput';
  data: UpdateUserOutputData;
};

export type UpdateUserOutputData = {
  __typename?: 'UpdateUserOutputData';
  users: UpdateUserOutputUsers;
};

export type UpdateUserOutputUsers = {
  __typename?: 'UpdateUserOutputUsers';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UpdateWcmBuyerExclusionRemarkInput = {
  id: Scalars['Int']['input'];
  remark: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerExclusionRemarkOutput = {
  __typename?: 'UpdateWcmBuyerExclusionRemarkOutput';
  id: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
  wcmBuyerUuid: Scalars['String']['output'];
};

export type UpdateWcmBuyerTypeToPaidInput = {
  /** UUID of the buyer to update from trial to paid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmBuyerTypeToPaidOutput = {
  __typename?: 'UpdateWcmBuyerTypeToPaidOutput';
  /** Number of other non-paid buyer mappings deleted for non-C2FO users associated with the given buyer */
  deletedOtherNonPaidMappingsCount: Scalars['Int']['output'];
  /** Message describing the result */
  message: Scalars['String']['output'];
  /** Number of access validity records removed for affected users */
  removedUsersExpiryCount: Scalars['Int']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
  /** UUID of the updated buyer */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type UpdateWcmCustomAttributeDefinitionInput = {
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['input'];
};

export type UpdateWcmCustomAttributeForSuppliersInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** Array of custom attributes to update */
  attributes: Array<WcmAttributeUpdateItem>;
  /** Supplier IDs to be excluded from the benchmarking strategy update */
  deselectedSupplierIds?: Array<Scalars['Float']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Supplier IDs for which the custom attribute will be updated */
  selectedSupplierIds?: Array<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmCustomAttributeForSuppliersOutput = {
  __typename?: 'UpdateWcmCustomAttributeForSuppliersOutput';
  /** Results for each attribute that was updated */
  results: Array<UpdateCustomAttributeResult>;
  /** Indicates whether all attribute updates were successful */
  success: Scalars['Boolean']['output'];
};

export type UpdateWcmCustomAttributeValueInput = {
  /** The new value text */
  value: Scalars['String']['input'];
};

export type UpdateWcmDiversityStatusInput = {
  displayCurrency: Scalars['String']['input'];
  diversityStatus: Scalars['String']['input'];
  /** List of supplier IDs selected for diversity status update */
  supplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmDiversityStatusOutput = {
  __typename?: 'UpdateWcmDiversityStatusOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmNaicsPaymentTermsInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  /** List of supplier IDs explicitly not selected(excluded) for naics update */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  naicsCode: Scalars['Int']['input'];
  /** List of supplier IDs selected for naics update */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmNaicsPaymentTermsOutput = {
  __typename?: 'UpdateWcmNaicsPaymentTermsOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmPaymentTermsVersionInput = {
  /** Benchmarking generation date */
  benchmarkingGenerationDate: Scalars['String']['input'];
  displayCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmPaymentTermsVersionOutput = {
  __typename?: 'UpdateWcmPaymentTermsVersionOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmPlanWaveInput = {
  /** Wave end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Wave name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the wave */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Wave start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateWcmRolePermissionsOutput = {
  __typename?: 'UpdateWcmRolePermissionsOutput';
  permissionIds: Array<Scalars['ID']['output']>;
};

export type UpdateWcmRoleUsersInput = {
  actionType: Update_Wcm_Role_Users_Action_Type;
  roleId: Scalars['ID']['input'];
  userMappingIds: Array<Scalars['ID']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmRoleUsersOutput = {
  __typename?: 'UpdateWcmRoleUsersOutput';
  message: Scalars['String']['output'];
};

export type UpdateWcmRolesPermissionsInput = {
  addPermissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  managedByC2foUsers?: InputMaybe<Scalars['Boolean']['input']>;
  removePermissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  roleId: Scalars['ID']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierGroupBenchmarkingStrategyInputDto = {
  benchmarkingStrategy: Benchmarking_Strategies;
  customBenchmark?: InputMaybe<Scalars['Int']['input']>;
  isDefaultStrategy: Scalars['Boolean']['input'];
  supplierId: Scalars['Int']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierGroupBenchmarkingStrategyOutput = {
  __typename?: 'UpdateWcmSupplierGroupBenchmarkingStrategyOutput';
  status: Scalars['Float']['output'];
};

export type UpdateWcmSupplierGroupNoteInput = {
  /** Updated note content */
  content: Scalars['String']['input'];
  /** ID of the note to update */
  noteId: Scalars['Int']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierItemInput = {
  /** Company ID */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Supplier ID */
  id: Scalars['Float']['input'];
};

export type UpdateWcmSupplierSegmentConfigInput = {
  displayCurrency: Scalars['String']['input'];
  segmentationRules: SegmentationRules;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSupplierSegmentConfigOutput = {
  __typename?: 'UpdateWcmSupplierSegmentConfigOutput';
  status: Scalars['String']['output'];
};

export type UpdateWcmSuppliersBenchmarkStrategyBySegmentInput = {
  applyTermsHarmonization?: InputMaybe<Scalars['Boolean']['input']>;
  benchmarkingStrategy: WcmBenchmarkStrategyBySegmentInput;
  displayCurrency: Scalars['String']['input'];
  overrideCustomBenchmarks: Scalars['Boolean']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput = {
  __typename?: 'UpdateWcmSuppliersBenchmarkStrategyBySegmentOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSuppliersBenchmarkStrategyInput = {
  /** All selected configuration */
  allSelected: AllSelectedOptionsInput;
  benchmarkingStrategy: Benchmarking_Strategies;
  customBenchmark?: InputMaybe<Scalars['Float']['input']>;
  /** Supplier IDs to be excluded from the benchmarking strategy update */
  deselectedSupplierIds?: Array<Scalars['Int']['input']>;
  displayCurrency: Scalars['String']['input'];
  /** Supplier IDs for which the benchmarking strategy will be updated */
  selectedSupplierIds?: Array<Scalars['Int']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersBenchmarkStrategyOutput = {
  __typename?: 'UpdateWcmSuppliersBenchmarkStrategyOutput';
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmSuppliersInput = {
  /** Array of suppliers to update with their new attributes */
  suppliers: Array<UpdateWcmSupplierItemInput>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpdateWcmSuppliersOutput = {
  __typename?: 'UpdateWcmSuppliersOutput';
  /** Status of the update operation */
  status: Scalars['Boolean']['output'];
};

export type UpdateWcmUserRegistrationRequestInput = {
  /** Registration request ID */
  id: Scalars['ID']['input'];
  /** New status */
  status: Wcm_User_Self_Registration_Request_Status;
};

export type UpdateWcmUserRegistrationRequestResponse = {
  __typename?: 'UpdateWcmUserRegistrationRequestResponse';
  /** Update status: SUCCESS */
  status: Scalars['String']['output'];
};

export type UpsertBuyerAppMarketTakerConfigurationInput = {
  divisionUuid: Scalars['String']['input'];
  marketUuid: Scalars['String']['input'];
  minReturnAmount: Scalars['Float']['input'];
  takerUuid: Scalars['String']['input'];
};

export type UpsertBuyerAppMarketTakerConfigurationOutput = {
  __typename?: 'UpsertBuyerAppMarketTakerConfigurationOutput';
  minReturnAmount: Scalars['Float']['output'];
};

export type UpsertBuyerAppUserPreferenceInput = {
  /** Preference name */
  preferenceName: Scalars['String']['input'];
  /** User preference settings */
  settings: Scalars['JSON']['input'];
};

export type UpsertBuyerAppUserPreferenceOutput = {
  __typename?: 'UpsertBuyerAppUserPreferenceOutput';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** Whether the upsert succeeded */
  success: Scalars['Boolean']['output'];
};

export type UpsertOneTakerConfigurationInput = {
  /** The record to create */
  takerConfiguration: UpsertTakerConfigurationInput;
};

/** Canonical phase for status-phase mapping upsert; UNMAPPED removes the mapping */
export type UpsertStatusPhaseCanonicalPhaseInput =
  | 'COMPLETED'
  | 'ERP_UPDATED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'UNMAPPED'
  | 'UNSUCCESSFUL';

/**
 * Updates a taker configuration if it exists, otherwise creates it. Determines
 * which datacenter to query based on the marketUuid. Determines whether the taker
 * configuration already exists via takerDivisionId and marketId.
 */
export type UpsertTakerConfigurationInput = {
  currency: Scalars['String']['input'];
  disableAfterMarketClearsDate?: InputMaybe<Scalars['DateTime']['input']>;
  disableAfterNumMarketClears?: InputMaybe<Scalars['Int']['input']>;
  /** Field to update the exclusion_settings column with whether or not new invoices are excluded. Internally this setting is stored as a jsonb column, but for API simplicity this is exposed directly as a boolean. NOTE: This field only controls exclusion for new invoices and does NOT automatically exclude current invoices. You will have to manually call the legacy excludeIneligibleInvoices endpoint as well: https://github.com/C2FO/c2fo/blob/04ede344b75083b038e48e453ed17b201ee22e0a/api/lib/c2fo/maker/routes.js#L164 */
  excludeNewInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscountBidding: Scalars['Boolean']['input'];
  isEnabled: Scalars['Boolean']['input'];
  isMigratedToEarlyPayOffer?: InputMaybe<Scalars['Boolean']['input']>;
  isReferenceRateBidding?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field to update the last_updated_by column using an auth service uuid.Internally, this will be converted to the datacenter specific integer user id */
  lastUpdatedByAuthServiceUuid: Scalars['String']['input'];
  marketId: Scalars['Int']['input'];
  marketUuid: Scalars['ID']['input'];
  maxApr?: InputMaybe<Scalars['Float']['input']>;
  maxDiscount?: InputMaybe<Scalars['Float']['input']>;
  offerType?: InputMaybe<Scalars['String']['input']>;
  offerUuid?: InputMaybe<Scalars['String']['input']>;
  setByGlobalOffer: Scalars['Boolean']['input'];
  spread?: InputMaybe<Scalars['Float']['input']>;
  takerDivisionId: Scalars['Int']['input'];
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpsertWcmBenchmarkConfigInput = {
  /** Apply terms harmonization in benchmarking */
  applyTermsHarmonization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of banking days used for WCO calculations */
  bankingDays?: InputMaybe<Scalars['Float']['input']>;
  /** Benchmarking version calendar date (ISO 8601 date, e.g. 2026-04-27) */
  benchmarkingVersionDate?: InputMaybe<Scalars['String']['input']>;
  /** Display Currency */
  currency: Scalars['String']['input'];
  /** Enable country-specific regulatory term limits */
  goodPracticeAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum allowable payment-term days (1–365) */
  maxTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** Day increment for suppliers without NAICS (5-60 in increments of 5) */
  noNaicsTermsIncrement?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum payment-term days for PACA-related suppliers (1–365) */
  pacaMaxTermDays?: InputMaybe<Scalars['Int']['input']>;
  /** Total days in the spend period */
  spendPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  /** Last calendar month in the spend period */
  spendPeriodEndMonth?: InputMaybe<Scalars['String']['input']>;
  /** Total months in the spend period */
  spendPeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  /** First calendar month in the spend period */
  spendPeriodStartMonth?: InputMaybe<Scalars['String']['input']>;
  /** Rounding step (in days) for target payment terms */
  targetTermRoundingDays?: InputMaybe<Scalars['Float']['input']>;
  /** Buyer WACC in % */
  waccPercentage?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmBenchmarkCountryRegulationsInput = {
  /** Currency code */
  currency: Scalars['String']['input'];
  /** List of country regulations to upsert */
  regulations: Array<WcmCountryRegulationItemInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmDomainConfigInput = {
  /** Buyer access type (ALL, SOME, or NONE) */
  buyerAccessType: Scalars['String']['input'];
  /** Domain-specific configuration */
  config?: InputMaybe<WcmDomainClientConfigInput>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type UpsertWcmEconomicValueConfigInput = {
  displayCurrency: Scalars['String']['input'];
  economicValue: Scalars['Float']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmExclusionsConfigInput = {
  /** Exclude suppliers with discounted payment terms */
  discountTermExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  /** Exclude diverse suppliers */
  diverseSupplierExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum spend value threshold for supplier groups */
  minSpendValue?: InputMaybe<Scalars['Float']['input']>;
  /** Exclude suppliers with missing payment terms */
  missingTermExclusion?: InputMaybe<Scalars['Boolean']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmNegotiationInput = {
  /** Backdateable ISO 8601 date the status change took effect */
  eventDate?: InputMaybe<Scalars['String']['input']>;
  /** Negotiated terms value */
  negotiatedTerms?: InputMaybe<Scalars['Float']['input']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text remarks recorded against the negotiation and its status event */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertWcmNegotiationItem = {
  /** Backdateable ISO 8601 date the status change took effect */
  eventDate?: InputMaybe<Scalars['String']['input']>;
  /** Negotiated terms value */
  negotiatedTerms?: InputMaybe<Scalars['Float']['input']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: InputMaybe<Scalars['String']['input']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: InputMaybe<Scalars['Float']['input']>;
  /** Free-text remarks recorded against the negotiation and its status event */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: InputMaybe<Scalars['String']['input']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: InputMaybe<Scalars['String']['input']>;
  /** Vendor variant ID */
  vendorVariantId: Scalars['String']['input'];
};

export type UpsertWcmNegotiationsInput = {
  /** Array of negotiations to create or update */
  negotiations: Array<UpsertWcmNegotiationItem>;
};

export type UpsertWcmSegmentConversionRateInput = {
  coreSegmentConversionRate: Scalars['Float']['input'];
  displayCurrency: Scalars['String']['input'];
  strategicSegmentConversionRate: Scalars['Float']['input'];
  tailSegmentConversionRate: Scalars['Float']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type UpsertWcmStatusPhaseMappingItemInput = {
  /** Canonical phase to map the status to; UNMAPPED removes the mapping */
  canonicalPhase: UpsertStatusPhaseCanonicalPhaseInput;
  /** Ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['input'];
  /** ID of the custom status from wcm_custom_attribute_value_mappings */
  customStatusValueId: Scalars['Int']['input'];
};

export type UpsertWcmStatusPhaseMappingsInput = {
  /** Array of status phase mappings to upsert */
  mappings: Array<UpsertWcmStatusPhaseMappingItemInput>;
};

export type UpsertWcmUserPreferenceInput = {
  /** Preference name */
  preferenceName: Scalars['String']['input'];
  /** User preference settings */
  settings: Scalars['JSON']['input'];
};

export type UpsertWcmUserPreferenceOutput = {
  __typename?: 'UpsertWcmUserPreferenceOutput';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** Whether the operation was successful */
  success: Scalars['Boolean']['output'];
};

export type UpsertWcmUsersInput = {
  /** WCM user info */
  users: Array<WcmUpsertUserInfoParams>;
};

export type User = Node & {
  __typename?: 'User';
  /** The Account this user belongs to. This is determined by joining the user's divisions to the account's divisions. If the user has multiple divisions we pick the first one. */
  account?: Maybe<Account>;
  created?: Maybe<Scalars['String']['output']>;
  /** Who created the user */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** How was the user created. */
  createdSource?: Maybe<Scalars['String']['output']>;
  /** A list of datacenters where the user exists. */
  datacenters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Divisions this user is associated with. */
  divisions?: Maybe<Array<Maybe<Division>>>;
  earlyPayDivisions?: Maybe<EarlyPayDivisionOffsetConnection>;
  /** The email address of the user. */
  emailAddress: Scalars['String']['output'];
  /** The date when the user's email was verified */
  emailVerifiedDate?: Maybe<Scalars['String']['output']>;
  /** Features the user has access to. */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The date the user triggered the Right to be Forgotten process */
  forgottenOn?: Maybe<Scalars['String']['output']>;
  /** Date/Number/Currency formatting preferences of the user */
  formatPreferences?: Maybe<FormatPreferences>;
  fundingPartnerDivisions?: Maybe<FundingPartnerDivisionsUsersOffsetConnection>;
  /** Does the user have a password. New users and SSO users will not have passwords. */
  hasPassword: Scalars['Boolean']['output'];
  /** User UUID */
  id: Scalars['ID']['output'];
  /** Intercom User ID */
  intercomUserId?: Maybe<Scalars['String']['output']>;
  /** If the accounts is locked and requires a password reset before logging in. */
  isAccountLocked: Scalars['Boolean']['output'];
  /** Is the user connected to a Buyer Division. A user can be a Buyer and a Supplier! */
  isBuyer?: Maybe<Scalars['Boolean']['output']>;
  /** Is this user a C2FO employee */
  isC2FO?: Maybe<Scalars['Boolean']['output']>;
  /** Can the user make offer decisions? */
  isDecisionMaker?: Maybe<Scalars['Boolean']['output']>;
  /** If the accounts is locked and requires a manual unlocking by support to logging in. */
  isHardLocked: Scalars['Boolean']['output'];
  /** Is the DC we are in the same as the users 'source' DC. */
  isSource?: Maybe<Scalars['Boolean']['output']>;
  /** Is the user connected to a Supplier Division. A user can be a Buyer and a Supplier! */
  isSupplier?: Maybe<Scalars['Boolean']['output']>;
  isWCM: Scalars['Boolean']['output'];
  /** Timestamp of the last time the user logged in. */
  lastLogin?: Maybe<Scalars['String']['output']>;
  /** Where the lead came from. */
  leadSource?: Maybe<Scalars['String']['output']>;
  /** Login history for the user */
  loginHistory?: Maybe<Array<Maybe<LoginHistory>>>;
  /** Does the user need a password. */
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp of the last time they updated their password. */
  passwordUpdatedOnDate?: Maybe<Scalars['Boolean']['output']>;
  /** Personal Identifiable Information of the user. */
  personalInfo?: Maybe<PersonalInfo>;
  /** Registration and other info from C2FO. */
  registration?: Maybe<RegistrationInfo>;
  /** Roles the user belongs to. */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The datacenter where the user was first created. Usually via ESLAP file loads. */
  source: Scalars['String']['output'];
  /** Is the user readonly. Applies to supplier app only. */
  supplierReadOnly?: Maybe<Scalars['Boolean']['output']>;
  updated?: Maybe<Scalars['String']['output']>;
  /** Randomly generated UUID for the user. NOT auth service uuid. */
  uuid?: Maybe<Scalars['String']['output']>;
};


export type UserEarlyPayDivisionsArgs = {
  filter?: EarlyPayDivisionDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<EarlyPayDivisionSort>;
};


export type UserFundingPartnerDivisionsArgs = {
  filter?: FundingPartnerDivisionsUsersDeepFilter;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  paging?: OffsetPaging;
  sorting?: Array<FundingPartnerDivisionsUsersSort>;
};


export type UserLoginHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Order>;
};

export type UserAddress = {
  /** ISO-3166-2 country code. Supported values are TW, CN, FR, CA, MX, PT, TR, RU, US, IN, GB, AU, IT, DE, ES, NL */
  country: Scalars['String']['input'];
};

export type UserAddressInput = {
  /** This is the name of the locality. USA, Canda, etc. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Zip or postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserAuthTokenDetails = {
  __typename?: 'UserAuthTokenDetails';
  jwt?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Payload>;
};

export type UserInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdSource?: InputMaybe<Scalars['String']['input']>;
  formatPreferences?: InputMaybe<FormatPreferencesInput>;
  id: Scalars['ID']['input'];
  isDecisionMaker?: InputMaybe<Scalars['Boolean']['input']>;
  leadSource?: InputMaybe<Scalars['String']['input']>;
  personalInfo?: InputMaybe<PersonalInfoInput>;
  registration?: InputMaybe<RegistrationInfoInput>;
  supplierReadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type UserInputViaWcm = {
  /** User country code */
  country?: Scalars['String']['input'];
  /** User email address */
  emailAddress: Scalars['String']['input'];
  /** User first name */
  firstName: Scalars['String']['input'];
  /** Whether user has full version access in WCM */
  fullVersion?: Scalars['Boolean']['input'];
  /** User last name */
  lastName: Scalars['String']['input'];
  /** User locale */
  locale?: InputMaybe<Scalars['String']['input']>;
  /** Whether to onboard user to WCM */
  onboardToWcm?: Scalars['Boolean']['input'];
  /** User password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** User role */
  role?: Admin_User_Role;
};

export type UserLookupInSfResponse = {
  __typename?: 'UserLookupInSfResponse';
  message?: Maybe<Scalars['String']['output']>;
  sfInfo?: Maybe<RegistrationUserLookupOutput>;
  statusCode: Scalars['Float']['output'];
};

export type UserMutationResponse = MultiMutationResponse & {
  __typename?: 'UserMutationResponse';
  code: Scalars['String']['output'];
  errors?: Maybe<Array<Maybe<Error>>>;
  message: Scalars['String']['output'];
  nodes?: Maybe<Array<Maybe<User>>>;
  success: Scalars['Boolean']['output'];
};

export type UserSyncInput = {
  authServiceUuid?: InputMaybe<Scalars['ID']['input']>;
  c2foDbId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UserToken = {
  __typename?: 'UserToken';
  datacenters?: Maybe<Array<Scalars['String']['output']>>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasPassword?: Maybe<Scalars['Boolean']['output']>;
  isAccountLocked?: Maybe<Scalars['Boolean']['output']>;
  isSource?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  needsPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  sessionUuid?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type UserTreatment = {
  __typename?: 'UserTreatment';
  authServiceUuid: Scalars['String']['output'];
  treatment?: Maybe<Treatment>;
};

export type UsersResponse = MultiQueryResponse & {
  __typename?: 'UsersResponse';
  count?: Maybe<Scalars['Int']['output']>;
  errorCount?: Maybe<Scalars['Int']['output']>;
  errors?: Maybe<Array<Maybe<Error>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
};

export type ValidateUserExistanceInAppResponse = {
  __typename?: 'ValidateUserExistanceInAppResponse';
  /** Includes JSON email address/locale if successful or string 'error' if not */
  body?: Maybe<Scalars['String']['output']>;
  /** Status code to return with the response */
  statusCode: Scalars['Float']['output'];
};

export type Variable = {
  __typename?: 'Variable';
  mandatory: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  value?: Maybe<Scalars['String']['output']>;
};

export type Variance = {
  current?: InputMaybe<Scalars['String']['input']>;
  updated?: InputMaybe<Scalars['String']['input']>;
};

export type Wcm_Adherence_Kpi_By_Aggregator_Sort_Field =
  | 'BASELINE_EARLY_PAYMENTS_PCT'
  | 'BASELINE_PAYMENT_RUN_ADHERENCE_PCT'
  | 'BASELINE_WA_DTP_DAYS'
  | 'BASELINE_WA_EARLY_LATE_DAYS'
  | 'BASELINE_WA_TERMS_DAYS'
  | 'DELTA_AMOUNT_PAID_EARLY'
  | 'DELTA_EARLY_PAYMENTS_PCT'
  | 'DELTA_INVOICE_COUNT_NOT_PAID_ON_PAYMENT_RUN'
  | 'DELTA_PAYMENT_RUN_ADHERENCE_PCT'
  | 'DELTA_WA_DTP_DAYS'
  | 'DELTA_WA_EARLY_LATE_DAYS'
  | 'DELTA_WA_TERMS_DAYS'
  | 'INVOICE_COUNT'
  | 'SELECTED_EARLY_PAYMENTS_PCT'
  | 'SELECTED_PAYMENT_RUN_ADHERENCE_PCT'
  | 'SELECTED_WA_DTP_DAYS'
  | 'SELECTED_WA_EARLY_LATE_DAYS'
  | 'SELECTED_WA_TERMS_DAYS'
  | 'TOTAL_AMOUNT';

export type Wcm_Adherence_Kpi_By_Period_Sort_Field =
  | 'EARLY_PAYMENTS_PCT'
  | 'INVOICE_COUNT'
  | 'PAYMENT_RUN_ADHERENCE_PCT'
  | 'PERIOD'
  | 'TOTAL_AMOUNT'
  | 'WA_DTP_DAYS'
  | 'WA_EARLY_LATE_DAYS'
  | 'WA_TERMS_DAYS';

export type Wcm_Adherence_Kpi_Period_Granularity =
  | 'MONTH'
  | 'YEAR';

export type Wcm_Buyer_Region =
  | 'AMER'
  | 'APAC'
  | 'EMEA';

export type Wcm_Buyer_Type =
  | 'DEMO'
  | 'PAID'
  | 'TRIAL';

export type Wcm_Buyer_TypeFilterComparison = {
  eq?: InputMaybe<Wcm_Buyer_Type>;
  gt?: InputMaybe<Wcm_Buyer_Type>;
  gte?: InputMaybe<Wcm_Buyer_Type>;
  iLike?: InputMaybe<Wcm_Buyer_Type>;
  in?: InputMaybe<Array<Wcm_Buyer_Type>>;
  is?: InputMaybe<Scalars['Boolean']['input']>;
  isNot?: InputMaybe<Scalars['Boolean']['input']>;
  like?: InputMaybe<Wcm_Buyer_Type>;
  lt?: InputMaybe<Wcm_Buyer_Type>;
  lte?: InputMaybe<Wcm_Buyer_Type>;
  neq?: InputMaybe<Wcm_Buyer_Type>;
  notILike?: InputMaybe<Wcm_Buyer_Type>;
  notIn?: InputMaybe<Array<Wcm_Buyer_Type>>;
  notLike?: InputMaybe<Wcm_Buyer_Type>;
};

/** Canonical negotiation phases for monitoring charts */
export type Wcm_Canonical_Phase =
  | 'COMPLETED'
  | 'ERP_UPDATED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'UNSUCCESSFUL';

export type Wcm_Segment =
  | 'Core'
  | 'Strategic'
  | 'Tail';

export type Wcm_Suppliers_Order_Level =
  | 'ESTIMATED_OPPORTUNITY'
  | 'SPEND'
  | 'WORKING_CAPITAL_OPPORTUNITY';

/** Controls which suppliers are included: only in-scope, only excluded, or all */
export type Wcm_Supplier_Scope =
  | 'ALL'
  | 'EXCLUDED'
  | 'IN_SCOPE';

export type Wcm_User_Roles_For_Registration_Request =
  | 'ACCOUNTING'
  | 'BUYING_MANAGER'
  | 'CEO'
  | 'CFO'
  | 'CONTROLLER'
  | 'CPO'
  | 'FINANCE_DIRECTOR'
  | 'OFFICE_MANAGER'
  | 'OTHER'
  | 'PRESIDENT'
  | 'TREASURER';

export type Wcm_User_Self_Registration_Order_By =
  | 'CREATED'
  | 'UPDATED';

export type Wcm_User_Self_Registration_Request_Status =
  | 'APPROVED'
  | 'PENDING'
  | 'REJECTED';

export type Wco_Matrix_Bucket =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM';

export type Wco_Matrix_Tier =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM';

export type WcmAdherenceDynamicInvoiceFilters = {
  __typename?: 'WcmAdherenceDynamicInvoiceFilters';
  /** Custom-attribute facets keyed by attribute internal name; each holds its displayName and available values */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  /** Distinct naics_description (level 1) values still selectable given the other filter selections */
  industries: Array<Scalars['String']['output']>;
  /** Distinct naics_description (level 2) values still selectable given the other filter selections */
  industriesL2: Array<Scalars['String']['output']>;
  /** Distinct naics_description (level 3) values still selectable given the other filter selections */
  industriesL3: Array<Scalars['String']['output']>;
  /** Distinct negotiation-status values still selectable given the other filter selections. Empty string is the "No status" bucket. */
  negotiationStatus: Array<Scalars['String']['output']>;
  /** Distinct payment months (ISO first-of-month) with at least one paid invoice in scope */
  paymentMonths: Array<Scalars['String']['output']>;
  /** Distinct plan-wave {label, value} options still selectable given the other filter selections */
  planWaves: Array<WcmFilterOption>;
  /** Distinct plan {label, value} options still selectable given the other filter selections */
  plans: Array<WcmFilterOption>;
  /** Distinct regions derived from `supplierCountries` */
  region: Array<Scalars['String']['output']>;
  /** Distinct supplier_country values still selectable given the other filter selections */
  supplierCountries: Array<Scalars['String']['output']>;
  /** Distinct supplier_segment values still selectable given the other filter selections */
  supplierSegments: Array<Scalars['String']['output']>;
};

export type WcmAdherenceDynamicInvoiceFiltersInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters?: InputMaybe<WcmAdherenceInvoiceFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceInvoiceFiltersInput = {
  /** Baseline month (ISO, first of month) */
  baselineMonth?: InputMaybe<Scalars['String']['input']>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** NAICS description (level 1) */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 2) */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 3) */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation status values to filter by. Empty string is the "No status" bucket. */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Logical regions; expanded to country codes for buyer-api and derived back in output when `region` is requested */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Selected month (ISO, first of month) */
  selectedMonth?: InputMaybe<Scalars['String']['input']>;
  /** Supplier country codes (ISO) */
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier segments */
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WcmAdherenceKpiByAggregatorInput = {
  /** Group-by supplier dimensions (min: 1, max: 3). Each value is a WCM_AGGREGATOR_DIMENSION_MAP key or `custom_attribute_{N}`. */
  aggregators: Array<Scalars['String']['input']>;
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Adherence filters with required baseline/selected month */
  filters: WcmAdherenceKpisFiltersInput;
  /** Optional paging */
  paging?: InputMaybe<WcmAdherenceKpiByAggregatorPagingInput>;
  /** Optional sorting */
  sorting?: InputMaybe<WcmAdherenceKpiByAggregatorSortingInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpiByAggregatorMetricsValues = {
  __typename?: 'WcmAdherenceKpiByAggregatorMetricsValues';
  earlyPaymentsPct?: Maybe<Scalars['Float']['output']>;
  paymentRunAdherencePct?: Maybe<Scalars['Float']['output']>;
  waDtpDays?: Maybe<Scalars['Float']['output']>;
  waEarlyLateDays?: Maybe<Scalars['Float']['output']>;
  waTermsDays?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpiByAggregatorOutput = {
  __typename?: 'WcmAdherenceKpiByAggregatorOutput';
  rows: Array<WcmAdherenceKpiByAggregatorRow>;
  summary: WcmAdherenceKpiByAggregatorSummary;
  /** Pre-paging row count (leaf rows + rollup subtotals) */
  totalRows: Scalars['Int']['output'];
};

export type WcmAdherenceKpiByAggregatorPagingInput = {
  /** Page number (zero-indexed) */
  page?: Scalars['Int']['input'];
  /** Rows per page (max 100) */
  pageSize?: Scalars['Int']['input'];
};

export type WcmAdherenceKpiByAggregatorRow = {
  __typename?: 'WcmAdherenceKpiByAggregatorRow';
  /** true for rollup subtotal rows, false for leaf rows */
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  /** Variance-only (selected − baseline) of amount paid early; null when either month has no invoices */
  amountPaidEarlyVariance?: Maybe<Scalars['Float']['output']>;
  baseline?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  delta?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  /** Invoices in this group across both months */
  invoiceCount: Scalars['Int']['output'];
  /** Variance-only (selected − baseline) of invoice count not paid on the payment run; null when either month has no invoices */
  invoiceCountNotPaidOnPaymentRunVariance?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<WcmAdherenceKpiByAggregatorMetricsValues>;
  /** Sum of `amount` in this group across both months (file currency) */
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpiByAggregatorSortingInput = {
  /** Sort direction (default DESC) */
  direction?: Order_Type;
  /** Sortable column. One of 19 fields. */
  field: Wcm_Adherence_Kpi_By_Aggregator_Sort_Field;
};

export type WcmAdherenceKpiByAggregatorSummary = {
  __typename?: 'WcmAdherenceKpiByAggregatorSummary';
  baseline: WcmAdherenceSummaryTotals;
  selected: WcmAdherenceSummaryTotals;
};

export type WcmAdherenceKpiByPeriodInput = {
  /** Group-by supplier dimensions nested under the period (max: 3). Each value is a WCM_AGGREGATOR_DIMENSION_MAP key or `custom_attribute_{N}`. Omit/empty for a pure period view. */
  aggregators?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Adherence filters; baseline/selected months are optional (omit both for the full range) */
  filters: WcmAdherenceInvoiceFiltersInput;
  /** Time-bucket width for each row (default MONTH). */
  granularity?: InputMaybe<Wcm_Adherence_Kpi_Period_Granularity>;
  /** Optional paging */
  paging?: InputMaybe<WcmAdherenceKpiByAggregatorPagingInput>;
  /** Optional sorting */
  sorting?: InputMaybe<WcmAdherenceKpiByPeriodSortingInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpiByPeriodMetricsValues = {
  __typename?: 'WcmAdherenceKpiByPeriodMetricsValues';
  earlyPaymentsPct?: Maybe<Scalars['Float']['output']>;
  paymentRunAdherencePct?: Maybe<Scalars['Float']['output']>;
  waDtpDays?: Maybe<Scalars['Float']['output']>;
  waEarlyLateDays?: Maybe<Scalars['Float']['output']>;
  waTermsDays?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpiByPeriodOutput = {
  __typename?: 'WcmAdherenceKpiByPeriodOutput';
  rows: Array<WcmAdherenceKpiByPeriodRow>;
  /** Range-wide scope totals over the visible period range (vendor count + net payment amount). */
  summary: WcmAdherenceSummaryTotals;
  /** Pre-paging count of `(period, group)` rows */
  totalRows: Scalars['Int']['output'];
};

export type WcmAdherenceKpiByPeriodRow = {
  __typename?: 'WcmAdherenceKpiByPeriodRow';
  /** true for rollup subtotal ("Total") rows, false for leaf rows */
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  /** Invoices paid in this period for this group */
  invoiceCount: Scalars['Int']['output'];
  metrics: WcmAdherenceKpiByPeriodMetricsValues;
  /** Period start (ISO date, first of the bucket) */
  period: Scalars['String']['output'];
  /** Sum of `amount` paid in this period for this group (file currency) */
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpiByPeriodSortingInput = {
  /** Sort direction (default DESC) */
  direction?: Order_Type;
  /** Sortable column. One of 8 fields (default PERIOD). */
  field?: Wcm_Adherence_Kpi_By_Period_Sort_Field;
};

export type WcmAdherenceKpiMetricTriple = {
  __typename?: 'WcmAdherenceKpiMetricTriple';
  baseline?: Maybe<Scalars['Float']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
  selected?: Maybe<Scalars['Float']['output']>;
};

export type WcmAdherenceKpis = {
  __typename?: 'WcmAdherenceKpis';
  baselineInvoiceCount: Scalars['Int']['output'];
  baselineMonth: Scalars['String']['output'];
  baselineTotalAmount: Scalars['Float']['output'];
  metrics: WcmAdherenceKpisMetrics;
  selectedInvoiceCount: Scalars['Int']['output'];
  selectedMonth: Scalars['String']['output'];
  selectedTotalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceKpisFiltersInput = {
  /** Baseline month (ISO, first of month) */
  baselineMonth: Scalars['String']['input'];
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** NAICS description (level 1) */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 2) */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS description (level 3) */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation status values to filter by. Empty string is the "No status" bucket. */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Logical regions; expanded to country codes for buyer-api and derived back in output when `region` is requested */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Selected month (ISO, first of month) */
  selectedMonth: Scalars['String']['input'];
  /** Supplier country codes (ISO) */
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier segments */
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WcmAdherenceKpisInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters: WcmAdherenceKpisFiltersInput;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAdherenceKpisMetrics = {
  __typename?: 'WcmAdherenceKpisMetrics';
  earlyPaymentsPct: WcmAdherenceKpiMetricTriple;
  paymentRunAdherencePct: WcmAdherenceKpiMetricTriple;
  waDtpDays: WcmAdherenceKpiMetricTriple;
  waEarlyLateDays: WcmAdherenceKpiMetricTriple;
  waTermsDays: WcmAdherenceKpiMetricTriple;
};

export type WcmAdherenceSeriesMetricsValues = {
  __typename?: 'WcmAdherenceSeriesMetricsValues';
  earlyPaymentsPct: Scalars['Float']['output'];
  paymentRunAdherencePct: Scalars['Float']['output'];
  waDtpDays: Scalars['Float']['output'];
  waEarlyLateDays: Scalars['Float']['output'];
  waTermsDays: Scalars['Float']['output'];
};

export type WcmAdherenceSeriesPoint = {
  __typename?: 'WcmAdherenceSeriesPoint';
  invoiceCount: Scalars['Int']['output'];
  /** Null when no payments in the month */
  metrics?: Maybe<WcmAdherenceSeriesMetricsValues>;
  month: Scalars['String']['output'];
  /** Rolling 3-month average (null if this month has no data) */
  rolling3?: Maybe<WcmAdherenceSeriesMetricsValues>;
  /** Rolling 6-month average (null if this month has no data) */
  rolling6?: Maybe<WcmAdherenceSeriesMetricsValues>;
  totalAmount: Scalars['Float']['output'];
};

export type WcmAdherenceSeriesWindow = {
  __typename?: 'WcmAdherenceSeriesWindow';
  /** Latest paid_date among invoices matching filters */
  latestPaidDate: Scalars['String']['output'];
  /** Last month in the 12-bucket series (UTC, first of month) */
  seriesEndMonth: Scalars['String']['output'];
  /** First month in the 12-bucket series (UTC, first of month) */
  seriesStartMonth: Scalars['String']['output'];
};

export type WcmAdherenceSummaryTotals = {
  __typename?: 'WcmAdherenceSummaryTotals';
  /** Sum of `amount` paid in scope (file currency) */
  netPaymentAmount: Scalars['Float']['output'];
  /** Distinct suppliers (vendor entities) with paid invoices in scope */
  vendorCount: Scalars['Int']['output'];
};

export type WcmAdherenceTrend = {
  __typename?: 'WcmAdherenceTrend';
  /** Exactly 12 buckets, newest month first */
  points: Array<WcmAdherenceSeriesPoint>;
  window: WcmAdherenceSeriesWindow;
};

export type WcmAdherenceTrendInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  filters?: InputMaybe<WcmAdherenceInvoiceFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAggregatedSpends = {
  __typename?: 'WcmAggregatedSpends';
  aggregated: Scalars['Boolean']['output'];
  aggregator1: Scalars['String']['output'];
  aggregator1Code?: Maybe<Scalars['String']['output']>;
  aggregator2?: Maybe<Scalars['String']['output']>;
  aggregator2Code?: Maybe<Scalars['String']['output']>;
  aggregator3?: Maybe<Scalars['String']['output']>;
  aggregator3Code?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  changeInTerms: Scalars['Float']['output'];
  estimatedBenchmarkTerms: Scalars['Float']['output'];
  estimatedChangeInTerms: Scalars['Float']['output'];
  estimatedWco: Scalars['Float']['output'];
  existingTerms: Scalars['Float']['output'];
  harmonizationBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  harmonizationWco?: Maybe<Scalars['Float']['output']>;
  industryCountry75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry75Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry85Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry90Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry95Wco?: Maybe<Scalars['Float']['output']>;
  industryCountry99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountry99Wco?: Maybe<Scalars['Float']['output']>;
  industryCountryMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountryMaxWco?: Maybe<Scalars['Float']['output']>;
  industryCountryMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryCountryMedianWco?: Maybe<Scalars['Float']['output']>;
  industryGlobal75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal75Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal85Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal90Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal95Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobal99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobal99Wco?: Maybe<Scalars['Float']['output']>;
  industryGlobalMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobalMaxWco?: Maybe<Scalars['Float']['output']>;
  industryGlobalMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  industryGlobalMedianWco?: Maybe<Scalars['Float']['output']>;
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  percentageEstimatedWco: Scalars['Float']['output'];
  percentageSpend: Scalars['Float']['output'];
  percentageWco: Scalars['Float']['output'];
  realisedOpportunity: Scalars['Float']['output'];
  spend: Scalars['Float']['output'];
  statusBreakdown?: Maybe<Array<WcmStatusBreakdownEntry>>;
  supplierEntities: Scalars['Float']['output'];
  supplierGroups: Scalars['Float']['output'];
  updatedOpportunity: Scalars['Float']['output'];
  wco: Scalars['Float']['output'];
};

export type WcmAggregatedSpendsFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  regionsList?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmAggregatedSpendsPaging = {
  pageNum?: Scalars['Int']['input'];
  pageSize?: Scalars['Int']['input'];
};

export type WcmAllUserFileLogs = {
  __typename?: 'WcmAllUserFileLogs';
  /** Buyer Name */
  buyerName: Scalars['String']['output'];
  /** Created Date and Time */
  created: Scalars['String']['output'];
  /** File name */
  fileName: Scalars['String']['output'];
  /** File Uuid */
  fileUuid: Scalars['String']['output'];
  /** WCM buyer uuid */
  status: Scalars['String']['output'];
  /** User Email */
  userEmail: Scalars['String']['output'];
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmAttributeUpdateItem = {
  /** Internal name of the custom attribute */
  internalName: Scalars['String']['input'];
  /** Value ID to assign/update. Use null to unassign/remove the attribute. */
  valueId?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmBenchmarkConfigOutput = {
  __typename?: 'WcmBenchmarkConfigOutput';
  /** Apply terms harmonization in benchmarking */
  applyTermsHarmonization: Scalars['Boolean']['output'];
  /** Available benchmarking version dates (YYYY-MM-DD) */
  availableBenchmarkVersionDates: Array<Scalars['String']['output']>;
  bankingDays: Scalars['Float']['output'];
  /** Benchmarking version calendar date (YYYY-MM-DD) */
  benchmarkingVersionDate?: Maybe<Scalars['String']['output']>;
  buyerUuid: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  /** Enable country-specific regulatory term limits */
  goodPracticeAdjustment: Scalars['Boolean']['output'];
  /** Maximum allowable payment-term days (1–365) */
  maxTermDays: Scalars['Int']['output'];
  /** Day increment for suppliers without NAICS (15, 30, 45, or 60) */
  noNaicsTermsIncrement: Scalars['Int']['output'];
  /** Maximum payment-term days for PACA-related suppliers (1–365) */
  pacaMaxTermDays: Scalars['Int']['output'];
  /** Total days in the spend period */
  spendPeriodDays: Scalars['Int']['output'];
  spendPeriodEndMonth?: Maybe<Scalars['DateTime']['output']>;
  spendPeriodMonths: Scalars['Float']['output'];
  spendPeriodStartMonth?: Maybe<Scalars['DateTime']['output']>;
  targetTermRoundingDays: Scalars['Float']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  waccPercentage?: Maybe<Scalars['Float']['output']>;
};

export type WcmBenchmarkCountryRegulationItem = {
  __typename?: 'WcmBenchmarkCountryRegulationItem';
  /** Country code (ISO2) */
  countryCode: Scalars['String']['output'];
  /** Country name */
  countryName?: Maybe<Scalars['String']['output']>;
  /** Default max terms from regulated_country_terms */
  defaultMaxTerms?: Maybe<Scalars['Int']['output']>;
  /** Whether the country has regulatory term limits */
  isRegulated: Scalars['Boolean']['output'];
  /** Override max terms for this country */
  maxTerms?: Maybe<Scalars['Int']['output']>;
};

export type WcmBenchmarkCountryRegulationsOutput = {
  __typename?: 'WcmBenchmarkCountryRegulationsOutput';
  /** List of country regulations */
  regulations: Array<WcmBenchmarkCountryRegulationItem>;
};

export type WcmBenchmarkStrategyBySegmentInput = {
  Core: Benchmarking_Strategies;
  Strategic: Benchmarking_Strategies;
  Tail: Benchmarking_Strategies;
};

export type WcmBenchmarkStrategyBySegmentOutput = {
  __typename?: 'WcmBenchmarkStrategyBySegmentOutput';
  Core: Benchmarking_Strategies;
  Strategic: Benchmarking_Strategies;
  Tail: Benchmarking_Strategies;
  applyTermsHarmonization: Scalars['Boolean']['output'];
};

export type WcmBenchmarkingStrategies = {
  __typename?: 'WcmBenchmarkingStrategies';
  benchmarkTerms: Scalars['Float']['output'];
  custom: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  waHarmonization: Scalars['Float']['output'];
};

export type WcmBuyerData = {
  __typename?: 'WcmBuyerData';
  /** Wcm Buyer Permissions */
  permissions: Array<Scalars['String']['output']>;
  /** Wcm Buyer Name */
  wcmBuyerName: Scalars['String']['output'];
  /** WCM Buyer Type */
  wcmBuyerType: Wcm_Buyer_Type;
  /** Wcm Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerExclusionRemark = {
  __typename?: 'WcmBuyerExclusionRemark';
  id: Scalars['Int']['output'];
  remark: Scalars['String']['output'];
};

export type WcmBuyerExclusionRemarkOutput = {
  __typename?: 'WcmBuyerExclusionRemarkOutput';
  status: Scalars['Boolean']['output'];
};

export type WcmBuyerFileStatus = {
  __typename?: 'WcmBuyerFileStatus';
  isWorkingCapitalInsightsReady: Scalars['Boolean']['output'];
  spendFile: WcmBuyerSpendFileStatus;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerMetaDataInput = {
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmBuyerMetaDataOutput = {
  __typename?: 'WcmBuyerMetaDataOutput';
  /** report currencies */
  reportCurrencies: Array<Scalars['String']['output']>;
};

export type WcmBuyerSpendFileStatus = {
  __typename?: 'WcmBuyerSpendFileStatus';
  daysSinceUpload?: Maybe<Scalars['Int']['output']>;
  uploaded: Scalars['Boolean']['output'];
};

export type WcmBuyerUser = {
  __typename?: 'WcmBuyerUser';
  buyerUserMappingId: Scalars['Int']['output'];
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  isC2FO: Scalars['Boolean']['output'];
  isPermissionManager: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roles: Array<WcmUserRolesInfo>;
  userUuid: Scalars['String']['output'];
};

export type WcmBuyerUserAccessInput = {
  /** Allows external users to access DEMO type buyers. Not required for internal C2FO users as they have access if mapping exists regardless of buyer type. */
  allowDemoAccessForExternalUsers?: Scalars['Boolean']['input'];
  /** Allows external users to access Trial type buyers. Not required for internal C2FO users as they have access if mapping exists regardless of buyer type. */
  allowTrialAccessForExternalUsers?: Scalars['Boolean']['input'];
  /** User UUID */
  userUuid: Scalars['String']['input'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmBuyerUserAccessOutput = {
  __typename?: 'WcmBuyerUserAccessOutput';
  /** Access validation status */
  status: Scalars['Boolean']['output'];
};

export type WcmBuyerUserDetailsForAdmin = {
  __typename?: 'WcmBuyerUserDetailsForAdmin';
  buyerUserMappingId: Scalars['Int']['output'];
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  isC2FO: Scalars['Boolean']['output'];
  isPermissionManager: Scalars['Boolean']['output'];
  /** User last login date */
  lastLogin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  roles: Array<WcmUserRolesInfo>;
  userUuid: Scalars['String']['output'];
  wcmBuyers: Array<WcmUserBuyer>;
};

export type WcmBuyerUserMappingOutput = {
  __typename?: 'WcmBuyerUserMappingOutput';
  userUuid: Scalars['String']['output'];
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerUsersCountOutput = {
  __typename?: 'WcmBuyerUsersCountOutput';
  /** Count of distinct C2FO users mapped to this buyer */
  c2foUserCount: Scalars['Int']['output'];
  /** Count of distinct non-C2FO users mapped to this buyer */
  nonC2foUserCount: Scalars['Int']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmBuyerUsersDetailsPaging = {
  pageNum?: Scalars['Int']['input'];
};

export type WcmCashflowDistributionInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmCashflowDistributionOutput = {
  __typename?: 'WcmCashflowDistributionOutput';
  /** alpha 2 code of top spend country of supplier */
  alpha2Code: Scalars['String']['output'];
  /** alpha 3 code of top spend country of supplier */
  alpha3Code: Scalars['String']['output'];
  /** cashflow spend amount */
  cashflow: Scalars['Float']['output'];
  /** top spend country of supplier */
  countryName: Scalars['String']['output'];
  /** estimated working capital opportunity */
  estimatedWco: Scalars['Float']['output'];
  /** region of supplier */
  region: Wcm_Buyer_Region;
  /** Segemnt category of spend data */
  segment: Wcm_Segment;
};

export type WcmCountryAggregatedValue = {
  __typename?: 'WcmCountryAggregatedValue';
  /** Aggregated values for this country */
  aggregatedValues: WcmSuppliersGroupAggregatedValue;
  /** Country code (e.g., US, CA, MX) */
  country: Scalars['String']['output'];
};

export type WcmCountryRegulationItemInput = {
  /** Country code (ISO2 or ISO3) */
  countryCode: Scalars['String']['input'];
  /** Whether the country has regulatory term limits */
  isRegulated: Scalars['Boolean']['input'];
  /** Override max terms for this country */
  maxTerms?: InputMaybe<Scalars['Int']['input']>;
};

export type WcmCreatePlanInput = {
  /** Plan end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Currency */
  fileCurrency: Scalars['String']['input'];
  /** Plan name */
  name: Scalars['String']['input'];
  /** Owner of the plan */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Plan start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmCumulativeBucket = {
  __typename?: 'WcmCumulativeBucket';
  /** Bucket start date (ISO format) */
  bucketStart: Scalars['String']['output'];
  /** Cumulative status entries for COMPLETED/ERP_UPDATED phases */
  statuses: Array<WcmCumulativeStatusEntry>;
  /** Target WCO at this bucket (null when non-plan/wave filters applied) */
  targetWco?: Maybe<Scalars['Float']['output']>;
};

export type WcmCumulativeStatusEntry = {
  __typename?: 'WcmCumulativeStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Cumulative supplier entity count that ever reached this status */
  cumSupplierEntities: Scalars['Int']['output'];
  /** Cumulative WCO for supplier entities that ever reached this status */
  cumWco: Scalars['Float']['output'];
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
};

export type WcmCustomAttributeDefinitionResponse = {
  __typename?: 'WcmCustomAttributeDefinitionResponse';
  /** ISO 4217 currency code (3 letters) */
  currency: Scalars['String']['output'];
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute (snake_case) */
  internalName: Scalars['String']['output'];
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmCustomAttributeResponse = {
  __typename?: 'WcmCustomAttributeResponse';
  /** Attribute definition ID */
  attributeId: Scalars['Int']['output'];
  /** Display name of the custom attribute for UI purposes */
  displayName: Scalars['String']['output'];
  /** Internal name of the custom attribute (snake_case) */
  internalName: Scalars['String']['output'];
  /** Array of value objects with usage counts */
  values: Array<CustomAttributeValueDto>;
};

export type WcmDeleteDomainBuyerMappingsInput = {
  /** Array of buyer UUIDs to remove from the domain */
  buyerUuids: Array<Scalars['String']['input']>;
  /** Domain name */
  domain: Scalars['String']['input'];
};

export type WcmDomainClientConfig = {
  __typename?: 'WcmDomainClientConfig';
  logoUrl?: Maybe<Scalars['String']['output']>;
  showAccountSettings: Scalars['Boolean']['output'];
  showAllRightsReserved: Scalars['Boolean']['output'];
  showBuyerApp: Scalars['Boolean']['output'];
  showC2FOChatbot: Scalars['Boolean']['output'];
  showC2FOLogo: Scalars['Boolean']['output'];
  showNavigator: Scalars['Boolean']['output'];
  showPoweredByC2FO: Scalars['Boolean']['output'];
  showPrivacyPolicy: Scalars['Boolean']['output'];
  showSubProcessors: Scalars['Boolean']['output'];
  showSupplierAgreement: Scalars['Boolean']['output'];
  showViewAsSupplier: Scalars['Boolean']['output'];
  /** Theme identifier to use for this domain */
  uiThemeName: Scalars['String']['output'];
};

export type WcmDomainClientConfigInput = {
  /** Custom logo URL to display */
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show Account Settings */
  showAccountSettings?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show "All Rights Reserved" text */
  showAllRightsReserved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Buyer App link */
  showBuyerApp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show C2FO chatbot */
  showC2FOChatbot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show C2FO logo */
  showC2FOLogo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Navigator link */
  showNavigator?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show "Powered by C2FO" text */
  showPoweredByC2FO?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Privacy Policy link */
  showPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Subprocessors link */
  showSubProcessors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show Supplier Agreement link */
  showSupplierAgreement?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show View as Supplier option */
  showViewAsSupplier?: InputMaybe<Scalars['Boolean']['input']>;
  /** Theme identifier to use for this domain (e.g., EY, PWC, DEFAULT) */
  uiThemeName?: InputMaybe<Scalars['String']['input']>;
};

export type WcmDomainClientConfigOutput = {
  __typename?: 'WcmDomainClientConfigOutput';
  /** List of allowed buyer UUIDs (only for SOME access type) */
  allowedBuyerUuids?: Maybe<Array<Scalars['String']['output']>>;
  /** Buyer access type (ALL, SOME, or NONE) */
  buyerAccessType: Scalars['String']['output'];
  /** Client-specific configuration settings */
  clientConfig: Scalars['JSONObject']['output'];
};

export type WcmDomainConfigResponse = {
  __typename?: 'WcmDomainConfigResponse';
  /** Operation status */
  status: Scalars['Boolean']['output'];
};

export type WcmEconomicValueConfigOutput = {
  __typename?: 'WcmEconomicValueConfigOutput';
  economicValue: Scalars['Float']['output'];
};

export type WcmEnrichedFileUploadHistory = {
  __typename?: 'WcmEnrichedFileUploadHistory';
  created: Scalars['String']['output'];
  fileCurrency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionUuid: Scalars['String']['output'];
  uploadedBy: Scalars['String']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
  wcmBuyerName?: Maybe<Scalars['String']['output']>;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumnField = {
  __typename?: 'WcmEnrichedSpendUpdatableColumnField';
  /** Description shown alongside the field. */
  description: Scalars['String']['output'];
  /** Unique key for the field */
  key: Scalars['String']['output'];
  /** Display label for the field. */
  label: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumnGroup = {
  __typename?: 'WcmEnrichedSpendUpdatableColumnGroup';
  /** Whether the group is pre-selected on first render. */
  defaultSelected: Scalars['Boolean']['output'];
  /** Fields belonging to this group. */
  fields: Array<WcmEnrichedSpendUpdatableColumnField>;
  /** Group identifier. */
  id: Scalars['String']['output'];
  /** Display name of the group. */
  name: Scalars['String']['output'];
};

export type WcmEnrichedSpendUpdatableColumns = {
  __typename?: 'WcmEnrichedSpendUpdatableColumns';
  /** Grouped updatable columns for the column-scoped update flow. */
  groups: Array<WcmEnrichedSpendUpdatableColumnGroup>;
  /** Identity / audit columns shown for transparency only — never updatable. */
  locked: Array<WcmEnrichedSpendUpdatableColumnField>;
};

export type WcmExclusionCriteria = {
  __typename?: 'WcmExclusionCriteria';
  /** exclusion criteria of supplier */
  exclusionCriteria: Scalars['String']['output'];
  /** exclusion remark of supplier */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  /** spend amount */
  spend: Scalars['Float']['output'];
  /** number of suppliers */
  supplierCount: Scalars['Float']['output'];
  /** Number of suppliers entities */
  supplierEntitiesCount: Scalars['Float']['output'];
  /** WA Current Terms */
  waCurrentTerms: Scalars['Float']['output'];
  /** Working Capital Opportunity */
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmExclusionCriteriaInput = {
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmExclusionCriteriaOutput = {
  __typename?: 'WcmExclusionCriteriaOutput';
  buyerExclusionCriterias: Array<WcmExclusionCriteria>;
  /** Economic Value Config */
  economicValueConfig: Scalars['Float']['output'];
  exclusionCriterias: Array<WcmExclusionCriteria>;
  /** Total Spend */
  totalSpend: Scalars['Float']['output'];
  /** Total Number of suppliers entities */
  totalSupplierEntitiesCount: Scalars['Float']['output'];
  /** Total Number of suppliers groups */
  totalSupplierGroupsCount: Scalars['Float']['output'];
  /** Total WA Current Terms */
  totalWaCurrentTerms: Scalars['Float']['output'];
};

export type WcmExclusionsConfigOutput = {
  __typename?: 'WcmExclusionsConfigOutput';
  /** Exclude suppliers with discounted payment terms */
  discountTermExclusion: Scalars['Boolean']['output'];
  /** Exclude diverse suppliers */
  diverseSupplierExclusion: Scalars['Boolean']['output'];
  /** Minimum spend value threshold for supplier groups */
  minSpendValue: Scalars['Float']['output'];
  /** Exclude suppliers with missing payment terms */
  missingTermExclusion: Scalars['Boolean']['output'];
};

export type WcmFetchAllSupplierGroups = {
  __typename?: 'WcmFetchAllSupplierGroups';
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: Maybe<Scalars['String']['output']>;
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes for the supplier group from the supplier with highest spend (spend rank 1). Object with internal attribute names as keys and objects containing displayName and value as values. */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  estimatedTerms: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Exclusion Remark */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  groupBenchmarkStrategies?: Maybe<Array<Scalars['String']['output']>>;
  groupCategories?: Maybe<Array<Scalars['String']['output']>>;
  groupContractualTermsDescriptions?: Maybe<Array<Scalars['String']['output']>>;
  groupRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** Enriched Supplier File Data ID */
  ids: Array<Scalars['Float']['output']>;
  includeReason: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  /** Indicates if supplier group has discounted terms */
  isDiscountedTerms?: Maybe<Scalars['Boolean']['output']>;
  isDiverseSupplier?: Maybe<Scalars['String']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  negotiationStatus?: Maybe<Array<Scalars['String']['output']>>;
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierGroup: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  vendorId?: Maybe<Scalars['String']['output']>;
  vendorMasterId: Scalars['String']['output'];
  /** Enriched Supplier Variant ID */
  vendorVariantIds: Array<Scalars['String']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllSupplierGroupsFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmFetchAllSupplierGroupsInput = {
  filters: WcmFetchAllSupplierGroupsFilters;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  paging: BuyerAppFetchAllSuppliersPaging;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<WcmFetchAllSupplierGroupsSorting>;
  /** Wave ID to filter suppliers by plan */
  waveId?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmFetchAllSupplierGroupsOutput = {
  __typename?: 'WcmFetchAllSupplierGroupsOutput';
  coreSupplierGroupCount: Scalars['Float']['output'];
  strategicSupplierGroupCount: Scalars['Float']['output'];
  supplierGroups: Array<WcmFetchAllSupplierGroups>;
  tailSupplierGroupCount: Scalars['Float']['output'];
  totalAnnualSpend: Scalars['Float']['output'];
  totalEstimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  totalSupplierGroups: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllSupplierGroupsSorting = {
  /** Field on which sorting is to be carried out (supports WCM_SUPPLIERS_ORDER_LEVEL or custom_attribute_N) */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type WcmFetchAllSuppliersFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  displayCurrency: Scalars['String']['input'];
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Level 6 Supplier Industries */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 2 Supplier Industries */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Level 3 Supplier Industries */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  naicsCodes?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary Supplier Categories */
  vendorCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Supplier Categories */
  vendorCategoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Supplier Categories */
  vendorCategoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmFetchAllSuppliersInput = {
  filters: WcmFetchAllSuppliersFilters;
  paging: BuyerAppFetchAllSuppliersPaging;
  sorting?: InputMaybe<WcmFetchAllSuppliersSorting>;
};

export type WcmFetchAllSuppliersSorting = {
  /** Field on which sorting is to be carried out (supports WCM_SUPPLIERS_ORDER_LEVEL or custom_attribute_N) */
  orderLevel: Scalars['String']['input'];
  orderType?: Order_Type;
};

export type WcmFetchAllWcmSuppliers = {
  __typename?: 'WcmFetchAllWcmSuppliers';
  /** Additional Exclusion Remark */
  additionalExclusionRemark?: Maybe<Scalars['String']['output']>;
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  bargainingPower: Scalars['String']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes for the supplier. Object with internal attribute names as keys and objects containing displayName and value as values. */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  estimatedTerms: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Exclusion Remark */
  exclusionRemark?: Maybe<Scalars['String']['output']>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  includeReason: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  /** Indicates if supplier has discounted terms */
  isDiscountedTerms?: Maybe<Scalars['Boolean']['output']>;
  isDiverseSupplier?: Maybe<Scalars['String']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  negotiationStatus?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierId?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmFetchAllWcmSuppliersOutput = {
  __typename?: 'WcmFetchAllWcmSuppliersOutput';
  coreSupplierEntitiesCount: Scalars['Float']['output'];
  maxAnnualSpend?: Maybe<Scalars['Float']['output']>;
  maxCurrentTerms?: Maybe<Scalars['Float']['output']>;
  minAnnualSpend?: Maybe<Scalars['Float']['output']>;
  minCurrentTerms?: Maybe<Scalars['Float']['output']>;
  strategicSupplierEntitiesCount: Scalars['Float']['output'];
  suppliers: Array<WcmFetchAllWcmSuppliers>;
  tailSupplierEntitiesCount: Scalars['Float']['output'];
  totalAnnualSpend?: Maybe<Scalars['Float']['output']>;
  totalEstimatedWorkingCapitalOpportunity?: Maybe<Scalars['Float']['output']>;
  totalSuppliers: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity?: Maybe<Scalars['Float']['output']>;
};

export type WcmFetchEnrichedFileUploadHistoryInput = {
  /** File Currency */
  fileCurrency: Scalars['String']['input'];
  /** WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmFetchInvoiceFileUploadHistoryInput = {
  fileCurrency: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmFilterOption = {
  __typename?: 'WcmFilterOption';
  /** Display label */
  label: Scalars['String']['output'];
  /** Filter value (stringified ID, empty string for NA) */
  value: Scalars['String']['output'];
};

export type WcmGenerateWorkingCapitalFilters = {
  displayCurrency: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  spendValue?: InputMaybe<WcmWorkingCapitalFilters>;
  supplierCount?: InputMaybe<Scalars['Float']['input']>;
  term?: InputMaybe<WcmWorkingCapitalFilters>;
  wcmBuyerUuid: Scalars['String']['input'];
  workingCapitalRequirement: Scalars['Float']['input'];
};

export type WcmGenerateWorkingCapitalGroupsOutput = {
  __typename?: 'WcmGenerateWorkingCapitalGroupsOutput';
  supplierGroups: Array<WcmGenerateWorkingCapitalSupplierGroup>;
  totalRows: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalInput = {
  filters: WcmGenerateWorkingCapitalFilters;
  paging: BuyerAppFetchAllSuppliersPaging;
  sorting?: InputMaybe<WcmGenerateWorkingCapitalSorting>;
};

export type WcmGenerateWorkingCapitalOutput = {
  __typename?: 'WcmGenerateWorkingCapitalOutput';
  suppliers: Array<WcmGenerateWorkingCapitalSupplier>;
  totalRows: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalSorting = {
  /** Field on which sorting is to be carried out */
  orderLevel: Wcm_Suppliers_Order_Level;
  orderType?: Order_Type;
};

export type WcmGenerateWorkingCapitalSupplier = {
  __typename?: 'WcmGenerateWorkingCapitalSupplier';
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  bargainingPower: Scalars['String']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  industry: Scalars['String']['output'];
  region: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  supplierName: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory: Scalars['String']['output'];
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGenerateWorkingCapitalSupplierGroup = {
  __typename?: 'WcmGenerateWorkingCapitalSupplierGroup';
  alpha3Code?: Maybe<Scalars['String']['output']>;
  annualSpend: Scalars['Float']['output'];
  benchmarkStrategy?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  groupRegions?: Maybe<Array<Scalars['String']['output']>>;
  /** Enriched Supplier File Data IDs */
  ids: Array<Scalars['Float']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  supplierGroup: Scalars['String']['output'];
  supplierType?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmGetNaicsExclusionsInput = {
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGetNaicsSuggestionsInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  supplierName: Scalars['String']['input'];
  supplierUuid: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type WcmGetNaicsSuggestionsOutput = {
  __typename?: 'WcmGetNaicsSuggestionsOutput';
  /** Indicates if the NAICS code is excluded for this buyer */
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  /** Naics code */
  naicsCode: Scalars['Float']['output'];
  /** Naics description */
  naicsDescription: Scalars['String']['output'];
};

export type WcmGroupedWorkingCapitalOpportunityByDimensionFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dimension on which data is grouped by (enum value or custom_attribute_N) */
  groupBy: Scalars['String']['input'];
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmGroupedWorkingCapitalOpportunityByDimensionOutput = {
  __typename?: 'WcmGroupedWorkingCapitalOpportunityByDimensionOutput';
  coreEstimatedWCO: Scalars['Float']['output'];
  coreWCO: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  labelCode: Scalars['String']['output'];
  strategicEstimatedWCO: Scalars['Float']['output'];
  strategicWCO: Scalars['Float']['output'];
  tailEstimatedWCO: Scalars['Float']['output'];
  tailWCO: Scalars['Float']['output'];
};

/** A WCM Insights conversation */
export type WcmInsightsConversationDto = {
  __typename?: 'WcmInsightsConversationDto';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  messageCount: Scalars['Float']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Input for listing conversations */
export type WcmInsightsConversationsInputDto = {
  /** Max number of conversations to return */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Input for deleting a conversation */
export type WcmInsightsDeleteConversationInputDto = {
  /** The conversation ID to delete */
  conversationId: Scalars['String']['input'];
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Result of deleting a conversation */
export type WcmInsightsDeleteResultDto = {
  __typename?: 'WcmInsightsDeleteResultDto';
  success: Scalars['Boolean']['output'];
};

/** Input for submitting feedback on an assistant message */
export type WcmInsightsFeedbackInputDto = {
  /** Optional comment with the feedback */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The message ID to provide feedback for */
  messageId: Scalars['String']['input'];
  /** Feedback rating */
  rating: WcmInsightsFeedbackRating;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Rating for WCM Insights assistant messages */
export type WcmInsightsFeedbackRating =
  | 'NEGATIVE'
  | 'POSITIVE';

/** Result of submitting feedback */
export type WcmInsightsFeedbackResultDto = {
  __typename?: 'WcmInsightsFeedbackResultDto';
  id: Scalars['ID']['output'];
  rating: WcmInsightsFeedbackRating;
  success: Scalars['Boolean']['output'];
};

/** A message within a WCM Insights conversation */
export type WcmInsightsMessageDto = {
  __typename?: 'WcmInsightsMessageDto';
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  role: Scalars['String']['output'];
};

/** Input for getting messages in a conversation */
export type WcmInsightsMessagesInputDto = {
  /** The conversation ID */
  conversationId: Scalars['String']['input'];
  /** Max number of messages to return */
  limit?: InputMaybe<Scalars['Float']['input']>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars['Float']['input']>;
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Input for querying WCM Insights via GraphQL */
export type WcmInsightsQueryInputDto = {
  /** Optional conversation ID to continue */
  conversationId?: InputMaybe<Scalars['String']['input']>;
  /** ISO 4217 currency code to scope data (e.g. USD, EUR). If omitted, the latest upload across all currencies is used. */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The user question or prompt */
  question: Scalars['String']['input'];
  /** The WCM buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

/** Result of a WCM Insights query via GraphQL */
export type WcmInsightsQueryResultDto = {
  __typename?: 'WcmInsightsQueryResultDto';
  /** The LLM answer */
  answer: Scalars['String']['output'];
  /** The conversation ID */
  conversationId: Scalars['String']['output'];
  inputTokens: Scalars['Float']['output'];
  latencyMs: Scalars['Float']['output'];
  outputTokens: Scalars['Float']['output'];
};

export type WcmInvoiceFileUploadHistory = {
  __typename?: 'WcmInvoiceFileUploadHistory';
  created: Scalars['String']['output'];
  fileCurrency: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  transactionUuid: Scalars['String']['output'];
  uploadBatchId: Scalars['Int']['output'];
  uploadedByName?: Maybe<Scalars['String']['output']>;
  wcmBuyerName?: Maybe<Scalars['String']['output']>;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmMasterBuyerList = {
  __typename?: 'WcmMasterBuyerList';
  /** WCM buyer created date */
  created: Scalars['DateTime']['output'];
  /** WCM buyer data center */
  dataCenter: Scalars['String']['output'];
  /** WCM buyer type */
  type: Wcm_Buyer_Type;
  /** WCM buyer name */
  wcmBuyerName: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmMasterBuyerListDeleteFilter = {
  and?: InputMaybe<Array<WcmMasterBuyerListDeleteFilter>>;
  dataCenter?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<WcmMasterBuyerListDeleteFilter>>;
  type?: InputMaybe<Wcm_Buyer_TypeFilterComparison>;
  wcmBuyerUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmMasterBuyerListFilter = {
  and?: InputMaybe<Array<WcmMasterBuyerListFilter>>;
  dataCenter?: InputMaybe<StringFieldComparison>;
  or?: InputMaybe<Array<WcmMasterBuyerListFilter>>;
  type?: InputMaybe<Wcm_Buyer_TypeFilterComparison>;
  wcmBuyerUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmMasterBuyerListSort = {
  direction: SortDirection;
  field: WcmMasterBuyerListSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmMasterBuyerListSortFields =
  | 'dataCenter'
  | 'type'
  | 'wcmBuyerUuid';

export type WcmMasterRegionCountryList = {
  __typename?: 'WcmMasterRegionCountryList';
  /** alpha2 country code */
  alpha2Code: Scalars['String']['output'];
  /** alpha3 country code */
  alpha3Code: Scalars['String']['output'];
  /** Country name */
  countryName: Scalars['String']['output'];
  /** Region */
  region: Wcm_Buyer_Region;
};

export type WcmMasterRegionCountryListFilter = {
  alpha2Code?: InputMaybe<StringFieldComparison>;
  alpha3Code?: InputMaybe<StringFieldComparison>;
  and?: InputMaybe<Array<WcmMasterRegionCountryListFilter>>;
  or?: InputMaybe<Array<WcmMasterRegionCountryListFilter>>;
};

export type WcmMasterRegionCountryListSort = {
  direction: SortDirection;
  field: WcmMasterRegionCountryListSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmMasterRegionCountryListSortFields =
  | 'alpha2Code'
  | 'alpha3Code';

export type WcmMonitoringCumulativeInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Time bucket interval */
  interval: Time_Periods;
  /** Range end date (ISO format). */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format). */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringFiltersInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by country */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by industry */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Filter by segment */
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
};

export type WcmMonitoringSnapshotInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Time bucket interval (group by) */
  interval: Time_Periods;
  /** Range end date (ISO format, e.g. 2025-12-01) */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format, e.g. 2025-01-01) */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringStats = {
  __typename?: 'WcmMonitoringStats';
  /** Estimated working capital opportunity (benchmark-based with segment conversion rate) */
  estimatedOpportunity: Scalars['Float']['output'];
  /** Per-status stats */
  statusStats: Array<WcmMonitoringStatusStat>;
  /** Target WCO (null when non-plan/wave filters applied) */
  targetWco?: Maybe<Scalars['Float']['output']>;
  /** Total spend across all in-scope supplier entities */
  totalSpend: Scalars['Float']['output'];
  /** Total supplier entity count */
  totalSupplierEntityCount: Scalars['Int']['output'];
  /** Total working capital opportunity (phase-aware) */
  totalWco: Scalars['Float']['output'];
};

export type WcmMonitoringStatsInput = {
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmMonitoringStatusStat = {
  __typename?: 'WcmMonitoringStatusStat';
  /** Canonical negotiation phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Custom display order for this status */
  customOrder: Scalars['Int']['output'];
  /** Status label (e.g. "Outreach Sent") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for this status */
  wco: Scalars['Float']['output'];
};

export type WcmMonitoringTrackingByAggregatorInput = {
  /** Aggregator dimension key (e.g. SUPPLIER_SEGMENT, SUPPLIER_COUNTRY, custom_attribute_1) */
  aggregator: Scalars['String']['input'];
  /** ISO 4217 currency code */
  currency: Scalars['String']['input'];
  /** Monitoring filters */
  filters?: InputMaybe<WcmMonitoringFiltersInput>;
  /** Field on which sorting is to be carried out */
  orderLevel?: InputMaybe<Scalars['String']['input']>;
  /** Order direction (ASC/DESC) */
  orderType?: InputMaybe<Order_Type>;
  /** Range end date (ISO format) */
  rangeEnd?: InputMaybe<Scalars['String']['input']>;
  /** Range start date (ISO format) */
  rangeStart?: InputMaybe<Scalars['String']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmNaicsExclusionDefaultsSummary = {
  __typename?: 'WcmNaicsExclusionDefaultsSummary';
  /** Whether the buyer set differs from the C2FO default set */
  differsFromDefaults: Scalars['Boolean']['output'];
  /** Number of codes in the C2FO managed default-exclusion set */
  totalDefaultCodes: Scalars['Int']['output'];
};

export type WcmNaicsExclusionGroup = {
  __typename?: 'WcmNaicsExclusionGroup';
  /** 4-digit NAICS group code */
  code: Scalars['Int']['output'];
  codes: Array<WcmNaicsExclusionLeaf>;
  /** NAICS group description */
  description: Scalars['String']['output'];
  /** Number of excluded leaf codes in this group */
  excludedCount: Scalars['Int']['output'];
  /** Total number of 6-digit leaf codes in this group */
  totalCount: Scalars['Int']['output'];
};

export type WcmNaicsExclusionLeaf = {
  __typename?: 'WcmNaicsExclusionLeaf';
  /** 6-digit NAICS code */
  code: Scalars['Int']['output'];
  /** NAICS code description */
  description: Scalars['String']['output'];
  /** Whether this code is currently excluded by the buyer */
  excluded: Scalars['Boolean']['output'];
  /** Whether this code belongs to the C2FO managed default-exclusion set */
  isC2foDefault: Scalars['Boolean']['output'];
  /** Source of the exclusion (DEFAULT/CUSTOM); null when the code is not excluded */
  source?: Maybe<NaicsExclusionSource>;
};

export type WcmNaicsExclusionSector = {
  __typename?: 'WcmNaicsExclusionSector';
  /** 2-digit NAICS sector code */
  code: Scalars['Int']['output'];
  /** NAICS sector description */
  description: Scalars['String']['output'];
  /** Number of excluded leaf codes in this sector */
  excludedCount: Scalars['Int']['output'];
  groups: Array<WcmNaicsExclusionGroup>;
  /** Total number of 6-digit leaf codes in this sector */
  totalCount: Scalars['Int']['output'];
};

export type WcmNaicsExclusions = {
  __typename?: 'WcmNaicsExclusions';
  defaults: WcmNaicsExclusionDefaultsSummary;
  /** Total number of codes currently excluded by the buyer */
  excludedCount: Scalars['Int']['output'];
  /** Timestamp of the most recent change to the buyer set */
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  /** Preview of what will change when the buyer restores system defaults. */
  restorePreview: WcmNaicsRestorePreview;
  sectors: Array<WcmNaicsExclusionSector>;
  /** Total number of 6-digit NAICS leaf codes in the taxonomy */
  totalNaicsCount: Scalars['Int']['output'];
};

export type WcmNaicsRestorePreview = {
  __typename?: 'WcmNaicsRestorePreview';
  /** Default NAICS codes present in the buyer spend that are not currently excluded and will be added when restoring. */
  willBeAdded: Array<Scalars['Int']['output']>;
  /** Custom NAICS codes (not in the default set) that will be dropped when restoring system defaults. */
  willBeRemoved: Array<Scalars['Int']['output']>;
};

export type WcmNegotiationItem = {
  __typename?: 'WcmNegotiationItem';
  /** Negotiated terms value */
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: Maybe<Scalars['String']['output']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: Maybe<Scalars['Float']['output']>;
  /** Free-text remarks recorded against the negotiation */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: Maybe<Scalars['String']['output']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: Maybe<Scalars['String']['output']>;
  /** Vendor variant ID */
  vendorVariantId: Scalars['String']['output'];
};

export type WcmNegotiationOutput = {
  __typename?: 'WcmNegotiationOutput';
  /** Available statuses for the negotiation */
  availableStatuses?: Maybe<Array<WcmNegotiationStatusOption>>;
  /** Negotiated terms value */
  negotiatedTerms?: Maybe<Scalars['Float']['output']>;
  /** Description of negotiated terms */
  negotiatedTermsDescription?: Maybe<Scalars['String']['output']>;
  /** Negotiation status value ID from custom attribute value mappings */
  negotiationStatusValueId?: Maybe<Scalars['Float']['output']>;
  /** Free-text remarks recorded against the negotiation */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Latest recorded event per status value ID, used to pre-fill the modal for a single entity */
  statusEvents?: Maybe<Array<WcmNegotiationStatusEventItem>>;
  /** Date when terms were agreed upon */
  termsAgreedOn?: Maybe<Scalars['String']['output']>;
  /** Date when terms become effective */
  termsEffectiveFrom?: Maybe<Scalars['String']['output']>;
};

export type WcmNegotiationStatusEventItem = {
  __typename?: 'WcmNegotiationStatusEventItem';
  /** ISO date (YYYY-MM-DD) of the most recent event for this status */
  eventDate?: Maybe<Scalars['String']['output']>;
  /** Status value ID this event was recorded against */
  negotiationStatusValueId: Scalars['Int']['output'];
  /** Remarks recorded with the event */
  remarks?: Maybe<Scalars['String']['output']>;
};

export type WcmNegotiationStatusOption = {
  __typename?: 'WcmNegotiationStatusOption';
  /** Canonical phase this status is mapped to. Drives chip/card color across supplier list, profile, and monitoring screens. */
  canonicalPhase?: Maybe<Wcm_Canonical_Phase>;
  /** Status ID from custom attribute value mappings */
  id: Scalars['Float']['output'];
  /** Status value */
  value: Scalars['String']['output'];
};

export type WcmNegotiationsOutput = {
  __typename?: 'WcmNegotiationsOutput';
  /** Available statuses for negotiations */
  availableStatuses?: Maybe<Array<WcmNegotiationStatusOption>>;
  /** Array of negotiation data */
  negotiations: Array<WcmNegotiationItem>;
};

export type WcmOperationMessageOutput = {
  __typename?: 'WcmOperationMessageOutput';
  /** Operation result message */
  message: Scalars['String']['output'];
};

export type WcmPaymentTermsBenchmarkFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Dimension on which data is grouped by (enum value or custom_attribute_N) */
  groupBy: Scalars['String']['input'];
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmPaymentTermsBenchmarkOutput = {
  __typename?: 'WcmPaymentTermsBenchmarkOutput';
  country75: Scalars['Float']['output'];
  country85: Scalars['Float']['output'];
  country90: Scalars['Float']['output'];
  country95: Scalars['Float']['output'];
  country99: Scalars['Float']['output'];
  countryCode?: Maybe<Scalars['String']['output']>;
  countryMax: Scalars['Float']['output'];
  countryMedian: Scalars['Float']['output'];
  currentTerms: Scalars['Float']['output'];
  global75: Scalars['Float']['output'];
  global85: Scalars['Float']['output'];
  global90: Scalars['Float']['output'];
  global95: Scalars['Float']['output'];
  global99: Scalars['Float']['output'];
  globalMax: Scalars['Float']['output'];
  globalMedian: Scalars['Float']['output'];
  label: Scalars['String']['output'];
  totalEstimatedWco: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
};

export type WcmPaymentTermsInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmPaymentTermsLandscapeOutput = {
  __typename?: 'WcmPaymentTermsLandscapeOutput';
  /** Lower bound of 10-day payment term bucket (e.g. 30 = 30–40 days) */
  paymentTermBucket: Scalars['Int']['output'];
  /** Segment (core or tail or strategic) */
  segment: Scalars['String']['output'];
  /** Exclusive upper bound of the spend bucket, or null for the open-ended last bucket */
  spendBucketMax?: Maybe<Scalars['Float']['output']>;
  /** Inclusive lower bound of the spend bucket */
  spendBucketMin: Scalars['Float']['output'];
  /** Number of suppliers in this group */
  supplierCount: Scalars['Int']['output'];
};

export type WcmPaymentTermsOutput = {
  __typename?: 'WcmPaymentTermsOutput';
  /** benchmark payment terms */
  benchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** existing payment terms */
  existingTerms?: Maybe<Scalars['Float']['output']>;
  /** Weighted average benchmark payment terms */
  weightedAvgBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
};

export type WcmPlanOutput = {
  __typename?: 'WcmPlanOutput';
  /** Creation timestamp (ISO 8601) */
  created: Scalars['String']['output'];
  /** UUID of the user who created the plan */
  createdBy: Scalars['String']['output'];
  /** Plan end date (ISO 8601) */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Plan ID */
  id: Scalars['Int']['output'];
  /** Whether the plan is synced with external system */
  isSynced: Scalars['Boolean']['output'];
  /** Plan name */
  name: Scalars['String']['output'];
  /** Owner of the plan */
  owner?: Maybe<Scalars['String']['output']>;
  /** Plan start date (ISO 8601) */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Target working capital amount */
  targetWorkingCapital: Scalars['Float']['output'];
  /** Transaction UUID associated with the plan */
  transactionUuid: Scalars['String']['output'];
  /** Last update timestamp (ISO 8601) */
  updated: Scalars['String']['output'];
};

export type WcmPlanWaveOutput = {
  __typename?: 'WcmPlanWaveOutput';
  /** Creation timestamp (ISO 8601) */
  created: Scalars['String']['output'];
  /** UUID of the user who created the wave */
  createdBy: Scalars['String']['output'];
  /** Wave end date (ISO 8601) */
  endDate?: Maybe<Scalars['String']['output']>;
  /** Wave ID */
  id: Scalars['Int']['output'];
  /** Wave name */
  name: Scalars['String']['output'];
  /** Owner of the wave */
  owner?: Maybe<Scalars['String']['output']>;
  /** Wave start date (ISO 8601) */
  startDate?: Maybe<Scalars['String']['output']>;
  /** Target working capital amount */
  targetWorkingCapital: Scalars['Float']['output'];
  /** Last update timestamp (ISO 8601) */
  updated: Scalars['String']['output'];
  /** Parent plan ID */
  wcmPlanId: Scalars['Int']['output'];
};

export type WcmPublicUser = {
  __typename?: 'WcmPublicUser';
  /** User Email Address */
  emailAddress: Scalars['String']['output'];
  /** Access expiry in UTC format (e.g., "2025-01-01T00:00:00.000Z") */
  expiresAt?: Maybe<Scalars['String']['output']>;
  /** Is C2FO User */
  isC2FO: Scalars['Boolean']['output'];
  /** Is User Onboarded in WCM */
  isOnboarded: Scalars['Boolean']['output'];
  /** User Name */
  name: Scalars['String']['output'];
  /** User UUID */
  uuid: Scalars['String']['output'];
};

export type WcmRole = {
  __typename?: 'WcmRole';
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  internallyManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions: Array<WcmRolePermission>;
  updated?: Maybe<Scalars['DateTime']['output']>;
  usersCount: Scalars['Float']['output'];
};

export type WcmRoleBasicInfo = {
  __typename?: 'WcmRoleBasicInfo';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type WcmRolePermission = {
  __typename?: 'WcmRolePermission';
  id: Scalars['ID']['output'];
  permission: Scalars['String']['output'];
};

export type WcmSearchCompanyFinancialsInput = {
  /** Search term for company name or ticker symbol */
  searchTerm: Scalars['String']['input'];
};

export type WcmSearchCompanyFinancialsOutput = {
  __typename?: 'WcmSearchCompanyFinancialsOutput';
  /** Annual revenue in USD */
  annualRevenueUsd?: Maybe<Scalars['Float']['output']>;
  /** Average Days Payable Outstanding */
  avgDpo?: Maybe<Scalars['Float']['output']>;
  /** Average Days Sales Outstanding */
  avgDso?: Maybe<Scalars['Float']['output']>;
  /** Company ID */
  companyId: Scalars['String']['output'];
  /** Company name */
  companyName: Scalars['String']['output'];
  /** Country name */
  country: Scalars['String']['output'];
  /** ISO 2-letter country code */
  countryIso2: Scalars['String']['output'];
  /** Credit rating */
  creditRating?: Maybe<Scalars['String']['output']>;
  /** Stock ticker symbol */
  tickerSymbol?: Maybe<Scalars['String']['output']>;
};

export type WcmSearchNaicsInput = {
  query: Scalars['String']['input'];
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSearchNaicsOutput = {
  __typename?: 'WcmSearchNaicsOutput';
  /** Indicates if the NAICS code is excluded for this buyer */
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
  /** Naics code */
  naicsCode: Scalars['Float']['output'];
  /** Naics description */
  naicsDescription: Scalars['String']['output'];
};

export type WcmSegmentConversionRateConfigOutput = {
  __typename?: 'WcmSegmentConversionRateConfigOutput';
  coreSegmentConversionRate: Scalars['Float']['output'];
  strategicSegmentConversionRate: Scalars['Float']['output'];
  tailSegmentConversionRate: Scalars['Float']['output'];
};

export type WcmSnapshotBucket = {
  __typename?: 'WcmSnapshotBucket';
  /** Bucket start date (ISO format) */
  bucketStart: Scalars['String']['output'];
  /** Status distribution at this point in time */
  statuses: Array<WcmSnapshotStatusEntry>;
};

export type WcmSnapshotStatusEntry = {
  __typename?: 'WcmSnapshotStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Estimated WCO adjusted by segment conversion rate */
  estimatedWco: Scalars['Float']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status at this point in time */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for supplier entities in this status */
  wco: Scalars['Float']['output'];
};

export type WcmSpendAnalysisInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSpendAnalysisStatsOutput = {
  __typename?: 'WcmSpendAnalysisStatsOutput';
  /** count of distinct payment terms */
  paymentTermsCount: Scalars['Int']['output'];
  /** total number of supplier countries */
  supplierCountriesCount: Scalars['Int']['output'];
  /** total number of supplier entities */
  supplierEntitiesCount: Scalars['Int']['output'];
  /** total number of supplier groups */
  supplierGroupsCount: Scalars['Int']['output'];
  /** total spend amount */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendDistributionOutput = {
  __typename?: 'WcmSpendDistributionOutput';
  /** percentage of total spend in this range */
  spendPercentage: Scalars['Float']['output'];
  /** spend range category */
  spendRange: Scalars['String']['output'];
  /** count of supplier groups in this spend range */
  supplierGroupCount: Scalars['Int']['output'];
  /** percentage of supplier groups in this spend range */
  supplierGroupPercentage: Scalars['Float']['output'];
  /** total spend amount in this range */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendDynamicFiltersInput = {
  /** Display Currency */
  displayCurrency: Scalars['String']['input'];
  selectedFilters?: InputMaybe<WcmSpendSelectedFilters>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSpendDynamicFiltersOutput = {
  __typename?: 'WcmSpendDynamicFiltersOutput';
  benchmarkingStrategies?: Maybe<Array<Scalars['String']['output']>>;
  buyingEntity?: Maybe<Array<Scalars['String']['output']>>;
  buyingTeam?: Maybe<Array<Scalars['String']['output']>>;
  category?: Maybe<Array<Scalars['String']['output']>>;
  country?: Maybe<Array<Scalars['String']['output']>>;
  /** Custom attributes - key is attribute internal name, value contains displayName and available values */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  excludeReason?: Maybe<Array<Scalars['String']['output']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: Maybe<Array<Scalars['String']['output']>>;
  isDiscountedTerms?: Maybe<Array<Scalars['String']['output']>>;
  isDiverseSupplier?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescription?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescriptionL2?: Maybe<Array<Scalars['String']['output']>>;
  naicsDescriptionL3?: Maybe<Array<Scalars['String']['output']>>;
  /** Negotiation Status */
  negotiationStatus?: Maybe<Array<Scalars['String']['output']>>;
  /** Plan wave filter options with label and ID */
  planWaves?: Maybe<Array<WcmFilterOption>>;
  /** Plan filter options with label and ID */
  plans?: Maybe<Array<WcmFilterOption>>;
  region?: Maybe<Array<Scalars['String']['output']>>;
  supplierLead?: Maybe<Array<Scalars['String']['output']>>;
  supplierType?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategory?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategoryL2?: Maybe<Array<Scalars['String']['output']>>;
  vendorCategoryL3?: Maybe<Array<Scalars['String']['output']>>;
};

export type WcmSpendFileTemplateUrl = {
  __typename?: 'WcmSpendFileTemplateUrl';
  /** Signed URL for the WCM spend file template download */
  signedUrl: Scalars['String']['output'];
};

export type WcmSpendGeoOverviewOutput = {
  __typename?: 'WcmSpendGeoOverviewOutput';
  /** Country ISO Code(2 characters) */
  alpha2Code: Scalars['String']['output'];
  /** Country ISO Code(3 characters) */
  alpha3Code: Scalars['String']['output'];
  /** Country Name */
  countryName: Scalars['String']['output'];
  /** Total Spend Amount */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSpendSelectedFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  buyingTeam?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Segment Category */
  category?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  excludeReason?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclusion Remarks */
  exclusionRemarks?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 6) */
  naicsDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 2) */
  naicsDescriptionL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** NAICS Description (Level 3) */
  naicsDescriptionL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status to filter by */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Region */
  region?: InputMaybe<Array<Wcm_Buyer_Region>>;
  supplierLead?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  supplierType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Terms Category */
  termsCategory?: InputMaybe<Wco_Matrix_Tier>;
  /** Primary category */
  vendorCategory?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary category */
  vendorCategoryL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary category */
  vendorCategoryL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCO Category */
  wcoCategory?: InputMaybe<Wco_Matrix_Tier>;
};

export type WcmStatsInput = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of benchmarking strategies for which additional stats will be calculated. If present, stats will include results for these strategies in addition to the default ones. */
  benchmarkingStrategiesForStats?: InputMaybe<Array<Benchmarking_Strategies_With_Harmonization>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Supplier name search filter */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmStatsOutput = {
  __typename?: 'WcmStatsOutput';
  /** estimated working capital opportunity */
  estimatedWco?: Maybe<Scalars['Float']['output']>;
  /** Realised working capital opportunity — total WCO from suppliers whose negotiation has reached COMPLETED or ERP_UPDATED, evaluated against negotiated terms. */
  realisedWco?: Maybe<Scalars['Float']['output']>;
  /** spend amount */
  spend?: Maybe<Scalars['Float']['output']>;
  /** total number of supplier entities */
  supplierEntityCount?: Maybe<Scalars['Float']['output']>;
  /** total number of supplier groups */
  supplierGroupCount?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for waHarmonization */
  totalHarmonizationWco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry75 */
  totalIndustryCountry75Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry85 */
  totalIndustryCountry85Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry90 */
  totalIndustryCountry90Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry95 */
  totalIndustryCountry95Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountry99 */
  totalIndustryCountry99Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountryMax */
  totalIndustryCountryMaxWco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryCountryMedian */
  totalIndustryCountryMedianWco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal75 */
  totalIndustryGlobal75Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal85 */
  totalIndustryGlobal85Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal90 */
  totalIndustryGlobal90Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal95 */
  totalIndustryGlobal95Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobal99 */
  totalIndustryGlobal99Wco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobalMax */
  totalIndustryGlobalMaxWco?: Maybe<Scalars['Float']['output']>;
  /** Total WCO for industryGlobalMedian */
  totalIndustryGlobalMedianWco?: Maybe<Scalars['Float']['output']>;
  /** total working capital amount */
  twc?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for waHarmonization */
  waHarmonizationBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry75 */
  waIndustryCountry75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry85 */
  waIndustryCountry85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry90 */
  waIndustryCountry90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry95 */
  waIndustryCountry95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountry99 */
  waIndustryCountry99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountryMax */
  waIndustryCountryMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryCountryMedian */
  waIndustryCountryMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal75 */
  waIndustryGlobal75BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal85 */
  waIndustryGlobal85BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal90 */
  waIndustryGlobal90BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal95 */
  waIndustryGlobal95BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobal99 */
  waIndustryGlobal99BenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobalMax */
  waIndustryGlobalMaxBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
  /** WA Benchmark Terms for industryGlobalMedian */
  waIndustryGlobalMedianBenchmarkTerms?: Maybe<Scalars['Float']['output']>;
};

export type WcmStatusBreakdownEntry = {
  __typename?: 'WcmStatusBreakdownEntry';
  canonicalPhase: Scalars['String']['output'];
  customOrder: Scalars['Float']['output'];
  estimatedWco: Scalars['Float']['output'];
  percentageWco: Scalars['Float']['output'];
  statusLabel: Scalars['String']['output'];
  supplierEntities: Scalars['Float']['output'];
  supplierGroups: Scalars['Float']['output'];
  wco: Scalars['Float']['output'];
};

export type WcmStatusPhaseMappingItem = {
  __typename?: 'WcmStatusPhaseMappingItem';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Custom status value ID */
  customStatusValueId: Scalars['Int']['output'];
  /** Phase mapping ID */
  id: Scalars['Int']['output'];
};

export type WcmStatusPhaseMappings = {
  __typename?: 'WcmStatusPhaseMappings';
  /** List of successfully upserted mappings */
  mappings: Array<WcmStatusPhaseMappingItem>;
};

export type WcmSupplierGroupEntitiesData = {
  __typename?: 'WcmSupplierGroupEntitiesData';
  annualSpend: Scalars['Float']['output'];
  benchmarkTerms: Scalars['Float']['output'];
  contractualTermsDescription?: Maybe<Scalars['String']['output']>;
  currentTerms: Scalars['Float']['output'];
  /** Custom attributes with display names and values. Keys are internal names (e.g., custom_attribute_1) */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  defaultBenchmarkStrategy: Scalars['String']['output'];
  excludeReason?: Maybe<Scalars['String']['output']>;
  hasAContract?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  naicsCode?: Maybe<Scalars['Float']['output']>;
  naicsDescription?: Maybe<Scalars['String']['output']>;
  paidOnTime?: Maybe<Scalars['Boolean']['output']>;
  preferredBenchmarkStrategy: Scalars['String']['output'];
  region: Scalars['String']['output'];
  segmentConversionRate: Scalars['Float']['output'];
  supplierCountryRegulationTerms: Scalars['Float']['output'];
  supplierName: Scalars['String']['output'];
  supplierSegment?: Maybe<Scalars['String']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  topCurrency?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['String']['output'];
  vendorVariantId: Scalars['String']['output'];
  withMaxSpend?: Maybe<Scalars['Boolean']['output']>;
  workingCapitalOpportunity: Scalars['Float']['output'];
};

export type WcmSupplierGroupEntitiesDataInput = {
  /** Exclude Reasons */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['input'];
  onlyIncludeEntitiesWithPositiveTermsDifference?: Scalars['Boolean']['input'];
  /** Supplier Categories */
  supplierCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Industries */
  supplierIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSupplierGroupEntitiesDataOutput = {
  __typename?: 'WcmSupplierGroupEntitiesDataOutput';
  aggregatedValues: WcmSuppliersGroupAggregatedValue;
  /** Aggregated values grouped by country. Each entry contains a country code and its aggregated benchmarks. */
  countryWiseAggregatedValues: Array<WcmCountryAggregatedValue>;
  /** supplier entities */
  entities: Array<WcmSupplierGroupEntitiesData>;
  entitiesCountWithPositiveTermDifference: Scalars['Int']['output'];
  /** filtered out supplier entities */
  filteredOutEntities?: Maybe<Array<WcmSupplierGroupEntitiesData>>;
  vendorMasterId: Scalars['String']['output'];
};

export type WcmSupplierGroupNote = {
  __typename?: 'WcmSupplierGroupNote';
  /** Note body */
  content: Scalars['String']['output'];
  /** Timestamp when the note was created (ISO string) */
  createdAt: Scalars['String']['output'];
  /** UUID of the user that created the note */
  createdBy: Scalars['String']['output'];
  /** Primary key of the note */
  id: Scalars['Int']['output'];
  /** True if this is the most recent note for the supplier group and may therefore be edited by the user. */
  isEditable: Scalars['Boolean']['output'];
  /** Timestamp when the note was last updated (ISO string) */
  updatedAt: Scalars['String']['output'];
  /** UUID of the user that last updated the note */
  updatedBy?: Maybe<Scalars['String']['output']>;
  /** Vendor master ID identifying the supplier group */
  vendorMasterId: Scalars['String']['output'];
  /** WCM Buyer UUID owning the note */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmSupplierGroupNotesOutput = {
  __typename?: 'WcmSupplierGroupNotesOutput';
  /** Notes for the supplier group. */
  items: Array<WcmSupplierGroupNote>;
  /** Total number of notes for the supplier group */
  total: Scalars['Int']['output'];
};

export type WcmSupplierHealthMetricsOutput = {
  __typename?: 'WcmSupplierHealthMetricsOutput';
  /** Entity terms health data */
  entity: WcmSupplierTermsHealthMetrics;
  /** Supplier group terms health data */
  supplierGroup: WcmSupplierTermsHealthMetrics;
};

export type WcmSupplierProfileBenchmarkingStrategies = {
  __typename?: 'WcmSupplierProfileBenchmarkingStrategies';
  custom: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  waHarmonization: Scalars['Float']['output'];
};

export type WcmSupplierProfileCommonFilters = {
  /** Exclude Reasons */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyIncludeEntitiesWithPositiveTermsDifference?: Scalars['Boolean']['input'];
  /** Supplier Categories */
  supplierCategories?: InputMaybe<Array<Scalars['String']['input']>>;
  supplierCountries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Industries */
  supplierIndustries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  supplierRegions?: InputMaybe<Array<Wcm_Buyer_Region>>;
};

export type WcmSupplierProfileDataInput = {
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['input'];
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmSupplierProfileDataOutput = {
  __typename?: 'WcmSupplierProfileDataOutput';
  annualRevenue: Scalars['Float']['output'];
  annualRevenueGroup: Scalars['Float']['output'];
  annualSpend: Scalars['Float']['output'];
  bargainingPower?: Maybe<Scalars['String']['output']>;
  benchmarkTerms: Scalars['Float']['output'];
  /** Company financials data */
  companyFinancials?: Maybe<WcmSearchCompanyFinancialsOutput>;
  countryInvoiceSampleSize: Scalars['Float']['output'];
  creditRating: Scalars['String']['output'];
  currentTerms: Scalars['Float']['output'];
  custom: Scalars['Float']['output'];
  /** Custom attributes with display names and values. Keys are internal names (e.g., custom_attribute_1) */
  customAttributes?: Maybe<Scalars['JSON']['output']>;
  defaultBenchmarkStrategy: Scalars['String']['output'];
  diverseSupplier?: Maybe<Scalars['String']['output']>;
  dpoGroup: Scalars['Float']['output'];
  dsoGroup: Scalars['Float']['output'];
  estimatedBenchmarkTerms: WcmBenchmarkingStrategies;
  estimatedWorkingCapitalOpportunity: WcmBenchmarkingStrategies;
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Executive summary describing the supplier risk posture */
  executiveSummary?: Maybe<Scalars['String']['output']>;
  /** Buyer file currency for the transaction associated with this supplier */
  fileCurrency?: Maybe<Scalars['String']['output']>;
  globalInvoiceSampleSize: Scalars['Float']['output'];
  hasCustomBenchmark: Scalars['Boolean']['output'];
  /** Enriched Supplier File Data ID */
  id: Scalars['Float']['output'];
  industryCountry75: Scalars['Float']['output'];
  industryCountry85: Scalars['Float']['output'];
  industryCountry90: Scalars['Float']['output'];
  industryCountry95: Scalars['Float']['output'];
  industryCountry99: Scalars['Float']['output'];
  industryCountryMax: Scalars['Float']['output'];
  industryCountryMedian: Scalars['Float']['output'];
  industryGlobal75: Scalars['Float']['output'];
  industryGlobal85: Scalars['Float']['output'];
  industryGlobal90: Scalars['Float']['output'];
  industryGlobal95: Scalars['Float']['output'];
  industryGlobal99: Scalars['Float']['output'];
  industryGlobalMax: Scalars['Float']['output'];
  industryGlobalMedian: Scalars['Float']['output'];
  /** Market concentration label */
  marketConcentrationLabel?: Maybe<Scalars['String']['output']>;
  /** Market concentration score on a 0-100 scale */
  marketConcentrationScore?: Maybe<Scalars['Float']['output']>;
  materiality: Scalars['String']['output'];
  multiBuyerSupplier?: Maybe<Scalars['Boolean']['output']>;
  naicsCode?: Maybe<Scalars['Float']['output']>;
  naicsDescription: Scalars['String']['output'];
  /** Detailed NAICS description for Level 6 industry tooltip */
  naicsDetailedDescription?: Maybe<Scalars['String']['output']>;
  /** NAICS weighted-average global payment terms */
  naicsWaAvgTermsGlobal?: Maybe<Scalars['Float']['output']>;
  preferredBenchmarkStrategy: Scalars['String']['output'];
  region: Scalars['String']['output'];
  /** Composite supplier risk score on a 0-100 scale (0 = Critical, 100 = Safe) */
  riskScore?: Maybe<Scalars['Float']['output']>;
  roundedBenchmarkValues: WcmSupplierProfileBenchmarkingStrategies;
  segmentConversionRate: Scalars['Float']['output'];
  /** Substitutability label, e.g. Low / Medium / High */
  substitutabilityLabel?: Maybe<Scalars['String']['output']>;
  /** Substitutability score on a 0-100 scale */
  substitutabilityScore?: Maybe<Scalars['Float']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  supplierCountryRegulationTerms: Scalars['Float']['output'];
  supplierName: Scalars['String']['output'];
  supplierSegment?: Maybe<Scalars['String']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  tickerGroup: Scalars['String']['output'];
  topCurrency?: Maybe<Scalars['String']['output']>;
  vendorCategory?: Maybe<Scalars['String']['output']>;
  vendorDpo: Scalars['Float']['output'];
  vendorDso: Scalars['Float']['output'];
  vendorId: Scalars['String']['output'];
  vendorMasterId: Scalars['String']['output'];
  vendorVariantId: Scalars['String']['output'];
  waCurrentTerms: Scalars['Float']['output'];
  waHarmonization?: Maybe<Scalars['Float']['output']>;
  workingCapitalOpportunity: WcmBenchmarkingStrategies;
};

export type WcmSupplierSpendOverviewOutput = {
  __typename?: 'WcmSupplierSpendOverviewOutput';
  /** Top Supplier Of Supplier Group */
  topSupplierName: Scalars['String']['output'];
  /** Total spend amount for the segment */
  totalSpend: Scalars['Float']['output'];
};

export type WcmSupplierTermsHealthMetrics = {
  __typename?: 'WcmSupplierTermsHealthMetrics';
  /** Different terms of same supplier */
  differentTermsOfSameSupplier?: Maybe<Scalars['Boolean']['output']>;
  /** Discount terms mismatch */
  discountTermsMismatch?: Maybe<Scalars['Boolean']['output']>;
  /** Has a contract */
  hasAContract?: Maybe<Scalars['Boolean']['output']>;
  /** Has discount terms */
  hasDiscountTerms?: Maybe<Scalars['Boolean']['output']>;
  /** Paid on time */
  paidOnTime?: Maybe<Scalars['Boolean']['output']>;
  /** Terms shorter than industry standard */
  termsShorterThanIndustryStandard?: Maybe<Scalars['Boolean']['output']>;
  /** Terms shorter than other suppliers in same industry */
  termsShorterThanOtherSuppliersInSameIndustry?: Maybe<Scalars['Boolean']['output']>;
};

export type WcmSuppliersGroupAggregatedValue = {
  __typename?: 'WcmSuppliersGroupAggregatedValue';
  defaultBenchmarkStrategy: Scalars['String']['output'];
  hasCustomBenchmark: Scalars['Boolean']['output'];
  preferredBenchmarkStrategy: Scalars['String']['output'];
  supplierCountryRegulationTerms?: Maybe<Scalars['Float']['output']>;
  termsRegulationsLimit?: Maybe<Scalars['String']['output']>;
  totalEstimatedOpportunity: WcmBenchmarkingStrategies;
  totalRevenue: Scalars['Float']['output'];
  totalSpend: Scalars['Float']['output'];
  totalWorkingCapitalOpportunity: WcmBenchmarkingStrategies;
  weightedAverageBenchmarkTerms: WcmBenchmarkingStrategies;
  weightedAverageCurrentTerm: Scalars['Float']['output'];
  weightedAverageEstimatedBenchmarkTerms: WcmBenchmarkingStrategies;
  weightedAverageMateriality: Scalars['Float']['output'];
  weightedAverageRawTerms: WcmBenchmarkingStrategies;
};

export type WcmSuppliersOperationResponse = {
  __typename?: 'WcmSuppliersOperationResponse';
  /** Supplier operation result message */
  message: Scalars['String']['output'];
};

export type WcmTrackingByAggregatorGroup = {
  __typename?: 'WcmTrackingByAggregatorGroup';
  /** Aggregator code (used for linking/filtering) */
  aggregatorCode: Scalars['String']['output'];
  /** Aggregator display label */
  aggregatorLabel: Scalars['String']['output'];
  /** Status breakdown for this aggregator group */
  statuses: Array<WcmTrackingStatusEntry>;
};

export type WcmTrackingStatusEntry = {
  __typename?: 'WcmTrackingStatusEntry';
  /** Canonical phase */
  canonicalPhase: Wcm_Canonical_Phase;
  /** Sub-ordering within the phase for chart stacking */
  customOrder: Scalars['Int']['output'];
  /** Total spend for supplier entities in this status */
  spend: Scalars['Float']['output'];
  /** Status label (e.g. "Terms Agreed") */
  statusLabel: Scalars['String']['output'];
  /** Number of supplier entities in this status */
  supplierEntityCount: Scalars['Int']['output'];
  /** Working capital opportunity for supplier entities in this status */
  wco: Scalars['Float']['output'];
};

export type WcmUpdateNaicsExclusionsInput = {
  /** Complete set of 6-digit NAICS codes to exclude for the buyer. Replaces any existing set. */
  excludedNaicsCodes: Array<Scalars['Int']['input']>;
  /** WCM Buyer UUID */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmUpdatePlanInput = {
  /** Plan end date (ISO 8601) */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Plan name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Owner of the plan */
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Plan start date (ISO 8601) */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** Target working capital amount */
  targetWorkingCapital?: InputMaybe<Scalars['Float']['input']>;
};

export type WcmUpsertUserInfoParams = {
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['input'];
  /** WCM user uuid */
  userUuid: Scalars['String']['input'];
};

export type WcmUserBuyer = {
  __typename?: 'WcmUserBuyer';
  wcmBuyerName: Scalars['String']['output'];
  /** WCM Buyer Type */
  wcmBuyerType: Wcm_Buyer_Type;
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmUserBuyerMapping = {
  /** User auth uuid */
  userUuid: Scalars['String']['input'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmUserBuyerMappingDetails = {
  __typename?: 'WcmUserBuyerMappingDetails';
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
  /** WCM buyer uuid */
  wcmBuyerUuid: Scalars['String']['output'];
};

export type WcmUserBuyerMappingDetailsFilter = {
  and?: InputMaybe<Array<WcmUserBuyerMappingDetailsFilter>>;
  or?: InputMaybe<Array<WcmUserBuyerMappingDetailsFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
  wcmBuyerUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmUserBuyerMappingDetailsSort = {
  direction: SortDirection;
  field: WcmUserBuyerMappingDetailsSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmUserBuyerMappingDetailsSortFields =
  | 'userUuid'
  | 'wcmBuyerUuid';

export type WcmUserFileLogs = {
  __typename?: 'WcmUserFileLogs';
  /** WCM user file upload date */
  created: Scalars['String']['output'];
  /** WCM user uploaded file name */
  fileName: Scalars['String']['output'];
  /** WCM user uploaded file uuid */
  fileUuid: Scalars['String']['output'];
  /** WCM user file upload status */
  status: File_Upload_Status;
};

export type WcmUserInfo = {
  __typename?: 'WcmUserInfo';
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** WCM C2FO user */
  isC2foUser?: Maybe<Scalars['Boolean']['output']>;
  /** WCM self-registration request id */
  selfRegistrationRequestId?: Maybe<Scalars['String']['output']>;
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
};

export type WcmUserInfoOutput = {
  __typename?: 'WcmUserInfoOutput';
  /** client config */
  clientConfig: WcmDomainClientConfig;
  /** error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** user access expiry date */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** wcm user full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** Wcm Buyers */
  wcmBuyers: Array<WcmBuyerData>;
};

export type WcmUserInformation = {
  __typename?: 'WcmUserInformation';
  /** WCM full version access */
  fullVersion: Scalars['Boolean']['output'];
  /** WCM is C2FO user */
  isC2foUser?: Maybe<Scalars['Boolean']['output']>;
  /** WCM user uuid */
  userUuid: Scalars['String']['output'];
};

export type WcmUserInformationFilter = {
  and?: InputMaybe<Array<WcmUserInformationFilter>>;
  fullVersion?: InputMaybe<BooleanFieldComparison>;
  isC2foUser?: InputMaybe<BooleanFieldComparison>;
  or?: InputMaybe<Array<WcmUserInformationFilter>>;
  userUuid?: InputMaybe<StringFieldComparison>;
};

export type WcmUserInformationSort = {
  direction: SortDirection;
  field: WcmUserInformationSortFields;
  nulls?: InputMaybe<SortNulls>;
};

export type WcmUserInformationSortFields =
  | 'fullVersion'
  | 'isC2foUser'
  | 'userUuid';

export type WcmUserPreference = {
  __typename?: 'WcmUserPreference';
  /** Preference name */
  preferenceName: Scalars['String']['output'];
  /** User preference settings */
  settings?: Maybe<Scalars['JSON']['output']>;
};

export type WcmUserRolesInfo = {
  __typename?: 'WcmUserRolesInfo';
  internallyManaged: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['ID']['output'];
};

export type WcmWorkingCapitalFilters = {
  maxValue: Scalars['Float']['input'];
  minValue: Scalars['Float']['input'];
};

export type WcmWorkingCapitalOpportunityMatrixFilters = {
  /** Benchmarking Strategies */
  benchmarkingStrategies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Entities */
  buyingEntities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Buying Teams */
  buyingTeams?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Primary Categories of supplier */
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Secondary Categories of supplier */
  categoriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Tertiary Categories of supplier */
  categoriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Countries for supplier regions */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Custom attributes filters - key is attribute internal name, value is array of selected values */
  customAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Display Currency */
  displayCurrency?: Scalars['String']['input'];
  /** Reasons for supplier exclusion */
  excludeReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If true, return suppliers in plan; if false, return suppliers not in plan */
  inPlan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Industries(Level 6) of supplier */
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 2) of supplier */
  industriesL2?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Industries(Level 3) of supplier */
  industriesL3?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiscountedTerms?: InputMaybe<Array<Scalars['String']['input']>>;
  isDiverseSupplier?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Negotiation Status */
  negotiationStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan ID to filter suppliers by plan */
  planId?: InputMaybe<Scalars['Float']['input']>;
  /** Plan Wave IDs to filter by */
  planWaves?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Plan IDs to filter by */
  plans?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Supplier Regions */
  regions?: InputMaybe<Array<Wcm_Buyer_Region>>;
  /** Segments of spend data */
  segments?: InputMaybe<Array<Wcm_Segment>>;
  /** Supplier Leads */
  supplierLeads?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Controls which suppliers are included in KPIs: IN_SCOPE, EXCLUDED, or ALL (default: ALL) */
  supplierScope?: InputMaybe<Wcm_Supplier_Scope>;
  /** Business types of supplier */
  supplierTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Wave ID to filter suppliers by wave */
  waveId?: InputMaybe<Scalars['Float']['input']>;
  /** WCM Buyer Uuid */
  wcmBuyerUuid: Scalars['String']['input'];
};

export type WcmWorkingCapitalOpportunityMatrixOutput = {
  __typename?: 'WcmWorkingCapitalOpportunityMatrixOutput';
  coreSupplierGroupCount: Scalars['Float']['output'];
  estimatedWorkingCapitalOpportunity: Scalars['Float']['output'];
  strategicSupplierGroupCount: Scalars['Float']['output'];
  supplierGroupCount: Scalars['Float']['output'];
  tailSupplierGroupCount: Scalars['Float']['output'];
  weightedAverageBenchmarkTerms: Scalars['Float']['output'];
  weightedAverageCurrentTerms: Scalars['Float']['output'];
  weightedAverageEstimatedTerms: Scalars['Float']['output'];
  workingCapitalOpportunity: Scalars['Float']['output'];
  workingCapitalOpportunityBucket: Wco_Matrix_Bucket;
  wtAvgTermsChangeBucket: Wco_Matrix_Bucket;
};

export type WeekOfMonth =
  | 'FIRST'
  | 'FOURTH'
  | 'LAST'
  | 'SECOND'
  | 'THIRD';

export type WriterTypeOutput = {
  __typename?: 'WriterTypeOutput';
  buyerGeneratedWriterTypes: Array<Scalars['String']['output']>;
  writerTypes: Array<Scalars['String']['output']>;
};

/** Provides average values for stats across the entire request: averageDiscount, averageApr, and averageWeightedDpe */
export type AverageStatDetails = {
  __typename?: 'averageStatDetails';
  /** Average rate of the request represented as APR (1.0 = 1%) */
  apr?: Maybe<Scalars['Float']['output']>;
  /** Average rate of the request represented as discount (1.0 = 1%) */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Weighted average days paid early across all the opportunities in the request */
  weightedDpe?: Maybe<Scalars['Float']['output']>;
};

export type FileSetConfiguration = {
  __typename?: 'fileSetConfiguration';
  addC2foFeeRecord: Scalars['Boolean']['output'];
  filterCriteria: FilterCriteria;
  name: Scalars['String']['output'];
  paymentConfig: OverrideConfig;
  uuid: Scalars['String']['output'];
  writerType: Scalars['String']['output'];
};

export type GetWcmBuyerAllAssignableRolesForPermissionManagerInput = {
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerAllAssignableRolesForPermissionManagerOutput = {
  __typename?: 'getWcmBuyerAllAssignableRolesForPermissionManagerOutput';
  roles: Array<WcmRoleBasicInfo>;
  total: Scalars['Float']['output'];
};

export type GetWcmBuyerRolesInput = {
  paging: BuyerAppFetchAllSuppliersPaging;
  roleNameSearch?: InputMaybe<Scalars['String']['input']>;
  wcmBuyerUuid: Scalars['String']['input'];
};

export type GetWcmBuyerRolesOutput = {
  __typename?: 'getWcmBuyerRolesOutput';
  roles: Array<WcmRole>;
  total: Scalars['Float']['output'];
};

export type GetWcmRolePermissionsOutput = {
  __typename?: 'getWcmRolePermissionsOutput';
  permissions: Array<WcmRolePermission>;
};

export type ProgramsData = {
  __typename?: 'programsData';
  auditFileCount: Scalars['Float']['output'];
  fileSetConfiguration: Array<FileSetConfiguration>;
  programUuid: Scalars['String']['output'];
};

/** A Requests stats may be requested in a single currency. If a toCurrency is provided as a filter and the toCurrency object is requested, the toCurrency object will be returned with stats for all opportunities that build up the request converted from their original currency(s) to the provided currency in the filtre.  */
export type ToCurrency = {
  __typename?: 'toCurrency';
  /** Total accepted apr weighted sum across the invoices in this request converted to the provided toCurrency */
  acceptedAprWeightedSum: Scalars['Float']['output'];
  /** The total discount across the accepted invoices converted to the provided toCurrency. */
  acceptedDiscountSum: Scalars['Float']['output'];
  /** Total weighted sum of the discount across accepted invoices converted to the provided toCurrency. */
  acceptedDiscountWeightedSum: Scalars['Float']['output'];
  /** Total accepted dpe weighted sum across the invoices in this request converted to the provided toCurrency */
  acceptedDpeWeightedSum: Scalars['Float']['output'];
  /** Total amount of the accepted invoices in this request converted to the provided toCurrency. */
  acceptedInvoiceAmount: Scalars['Float']['output'];
  /** Total awarded apr weighted sum across the invoices in this request converted to the provided toCurrency */
  awardedAprWeightedSum: Scalars['Float']['output'];
  /** The total discount across the awarded invoices converted to the provided toCurrency.  */
  awardedDiscountSum: Scalars['Float']['output'];
  /** Total awarded dpe weighted sum across the invoices in the request converted to the provided toCurrency */
  awardedDpeWeightedSum: Scalars['Float']['output'];
  /** Total amount of the awarded invoices in this request converted to the provided toCurrency.  */
  awardedInvoiceAmount: Scalars['Float']['output'];
  /**
   * The total discount across the clearing invoices converted to the provided toCurrency. To get the total discount (%) divide by the clearingInvoiceAmount.
   * clearing = accepted + awarded
   * discount = sum(invoice.earn)
   */
  clearingDiscountSum: Scalars['Float']['output'];
  /**
   * Total amount of the clearing invoices in this request converted to the provided toCurrency.
   * clearing = accepted + awarded
   */
  clearingInvoiceAmount: Scalars['Float']['output'];
  /** The (desired) currency in which stats have been converted to. */
  currency: Scalars['String']['output'];
  /** Total eligible apr weighted sum across the invoices in this request converted to the provided toCurrency */
  eligibleAprWeightedSum: Scalars['Float']['output'];
  /** Total eligible dpe weighted sum across the invoices in this request converted to the provided toCurrency */
  eligibleDpeWeightedSum: Scalars['Float']['output'];
  /** Total amount of the eligible invoices in this request converted to the provided toCurrency. */
  eligibleInvoiceAmount: Scalars['Float']['output'];
  /** Contains the list of currencies that were converted from, and the rate used in order to reach the desired currency (as defined in the desired currency field). It will only contain mappings for currencies that belong to opportunities in this request. */
  rates: Array<CurrencyMap>;
};

export type UpdateReserveInputDto = {
  /** UUID of the division */
  divisionUuid: Scalars['String']['input'];
  /** ID of the dual auth entry to be approved" */
  dualAuthId?: InputMaybe<Scalars['ID']['input']>;
  /** Invoice priority field */
  invoicePriority: Scalars['String']['input'];
  /** Market reserve id */
  marketReserveId: Scalars['Float']['input'];
  /** UUID of the market */
  marketUuid: Scalars['String']['input'];
  /** Reserve percentage value */
  reservePercentage: Scalars['Float']['input'];
  /** Field to indicate run before adjustments */
  runBeforeAdjustments: Scalars['Boolean']['input'];
};

export type UpsertWcmUsersOutput = {
  __typename?: 'upsertWcmUsersOutput';
  /** WCM users info */
  users: Array<WcmUserInfo>;
};

export type OptOutAllCommunicationPreferencesMutationVariables = Exact<{ [key: string]: never; }>;


export type OptOutAllCommunicationPreferencesMutation = { __typename?: 'Mutation', optOutAllCommunicationPreferences: { __typename?: 'OptOutCommunicationPreferencesResponse', channels: Array<string> } };

export type UpdateCompanyProfileMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateCompanyProfileMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateLocationMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type GetSupplierAgreementsQueryVariables = Exact<{
  marketUuids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type GetSupplierAgreementsQuery = { __typename?: 'Query', agreements: { __typename?: 'AgreementConnection', edges: Array<{ __typename?: 'AgreementEdge', node: { __typename?: 'Agreement', id: string, cmsId: string, marketId: string } }> } };

export type GetCustomAgreementsQueryVariables = Exact<{
  agreementNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<AgreementStatusEnum>;
}>;


export type GetCustomAgreementsQuery = { __typename?: 'Query', customAgreements: Array<{ __typename?: 'CustomAgreement', uuid: string }> };

export type GetCustomAgreementWithContentQueryVariables = Exact<{
  agreementUuid: Scalars['String']['input'];
}>;


export type GetCustomAgreementWithContentQuery = { __typename?: 'Query', customAgreementWithContent: { __typename?: 'CustomAgreementWithContent', content: string, agreementTitle: string, updatedAt?: any | null, updatedBy?: string | null } };

export type ConfirmSupplierAgreementsMutationVariables = Exact<{
  agreementAudits: Array<AgreementAuditInput> | AgreementAuditInput;
}>;


export type ConfirmSupplierAgreementsMutation = { __typename?: 'Mutation', createManyAgreementAudits: Array<{ __typename?: 'AgreementAudit', dateAccepted: string }> };

export type UpdateUserCurrencyMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserCurrencyMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type UpdateUserLanguageMutationVariables = Exact<{
  users?: InputMaybe<Array<UserInput> | UserInput>;
}>;


export type UpdateUserLanguageMutation = { __typename?: 'Mutation', users?: { __typename?: 'UserMutationResponse', success: boolean } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'User', created?: string | null, emailAddress: string, intercomUserId?: string | null, supplierReadOnly?: boolean | null, account?: { __typename?: 'Account', name: string, newExperienceEnabled?: boolean | null, segment?: string | null, id: string, srm?: { __typename?: 'Srm', calendarLink?: string | null, center?: string | null, emailAddress: string, fallback: boolean, firstName?: string | null, isCalendlyEnabled: boolean, lastName?: string | null, phoneNumber?: string | null, team?: string | null } | null } | null, divisions?: Array<{ __typename?: 'Division', accountId?: string | null, srm?: { __typename?: 'Srm', team?: string | null } | null } | null> | null, formatPreferences?: { __typename?: 'FormatPreferences', aggregateCurrencyFormat?: string | null, dateDisplayFormat?: string | null, numberDisplayFormat?: string | null, useCustomFormatting: boolean } | null, loginHistory?: Array<{ __typename?: 'LoginHistory', created: string } | null> | null, personalInfo?: { __typename?: 'PersonalInfo', arDepartmentEmailAddress?: string | null, firstName?: string | null, fiscalYearEnd?: string | null, industry?: string | null, lastName?: string | null, locale?: string | null, primaryPhoneNumber?: string | null, role?: Role | null, secondaryPhoneNumber?: string | null, address?: { __typename?: 'Address', country?: string | null, postalCode?: string | null } | null } | null } | null };


export const OptOutAllCommunicationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OptOutAllCommunicationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optOutAllCommunicationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"channels"}}]}}]}}]} as unknown as DocumentNode<OptOutAllCommunicationPreferencesMutation, OptOutAllCommunicationPreferencesMutationVariables>;
export const UpdateCompanyProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCompanyProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateCompanyProfileMutation, UpdateCompanyProfileMutationVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const GetSupplierAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSupplierAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"marketUuids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"agreements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"marketId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"marketUuids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cmsId"}},{"kind":"Field","name":{"kind":"Name","value":"marketId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSupplierAgreementsQuery, GetSupplierAgreementsQueryVariables>;
export const GetCustomAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementNames"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementStatusEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customAgreements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementNames"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementNames"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}}]}}]}}]} as unknown as DocumentNode<GetCustomAgreementsQuery, GetCustomAgreementsQueryVariables>;
export const GetCustomAgreementWithContentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCustomAgreementWithContent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementUuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customAgreementWithContent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"agreementUuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementUuid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"agreementTitle"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedBy"}}]}}]}}]} as unknown as DocumentNode<GetCustomAgreementWithContentQuery, GetCustomAgreementWithContentQueryVariables>;
export const ConfirmSupplierAgreementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmSupplierAgreements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agreementAudits"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AgreementAuditInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createManyAgreementAudits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"agreementAudits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agreementAudits"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateAccepted"}}]}}]}}]} as unknown as DocumentNode<ConfirmSupplierAgreementsMutation, ConfirmSupplierAgreementsMutationVariables>;
export const UpdateUserCurrencyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserCurrency"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserCurrencyMutation, UpdateUserCurrencyMutationVariables>;
export const UpdateUserLanguageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserLanguage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateUserLanguageMutation, UpdateUserLanguageMutationVariables>;
export const GetMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"account"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"newExperienceEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"segment"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"srm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendarLink"}},{"kind":"Field","name":{"kind":"Name","value":"center"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fallback"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"isCalendlyEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"divisions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"srm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"team"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"formatPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateCurrencyFormat"}},{"kind":"Field","name":{"kind":"Name","value":"dateDisplayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"numberDisplayFormat"}},{"kind":"Field","name":{"kind":"Name","value":"useCustomFormatting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"intercomUserId"}},{"kind":"Field","name":{"kind":"Name","value":"loginHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"Field","name":{"kind":"Name","value":"personalInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"arDepartmentEmailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"fiscalYearEnd"}},{"kind":"Field","name":{"kind":"Name","value":"industry"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPhoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryPhoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierReadOnly"}}]}}]}}]} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;